webpackJsonp([0],{

/***/ "+RxT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ChatFooterEmojiButton":"ChatFooterEmojiButton__1T1Pn","CancelButton":"CancelButton__3Nr82","Spinner":"Spinner__3FtXd","ChatFooterSendButton":"ChatFooterSendButton__Tnfqp","ChatFooterButtons":"ChatFooterButtons__26eZL","FileBubble":"FileBubble__1HwDg","TextArea":"TextArea__24Z1F","ChatFooter":"ChatFooter__1p0cJ","ChatTextarea":"ChatTextarea__1ia1p"};

/***/ }),

/***/ "/750":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _ConversationItem = __webpack_require__("FW1l");

var _ConversationItem2 = _interopRequireDefault(_ConversationItem);

var _immutable = __webpack_require__("BYKG");

var _DateTime = __webpack_require__("uRCp");

var _DateTime2 = _interopRequireDefault(_DateTime);

var _style = __webpack_require__("9C9F");

var _style2 = _interopRequireDefault(_style);

var _Header = __webpack_require__("W0rJ");

var _Header2 = _interopRequireDefault(_Header);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ConversationsList = function (_Component) {
    _inherits(ConversationsList, _Component);

    function ConversationsList() {
        _classCallCheck(this, ConversationsList);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ConversationsList.prototype.render = function render() {
        var language = this.props.language;


        var conversationsList = this.conversationsMaptoList();

        var _groupConversationsBy = this.groupConversationsByResolvedStatus(conversationsList),
            unresolved = _groupConversationsBy.unresolved,
            resolved = _groupConversationsBy.resolved;

        unresolved = unresolved.sort(this.orderByLatestEntry);
        resolved = resolved.sort(this.orderByLatestEntry);

        var unresolvedC = unresolved.map(function (conversation) {
            return (0, _preact.h)(_ConversationItem2.default, { conversation: conversation });
        });
        var resolvedC = resolved.map(function (conversation) {
            return (0, _preact.h)(_ConversationItem2.default, { conversation: conversation });
        });

        return (0, _preact.h)(
            'div',
            { className: _style2.default.ConversationsList },
            unresolvedC.size !== 0 && (0, _preact.h)(
                'div',
                null,
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.ConversationSeparation },
                    language.get('CurrentConversations')
                ),
                unresolvedC.toJS()
            ),
            resolvedC.size !== 0 && (0, _preact.h)(
                'div',
                null,
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.ConversationSeparation },
                    language.get('PreviousConversations')
                ),
                resolvedC.toJS()
            )
        );
    };

    ConversationsList.prototype.conversationsMaptoList = function conversationsMaptoList() {
        var conversations = this.props.conversations;
        var conversationsList = (0, _immutable.List)();

        conversations.forEach(function (conversation) {
            conversationsList = conversationsList.push(conversation);
        });

        return conversationsList;
    };

    ConversationsList.prototype.groupConversationsByResolvedStatus = function groupConversationsByResolvedStatus(conversations) {
        var unresolved = conversations.filter(function (conversation) {
            return !conversation.get('is_resolved');
        });
        var resolved = conversations.filter(function (conversation) {
            return conversation.get('is_resolved');
        });

        return {
            unresolved: unresolved,
            resolved: resolved
        };
    };

    ConversationsList.prototype.orderByLatestEntry = function orderByLatestEntry(cA, cB) {
        var lastEntryA = cA.getIn(['entries', -1, 'date_created']);
        var lastEntryB = cB.getIn(['entries', -1, 'date_created']);
        if (!lastEntryA) return 0;
        if (!lastEntryB) return 0;
        var timeA = _DateTime2.default.getTimestamp(lastEntryA);
        var timeB = _DateTime2.default.getTimestamp(lastEntryB);

        return timeB - timeA;
    };

    return ConversationsList;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        language: _model2.default.getLanguage(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(ConversationsList);

/***/ }),

/***/ "/GQK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    'div',
    { 'class': 'typing-indicator-chat-body-wrapper' },
    (0, _preact.h)(
        'div',
        { 'class': 'typing-indicator-chat-body' },
        (0, _preact.h)('span', null),
        (0, _preact.h)('span', null),
        (0, _preact.h)('span', null)
    )
);

var TypingIndicatorChatBody = function (_Component) {
    _inherits(TypingIndicatorChatBody, _Component);

    function TypingIndicatorChatBody() {
        _classCallCheck(this, TypingIndicatorChatBody);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    TypingIndicatorChatBody.prototype.render = function render() {
        return _ref;
    };

    return TypingIndicatorChatBody;
}(_preact.Component);

exports.default = TypingIndicatorChatBody;

/***/ }),

/***/ "037A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  "skin-tone-2": "🏻",
  "skin-tone-3": "🏿",
  "skin-tone-4": "🏽",
  "skin-tone-5": "🏾",
  "skin-tone-6": "🏿",
  "100": "💯",
  "1234": "🔢",
  smile: "😄",
  smiley: "😃",
  grinning: "😀",
  slightly_smiling_face: "🙂",
  blush: "😊",
  relaxed: "☺️",
  wink: "😉",
  heart_eyes: "😍",
  kissing_heart: "😘",
  kissing_closed_eyes: "😚",
  kissing: "😗",
  kissing_smiling_eyes: "😙",
  stuck_out_tongue_winking_eye: "😜",
  stuck_out_tongue_closed_eyes: "😝",
  stuck_out_tongue: "😛",
  flushed: "😳",
  grin: "😁",
  pensive: "😔",
  relieved: "😌",
  unamused: "😒",
  disappointed: "😞",
  persevere: "😣",
  cry: "😢",
  joy: "😂",
  sob: "😭",
  sleepy: "😪",
  disappointed_relieved: "😥",
  cold_sweat: "😰",
  sweat_smile: "😅",
  sweat: "😓",
  weary: "😩",
  tired_face: "😫",
  fearful: "😨",
  scream: "😱",
  angry: "😠",
  rage: "😡",
  pout: "😡",
  triumph: "😤",
  confounded: "😖",
  laughing: "😆",
  satisfied: "😆",
  yum: "😋",
  mask: "😷",
  sunglasses: "😎",
  sleeping: "😴",
  dizzy_face: "😵",
  astonished: "😲",
  worried: "😟",
  frowning: "😦",
  anguished: "😧",
  smiling_imp: "😈",
  imp: "👿",
  open_mouth: "😮",
  grimacing: "😬",
  neutral_face: "😐",
  confused: "😕",
  hushed: "😯",
  no_mouth: "😶",
  innocent: "😇",
  smirk: "😏",
  expressionless: "😑",
  man_with_gua_pi_mao: "👲",
  man_with_turban: "👳",
  cop: "👮",
  construction_worker: "👷",
  guardsman: "💂",
  baby: "👶",
  boy: "👦",
  girl: "👧",
  man: "👨",
  woman: "👩",
  older_man: "👴",
  older_woman: "👵",
  person_with_blond_hair: "👱",
  angel: "👼",
  princess: "👸",
  smiley_cat: "😺",
  smile_cat: "😸",
  heart_eyes_cat: "😻",
  kissing_cat: "😽",
  smirk_cat: "😼",
  scream_cat: "🙀",
  crying_cat_face: "😿",
  joy_cat: "😹",
  pouting_cat: "😾",
  japanese_ogre: "👹",
  japanese_goblin: "👺",
  see_no_evil: "🙈",
  hear_no_evil: "🙉",
  speak_no_evil: "🙊",
  skull: "💀",
  alien: "👽",
  hankey: "💩",
  poop: "💩",
  shit: "💩",
  fire: "🔥",
  sparkles: "✨",
  star2: "🌟",
  dizzy: "💫",
  boom: "💥",
  collision: "💥",
  anger: "💢",
  sweat_drops: "💦",
  droplet: "💧",
  zzz: "💤",
  dash: "💨",
  ear: "👂",
  eyes: "👀",
  nose: "👃",
  tongue: "👅",
  lips: "👄",
  "+1": "👍",
  thumbsup: "👍",
  "-1": "👎",
  thumbsdown: "👎",
  ok_hand: "👌",
  facepunch: "👊",
  punch: "👊",
  fist: "✊",
  v: "✌️",
  wave: "👋",
  hand: "✋",
  raised_hand: "✋",
  open_hands: "👐",
  point_up_2: "👆",
  point_down: "👇",
  point_right: "👉",
  point_left: "👈",
  raised_hands: "🙌",
  pray: "🙏",
  point_up: "☝️",
  clap: "👏",
  muscle: "💪",
  walking: "🚶",
  runner: "🏃",
  running: "🏃",
  dancer: "💃",
  couple: "👫",
  family: "👪",
  two_men_holding_hands: "👬",
  two_women_holding_hands: "👭",
  couplekiss: "💏",
  couple_with_heart: "💑",
  dancers: "👯",
  ok_woman: "🙆",
  no_good: "🙅",
  ng_woman: "🙅",
  information_desk_person: "💁",
  raising_hand: "🙋",
  massage: "💆",
  haircut: "💇",
  nail_care: "💅",
  bride_with_veil: "👰",
  person_with_pouting_face: "🙎",
  person_frowning: "🙍",
  bow: "🙇",
  tophat: "🎩",
  crown: "👑",
  womans_hat: "👒",
  athletic_shoe: "👟",
  mans_shoe: "👞",
  shoe: "👞",
  sandal: "👡",
  high_heel: "👠",
  boot: "👢",
  shirt: "👕",
  tshirt: "👕",
  necktie: "👔",
  womans_clothes: "👚",
  dress: "👗",
  running_shirt_with_sash: "🎽",
  jeans: "👖",
  kimono: "👘",
  bikini: "👙",
  briefcase: "💼",
  handbag: "👜",
  pouch: "👝",
  purse: "👛",
  eyeglasses: "👓",
  ribbon: "🎀",
  closed_umbrella: "🌂",
  lipstick: "💄",
  yellow_heart: "💛",
  blue_heart: "💙",
  purple_heart: "💜",
  green_heart: "💚",
  heart: "❤️",
  broken_heart: "💔",
  heartpulse: "💗",
  heartbeat: "💓",
  two_hearts: "💕",
  sparkling_heart: "💖",
  revolving_hearts: "💞",
  cupid: "💘",
  love_letter: "💌",
  kiss: "💋",
  ring: "💍",
  gem: "💎",
  bust_in_silhouette: "👤",
  busts_in_silhouette: "👥",
  speech_balloon: "💬",
  footprints: "👣",
  thought_balloon: "💭",
  dog: "🐶",
  wolf: "🐺",
  cat: "🐱",
  mouse: "🐭",
  hamster: "🐹",
  rabbit: "🐰",
  frog: "🐸",
  tiger: "🐯",
  koala: "🐨",
  bear: "🐻",
  pig: "🐷",
  pig_nose: "🐽",
  cow: "🐮",
  boar: "🐗",
  monkey_face: "🐵",
  monkey: "🐒",
  horse: "🐴",
  sheep: "🐑",
  elephant: "🐘",
  panda_face: "🐼",
  penguin: "🐧",
  bird: "🐦",
  baby_chick: "🐤",
  hatched_chick: "🐥",
  hatching_chick: "🐣",
  chicken: "🐔",
  snake: "🐍",
  turtle: "🐢",
  bug: "🐛",
  bee: "🐝",
  honeybee: "🐝",
  ant: "🐜",
  beetle: "🐞",
  snail: "🐌",
  octopus: "🐙",
  shell: "🐚",
  tropical_fish: "🐠",
  fish: "🐟",
  dolphin: "🐬",
  flipper: "🐬",
  whale: "🐳",
  whale2: "🐋",
  cow2: "🐄",
  ram: "🐏",
  rat: "🐀",
  water_buffalo: "🐃",
  tiger2: "🐅",
  rabbit2: "🐇",
  dragon: "🐉",
  racehorse: "🐎",
  goat: "🐐",
  rooster: "🐓",
  dog2: "🐕",
  pig2: "🐖",
  mouse2: "🐁",
  ox: "🐂",
  dragon_face: "🐲",
  blowfish: "🐡",
  crocodile: "🐊",
  camel: "🐫",
  dromedary_camel: "🐪",
  leopard: "🐆",
  cat2: "🐈",
  poodle: "🐩",
  feet: "🐾",
  paw_prints: "🐾",
  bouquet: "💐",
  cherry_blossom: "🌸",
  tulip: "🌷",
  four_leaf_clover: "🍀",
  rose: "🌹",
  sunflower: "🌻",
  hibiscus: "🌺",
  maple_leaf: "🍁",
  leaves: "🍃",
  fallen_leaf: "🍂",
  herb: "🌿",
  ear_of_rice: "🌾",
  mushroom: "🍄",
  cactus: "🌵",
  palm_tree: "🌴",
  evergreen_tree: "🌲",
  deciduous_tree: "🌳",
  chestnut: "🌰",
  seedling: "🌱",
  blossom: "🌼",
  globe_with_meridians: "🌐",
  sun_with_face: "🌞",
  full_moon_with_face: "🌝",
  new_moon_with_face: "🌚",
  new_moon: "🌑",
  waxing_crescent_moon: "🌒",
  first_quarter_moon: "🌓",
  moon: "🌔",
  waxing_gibbous_moon: "🌔",
  full_moon: "🌕",
  waning_gibbous_moon: "🌖",
  last_quarter_moon: "🌗",
  waning_crescent_moon: "🌘",
  last_quarter_moon_with_face: "🌜",
  first_quarter_moon_with_face: "🌛",
  crescent_moon: "🌙",
  earth_africa: "🌍",
  earth_americas: "🌎",
  earth_asia: "🌏",
  volcano: "🌋",
  milky_way: "🌌",
  stars: "🌠",
  star: "⭐",
  sunny: "☀️",
  partly_sunny: "⛅",
  cloud: "☁️",
  zap: "⚡",
  umbrella: "☔",
  snowflake: "❄️",
  snowman: "⛄",
  cyclone: "🌀",
  foggy: "🌁",
  rainbow: "🌈",
  ocean: "🌊",
  bamboo: "🎍",
  gift_heart: "💝",
  dolls: "🎎",
  school_satchel: "🎒",
  mortar_board: "🎓",
  flags: "🎏",
  fireworks: "🎆",
  sparkler: "🎇",
  wind_chime: "🎐",
  rice_scene: "🎑",
  jack_o_lantern: "🎃",
  ghost: "👻",
  santa: "🎅",
  christmas_tree: "🎄",
  gift: "🎁",
  tanabata_tree: "🎋",
  tada: "🎉",
  confetti_ball: "🎊",
  balloon: "🎈",
  crossed_flags: "🎌",
  crystal_ball: "🔮",
  movie_camera: "🎥",
  camera: "📷",
  video_camera: "📹",
  vhs: "📼",
  cd: "💿",
  dvd: "📀",
  minidisc: "💽",
  floppy_disk: "💾",
  computer: "💻",
  iphone: "📱",
  phone: "☎️",
  telephone: "☎️",
  telephone_receiver: "📞",
  pager: "📟",
  fax: "📠",
  satellite: "📡",
  tv: "📺",
  radio: "📻",
  loud_sound: "🔊",
  sound: "🔉",
  speaker: "🔈",
  mute: "🔇",
  bell: "🔔",
  no_bell: "🔕",
  loudspeaker: "📢",
  mega: "📣",
  hourglass_flowing_sand: "⏳",
  hourglass: "⌛",
  alarm_clock: "⏰",
  watch: "⌚",
  unlock: "🔓",
  lock: "🔒",
  lock_with_ink_pen: "🔏",
  closed_lock_with_key: "🔐",
  key: "🔑",
  mag_right: "🔎",
  bulb: "💡",
  flashlight: "🔦",
  high_brightness: "🔆",
  low_brightness: "🔅",
  electric_plug: "🔌",
  battery: "🔋",
  mag: "🔍",
  bathtub: "🛁",
  bath: "🛀",
  shower: "🚿",
  toilet: "🚽",
  wrench: "🔧",
  nut_and_bolt: "🔩",
  hammer: "🔨",
  door: "🚪",
  smoking: "🚬",
  bomb: "💣",
  gun: "🔫",
  hocho: "🔪",
  knife: "🔪",
  pill: "💊",
  syringe: "💉",
  moneybag: "💰",
  yen: "💴",
  dollar: "💵",
  pound: "💷",
  euro: "💶",
  credit_card: "💳",
  money_with_wings: "💸",
  calling: "📲",
  "e-mail": "📧",
  inbox_tray: "📥",
  outbox_tray: "📤",
  email: "✉️",
  envelope: "✉️",
  envelope_with_arrow: "📩",
  incoming_envelope: "📨",
  postal_horn: "📯",
  mailbox: "📫",
  mailbox_closed: "📪",
  mailbox_with_mail: "📬",
  mailbox_with_no_mail: "📭",
  postbox: "📮",
  package: "📦",
  memo: "📝",
  pencil: "📝",
  page_facing_up: "📄",
  page_with_curl: "📃",
  bookmark_tabs: "📑",
  bar_chart: "📊",
  chart_with_upwards_trend: "📈",
  chart_with_downwards_trend: "📉",
  scroll: "📜",
  clipboard: "📋",
  date: "📅",
  calendar: "📆",
  card_index: "📇",
  file_folder: "📁",
  open_file_folder: "📂",
  scissors: "✂️",
  pushpin: "📌",
  paperclip: "📎",
  black_nib: "✒️",
  pencil2: "✏️",
  straight_ruler: "📏",
  triangular_ruler: "📐",
  closed_book: "📕",
  green_book: "📗",
  blue_book: "📘",
  orange_book: "📙",
  notebook: "📓",
  notebook_with_decorative_cover: "📔",
  ledger: "📒",
  books: "📚",
  book: "📖",
  open_book: "📖",
  bookmark: "🔖",
  name_badge: "📛",
  microscope: "🔬",
  telescope: "🔭",
  newspaper: "📰",
  art: "🎨",
  clapper: "🎬",
  microphone: "🎤",
  headphones: "🎧",
  musical_score: "🎼",
  musical_note: "🎵",
  notes: "🎶",
  musical_keyboard: "🎹",
  violin: "🎻",
  trumpet: "🎺",
  saxophone: "🎷",
  guitar: "🎸",
  space_invader: "👾",
  video_game: "🎮",
  black_joker: "🃏",
  flower_playing_cards: "🎴",
  mahjong: "🀄",
  game_die: "🎲",
  dart: "🎯",
  football: "🏈",
  basketball: "🏀",
  soccer: "⚽",
  baseball: "⚾️",
  tennis: "🎾",
  "8ball": "🎱",
  rugby_football: "🏉",
  bowling: "🎳",
  golf: "⛳",
  mountain_bicyclist: "🚵",
  bicyclist: "🚴",
  checkered_flag: "🏁",
  horse_racing: "🏇",
  trophy: "🏆",
  ski: "🎿",
  snowboarder: "🏂",
  swimmer: "🏊",
  surfer: "🏄",
  fishing_pole_and_fish: "🎣",
  coffee: "☕",
  tea: "🍵",
  sake: "🍶",
  baby_bottle: "🍼",
  beer: "🍺",
  beers: "🍻",
  cocktail: "🍸",
  tropical_drink: "🍹",
  wine_glass: "🍷",
  fork_and_knife: "🍴",
  pizza: "🍕",
  hamburger: "🍔",
  fries: "🍟",
  poultry_leg: "🍗",
  meat_on_bone: "🍖",
  spaghetti: "🍝",
  curry: "🍛",
  fried_shrimp: "🍤",
  bento: "🍱",
  sushi: "🍣",
  fish_cake: "🍥",
  rice_ball: "🍙",
  rice_cracker: "🍘",
  rice: "🍚",
  ramen: "🍜",
  stew: "🍲",
  oden: "🍢",
  dango: "🍡",
  egg: "🍳",
  bread: "🍞",
  doughnut: "🍩",
  custard: "🍮",
  icecream: "🍦",
  ice_cream: "🍨",
  shaved_ice: "🍧",
  birthday: "🎂",
  cake: "🍰",
  cookie: "🍪",
  chocolate_bar: "🍫",
  candy: "🍬",
  lollipop: "🍭",
  honey_pot: "🍯",
  apple: "🍎",
  green_apple: "🍏",
  tangerine: "🍊",
  orange: "🍊",
  mandarin: "🍊",
  lemon: "🍋",
  cherries: "🍒",
  grapes: "🍇",
  watermelon: "🍉",
  strawberry: "🍓",
  peach: "🍑",
  melon: "🍈",
  banana: "🍌",
  pear: "🍐",
  pineapple: "🍍",
  sweet_potato: "🍠",
  eggplant: "🍆",
  tomato: "🍅",
  corn: "🌽",
  house: "🏠",
  house_with_garden: "🏡",
  school: "🏫",
  office: "🏢",
  post_office: "🏣",
  hospital: "🏥",
  bank: "🏦",
  convenience_store: "🏪",
  love_hotel: "🏩",
  hotel: "🏨",
  wedding: "💒",
  church: "⛪",
  department_store: "🏬",
  european_post_office: "🏤",
  city_sunrise: "🌇",
  city_sunset: "🌆",
  japanese_castle: "🏯",
  european_castle: "🏰",
  tent: "⛺",
  factory: "🏭",
  tokyo_tower: "🗼",
  japan: "🗾",
  mount_fuji: "🗻",
  sunrise_over_mountains: "🌄",
  sunrise: "🌅",
  night_with_stars: "🌃",
  statue_of_liberty: "🗽",
  bridge_at_night: "🌉",
  carousel_horse: "🎠",
  ferris_wheel: "🎡",
  fountain: "⛲",
  roller_coaster: "🎢",
  ship: "🚢",
  boat: "⛵",
  sailboat: "⛵",
  speedboat: "🚤",
  rowboat: "🚣",
  anchor: "⚓",
  rocket: "🚀",
  airplane: "✈️",
  seat: "💺",
  helicopter: "🚁",
  steam_locomotive: "🚂",
  tram: "🚊",
  station: "🚉",
  mountain_railway: "🚞",
  train2: "🚆",
  bullettrain_side: "🚄",
  bullettrain_front: "🚅",
  light_rail: "🚈",
  metro: "🚇",
  monorail: "🚝",
  train: "🚋",
  railway_car: "🚃",
  trolleybus: "🚎",
  bus: "🚌",
  oncoming_bus: "🚍",
  blue_car: "🚙",
  oncoming_automobile: "🚘",
  car: "🚗",
  red_car: "🚗",
  taxi: "🚕",
  oncoming_taxi: "🚖",
  articulated_lorry: "🚛",
  truck: "🚚",
  rotating_light: "🚨",
  police_car: "🚓",
  oncoming_police_car: "🚔",
  fire_engine: "🚒",
  ambulance: "🚑",
  minibus: "🚐",
  bike: "🚲",
  aerial_tramway: "🚡",
  suspension_railway: "🚟",
  mountain_cableway: "🚠",
  tractor: "🚜",
  barber: "💈",
  busstop: "🚏",
  ticket: "🎫",
  vertical_traffic_light: "🚦",
  traffic_light: "🚥",
  warning: "⚠️",
  construction: "🚧",
  beginner: "🔰",
  fuelpump: "⛽",
  izakaya_lantern: "🏮",
  lantern: "🏮",
  slot_machine: "🎰",
  hotsprings: "♨️",
  moyai: "🗿",
  circus_tent: "🎪",
  performing_arts: "🎭",
  round_pushpin: "📍",
  triangular_flag_on_post: "🚩",
  jp: "🇯🇵",
  kr: "🇰🇷",
  de: "🇩🇪",
  cn: "🇨🇳",
  us: "🇺🇸",
  fr: "🇫🇷",
  es: "🇪🇸",
  it: "🇮🇹",
  ru: "🇷🇺",
  gb: "🇬🇧",
  uk: "🇬🇧",
  one: "1️⃣",
  two: "2️⃣",
  three: "3️⃣",
  four: "4️⃣",
  five: "5️⃣",
  six: "6️⃣",
  seven: "7️⃣",
  eight: "8️⃣",
  nine: "9️⃣",
  zero: "0️⃣",
  keycap_ten: "🔟",
  hash: "#️⃣",
  symbols: "🔣",
  arrow_up: "⬆️",
  arrow_down: "⬇️",
  arrow_left: "⬅️",
  arrow_right: "➡️",
  capital_abcd: "🔠",
  abcd: "🔡",
  abc: "🔤",
  arrow_upper_right: "↗️",
  arrow_upper_left: "↖️",
  arrow_lower_right: "↘️",
  arrow_lower_left: "↙️",
  left_right_arrow: "↔️",
  arrow_up_down: "↕️",
  arrows_counterclockwise: "🔄",
  arrow_backward: "◀️",
  arrow_forward: "▶️",
  arrow_up_small: "🔼",
  arrow_down_small: "🔽",
  leftwards_arrow_with_hook: "↩️",
  arrow_right_hook: "↪️",
  information_source: "ℹ️",
  rewind: "⏪",
  fast_forward: "⏩",
  arrow_double_up: "⏫",
  arrow_double_down: "⏬",
  arrow_heading_down: "⤵️",
  arrow_heading_up: "⤴️",
  ok: "🆗",
  twisted_rightwards_arrows: "🔀",
  repeat: "🔁",
  repeat_one: "🔂",
  new: "🆕",
  up: "🆙",
  cool: "🆒",
  free: "🆓",
  ng: "🆖",
  signal_strength: "📶",
  cinema: "🎦",
  koko: "🈁",
  u6307: "🈯",
  u7a7a: "🈳",
  u6e80: "🈵",
  u5408: "🈴",
  u7981: "🈲",
  ideograph_advantage: "🉐",
  u5272: "🈹",
  u55b6: "🈺",
  u6709: "🈶",
  u7121: "🈚",
  restroom: "🚻",
  mens: "🚹",
  womens: "🚺",
  baby_symbol: "🚼",
  wc: "🚾",
  potable_water: "🚰",
  put_litter_in_its_place: "🚮",
  parking: "🅿️",
  wheelchair: "♿",
  no_smoking: "🚭",
  u6708: "🈷️",
  u7533: "🈸",
  sa: "🈂️",
  m: "Ⓜ️",
  passport_control: "🛂",
  baggage_claim: "🛄",
  left_luggage: "🛅",
  customs: "🛃",
  accept: "🉑",
  secret: "㊙️",
  congratulations: "㊗️",
  cl: "🆑",
  sos: "🆘",
  id: "🆔",
  no_entry_sign: "🚫",
  underage: "🔞",
  no_mobile_phones: "📵",
  do_not_litter: "🚯",
  "non-potable_water": "🚱",
  no_bicycles: "🚳",
  no_pedestrians: "🚷",
  children_crossing: "🚸",
  no_entry: "⛔",
  eight_spoked_asterisk: "✳️",
  sparkle: "❇️",
  negative_squared_cross_mark: "❎",
  white_check_mark: "✅",
  eight_pointed_black_star: "✴️",
  heart_decoration: "💟",
  vs: "🆚",
  vibration_mode: "📳",
  mobile_phone_off: "📴",
  a: "🅰️",
  b: "🅱️",
  ab: "🆎",
  o2: "🅾️",
  diamond_shape_with_a_dot_inside: "💠",
  loop: "➿",
  recycle: "♻️",
  aries: "♈",
  taurus: "♉",
  gemini: "♊",
  cancer: "♋",
  leo: "♌",
  virgo: "♍",
  libra: "♎",
  scorpius: "♏",
  sagittarius: "♐",
  capricorn: "♑",
  aquarius: "♒",
  pisces: "♓",
  ophiuchus: "⛎",
  six_pointed_star: "🔯",
  atm: "🏧",
  chart: "💹",
  heavy_dollar_sign: "💲",
  currency_exchange: "💱",
  copyright: "©️",
  registered: "®️",
  tm: "™️",
  x: "❌",
  bangbang: "‼️",
  interrobang: "⁉️",
  exclamation: "❗",
  heavy_exclamation_mark: "❗",
  question: "❓",
  grey_exclamation: "❕",
  grey_question: "❔",
  o: "⭕",
  top: "🔝",
  end: "🔚",
  back: "🔙",
  on: "🔛",
  soon: "🔜",
  arrows_clockwise: "🔃",
  clock12: "🕛",
  clock1230: "🕧",
  clock1: "🕐",
  clock130: "🕜",
  clock2: "🕑",
  clock230: "🕝",
  clock3: "🕒",
  clock330: "🕞",
  clock4: "🕓",
  clock430: "🕟",
  clock5: "🕔",
  clock530: "🕠",
  clock6: "🕕",
  clock7: "🕖",
  clock8: "🕗",
  clock9: "🕘",
  clock10: "🕙",
  clock11: "🕚",
  clock630: "🕡",
  clock730: "🕢",
  clock830: "🕣",
  clock930: "🕤",
  clock1030: "🕥",
  clock1130: "🕦",
  heavy_multiplication_x: "✖️",
  heavy_plus_sign: "➕",
  heavy_minus_sign: "➖",
  heavy_division_sign: "➗",
  spades: "♠️",
  hearts: "♥️",
  clubs: "♣️",
  diamonds: "♦️",
  white_flower: "💮",
  heavy_check_mark: "✔️",
  ballot_box_with_check: "☑️",
  radio_button: "🔘",
  link: "🔗",
  curly_loop: "➰",
  wavy_dash: "〰️",
  part_alternation_mark: "〽️",
  trident: "🔱",
  black_medium_square: "◼️",
  white_medium_square: "◻️",
  black_medium_small_square: "◾",
  white_medium_small_square: "◽",
  black_small_square: "▪️",
  white_small_square: "▫️",
  small_red_triangle: "🔺",
  black_square_button: "🔲",
  white_square_button: "🔳",
  black_circle: "⚫",
  white_circle: "⚪",
  red_circle: "🔴",
  large_blue_circle: "🔵",
  small_red_triangle_down: "🔻",
  white_large_square: "⬜",
  black_large_square: "⬛",
  large_orange_diamond: "🔶",
  large_blue_diamond: "🔷",
  small_orange_diamond: "🔸",
  small_blue_diamond: "🔹"
};

/***/ }),

/***/ "0A5o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("mb5j");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Question = function (_Component) {
    _inherits(Question, _Component);

    function Question() {
        _classCallCheck(this, Question);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Question.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.QuestionWrapper, onClick: this.props.onClick },
            (0, _preact.h)(
                'div',
                {
                    className: _style2.default.Question },
                this.props.questionTitle
            )
        );
    };

    return Question;
}(_preact.Component);

exports.default = Question;

/***/ }),

/***/ "0A9V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _ChatFooterSendButton = __webpack_require__("WjAf");

var _ChatFooterSendButton2 = _interopRequireDefault(_ChatFooterSendButton);

var _ChatFooterEmojiButton = __webpack_require__("G8/f");

var _ChatFooterEmojiButton2 = _interopRequireDefault(_ChatFooterEmojiButton);

var _ChatFooterUploadButton = __webpack_require__("2E51");

var _ChatFooterUploadButton2 = _interopRequireDefault(_ChatFooterUploadButton);

var _EmojiContainer = __webpack_require__("6ES8");

var _EmojiContainer2 = _interopRequireDefault(_EmojiContainer);

var _ellipsis = __webpack_require__("xvMY");

var _ellipsis2 = _interopRequireDefault(_ellipsis);

var _FountainDrops = __webpack_require__("1xei");

var _FountainDrops2 = _interopRequireDefault(_FountainDrops);

var _reactEmojiRender = __webpack_require__("Stiw");

var _ENV = __webpack_require__("g/jL");

var _style = __webpack_require__("+RxT");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_FountainDrops2.default, null);

var ChatFooter = function (_Component) {
    _inherits(ChatFooter, _Component);

    function ChatFooter() {
        _classCallCheck(this, ChatFooter);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this._handleChange = _this._handleChange.bind(_this);
        _this.sendMessage = _this.sendMessage.bind(_this);
        _this.uploadFile = _this.uploadFile.bind(_this);
        _this.removeFile = _this.removeFile.bind(_this);
        _this.focusTimeout = null;
        _this.addEmoji = _this.addEmoji.bind(_this);
        _this.handleTextareaInput = _this.handleTextareaInput.bind(_this);
        _this.handleTextareaKeypress = _this.handleTextareaKeypress.bind(_this);
        _this.state = {
            filename: '',
            filetype: null,
            blob: null,
            fileIsUploading: false,
            size: null,
            value: ''
        };
        return _this;
    }

    ChatFooter.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        this.focusTimeout = setTimeout(function () {
            _this2.chatTextareaDOM.focus();
        });
    };

    ChatFooter.prototype.componentWillUnmount = function componentWillUnmount() {
        clearTimeout(this.focusTimeout);
    };

    ChatFooter.prototype.componentDidUpdate = function componentDidUpdate() {
        if (this.chatTextareaDOM) this.chatTextareaDOM.focus();
    };

    /**
     * The selected emoji is placed in the text, in the position of the caret.
     *
     * This causes React to update the DOM and the caret position will be moved to 0.
     * To counter this, this code manually moves the caret to the correct position
     * @param {*} emoji
     */


    ChatFooter.prototype.addEmoji = function addEmoji(emoji) {
        var _this3 = this;

        var caretPosStart = this.chatTextareaDOM.selectionStart;
        // Insert emoji into the text
        var text = this.state.value;
        var value = text.slice(0, caretPosStart) + emoji + text.slice(caretPosStart);
        // Restore the caret position after updating the text field
        this.setState({ value: value }, function () {
            _this3.chatTextareaDOM.setSelectionRange(caretPosStart + 2, caretPosStart + 2);
        });
    };

    ChatFooter.prototype.handleTextareaKeypress = function handleTextareaKeypress(e) {
        //  enter key
        if (e.keyCode === 13 && e.shiftKey === false) {
            if (!this.props.room) {
                this.sendMessage();
            } else {
                if (e.altKey === true) {
                    this.setState({ value: e.target.value + '\r\n' });
                } else {
                    this.sendMessage();
                }
            }
            e.preventDefault();
        }
    };

    ChatFooter.prototype.handleTextareaInput = function handleTextareaInput(e) {
        this.setState({ value: e.target.value });
        if (!this.props.room) return;
        this.props.dispatch(_model.TicketModel.socketSendIamTyping(this.props.room));
    };

    ChatFooter.prototype.sendMessage = function sendMessage() {
        this.uploadFile();
        this.props.dispatch(_model.TicketModel.socketSendTextEntry(this.state.value, this.props.room));
        this.setState({ value: '' });
    };
    //============================= HANDLE FILES =================================


    ChatFooter.prototype.humanFileSize = function humanFileSize(bytes, si) {
        var thresh = si ? 1000 : 1024;
        if (Math.abs(bytes) < thresh) {
            return bytes + ' B';
        }
        var units = si ? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'] : ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
        var u = -1;
        do {
            bytes /= thresh;
            ++u;
        } while (Math.abs(bytes) >= thresh && u < units.length - 1);
        return bytes.toFixed(1) + ' ' + units[u];
    };

    ChatFooter.prototype._handleChange = function _handleChange(event) {
        var _this4 = this;

        var reader = new FileReader();
        var file = event.target.files[0];
        reader.onloadend = function (evt) {
            var blob = new Blob([new Uint8Array(evt.target.result)]);
            _this4.setState({ filename: file.name, filetype: file.type, blob: blob, filesize: _this4.humanFileSize(file.size, true) });
        };
        // 7 MB
        if (file.size < 7000000) reader.readAsArrayBuffer(file);

        //HACK: Else, the user won't be able to select the same file in 2 consecutive uploads.
        event.target.value = '';
    };

    ChatFooter.prototype.removeFile = function removeFile() {
        this.setState({
            filename: '',
            filetype: null,
            blob: null,
            fileIsUploading: false,
            size: 0
        });
    };

    ChatFooter.prototype.uploadFile = function uploadFile() {
        var _this5 = this;

        if (!this.state.filename) return;
        var room = this.props.room;
        var url = _ENV.backendApiUrl;
        var token = this.props.token;
        var routePath = '/v1/room/file/upload_url/get';

        var contentType = this.state.filetype;
        var fileName = this.state.filename;
        var dataBlob = this.state.blob;
        this.setState({
            fileIsUploading: true
        });
        fetch(url + routePath, {
            method: 'POST',
            body: JSON.stringify({
                room: room, content_type: contentType, file_name: fileName
            }),
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
            }
        }).then(function (res) {
            if (!res.ok) throw res;
            return res.json();
        }).then(function (res) {
            var uploadUrl = res.url;
            fetch(uploadUrl, {
                method: 'PUT',
                body: dataBlob,
                headers: { 'Content-Type': contentType }
            }).then(function (res) {
                if (!res.ok) throw res;
            }).then(function (res) {
                fetch(url + '/v1/room/file/upload_url/done', {
                    method: 'POST',
                    body: JSON.stringify({ room: room, file_name: fileName }),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + token
                    }
                });
            }).then(function (res) {
                _this5.removeFile();
            });
        });
    };

    //=================================================================================

    ChatFooter.prototype.render = function render() {
        var _this6 = this;

        var textColor = this.state.fileIsUploading ? '#898989' : '#333333';
        var backgroundColor = this.state.fileIsUploading ? '#f0f0f0' : '#eaeaea';
        return (0, _preact.h)(
            'div',
            { className: _style2.default.ChatFooter },
            (0, _preact.h)(
                'div',
                { className: _style2.default.TextArea },
                this.state.filename && (0, _preact.h)(
                    'div',
                    {
                        style: { backgroundColor: backgroundColor, color: textColor },
                        className: _style2.default.FileBubble },
                    (0, _ellipsis2.default)(this.state.filename, 15) + ' ' + this.state.filesize,
                    !this.state.fileIsUploading && (0, _preact.h)(
                        'div',
                        { className: _style2.default.CancelButton },
                        ' ',
                        (0, _preact.h)('img', { onClick: this.removeFile, src: 'common/assets/images/Close_M.svg' }),
                        ' '
                    )
                ),
                this.state.fileIsUploading && (0, _preact.h)(
                    'div',
                    { className: _style2.default.Spinner },
                    ' ',
                    _ref,
                    ' '
                ),
                (0, _preact.h)('textarea', {
                    color: this.props.color,
                    onInput: this.handleTextareaInput,
                    onKeyup: this.handleTextareaKeyup,
                    onKeypress: this.handleTextareaKeypress,
                    value: this.state.value,
                    'class': _style2.default.ChatTextarea,
                    style: { height: this.state.filename ? '70%' : '100%' },
                    placeholder: this.props.language.get("SendAMessage"),
                    ref: function ref(chatTextareaDOM) {
                        _this6.chatTextareaDOM = chatTextareaDOM;
                    } })
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.ChatFooterButtons },
                (0, _preact.h)(_ChatFooterUploadButton2.default, {
                    color: this.props.color,
                    onChange: this._handleChange
                }),
                (0, _preact.h)(_ChatFooterEmojiButton2.default, { color: this.props.color }),
                (0, _preact.h)(_ChatFooterSendButton2.default, { color: this.props.color, onClick: this.sendMessage })
            ),
            (0, _preact.h)(_EmojiContainer2.default, { color: this.props.color, addToMessageValue: this.addEmoji })
        );
    };

    return ChatFooter;
}(_preact.Component);

function mapStateToProps(state) {
    var room = _model.TicketModel.getCurrentRoom(state);
    var language = _model.CustomizationModel.getLanguage(state);

    return {
        language: language,
        token: state.getIn(['user', 'token']),
        room: room,
        color: state.getIn(['customization', 'color']),
        onlineFormData: state.getIn(['ticket', 'onlineFormData'])
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps, null)(ChatFooter);

/***/ }),

/***/ "0DRr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ArrowLeft = function (_Component) {
    _inherits(ArrowLeft, _Component);

    function ArrowLeft() {
        _classCallCheck(this, ArrowLeft);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ArrowLeft.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42", width: "16", height: "16" },
            (0, _preact.h)("path", { fill: this.props.color, d: "M38.35,18H9C11.8,15.21,20,6.9,20.24,6.62c.39-.44,1.39-1.78.18-2.94a2.25,2.25,0,0,0-2.95-.23c-.39.31-15.62,15.43-15.62,15.43a2,2,0,0,0,0,3.18s15,14.82,15.64,15.34a2,2,0,0,0,2.86-.12,2,2,0,0,0-.1-3.06c-.39-.38-8.48-8.54-11.19-11.3H38.35a2.69,2.69,0,0,0,2.48-2.44A2.69,2.69,0,0,0,38.35,18Z" })
        );
    };

    return ArrowLeft;
}(_preact.Component);

exports.default = ArrowLeft;

/***/ }),

/***/ "0K3L":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var clean = __webpack_require__("nMX2");

/**
 * Export.
 */

module.exports = toSpaceCase;

/**
 * Convert a `string` to space case.
 *
 * @param {String} string
 * @return {String}
 */

function toSpaceCase(string) {
  return clean(string).replace(/[\W_]+(.|$)/g, function (matches, match) {
    return match ? ' ' + match : '';
  }).trim();
}

/***/ }),

/***/ "0ze8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__2aCy0","StartChattingButton":"StartChattingButton__1WND1","StartChattingText":"StartChattingText__1RKYW"};

/***/ }),

/***/ "1RYr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getScrollbarWidth;

var _domCss = __webpack_require__("PqSB");

var _domCss2 = _interopRequireDefault(_domCss);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

var scrollbarWidth = false;

function getScrollbarWidth() {
  if (scrollbarWidth !== false) return scrollbarWidth;
  /* istanbul ignore else */
  if (typeof document !== 'undefined') {
    var div = document.createElement('div');
    (0, _domCss2["default"])(div, {
      width: 100,
      height: 100,
      position: 'absolute',
      top: -9999,
      overflow: 'scroll',
      MsOverflowStyle: 'scrollbar'
    });
    document.body.appendChild(div);
    scrollbarWidth = div.offsetWidth - div.clientWidth;
    document.body.removeChild(div);
  } else {
    scrollbarWidth = 0;
  }
  return scrollbarWidth || 0;
}

/***/ }),

/***/ "1SMb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NewConversationButton":"NewConversationButton__DCdm8","NewConversationText":"NewConversationText__1b89Q","NewConversationWrapper":"NewConversationWrapper__2OEOT"};

/***/ }),

/***/ "1xei":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("I52i");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*https://icons8.com/cssload/en/horizontal-bars*/
var FountainDrops = function (_Component) {
    _inherits(FountainDrops, _Component);

    function FountainDrops() {
        _classCallCheck(this, FountainDrops);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    FountainDrops.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { id: _style2.default.fountainG },
            (0, _preact.h)('div', { id: _style2.default.fountainG_1, className: _style2.default.fountainG }),
            (0, _preact.h)('div', { id: _style2.default.fountainG_2, className: _style2.default.fountainG }),
            (0, _preact.h)('div', { id: _style2.default.fountainG_3, className: _style2.default.fountainG }),
            (0, _preact.h)('div', { id: _style2.default.fountainG_4, className: _style2.default.fountainG })
        );
    };

    return FountainDrops;
}(_preact.Component);

exports.default = FountainDrops;

/***/ }),

/***/ "2/Ia":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FileInputButton":"FileInputButton__3eJGc","FileName":"FileName__1TCF3","FileInput":"FileInput__3czDy","ChatFooterUploadButton":"ChatFooterUploadButton__9t6tj"};

/***/ }),

/***/ "2E51":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _ChatFooterUploadButton = __webpack_require__("2/Ia");

var _ChatFooterUploadButton2 = _interopRequireDefault(_ChatFooterUploadButton);

var _UploadFileIcon = __webpack_require__("XX8A");

var _UploadFileIcon2 = _interopRequireDefault(_UploadFileIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatFooterSendButton = function (_Component) {
    _inherits(ChatFooterSendButton, _Component);

    function ChatFooterSendButton() {
        _classCallCheck(this, ChatFooterSendButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            hover: false
        };
        return _this;
    }

    ChatFooterSendButton.prototype.onHover = function onHover(e) {
        this.setState({ hover: true });
    };

    ChatFooterSendButton.prototype.onHoverLeave = function onHoverLeave(e) {
        this.setState({ hover: false });
    };

    ChatFooterSendButton.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            {
                onMouseEnter: this.onHover.bind(this),
                onMouseLeave: this.onHoverLeave.bind(this),
                className: _ChatFooterUploadButton2.default.ChatFooterUploadButton },
            (0, _preact.h)('input', {
                onChange: this.props.onChange,
                className: _ChatFooterUploadButton2.default.FileInput,
                type: 'file',
                id: 'file'
            }),
            (0, _preact.h)(
                'label',
                { 'for': 'file', className: _ChatFooterUploadButton2.default.FileInputButton },
                (0, _preact.h)(_UploadFileIcon2.default, { active: this.state.hover, color: this.props.color })
            )
        );
    };

    return ChatFooterSendButton;
}(_preact.Component);

exports.default = ChatFooterSendButton;

/***/ }),

/***/ "2g6U":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"RightNav":"RightNav__ubTS7","LeftNav":"LeftNav__2xAf7","NavBtn":"NavBtn__1T_Kh","NavWrapper":"NavWrapper__D0TWr"};

/***/ }),

/***/ "2i1w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("DlyD");

var _style2 = _interopRequireDefault(_style);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _AutoMessage = __webpack_require__("O6gZ");

var _AutoMessage2 = _interopRequireDefault(_AutoMessage);

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            HeaderHeight: 0
        };
        return _this;
    }

    Header.prototype.render = function render() {
        var _props = this.props,
            company = _props.company,
            automessage = _props.automessage,
            features = _props.features,
            language = _props.language,
            name = _props.name;

        var hasFaq = features.get('hasFaq');
        var welcomeTo = language.get("WelcomeTo");

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Header },
                (0, _preact.h)(_Title2.default, { title: welcomeTo, body: name }),
                (0, _preact.h)(_AutoMessage2.default, { automessage: automessage }),
                _ref
            )
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    var name = _model4.default.getCompanyDisplayName(state);
    return {
        color: color,
        language: language,
        company: state.get('company'),
        automessage: state.getIn(['autoMessages', 'currentAutoMessage']),
        features: state.get('features'),
        system: state.get('system'),
        name: name
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "2wQW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"TimeLine":"TimeLine__1z_W4","TimeBody":"TimeBody__1GJa5","TimeMessage":"TimeMessage__3XzL3","MetaAutoResponse":"MetaAutoResponse__76K-I","MetaAutoResponseSendButton":"MetaAutoResponseSendButton__1aT1E","MetaAutoResponseSendConfirmButton":"MetaAutoResponseSendConfirmButton__RZLnh","MetaAutoResponseSendConfirmButtonDisable":"MetaAutoResponseSendConfirmButtonDisable__1OAA3","MetaOffline":"MetaOffline__WmaIg"};

/***/ }),

/***/ "3MPn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__1ZDae","StartChattingButton":"StartChattingButton__I2tfO","StartChattingText":"StartChattingText__17RJc","Header":"Header__2OHXa"};

/***/ }),

/***/ "3Yhk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

var _Message = __webpack_require__("eTtw");

var _Message2 = _interopRequireDefault(_Message);

var _style = __webpack_require__("gknL");

var _style2 = _interopRequireDefault(_style);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OnlineFormular = function (_Component) {
    _inherits(OnlineFormular, _Component);

    function OnlineFormular() {
        _classCallCheck(this, OnlineFormular);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    OnlineFormular.prototype.render = function render() {
        var forms = this.props.entry.meta.details.forms;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.MessageWrapper },
            (0, _preact.h)(
                'div',
                {
                    'class': 'message message--right message--single'
                },
                (0, _preact.h)(
                    'div',
                    { 'class': 'message__body' },
                    (0, _preact.h)(_TextDisplay2.default, { text: this.props.entry.entry_body })
                )
            )
        );
    };

    return OnlineFormular;
}(_preact.Component);

exports.default = OnlineFormular;

/***/ }),

/***/ "3rs2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Input":"Input__2hjGS","Textarea":"Textarea__jji5-","TextareaLabelHover":"TextareaLabelHover__3GOXE","TextareaLabel":"TextareaLabel__1qMoy","TextareaRequired":"TextareaRequired__35uAH","InputLabelHover":"InputLabelHover__X7UNP","InputLabel":"InputLabel__3A_v1","InputWrapper":"InputWrapper__Y1eW-","InputRequired":"InputRequired__1xFK8","InputRequiredMissing":"InputRequiredMissing__10tis","LabelRequiredMissing":"LabelRequiredMissing__1jKWm"};

/***/ }),

/***/ "4LjX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*https://icons8.com/cssload/en/horizontal-bars*/
var Faq = function (_Component) {
    _inherits(Faq, _Component);

    function Faq() {
        _classCallCheck(this, Faq);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Faq.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            width = _props.width,
            height = _props.height;

        return (0, _preact.h)(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 80 50" },
            (0, _preact.h)("path", { fill: color, d: "M23.8,11l-8.27.05A1.53,1.53,0,0,0,14,12.73s0,14.45,0,14.85c0,1.11.3,1.56,1.47,1.56,1,0,1.43-.56,1.43-1.49L17,21h5.54A1.39,1.39,0,0,0,24,19.53,1.46,1.46,0,0,0,22.5,18l-5.54,0V13.91l6.81,0c.82-.05,1.22-.59,1.22-1.46S24.64,11,23.8,11Z" }),
            (0, _preact.h)("path", { fill: color, d: "M59,3.1c5.74,0,9.9,4.58,9.9,10.9V26A10.91,10.91,0,0,1,58,36.9H14A10.91,10.91,0,0,1,3.12,26V14A10.91,10.91,0,0,1,14,3.1H59m-45,32H58a9.11,9.11,0,0,0,9.1-9.1V14A9.11,9.11,0,0,0,58,4.9H14A9.11,9.11,0,0,0,4.92,14V26A9.11,9.11,0,0,0,14,35.1" }),
            (0, _preact.h)("path", { fill: color, d: "M40.66,26.82c-.6-1.36-1.17-2.75-2.14-5.19-.1-.26-.26-.58-.36-.81C37,17.88,35.52,14,34.72,12.06A1.55,1.55,0,0,0,33,11a1.51,1.51,0,0,0-1.65,1c-1.8,4.59-2.74,6.84-3.2,8.05-.23.55-1.35,3.23-2.58,6a3.42,3.42,0,0,0-.44,1.49c0,1,.89,1.36,1.67,1.36s1.07-.5,1.35-1.21.77-2,1.05-2.78h7.56c.21.6.59,1.66,1.1,3a1.35,1.35,0,0,0,1.43,1,1.5,1.5,0,0,0,1.59-1.21A2.19,2.19,0,0,0,40.66,26.82ZM33,14.52c.46,1.34,2.29,6.31,2.73,7.5H30.21C30.66,20.87,32.45,16.22,33,14.52Z" }),
            (0, _preact.h)("path", { fill: color, d: "M58.6,27.7l-1.79-1.8.16-.15A9.25,9.25,0,0,0,59,20a8.72,8.72,0,0,0-8.45-9,8.72,8.72,0,0,0-8.45,9,8.72,8.72,0,0,0,8.45,9,8,8,0,0,0,4.28-1.26L56.7,29.6a1.34,1.34,0,1,0,1.9-1.9ZM51,26a5.75,5.75,0,0,1-6.07-6c0-3.37,2.61-6,5.29-6a5.59,5.59,0,0,1,5.84,5.79,7,7,0,0,1-1.1,4l-.19.16-1.45-1.45a1.34,1.34,0,0,0-1.9,1.9l1.23,1.23A6,6,0,0,1,51,26Z" })
        );
    };

    return Faq;
}(_preact.Component);

exports.default = Faq;

/***/ }),

/***/ "5ASY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var containerStyleDefault = exports.containerStyleDefault = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: '100%'
};

// Overrides containerStyleDefault properties
var containerStyleAutoHeight = exports.containerStyleAutoHeight = {
  height: 'auto'
};

var viewStyleDefault = exports.viewStyleDefault = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'scroll',
  WebkitOverflowScrolling: 'touch'
};

// Overrides viewStyleDefault properties
var viewStyleAutoHeight = exports.viewStyleAutoHeight = {
  position: 'relative',
  top: undefined,
  left: undefined,
  right: undefined,
  bottom: undefined
};

var viewStyleUniversalInitial = exports.viewStyleUniversalInitial = {
  overflow: 'hidden',
  marginRight: 0,
  marginBottom: 0
};

var trackHorizontalStyleDefault = exports.trackHorizontalStyleDefault = {
  position: 'absolute',
  height: 6
};

var trackVerticalStyleDefault = exports.trackVerticalStyleDefault = {
  position: 'absolute',
  width: 6
};

var thumbHorizontalStyleDefault = exports.thumbHorizontalStyleDefault = {
  position: 'relative',
  display: 'block',
  height: '100%'
};

var thumbVerticalStyleDefault = exports.thumbVerticalStyleDefault = {
  position: 'relative',
  display: 'block',
  width: '100%'
};

var disableSelectStyle = exports.disableSelectStyle = {
  userSelect: 'none'
};

var disableSelectStyleReset = exports.disableSelectStyleReset = {
  userSelect: ''
};

/***/ }),

/***/ "5MAO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SearchIcon":"SearchIcon__3ECd_","InputWrapper":"InputWrapper__3NV_1","InputSearch":"InputSearch__WQ8Vw","FAQList":"FAQList__z90-Q","FAQNotFound":"FAQNotFound__2OcFf","ItemQuestion":"ItemQuestion__3rBBu","ItemAnswer":"ItemAnswer__1D9C5","ItemWrapper":"ItemWrapper__2IpdQ","ArrowDown":"ArrowDown__8bFXc","ArrowUp":"ArrowUp__14WuA","ellipsis":"ellipsis__24Oss"};

/***/ }),

/***/ "5T05":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _style = __webpack_require__("ngBf");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("9VrP");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("2YDt");

var _model6 = _interopRequireDefault(_model5);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

var _Feedback = __webpack_require__("d04+");

var _Feedback2 = _interopRequireDefault(_Feedback);

var _DateTime = __webpack_require__("VN4q");

var _DateTime2 = _interopRequireDefault(_DateTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var REQUEST_STATES = {
    LOADING: 'loading',
    FAIL: 'fail',
    SUCCESS: 'success'
};

var HelpDeskArticle = function (_Component) {
    _inherits(HelpDeskArticle, _Component);

    function HelpDeskArticle(props) {
        _classCallCheck(this, HelpDeskArticle);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this._goBack = _this._goBack.bind(_this);
        _this._handleRequest = _this._handleRequest.bind(_this);

        _this.state = {
            xTranslation: -5,
            opacity: 0,
            requestState: REQUEST_STATES.LOADING,
            articleTitle: '',
            articleContent: '',
            authorImg: '',
            authorName: '',
            dateModified: ''
        };
        return _this;
    }

    HelpDeskArticle.prototype._handleRequest = function _handleRequest(payload, status) {
        var _this2 = this;

        if (status !== '200') {
            this.setState({ requestState: REQUEST_STATES.FAIL });
        } else {
            var _payload$faq = payload.faq,
                question = _payload$faq.question,
                answer = _payload$faq.answer,
                author_img = _payload$faq.author_img,
                author_name = _payload$faq.author_name,
                date_modified = _payload$faq.date_modified;


            this.setState({
                articleContent: answer,
                articleTitle: question,
                authorImg: author_img,
                authorName: author_name,
                dateModified: date_modified,
                requestState: REQUEST_STATES.SUCCESS
            });
            setTimeout(function () {
                return _this2.setState({ xTranslation: 0, opacity: 1 });
            }, 0);
        }
    };

    HelpDeskArticle.prototype.componentDidMount = function componentDidMount() {
        this.setState({ requestState: REQUEST_STATES.LOADING });
        _model4.default.requestFAQArticle(this.props.articleId, this._handleRequest);
    };

    HelpDeskArticle.prototype._renderText = function _renderText() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.ArticleTextContainer },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Title },
                ' ',
                this.state.articleTitle,
                ' '
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.BodyText },
                (0, _preact.h)(_TextDisplay2.default, { text: this.state.articleContent })
            )
        );
    };

    HelpDeskArticle.prototype._renderProfile = function _renderProfile() {
        var _state = this.state,
            authorName = _state.authorName,
            authorImg = _state.authorImg,
            dateModified = _state.dateModified;

        var niceDate = _DateTime2.default.getDetailedNiceDate(dateModified);
        var placeholder = false;

        if (authorImg === '/images/employee-avatar.png') {
            placeholder = true;
        }

        return (0, _preact.h)(
            'div',
            null,
            authorImg && !placeholder && (0, _preact.h)('img', { className: _style2.default.ProfilePicture,
                src: this.state.authorImg }),
            (0, _preact.h)(
                'div',
                { className: _style2.default.ProfileMetaText },
                authorName && (0, _preact.h)(
                    'div',
                    null,
                    ' Skriven av: ',
                    authorName,
                    ' '
                ),
                (0, _preact.h)(
                    'div',
                    null,
                    ' Uppdaterad: ',
                    niceDate,
                    ' '
                )
            )
        );
    };

    HelpDeskArticle.prototype._goBack = function _goBack() {
        var activeCategory = this.props.activeCategory;
        if (activeCategory === '-1') {
            this.props.dispatch(_model2.default.setHelpDeskRoute('HelpDeskSearch'));
        } else {
            this.props.dispatch(_model2.default.setHelpDeskRoute('HelpDeskFocused', activeCategory));
        }
    };

    HelpDeskArticle.prototype.render = function render() {
        var _state2 = this.state,
            xTranslation = _state2.xTranslation,
            opacity = _state2.opacity,
            requestState = _state2.requestState,
            dateModified = _state2.dateModified;
        var _props = this.props,
            language = _props.language,
            articleId = _props.articleId;


        if (requestState === REQUEST_STATES.LOADING) return null;

        var article = '';
        switch (requestState) {
            case REQUEST_STATES.FAIL:
                article = (0, _preact.h)(
                    'div',
                    { className: _style2.default.ErrorText },
                    ' ',
                    language.get('ArticleFetchError'),
                    ' '
                );
                break;
            default:
                article = (0, _preact.h)(
                    'div',
                    { className: _style2.default.ArticleContainer, style: { transform: 'translateX(' + xTranslation + 'px)', opacity: opacity } },
                    this._renderText(),
                    this._renderProfile(),
                    (0, _preact.h)(
                        'div',
                        { className: _style2.default.BackLink, onClick: this._goBack },
                        '< ' + language.get('BackButton')
                    )
                );
                break;
        }

        return (0, _preact.h)(
            'div',
            { className: _style2.default.ArticlePage, style: { height: this.props.height + 'px' } },
            article,
            requestState !== REQUEST_STATES.FAIL ? (0, _preact.h)(_Feedback2.default, { articleId: articleId, dateModified: dateModified }) : null
        );
    };

    return HelpDeskArticle;
}(_preact.Component);

function mapStateToProps(state) {
    var fullRoute = _model2.default.getHelpDeskRoute(state).split(';');
    var articleId = fullRoute[2];
    var activeCategory = fullRoute[1];
    return {
        height: _model2.default.getBodyHeight(state),
        activeCategory: activeCategory,
        articleId: articleId,
        language: _model6.default.getLanguage(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(HelpDeskArticle);

/***/ }),

/***/ "62F2":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"GDPRButtonWrapper":"GDPRButtonWrapper__3RXnx","GDPRButton":"GDPRButton__rfpWu","GDPRPromptText":"GDPRPromptText__2_hXB"};

/***/ }),

/***/ "63ec":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Request = __webpack_require__("G7eB");
var extractResponseProps = __webpack_require__("Oqyg");

function Response(props) {
  this.request = props.request;
  this.xhr = props.xhr;
  this.headers = props.headers || {};
  this.status = props.status || 0;
  this.text = props.text;
  this.body = props.body;
  this.contentType = props.contentType;
  this.isHttpError = props.status >= 400;
}

Response.prototype.header = Request.prototype.header;

Response.fromRequest = function (req) {
  return new Response(extractResponseProps(req));
};

module.exports = Response;

/***/ }),

/***/ "6AAI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderRightToolBelt = function (_Component) {
    _inherits(HeaderRightToolBelt, _Component);

    function HeaderRightToolBelt() {
        _classCallCheck(this, HeaderRightToolBelt);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    HeaderRightToolBelt.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { style: {
                    position: 'absolute',
                    right: '15px',
                    top: '7px',
                    paddingTop: '-3px',
                    height: '23px'
                } },
            this.props.children
        );
    };

    return HeaderRightToolBelt;
}(_preact.Component);

exports.default = HeaderRightToolBelt;

/***/ }),

/***/ "6ES8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _reactEmojiRender = __webpack_require__("Stiw");

var _redux = __webpack_require__("2KeS");

var _actionSetEmojiContainerIsDisplayed = __webpack_require__("pjGl");

var _actionSetEmojiContainerIsDisplayed2 = _interopRequireDefault(_actionSetEmojiContainerIsDisplayed);

var _style = __webpack_require__("zjtR");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Redux


var EmojiContainer = function (_Component) {
    _inherits(EmojiContainer, _Component);

    function EmojiContainer() {
        _classCallCheck(this, EmojiContainer);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleEmojiClick = _this.handleEmojiClick.bind(_this);
        _this.handleOutsideClick = _this.handleOutsideClick.bind(_this);
        return _this;
    }

    EmojiContainer.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (this.props.emoji.get('isEmojiContainerDisplayed')) {
            document.addEventListener('click', this.handleOutsideClick, false);
            this.outsideClickCount = 0;
        } else {
            document.removeEventListener('click', this.handleOutsideClick, false);
        }
    };

    EmojiContainer.prototype.render = function render() {
        var _this2 = this;

        var emoji = this.props.emoji;
        var isDisplayed = emoji.get('isEmojiContainerDisplayed');

        var display = 'none';
        if (isDisplayed) {
            display = 'block';
        }
        var lst = ["🙂", "😃", "😄", "😐", "😦", "😔", "😬", "🤔", "😫", "😤", "😠", "👋", "👌", "👍", "👎", "🤝"];

        return (0, _preact.h)(
            'div',
            { 'class': _style2.default.Container, style: { display: display }, ref: function ref(body) {
                    _this2.body = body;
                } },
            lst.map(function (text, index) {
                return (0, _preact.h)(_reactEmojiRender.Twemoji, {
                    svg: true,
                    text: text,
                    key: index,
                    onlyEmojiClassName: _style2.default.Emoji,
                    onClick: _this2.handleEmojiClick
                });
            })
        );
    };

    EmojiContainer.prototype.handleEmojiClick = function handleEmojiClick(e) {
        if (e.target.alt != undefined) {
            // If user presses just between emojis, treat it like nothing happened
            var emojiString = e.target.alt;
            this.props.addToMessageValue(emojiString);
            if (!e.shiftKey) {
                // If shift-button is held while pressing, don't close the emojidrawer
                this.closeEmojiContainer();
            }
        }
    };

    EmojiContainer.prototype.handleOutsideClick = function handleOutsideClick(e) {
        if (!this.body) return;
        var emoji = this.props.emoji;
        this.outsideClickCount += 1;
        if (!this.body.contains(e.target) && this.outsideClickCount > 1) {
            this.closeEmojiContainer();
        }
    };

    EmojiContainer.prototype.addEmojiToTextareaValue = function addEmojiToTextareaValue(emojiString) {
        var currentTextareaValue = this.props.inputs.get('chatTextareaValue');
    };

    EmojiContainer.prototype.closeEmojiContainer = function closeEmojiContainer() {
        this.props.actionSetEmojiContainerIsDisplayed(false);
    };

    return EmojiContainer;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        emoji: state.get('emoji'),
        inputs: state.get('inputs')
    };
}

function matchDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        actionSetEmojiContainerIsDisplayed: _actionSetEmojiContainerIsDisplayed2.default
    }, dispatch);
}

exports.default = (0, _preactRedux.connect)(mapStateToProps, matchDispatchToProps)(EmojiContainer);

/***/ }),

/***/ "6UoE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Wrap a function in a `setTimeout` call. This is used to guarantee async
// behavior, which can avoid unexpected errors.

module.exports = function (fn) {
  return function () {
    var args = Array.prototype.slice.call(arguments, 0),
        newFunc = function newFunc() {
      return fn.apply(null, args);
    };
    setTimeout(newFunc, 0);
  };
};

/***/ }),

/***/ "6Xo/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ratingContainer":"ratingContainer__1zFxi","rating":"rating__M673J","ratingTitle":"ratingTitle__EN3zK","star":"star__OZN7a","star-rating":"star-rating__UH6sF"};

/***/ }),

/***/ "7WtF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CategoryContainer":"CategoryContainer__1bq6I","ClickSurface":"ClickSurface__6nb1Z","CategoryText":"CategoryText__NqUdm","ImageWrapper":"ImageWrapper__2cIS9","CategoryIcon":"CategoryIcon__3pU8P"};

/***/ }),

/***/ "7suT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var wrappy = __webpack_require__("G0LE");
module.exports = wrappy(once);
module.exports.strict = wrappy(onceStrict);

once.proto = once(function () {
  Object.defineProperty(Function.prototype, 'once', {
    value: function value() {
      return once(this);
    },
    configurable: true
  });

  Object.defineProperty(Function.prototype, 'onceStrict', {
    value: function value() {
      return onceStrict(this);
    },
    configurable: true
  });
});

function once(fn) {
  var f = function f() {
    if (f.called) return f.value;
    f.called = true;
    return f.value = fn.apply(this, arguments);
  };
  f.called = false;
  return f;
}

function onceStrict(fn) {
  var f = function f() {
    if (f.called) throw new Error(f.onceError);
    f.called = true;
    return f.value = fn.apply(this, arguments);
  };
  var name = fn.name || 'Function wrapped with `once`';
  f.onceError = name + " shouldn't be called more than once";
  f.called = false;
  return f;
}

/***/ }),

/***/ "8Yot":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _DateTime = __webpack_require__("uRCp");

var _DateTime2 = _interopRequireDefault(_DateTime);

var _lang = __webpack_require__("r3oa");

var _lang2 = _interopRequireDefault(_lang);

var _style = __webpack_require__("2wQW");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

var _model2 = __webpack_require__("2YDt");

var _model3 = _interopRequireDefault(_model2);

var _preactRedux = __webpack_require__("1AcT");

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoresponseMetaMessage = function (_Component) {
    _inherits(AutoresponseMetaMessage, _Component);

    function AutoresponseMetaMessage(props) {
        _classCallCheck(this, AutoresponseMetaMessage);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            inputHover: false,
            buttonHover: false,
            value: props.user.email
        };
        _this.renderEmailField = _this.renderEmailField.bind(_this);
        _this.renderEmailExist = _this.renderEmailExist.bind(_this);
        _this.renderEmailNotExist = _this.renderEmailNotExist.bind(_this);
        _this.confirmReplyByEmail = _this.confirmReplyByEmail.bind(_this);
        return _this;
    }

    AutoresponseMetaMessage.prototype.confirmReplyByEmail = function confirmReplyByEmail() {
        this.props.dispatch(_model.TicketModel.responseToAutoresponse({
            'email': this.state.value,
            'reply_by_email': true
        }, this.props.entry.id));
    };

    AutoresponseMetaMessage.prototype.renderEmailField = function renderEmailField(text, onClick) {
        var _this2 = this;

        var entry = this.props.entry;
        var meta = entry.meta;
        var active = this.state.value || this.state.inputHover;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.MetaAutoResponse },
            text,
            (0, _preact.h)('input', {
                type: 'text',
                style: active && {
                    border: '1px solid',
                    color: this.props.color
                },
                onMouseEnter: function onMouseEnter() {
                    return _this2.setState({ inputHover: true });
                },
                onMouseLeave: function onMouseLeave() {
                    return _this2.setState({ inputHover: false });
                },
                placeholder: 'Email',
                value: this.state.value,
                onInput: function onInput(event) {
                    return _this2.setState({ value: event.target.value });
                },
                onKeypress: function onKeypress(event) {
                    if (event.keyCode === 13) {
                        onClick();
                    }
                }
            }),
            onClick && (0, _preact.h)(
                'div',
                {
                    onClick: onClick,
                    className: _style2.default.MetaAutoResponseSendButton },
                (0, _preact.h)('img', {
                    style: active && {
                        backgroundColor: this.props.color
                    },
                    src: '/common/assets/images/ClientChat_Icon_Send.png' })
            )
        );
    };

    AutoresponseMetaMessage.prototype.renderInactiveField = function renderInactiveField(text, email) {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.MetaAutoResponse },
            text,
            (0, _preact.h)('input', {
                type: 'text',
                style: {
                    border: '1px solid lightgrey',
                    color: 'grey'
                },
                value: email,
                disabled: true
            })
        );
    };

    AutoresponseMetaMessage.prototype.renderEmailNotExist = function renderEmailNotExist(responded, respond_data) {
        var _this3 = this;

        var text = this.props.language.get("AutoresponseEmailRequest");
        if (responded) {
            return (0, _preact.h)(
                'div',
                null,
                this.renderInactiveField(text, respond_data.email),
                (0, _preact.h)(
                    'div',
                    {
                        className: 'meta-message' },
                    this.props.language.get("AutoresponseCustomerReplyByEmail")
                )
            );
        }
        return this.renderEmailField(text, function () {
            _this3.confirmReplyByEmail();
        });
    };

    AutoresponseMetaMessage.prototype.renderEmailExist = function renderEmailExist(responded, respond_data) {
        var _this4 = this;

        var text = this.props.language.get("AutoresponseEmailSendConfirm");

        var emailField = void 0;

        if (responded) {
            return (0, _preact.h)(
                'div',
                null,
                this.renderInactiveField(text, respond_data.email),
                (0, _preact.h)(
                    'div',
                    {
                        className: _style2.default.MetaAutoResponseSendConfirmButtonDisable },
                    this.props.language.get("YesPleaseSendEmail")
                ),
                (0, _preact.h)(
                    'div',
                    {
                        className: 'meta-message' },
                    this.props.language.get("AutoresponseCustomerReplyByEmail")
                )
            );
        } else {
            return (0, _preact.h)(
                'div',
                null,
                this.renderEmailField(text, function () {
                    _this4.confirmReplyByEmail();
                }),
                (0, _preact.h)(
                    'div',
                    {
                        style: this.state.buttonHover && !responded && {
                            backgroundColor: this.props.color,
                            color: 'white'
                        },
                        onClick: function onClick() {
                            _this4.confirmReplyByEmail();
                        },
                        onMouseEnter: function onMouseEnter() {
                            return _this4.setState({ buttonHover: true });
                        },
                        onMouseLeave: function onMouseLeave() {
                            return _this4.setState({ buttonHover: false });
                        },
                        className: _style2.default.MetaAutoResponseSendConfirmButton },
                    this.props.language.get("YesPleaseSendEmail")
                )
            );
        }
    };

    AutoresponseMetaMessage.prototype.render = function render() {
        var entry = this.props.entry;
        var meta = entry.meta;
        var responded = meta.details.responded;
        var respond_data = meta.details.respond_data;

        switch (meta.details.type) {
            case 'email_exist':
                return this.renderEmailExist(responded, respond_data);
            case 'email_not_exist':
                return this.renderEmailNotExist(responded, respond_data);
            default:
                return null;
        }
    };

    return AutoresponseMetaMessage;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        language: _model3.default.getLanguage(state),
        color: _model3.default.getColor(state),
        room: _model.TicketModel.getCurrentRoom(state)
    };
})(AutoresponseMetaMessage);

/***/ }),

/***/ "8d6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _Header = __webpack_require__("X0Jh");

var _Header2 = _interopRequireDefault(_Header);

var _ChatBody = __webpack_require__("Bbo7");

var _ChatBody2 = _interopRequireDefault(_ChatBody);

var _ChatFooter = __webpack_require__("0A9V");

var _ChatFooter2 = _interopRequireDefault(_ChatFooter);

var _NewConversationButton = __webpack_require__("92gr");

var _NewConversationButton2 = _interopRequireDefault(_NewConversationButton);

var _model = __webpack_require__("lmuV");

var _Rating = __webpack_require__("cbmj");

var _Rating2 = _interopRequireDefault(_Rating);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_NewConversationButton2.default, null);

var _ref2 = (0, _preact.h)(_Rating2.default, null);

var _ref3 = (0, _preact.h)(_ChatBody2.default, null);

var _ref4 = (0, _preact.h)(_ChatFooter2.default, null);

var Chat = function (_Component) {
    _inherits(Chat, _Component);

    function Chat(props) {
        _classCallCheck(this, Chat);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            isResolved: false
        };
        return _this;
    }

    Chat.prototype.componentWillUnmount = function componentWillUnmount() {
        //this.props.dispatch(TicketModel.setCurrentRoom(''))
    };

    Chat.prototype.componentDidMount = function componentDidMount() {
        if (this.props.room) {
            // because of cookie
            this.props.dispatch(_model.TicketModel.requestEntriesGet(this.props.room));
            if (this.props.unread) {
                this.props.dispatch(_model.TicketModel.requestSetTicketToRead(this.props.room));
            }
        }
    };

    Chat.prototype.renderNewConversationButton = function renderNewConversationButton() {
        if (!this.props.ticket) return;
        if (this.props.ticket.get('is_resolved')) return _ref;
        return null;
    };

    Chat.prototype.renderRating = function renderRating() {
        if (!this.props.ticket) return;
        if (this.props.ticket.get('is_resolved')) return _ref2;
        return null;
    };

    Chat.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            null,
            this.props.ratingOn ? this.renderRating() : null /*Only render stars if rating feature is turned on*/,
            _ref3,
            _ref4,
            this.renderNewConversationButton()
        );
    };

    return Chat;
}(_preact.Component);

function mapStateToProps(state) {
    var ratingOn = _model.CustomizationModel.getRatingStatus(state);
    var room = _model.TicketModel.getCurrentRoom(state);
    var ticket = _model.TicketModel.get(room, state);
    var unread = _model.TicketModel.getUnread(room, state);

    return { ratingOn: ratingOn, room: room, ticket: ticket, unread: unread };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Chat);

/***/ }),

/***/ "92gr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("1SMb");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

var _model2 = __webpack_require__("2YDt");

var _model3 = _interopRequireDefault(_model2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var ResumeConversationButton = function (_Component) {
    _inherits(ResumeConversationButton, _Component);

    function ResumeConversationButton() {
        _classCallCheck(this, ResumeConversationButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    ResumeConversationButton.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.NewConversationWrapper },
            (0, _preact.h)(
                'div',
                { style: {
                        width: '100%',
                        position: 'absolute',
                        height: '65px',
                        bottom: '0px',
                        backgroundColor: 'rgba(255, 255, 255, 0.5)'
                    } },
                (0, _preact.h)(
                    'div',
                    {
                        className: _style2.default.NewConversationButton,
                        style: { backgroundColor: this.props.color },
                        onClick: this.handleClick },
                    (0, _preact.h)(
                        'div',
                        { className: _style2.default.NewConversationText },
                        this.props.language.get("ResumeChatting")
                    )
                )
            )
        );
    };

    ResumeConversationButton.prototype.handleClick = function handleClick() {
        this.props.dispatch(_model.TicketModel.requestReopenTicket(this.props.room));
    };

    return ResumeConversationButton;
}(_preact.Component);

function mapStateToProps(state) {
    var language = _model3.default.getLanguage(state);
    var color = _model3.default.getColor(state);
    var room = _model.TicketModel.getCurrentRoom(state);
    return {
        room: room, language: language, color: color
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(ResumeConversationButton);

/***/ }),

/***/ "9C9F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ConversationsList":"ConversationsList__3e715","ConversationSeparation":"ConversationSeparation__1r3kR"};

/***/ }),

/***/ "9bxs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _immutable = __webpack_require__("BYKG");

var _model = __webpack_require__("lmuV");

var _model2 = __webpack_require__("2YDt");

var _model3 = _interopRequireDefault(_model2);

var _Message = __webpack_require__("eTtw");

var _Message2 = _interopRequireDefault(_Message);

var _MetaMessage = __webpack_require__("SgI6");

var _MetaMessage2 = _interopRequireDefault(_MetaMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MessageList = function (_Component) {
    _inherits(MessageList, _Component);

    function MessageList() {
        _classCallCheck(this, MessageList);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    MessageList.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { 'class': 'message-list' },
            this.props.room && this.renderMessageList().toJS()
        );
    };

    MessageList.prototype.renderMessageList = function renderMessageList() {
        var _this2 = this;

        // we got this when we in a new conversation
        var entries = this.props.entries;
        if (!entries || !entries.size) return (0, _immutable.Map)();
        var visitor = this.props.visitor;
        return entries.map(function (entry, index) {
            if (!entry) return null;
            var meta = entry.get('meta');
            // we work with online_formular normaly
            if (meta && meta.get('type') !== 'online_formular') {
                return (0, _preact.h)(_MetaMessage2.default, {
                    entry: _model.TicketModel.__digestMetaEntry(entry),
                    user: visitor
                });
            }
            return (0, _preact.h)(_Message2.default, {
                entry: entry,
                index: index,
                color: _this2.props.color,
                visitor: _this2.props.visitor,
                conversation: _this2.props.conversation,
                employees: _this2.props.employees,

                previousEntry: entries.get(index - 1),
                nextEntry: entries.get(index + 1)
            });
        });
    };

    return MessageList;
}(_preact.Component);

function mapStateToProps(state) {
    var room = _model.TicketModel.getCurrentRoom(state);
    var entries = _model.TicketModel.getEntries(room, state);
    var conversation = _model.TicketModel.get(room, state);
    var employees = state.getIn(['company', 'employees']);
    var color = _model3.default.getColor(state);
    var visitor = state.get('user');
    return { entries: entries, color: color, visitor: visitor, conversation: conversation, employees: employees, room: room };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(MessageList);

/***/ }),

/***/ "9fbE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__1RFHz"};

/***/ }),

/***/ "9rLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _GDPROverlay = __webpack_require__("62F2");

var _GDPROverlay2 = _interopRequireDefault(_GDPROverlay);

var _style = __webpack_require__("0ze8");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

var _Button = __webpack_require__("AO3P");

var _Button2 = _interopRequireDefault(_Button);

var _CheckboxInput = __webpack_require__("rALM");

var _CheckboxInput2 = _interopRequireDefault(_CheckboxInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_PoweredByJibber2.default, null);

var GDPROverlay = function (_Component) {
  _inherits(GDPROverlay, _Component);

  function GDPROverlay(props) {
    _classCallCheck(this, GDPROverlay);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.state = {
      GDPRCheckBox: false
    };
    return _this;
  }

  GDPROverlay.prototype.render = function render() {
    var _this2 = this;

    if (this.props.gdprRequire && !this.props.acceptedGDPR) {
      var GDPRPromptText = this.props.language.get("GDPRPrompt");
      return (0, _preact.h)(
        "div",
        { className: _style2.default.Body },
        (0, _preact.h)(
          "div",
          { className: _GDPROverlay2.default.GDPRPromptText },
          (0, _preact.h)(_CheckboxInput2.default, {
            value: this.state.GDPRCheckBox,
            onChange: function onChange(value) {
              return _this2.setState({ GDPRCheckBox: value });
            },
            label: GDPRPromptText
          })
        ),
        (0, _preact.h)(_Button2.default, { disabled: !this.state.GDPRCheckBox }),
        _ref
      );
    }

    return this.props.children[0];
  };

  return GDPROverlay;
}(_preact.Component);

function mapStateToProps(state) {
  var acceptedGDPR = _model.UserModel.getAcceptedGDPR(state);
  var language = _model.CustomizationModel.getLanguage(state);
  var gdprRequire = _model.FeaturesModel.getGdprRequire(state);

  var user = _model.UserModel.get(state);
  return { acceptedGDPR: acceptedGDPR, user: user, language: language, gdprRequire: gdprRequire };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(GDPROverlay);

/***/ }),

/***/ "A+Mm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__1aduc","Body":"Body__1FCgX","Component":"Component__HYRVa","Button":"Button__1wud2","Rounded":"Rounded__MnLg3"};

/***/ }),

/***/ "AO3P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("0ze8");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// this is a copy from StartChatting Button

var StartChattingButton = function (_Component) {
  _inherits(StartChattingButton, _Component);

  function StartChattingButton(props) {
    _classCallCheck(this, StartChattingButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this.handleStartChatClick = _this.handleStartChatClick.bind(_this);
    return _this;
  }

  StartChattingButton.prototype.handleStartChatClick = function handleStartChatClick() {
    if (this.props.disabled) return; // if disabled do not answer
    this.props.dispatch(_model.UserModel.requestSetUserAcceptedGDPR());
    if (this.props.formsRequire || this.props.isOffline) {
      this.props.dispatch(_model.SystemModel.setRoute("StartChatting"));
    } else if (this.props.conversations.isEmpty()) {
      this.props.dispatch(_model.SystemModel.setRoute("Chat"));
    } else {
      this.props.dispatch(_model.SystemModel.setRoute("Conversations"));
    }
  };

  StartChattingButton.prototype.render = function render() {
    //20px for Powered by Jibber label
    var bodyHeight = this.props.height - 35;
    var bodyHeightPx = bodyHeight + "px";
    var bodyWidth = this.props.width;
    var language = this.props.language;

    var text = language.get("StartChatting");

    var size = bodyHeight > bodyWidth ? bodyWidth / 2 : bodyHeight / 2;
    size += 30;
    var height = size;
    var width = size;
    var borderRadius = size;
    var heightPx = height - 40 + "px";
    var widthPx = width - 40 + "px";
    var marginTop = bodyHeight / 2 - size / 2 + 20 + "px";
    var fontSize = "20px";
    var hoverStyle = " hvr-grow";
    if (bodyHeight < 260) {
      heightPx = "55px";
      widthPx = "50%";
      borderRadius = "60px";
      marginTop = height / 2 + "px";
      hoverStyle = " ";
    }
    return (0, _preact.h)(
      "div",
      {
        className: _style2.default.StartChattingButtonWrapper,
        style: { height: bodyHeightPx }
      },
      (0, _preact.h)(
        "div",
        {
          className: _style2.default.StartChattingButton + hoverStyle,
          onClick: this.handleStartChatClick,
          style: {
            cursor: this.props.disabled ? "not-allowed" : "pointer",
            opacity: this.props.disabled ? 0.3 : 1,
            marginTop: marginTop,
            backgroundColor: this.props.color,
            width: widthPx,
            height: heightPx,
            lineHeight: heightPx,
            borderRadius: borderRadius,
            fontSize: fontSize
          }
        },
        (0, _preact.h)(
          "span",
          { className: _style2.default.StartChattingText },
          " ",
          text,
          " "
        )
      )
    );
  };

  return StartChattingButton;
}(_preact.Component);

function mapStateToProps(state) {
  var color = _model.CustomizationModel.getColor(state);
  var language = _model.CustomizationModel.getLanguage(state);
  var conversations = _model.TicketModel.getAll(state);
  return {
    height: _model.SystemModel.getBodyHeight(state),
    width: _model.SystemModel.getShellWidth(state),
    user: _model.UserModel.get(state).toJS(),
    conversations: conversations,
    color: color,
    language: language,
    // need this for the default case, this will just imitate the default button click as if there was no gdpr form, check if case in button click
    formsRequire: _model.CustomizationModel.getFormsRequire(state),
    isOffline: _model.CompanyModel.isOffline(state)
  };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(StartChattingButton);

/***/ }),

/***/ "AX2D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.__spread = exports.unstable_renderSubtreeIntoContainer = exports.PureComponent = exports.Component = exports.unmountComponentAtNode = exports.findDOMNode = exports.isValidElement = exports.cloneElement = exports.createElement = exports.createFactory = exports.createClass = exports.render = exports.Children = exports.PropTypes = exports.DOM = exports.version = undefined;

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _preact = __webpack_require__("EBst");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var version = '15.1.0'; // trick libraries to think we are react

var ELEMENTS = 'a abbr address area article aside audio b base bdi bdo big blockquote body br button canvas caption cite code col colgroup data datalist dd del details dfn dialog div dl dt em embed fieldset figcaption figure footer form h1 h2 h3 h4 h5 h6 head header hgroup hr html i iframe img input ins kbd keygen label legend li link main map mark menu menuitem meta meter nav noscript object ol optgroup option output p param picture pre progress q rp rt ruby s samp script section select small source span strong style sub summary sup table tbody td textarea tfoot th thead time title tr track u ul var video wbr circle clipPath defs ellipse g image line linearGradient mask path pattern polygon polyline radialGradient rect stop svg text tspan'.split(' ');

var REACT_ELEMENT_TYPE = typeof Symbol !== 'undefined' && Symbol.for && Symbol.for('react.element') || 0xeac7;

var COMPONENT_WRAPPER_KEY = typeof Symbol !== 'undefined' && Symbol.for ? Symbol.for('__preactCompatWrapper') : '__preactCompatWrapper';

// don't autobind these methods since they already have guaranteed context.
var AUTOBIND_BLACKLIST = {
	constructor: 1,
	render: 1,
	shouldComponentUpdate: 1,
	componentWillReceiveProps: 1,
	componentWillUpdate: 1,
	componentDidUpdate: 1,
	componentWillMount: 1,
	componentDidMount: 1,
	componentWillUnmount: 1,
	componentDidUnmount: 1
};

var CAMEL_PROPS = /^(?:accent|alignment|arabic|baseline|cap|clip|color|fill|flood|font|glyph|horiz|marker|overline|paint|stop|strikethrough|stroke|text|underline|unicode|units|v|vector|vert|word|writing|x)[A-Z]/;

var BYPASS_HOOK = {};

/*global process*/
var DEV = typeof process === 'undefined' || !process.env || "production" !== 'production';

// a component that renders nothing. Used to replace components for unmountComponentAtNode.
function EmptyComponent() {
	return null;
}

// make react think we're react.
var VNode = (0, _preact.h)('a', null).constructor;
VNode.prototype.$$typeof = REACT_ELEMENT_TYPE;
VNode.prototype.preactCompatUpgraded = false;
VNode.prototype.preactCompatNormalized = false;

Object.defineProperty(VNode.prototype, 'type', {
	get: function get() {
		return this.nodeName;
	},
	set: function set(v) {
		this.nodeName = v;
	},
	configurable: true
});

Object.defineProperty(VNode.prototype, 'props', {
	get: function get() {
		return this.attributes;
	},
	set: function set(v) {
		this.attributes = v;
	},
	configurable: true
});

var oldEventHook = _preact.options.event;
_preact.options.event = function (e) {
	if (oldEventHook) {
		e = oldEventHook(e);
	}
	e.persist = Object;
	e.nativeEvent = e;
	return e;
};

var oldVnodeHook = _preact.options.vnode;
_preact.options.vnode = function (vnode) {
	if (!vnode.preactCompatUpgraded) {
		vnode.preactCompatUpgraded = true;

		var tag = vnode.nodeName,
		    attrs = vnode.attributes = extend({}, vnode.attributes);

		if (typeof tag === 'function') {
			if (tag[COMPONENT_WRAPPER_KEY] === true || tag.prototype && 'isReactComponent' in tag.prototype) {
				if (vnode.children && String(vnode.children) === '') {
					vnode.children = undefined;
				}
				if (vnode.children) {
					attrs.children = vnode.children;
				}

				if (!vnode.preactCompatNormalized) {
					normalizeVNode(vnode);
				}
				handleComponentVNode(vnode);
			}
		} else {
			if (vnode.children && String(vnode.children) === '') {
				vnode.children = undefined;
			}
			if (vnode.children) {
				attrs.children = vnode.children;
			}

			if (attrs.defaultValue) {
				if (!attrs.value && attrs.value !== 0) {
					attrs.value = attrs.defaultValue;
				}
				delete attrs.defaultValue;
			}

			handleElementVNode(vnode, attrs);
		}
	}

	if (oldVnodeHook) {
		oldVnodeHook(vnode);
	}
};

function handleComponentVNode(vnode) {
	var tag = vnode.nodeName,
	    a = vnode.attributes;

	vnode.attributes = {};
	if (tag.defaultProps) {
		extend(vnode.attributes, tag.defaultProps);
	}
	if (a) {
		extend(vnode.attributes, a);
	}
}

function handleElementVNode(vnode, a) {
	var shouldSanitize, attrs, i;
	if (a) {
		for (i in a) {
			if (shouldSanitize = CAMEL_PROPS.test(i)) {
				break;
			}
		}
		if (shouldSanitize) {
			attrs = vnode.attributes = {};
			for (i in a) {
				if (a.hasOwnProperty(i)) {
					attrs[CAMEL_PROPS.test(i) ? i.replace(/([A-Z0-9])/, '-$1').toLowerCase() : i] = a[i];
				}
			}
		}
	}
}

// proxy render() since React returns a Component reference.
function render$1(vnode, parent, callback) {
	var prev = parent && parent._preactCompatRendered && parent._preactCompatRendered.base;

	// ignore impossible previous renders
	if (prev && prev.parentNode !== parent) {
		prev = null;
	}

	// default to first Element child
	if (!prev && parent) {
		prev = parent.firstElementChild;
	}

	// remove unaffected siblings
	for (var i = parent.childNodes.length; i--;) {
		if (parent.childNodes[i] !== prev) {
			parent.removeChild(parent.childNodes[i]);
		}
	}

	var out = (0, _preact.render)(vnode, parent, prev);
	if (parent) {
		parent._preactCompatRendered = out && (out._component || { base: out });
	}
	if (typeof callback === 'function') {
		callback();
	}
	return out && out._component || out;
}

var ContextProvider = function ContextProvider() {};

ContextProvider.prototype.getChildContext = function () {
	return this.props.context;
};
ContextProvider.prototype.render = function (props) {
	return props.children[0];
};

function renderSubtreeIntoContainer(parentComponent, vnode, container, callback) {
	var wrap = (0, _preact.h)(ContextProvider, { context: parentComponent.context }, vnode);
	var renderContainer = render$1(wrap, container);
	var component = renderContainer._component || renderContainer.base;
	if (callback) {
		callback.call(component, renderContainer);
	}
	return component;
}

function unmountComponentAtNode(container) {
	var existing = container._preactCompatRendered && container._preactCompatRendered.base;
	if (existing && existing.parentNode === container) {
		(0, _preact.render)((0, _preact.h)(EmptyComponent), container, existing);
		return true;
	}
	return false;
}

var ARR = [];

// This API is completely unnecessary for Preact, so it's basically passthrough.
var Children = {
	map: function map(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		return children.map(fn);
	},
	forEach: function forEach(children, fn, ctx) {
		if (children == null) {
			return null;
		}
		children = Children.toArray(children);
		if (ctx && ctx !== children) {
			fn = fn.bind(ctx);
		}
		children.forEach(fn);
	},
	count: function count(children) {
		return children && children.length || 0;
	},
	only: function only(children) {
		children = Children.toArray(children);
		if (children.length !== 1) {
			throw new Error('Children.only() expects only one child.');
		}
		return children[0];
	},
	toArray: function toArray(children) {
		if (children == null) {
			return [];
		}
		return ARR.concat(children);
	}
};

/** Track current render() component for ref assignment */
var currentComponent;

function createFactory(type) {
	return createElement.bind(null, type);
}

var DOM = {};
for (var i = ELEMENTS.length; i--;) {
	DOM[ELEMENTS[i]] = createFactory(ELEMENTS[i]);
}

function upgradeToVNodes(arr, offset) {
	for (var i = offset || 0; i < arr.length; i++) {
		var obj = arr[i];
		if (Array.isArray(obj)) {
			upgradeToVNodes(obj);
		} else if (obj && typeof obj === 'object' && !isValidElement(obj) && (obj.props && obj.type || obj.attributes && obj.nodeName || obj.children)) {
			arr[i] = createElement(obj.type || obj.nodeName, obj.props || obj.attributes, obj.children);
		}
	}
}

function isStatelessComponent(c) {
	return typeof c === 'function' && !(c.prototype && c.prototype.render);
}

// wraps stateless functional components in a PropTypes validator
function wrapStatelessComponent(WrappedComponent) {
	return createClass({
		displayName: WrappedComponent.displayName || WrappedComponent.name,
		render: function render() {
			return WrappedComponent(this.props, this.context);
		}
	});
}

function statelessComponentHook(Ctor) {
	var Wrapped = Ctor[COMPONENT_WRAPPER_KEY];
	if (Wrapped) {
		return Wrapped === true ? Ctor : Wrapped;
	}

	Wrapped = wrapStatelessComponent(Ctor);

	Object.defineProperty(Wrapped, COMPONENT_WRAPPER_KEY, { configurable: true, value: true });
	Wrapped.displayName = Ctor.displayName;
	Wrapped.propTypes = Ctor.propTypes;
	Wrapped.defaultProps = Ctor.defaultProps;

	Object.defineProperty(Ctor, COMPONENT_WRAPPER_KEY, { configurable: true, value: Wrapped });

	return Wrapped;
}

function createElement() {
	var args = [],
	    len = arguments.length;
	while (len--) {
		args[len] = arguments[len];
	}upgradeToVNodes(args, 2);
	return normalizeVNode(_preact.h.apply(void 0, args));
}

function normalizeVNode(vnode) {
	vnode.preactCompatNormalized = true;

	applyClassName(vnode);

	if (isStatelessComponent(vnode.nodeName)) {
		vnode.nodeName = statelessComponentHook(vnode.nodeName);
	}

	var ref = vnode.attributes.ref,
	    type = ref && typeof ref;
	if (currentComponent && (type === 'string' || type === 'number')) {
		vnode.attributes.ref = createStringRefProxy(ref, currentComponent);
	}

	applyEventNormalization(vnode);

	return vnode;
}

function cloneElement$1(element, props) {
	var children = [],
	    len = arguments.length - 2;
	while (len-- > 0) {
		children[len] = arguments[len + 2];
	}if (!isValidElement(element)) {
		return element;
	}
	var elementProps = element.attributes || element.props;
	var node = (0, _preact.h)(element.nodeName || element.type, extend({}, elementProps), element.children || elementProps && elementProps.children);
	// Only provide the 3rd argument if needed.
	// Arguments 3+ overwrite element.children in preactCloneElement
	var cloneArgs = [node, props];
	if (children && children.length) {
		cloneArgs.push(children);
	} else if (props && props.children) {
		cloneArgs.push(props.children);
	}
	return normalizeVNode(_preact.cloneElement.apply(void 0, cloneArgs));
}

function isValidElement(element) {
	return element && (element instanceof VNode || element.$$typeof === REACT_ELEMENT_TYPE);
}

function createStringRefProxy(name, component) {
	return component._refProxies[name] || (component._refProxies[name] = function (resolved) {
		if (component && component.refs) {
			component.refs[name] = resolved;
			if (resolved === null) {
				delete component._refProxies[name];
				component = null;
			}
		}
	});
}

function applyEventNormalization(ref) {
	var nodeName = ref.nodeName;
	var attributes = ref.attributes;

	if (!attributes || typeof nodeName !== 'string') {
		return;
	}
	var props = {};
	for (var i in attributes) {
		props[i.toLowerCase()] = i;
	}
	if (props.ondoubleclick) {
		attributes.ondblclick = attributes[props.ondoubleclick];
		delete attributes[props.ondoubleclick];
	}
	// for *textual inputs* (incl textarea), normalize `onChange` -> `onInput`:
	if (props.onchange && (nodeName === 'textarea' || nodeName.toLowerCase() === 'input' && !/^fil|che|rad/i.test(attributes.type))) {
		var normalized = props.oninput || 'oninput';
		if (!attributes[normalized]) {
			attributes[normalized] = multihook([attributes[normalized], attributes[props.onchange]]);
			delete attributes[props.onchange];
		}
	}
}

function applyClassName(vnode) {
	var a = vnode.attributes || (vnode.attributes = {});
	classNameDescriptor.enumerable = 'className' in a;
	if (a.className) {
		a.class = a.className;
	}
	Object.defineProperty(a, 'className', classNameDescriptor);
}

var classNameDescriptor = {
	configurable: true,
	get: function get() {
		return this.class;
	},
	set: function set(v) {
		this.class = v;
	}
};

function extend(base, props) {
	var arguments$1 = arguments;

	for (var i = 1, obj = void 0; i < arguments.length; i++) {
		if (obj = arguments$1[i]) {
			for (var key in obj) {
				if (obj.hasOwnProperty(key)) {
					base[key] = obj[key];
				}
			}
		}
	}
	return base;
}

function shallowDiffers(a, b) {
	for (var i in a) {
		if (!(i in b)) {
			return true;
		}
	}
	for (var i$1 in b) {
		if (a[i$1] !== b[i$1]) {
			return true;
		}
	}
	return false;
}

function findDOMNode(component) {
	return component && component.base || component;
}

function F() {}

function createClass(obj) {
	function cl(props, context) {
		bindAll(this);
		Component$1.call(this, props, context, BYPASS_HOOK);
		newComponentHook.call(this, props, context);
	}

	obj = extend({ constructor: cl }, obj);

	// We need to apply mixins here so that getDefaultProps is correctly mixed
	if (obj.mixins) {
		applyMixins(obj, collateMixins(obj.mixins));
	}
	if (obj.statics) {
		extend(cl, obj.statics);
	}
	if (obj.propTypes) {
		cl.propTypes = obj.propTypes;
	}
	if (obj.defaultProps) {
		cl.defaultProps = obj.defaultProps;
	}
	if (obj.getDefaultProps) {
		cl.defaultProps = obj.getDefaultProps.call(cl);
	}

	F.prototype = Component$1.prototype;
	cl.prototype = extend(new F(), obj);

	cl.displayName = obj.displayName || 'Component';

	return cl;
}

// Flatten an Array of mixins to a map of method name to mixin implementations
function collateMixins(mixins) {
	var keyed = {};
	for (var i = 0; i < mixins.length; i++) {
		var mixin = mixins[i];
		for (var key in mixin) {
			if (mixin.hasOwnProperty(key) && typeof mixin[key] === 'function') {
				(keyed[key] || (keyed[key] = [])).push(mixin[key]);
			}
		}
	}
	return keyed;
}

// apply a mapping of Arrays of mixin methods to a component prototype
function applyMixins(proto, mixins) {
	for (var key in mixins) {
		if (mixins.hasOwnProperty(key)) {
			proto[key] = multihook(mixins[key].concat(proto[key] || ARR), key === 'getDefaultProps' || key === 'getInitialState' || key === 'getChildContext');
		}
	}
}

function bindAll(ctx) {
	for (var i in ctx) {
		var v = ctx[i];
		if (typeof v === 'function' && !v.__bound && !AUTOBIND_BLACKLIST.hasOwnProperty(i)) {
			(ctx[i] = v.bind(ctx)).__bound = true;
		}
	}
}

function callMethod(ctx, m, args) {
	if (typeof m === 'string') {
		m = ctx.constructor.prototype[m];
	}
	if (typeof m === 'function') {
		return m.apply(ctx, args);
	}
}

function multihook(hooks, skipDuplicates) {
	return function () {
		var arguments$1 = arguments;
		var this$1 = this;

		var ret;
		for (var i = 0; i < hooks.length; i++) {
			var r = callMethod(this$1, hooks[i], arguments$1);

			if (skipDuplicates && r != null) {
				if (!ret) {
					ret = {};
				}
				for (var key in r) {
					if (r.hasOwnProperty(key)) {
						ret[key] = r[key];
					}
				}
			} else if (typeof r !== 'undefined') {
				ret = r;
			}
		}
		return ret;
	};
}

function newComponentHook(props, context) {
	propsHook.call(this, props, context);
	this.componentWillReceiveProps = multihook([propsHook, this.componentWillReceiveProps || 'componentWillReceiveProps']);
	this.render = multihook([propsHook, beforeRender, this.render || 'render', afterRender]);
}

function propsHook(props, context) {
	if (!props) {
		return;
	}

	// React annoyingly special-cases single children, and some react components are ridiculously strict about this.
	var c = props.children;
	if (c && Array.isArray(c) && c.length === 1 && (typeof c[0] === 'string' || typeof c[0] === 'function' || c[0] instanceof VNode)) {
		props.children = c[0];

		// but its totally still going to be an Array.
		if (props.children && typeof props.children === 'object') {
			props.children.length = 1;
			props.children[0] = props.children;
		}
	}

	// add proptype checking
	if (DEV) {
		var ctor = typeof this === 'function' ? this : this.constructor,
		    propTypes = this.propTypes || ctor.propTypes;
		var displayName = this.displayName || ctor.name;

		if (propTypes) {
			_propTypes2.default.checkPropTypes(propTypes, props, 'prop', displayName);
		}
	}
}

function beforeRender(props) {
	currentComponent = this;
}

function afterRender() {
	if (currentComponent === this) {
		currentComponent = null;
	}
}

function Component$1(props, context, opts) {
	_preact.Component.call(this, props, context);
	this.state = this.getInitialState ? this.getInitialState() : {};
	this.refs = {};
	this._refProxies = {};
	if (opts !== BYPASS_HOOK) {
		newComponentHook.call(this, props, context);
	}
}
extend(Component$1.prototype = new _preact.Component(), {
	constructor: Component$1,

	isReactComponent: {},

	replaceState: function replaceState(state, callback) {
		var this$1 = this;

		this.setState(state, callback);
		for (var i in this$1.state) {
			if (!(i in state)) {
				delete this$1.state[i];
			}
		}
	},

	getDOMNode: function getDOMNode() {
		return this.base;
	},

	isMounted: function isMounted() {
		return !!this.base;
	}
});

function PureComponent(props, context) {
	Component$1.call(this, props, context);
}
F.prototype = Component$1.prototype;
PureComponent.prototype = new F();
PureComponent.prototype.isPureReactComponent = true;
PureComponent.prototype.shouldComponentUpdate = function (props, state) {
	return shallowDiffers(this.props, props) || shallowDiffers(this.state, state);
};

var index = {
	version: version,
	DOM: DOM,
	PropTypes: _propTypes2.default,
	Children: Children,
	render: render$1,
	createClass: createClass,
	createFactory: createFactory,
	createElement: createElement,
	cloneElement: cloneElement$1,
	isValidElement: isValidElement,
	findDOMNode: findDOMNode,
	unmountComponentAtNode: unmountComponentAtNode,
	Component: Component$1,
	PureComponent: PureComponent,
	unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer,
	__spread: extend
};

exports.version = version;
exports.DOM = DOM;
exports.PropTypes = _propTypes2.default;
exports.Children = Children;
exports.render = render$1;
exports.createClass = createClass;
exports.createFactory = createFactory;
exports.createElement = createElement;
exports.cloneElement = cloneElement$1;
exports.isValidElement = isValidElement;
exports.findDOMNode = findDOMNode;
exports.unmountComponentAtNode = unmountComponentAtNode;
exports.Component = Component$1;
exports.PureComponent = PureComponent;
exports.unstable_renderSubtreeIntoContainer = renderSubtreeIntoContainer;
exports.__spread = extend;
exports.default = index;
//# sourceMappingURL=preact-compat.es.js.map

/***/ }),

/***/ "ApQG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NormalBackButton":"NormalBackButton__3mXe1","MobileBackButton":"MobileBackButton__2PXZ9"};

/***/ }),

/***/ "BOLS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchIcon = function (_Component) {
    _inherits(SearchIcon, _Component);

    function SearchIcon() {
        _classCallCheck(this, SearchIcon);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SearchIcon.prototype.render = function render() {
        var color = this.props.color;

        return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M37.85,33.63l-8.46-7.2a4.73,4.73,0,0,0-1.34-.87,2.82,2.82,0,0,0-1.21-.23h-.06a12.86,12.86,0,0,0,2.28-3.8A12.55,12.55,0,0,0,29.88,17a12.51,12.51,0,0,0-1-5A13,13,0,0,0,22,5.14,12.82,12.82,0,0,0,12,5.08a13,13,0,0,0-6.83,6.83A12.82,12.82,0,0,0,5.08,22a13,13,0,0,0,6.83,6.83,12.51,12.51,0,0,0,5.07,1A12.55,12.55,0,0,0,21.53,29a12.86,12.86,0,0,0,3.8-2.28v.05h0A2.82,2.82,0,0,0,25.57,28a4.73,4.73,0,0,0,.87,1.34l7.18,8.48A3.17,3.17,0,0,0,35.9,39,2.89,2.89,0,0,0,39,35.89,3.17,3.17,0,0,0,37.85,33.63ZM25.45,20.56a9.17,9.17,0,1,1,0-7.13A9.23,9.23,0,0,1,25.45,20.56Z" }),
            (0, _preact.h)("path", { fill: color, d: "M35.91,35.92l0,0h0l0,0h0m-19-31.84a12.51,12.51,0,0,0-4.91,1,13,13,0,0,0-6.83,6.83A12.83,12.83,0,0,0,5.08,22a13,13,0,0,0,6.83,6.83,12.51,12.51,0,0,0,4.94,1h.22A12.55,12.55,0,0,0,21.53,29a12.86,12.86,0,0,0,3.8-2.28v.05A2.83,2.83,0,0,0,25.57,28a4.73,4.73,0,0,0,.87,1.34l7.18,8.48A3.17,3.17,0,0,0,35.9,39h.21A2.89,2.89,0,0,0,39,36.3a2.86,2.86,0,0,0,0-.41,3.17,3.17,0,0,0-1.14-2.25l-8.46-7.2a4.73,4.73,0,0,0-1.34-.87,2.83,2.83,0,0,0-1.11-.23h-.15a12.87,12.87,0,0,0,2.28-3.8A12.56,12.56,0,0,0,29.88,17a12.52,12.52,0,0,0-1-5A13,13,0,0,0,22,5.14a12.51,12.51,0,0,0-5-1.06h-.13ZM17,26.16a9.16,9.16,0,1,1,3.56-.72,9.22,9.22,0,0,1-3.56.72Z" })
        );
    };

    return SearchIcon;
}(_preact.Component);

exports.default = SearchIcon;

/***/ }),

/***/ "BXPw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _FetchErrorHandling = __webpack_require__("jbkD");

var _FetchErrorHandling2 = _interopRequireDefault(_FetchErrorHandling);

var _store = __webpack_require__("RHIr");

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Feedback = function () {
    function Feedback() {
        _classCallCheck(this, Feedback);
    }

    Feedback.prototype.sendFeedback = function sendFeedback(systemType, systemId, feedback, rating, cb) {
        //rating == {-1, 1} only accepted at the moment.
        var state = _store2.default.getState();
        var apiStub = state.getIn(['config', 'backendApiUrl']);
        var token = state.getIn(['user', 'token']);
        var url = apiStub + '/v2/feedback/create';
        return fetch(url, {
            method: 'POST',
            body: JSON.stringify({
                'system_type': systemType,
                'system_id': systemId,
                'feedback': feedback,
                'rating': rating
            }),
            headers: {
                'Content-Type': 'application/json',
                Authorization: 'Bearer ' + token
            }
        }).then(function (res) {
            return (0, _FetchErrorHandling2.default)(res);
        }).then(function (payload) {
            return cb(payload, '200');
        }).catch(function (error) {
            return cb(error, error.statusText);
        });
    };

    return Feedback;
}();

exports.default = new Feedback();

/***/ }),

/***/ "BZkz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("xfPb");

var _style2 = _interopRequireDefault(_style);

var _ArrowLeft = __webpack_require__("0DRr");

var _ArrowLeft2 = _interopRequireDefault(_ArrowLeft);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInput = function (_Component) {
    _inherits(SelectInput, _Component);

    function SelectInput(props) {
        _classCallCheck(this, SelectInput);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            select: props.select
        };
        _this.onChange = _this.onChange.bind(_this);
        return _this;
    }

    SelectInput.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        if (this.props.select !== prevProps.select) {
            this.setState({
                select: this.props.select
            });
        }
    };

    SelectInput.prototype.onChange = function onChange(e) {
        e.target.name = this.props.name;
        this.props.onChange(e);
        this.setState({
            select: e.target.value
        });
    };

    SelectInput.prototype._renderList = function _renderList(values) {
        var selects = [];
        for (var value in values) {
            selects.push((0, _preact.h)(
                'option',
                { value: value, key: value },
                ' ',
                values[value],
                ' '
            ));
        }
        return selects;
    };

    SelectInput.prototype.render = function render() {
        var _props = this.props,
            label = _props.label,
            values = _props.values,
            isValidate = _props.isValidate,
            rest = _objectWithoutProperties(_props, ['label', 'values', 'isValidate']);

        return (0, _preact.h)(
            'div',
            { className: _style2.default.SelectWrapper + ' ' + this.props.className, width: this.props.width, shrink: 0 },
            (0, _preact.h)(
                'select',
                _extends({ value: this.state.select, onChange: this.onChange, disabled: this.props.disabled }, rest, {
                    style: !isValidate && {
                        border: '2px solid #ff6d67'
                    }
                }),
                (0, _preact.h)(
                    'option',
                    { value: '', selected: true, disabled: true, hidden: true },
                    label
                ),
                this._renderList(values)
            )
        );
    };

    return SelectInput;
}(_preact.Component);

exports.default = SelectInput;

/***/ }),

/***/ "BbdM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = window.XMLHttpRequest;

/***/ }),

/***/ "Bbo7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _MessageList = __webpack_require__("9bxs");

var _MessageList2 = _interopRequireDefault(_MessageList);

var _TypingIndicatorChatBody = __webpack_require__("/GQK");

var _TypingIndicatorChatBody2 = _interopRequireDefault(_TypingIndicatorChatBody);

var _UnreadMessageIndicatorChatBody = __webpack_require__("lKnS");

var _UnreadMessageIndicatorChatBody2 = _interopRequireDefault(_UnreadMessageIndicatorChatBody);

var _model = __webpack_require__("lmuV");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var events = __webpack_require__("G/vx");

var _ref = (0, _preact.h)(_MessageList2.default, null);

var _ref2 = (0, _preact.h)(_TypingIndicatorChatBody2.default, null);

var ChatBody = function (_Component) {
    _inherits(ChatBody, _Component);

    function ChatBody() {
        _classCallCheck(this, ChatBody);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleChatBodyScroll = _this.handleChatBodyScroll.bind(_this);
        _this.hasScrolledUpState = false;
        _this.scrollToBottom = _this.scrollToBottom.bind(_this);
        _this.previousScrollHeight = 0;

        _this.visibilityChange = _this.visibilityChange.bind(_this);
        return _this;
    }

    ChatBody.prototype.componentDidMount = function componentDidMount() {
        this.scrollToBottom();
        if (this.props.room && this.props.unread) {
            this.props.dispatch(_model.TicketModel.requestSetTicketToRead(this.props.room));
        }
        events.addEventListener(this.chatBody, 'scroll', this.handleChatBodyScroll);
        window.document.addEventListener("visibilitychange", this.visibilityChange);
    };

    ChatBody.prototype.componentWillUnmount = function componentWillUnmount() {
        events.removeEventListener(this.chatBody, 'scroll', this.handleChatBodyScroll);
    };

    ChatBody.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var currentConversationRoom = this.props.room;
        if (!currentConversationRoom) return;

        var entries = this.props.entries;
        var prevEntries = prevProps.entries;
        if (this.chatBody.scrollTop === 0) {
            // we scrolled top and receive new entries
            // reset back the scroll
            this.chatBody.scrollTop = this.chatBody.scrollHeight - this.previousScrollHeight;
            return;
        }
        if (this.hasScrolledUp()) {
            if (entries.size !== prevEntries.size) {
                this.scrollToBottom();
            }
        }
        this.shouldSetAllEntriesToRead();
    };

    ChatBody.prototype.render = function render() {
        var _this2 = this;

        // TODO
        //{this.renderUnreadMessageIndicatorChatBody()}
        // NOTE: button at bottom take 63 px;
        var height = this.props.height - 63 + 'px';
        return (0, _preact.h)(
            'div',
            { 'class': 'chat-body', ref: function ref(chatBody) {
                    _this2.chatBody = chatBody;
                }, style: { height: height } },
            _ref,
            this.props.typing && _ref2
        );
    };

    ChatBody.prototype.renderUnreadMessageIndicatorChatBody = function renderUnreadMessageIndicatorChatBody() {
        var currentConversationRoom = this.props.room;
        var unreadEntriesCount = this.props.unreadEntriesCount;
        if (!currentConversationRoom) return;
        var unreadRoomEntriesCount = unreadEntriesCount.get(currentConversationRoom);
        if (!unreadRoomEntriesCount) return;
        if (unreadRoomEntriesCount > 0) {
            return (0, _preact.h)(_UnreadMessageIndicatorChatBody2.default, { unreadCount: unreadRoomEntriesCount, scrollToBottomOfChatBody: this.scrollToBottom });
        }
    };

    ChatBody.prototype.visibilityChange = function visibilityChange() {
        var visibleState = window.document.visibilityState;
        var visible = false;

        if (visibleState == 'visible') {
            visible = true;
        }

        this.props.dispatch(_model.SystemModel.setTabFocus(visible));
    };

    ChatBody.prototype.handleChatBodyScroll = function handleChatBodyScroll() {
        this.hasScrolledUpState = this.hasScrolledUp();
        if (this.chatBody.scrollTop === 0) {
            this.previousScrollHeight = this.chatBody.scrollHeight;
            var room = this.props.room;
            var entries = this.props.entries;
            var offset = entries.size;
            this.props.dispatch(_model.TicketModel.requestEntriesGet(room, offset));
        }
        this.shouldSetAllEntriesToRead();
    };

    ChatBody.prototype.shouldSetAllEntriesToRead = function shouldSetAllEntriesToRead() {
        if (!this.props.room) return;
        if (!this.props.unread) return;
        if (!this.isAtBottomOfChatBody) return;
        if (!this.props.currentTab) return;
        if (!this.props.bubbleButtonState) return;
        if (!this.props.browserTabFocus) return;

        this.props.dispatch(_model.TicketModel.requestSetTicketToRead(this.props.room));
    };

    ChatBody.prototype.scrollToBottom = function scrollToBottom() {
        var _this3 = this;

        //const currentConversationRoom = this.props.room;
        //actionSetAllEntriesToRead(currentConversationRoom);
        if (this.chatBody) {
            setTimeout(function () {
                _this3.setChatBodyScrollTop(100000000000000);
            }, 0);
        }
    };

    ChatBody.prototype.setChatBodyScrollTop = function setChatBodyScrollTop(scrollTop) {
        this.chatBody.scrollTop = scrollTop;
    };

    ChatBody.prototype.isAtBottomOfChatBody = function isAtBottomOfChatBody() {
        return this.chatBody.scrollHeight === this.chatBody.scrollTop + this.chatBody.offsetHeight;
    };

    ChatBody.prototype.hasScrolledUp = function hasScrolledUp() {
        return !this.isAtBottomOfChatBody();
    };

    return ChatBody;
}(_preact.Component);

function mapStateToProps(state) {
    var room = _model.TicketModel.getCurrentRoom(state);
    var entries = _model.TicketModel.getEntries(room, state);
    var eId = _model.TicketModel.getAssignedEmployeeId(room, state);
    var assignedEmployee = _model.CompanyModel.getEmployee(eId, state);
    var userId = _model.UserModel.getId(state);
    var currentTab = _model.SystemModel.getActiveTab(state);
    var bubbleButtonState = _model.SystemModel.getBubbleButtonState(state);
    var browserTabFocus = _model.SystemModel.getBrowserTabFocus(state);

    return {
        entries: entries,
        room: room,
        assignedEmployee: assignedEmployee,
        height: _model.SystemModel.getBodyHeight(state),
        unread: _model.TicketModel.getUnread(room, state),
        userId: userId,
        typing: _model.TicketModel.getTyping(room, state),
        currentTab: currentTab,
        bubbleButtonState: bubbleButtonState,
        browserTabFocus: browserTabFocus
    };
}
exports.default = (0, _preactRedux.connect)(mapStateToProps)(ChatBody);

/***/ }),

/***/ "BjJe":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"right":"right__zMdAB","left":"left__3rY7T","up":"up__3rgZc","down":"down__1P1iu","Arrow":"Arrow__36XLK"};

/***/ }),

/***/ "Bl3B":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _httpplease = __webpack_require__("Ma+D");

var _httpplease2 = _interopRequireDefault(_httpplease);

var _oldiexdomain = __webpack_require__("ZV3n");

var _oldiexdomain2 = _interopRequireDefault(_oldiexdomain);

var _utils = __webpack_require__("TAZ7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];var _n = true;var _d = false;var _e = undefined;try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;_e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }return _arr;
  }return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var http = _httpplease2.default.use(_oldiexdomain2.default);

var Status = {
  PENDING: 'pending',
  LOADING: 'loading',
  LOADED: 'loaded',
  FAILED: 'failed',
  UNSUPPORTED: 'unsupported'
};

var getRequestsByUrl = {};
var loadedIcons = {};

var InlineSVG = function (_React$PureComponent) {
  _inherits(InlineSVG, _React$PureComponent);

  function InlineSVG(props) {
    _classCallCheck(this, InlineSVG);

    var _this = _possibleConstructorReturn(this, (InlineSVG.__proto__ || Object.getPrototypeOf(InlineSVG)).call(this, props));

    _this.handleLoad = function (err, res) {
      var isCached = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      var _this$props = _this.props,
          onLoad = _this$props.onLoad,
          src = _this$props.src;

      if (err) {
        _this.fail(err);
        return;
      }

      if (_this.isActive) {
        _this.setState({
          loadedText: res.text,
          status: Status.LOADED
        }, function () {
          onLoad(src, isCached);
        });
      }
    };

    _this.state = {
      status: Status.PENDING
    };

    _this.isActive = false;
    return _this;
  }

  _createClass(InlineSVG, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.isActive = true;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var status = this.state.status;
      var _props = this.props,
          src = _props.src,
          supportTest = _props.supportTest;

      /* istanbul ignore else */

      if (status === Status.PENDING) {
        if (supportTest()) {
          if (src) {
            this.startLoad();
            return;
          }

          this.fail((0, _utils.configurationError)('Missing source'));
          return;
        }

        this.fail((0, _utils.unsupportedBrowserError)());
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps) {
      var src = this.props.src;

      if (prevProps.src !== src) {
        if (src) {
          this.startLoad();
          return;
        }

        this.fail((0, _utils.configurationError)('Missing source'));
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.isActive = false;
    }
  }, {
    key: 'getFile',
    value: function getFile(callback) {
      var _this2 = this;

      var _props2 = this.props,
          cacheGetRequests = _props2.cacheGetRequests,
          src = _props2.src;

      if (cacheGetRequests) {
        if (loadedIcons[src]) {
          var _loadedIcons$src = _slicedToArray(loadedIcons[src], 2),
              err = _loadedIcons$src[0],
              res = _loadedIcons$src[1];

          callback(err, res, true);
        }

        if (!getRequestsByUrl[src]) {
          getRequestsByUrl[src] = [];

          http.get(src, function (err, res) {
            getRequestsByUrl[src].forEach(function (cb) {
              var currentSrc = _this2.props.src;

              loadedIcons[src] = [err, res];

              if (src === currentSrc) {
                cb(err, res);
              }
            });
          });
        }

        getRequestsByUrl[src].push(callback);
      } else {
        http.get(src, function (err, res) {
          var currentSrc = _this2.props.src;

          if (src === currentSrc) {
            callback(err, res);
          }
        });
      }
    }
  }, {
    key: 'fail',
    value: function fail(error) {
      var onError = this.props.onError;

      var status = error.isUnsupportedBrowserError ? Status.UNSUPPORTED : Status.FAILED;

      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({ status: status }, function () {
          if (typeof onError === 'function') {
            onError(error);
          }
        });
      }
    }
  }, {
    key: 'startLoad',
    value: function startLoad() {
      /* istanbul ignore else */
      if (this.isActive) {
        this.setState({
          status: Status.LOADING
        }, this.load);
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var src = this.props.src;

      var match = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);

      if (match) {
        return this.handleLoad(null, {
          text: match[1] ? atob(match[2]) : decodeURIComponent(match[2])
        });
      }

      return this.getFile(this.handleLoad);
    }
  }, {
    key: 'getClassName',
    value: function getClassName() {
      var status = this.state.status;
      var className = this.props.className;

      var nextClassName = 'isvg ' + status;

      if (className) {
        nextClassName += ' ' + className;
      }

      return nextClassName;
    }
  }, {
    key: 'processSVG',
    value: function processSVG(text) {
      var _props3 = this.props,
          uniquifyIDs = _props3.uniquifyIDs,
          uniqueHash = _props3.uniqueHash,
          baseURL = _props3.baseURL,
          processSVG = _props3.processSVG;

      var svgText = text;
      if (processSVG) {
        svgText = processSVG(svgText);
      }

      if (uniquifyIDs) {
        return (0, _utils.uniquifySVGIDs)(svgText, uniqueHash || (0, _utils.randomString)(), baseURL);
      }

      return svgText;
    }
  }, {
    key: 'renderContents',
    value: function renderContents() {
      var status = this.state.status;
      var _props4 = this.props,
          children = _props4.children,
          preloader = _props4.preloader;

      switch (status) {
        case Status.UNSUPPORTED:
        case Status.FAILED:
          return children;
        default:
          return preloader;
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var loadedText = this.state.loadedText;
      var _props5 = this.props,
          style = _props5.style,
          wrapper = _props5.wrapper;

      var content = void 0;
      var html = void 0;

      if (loadedText) {
        html = {
          __html: this.processSVG(loadedText)
        };
      } else {
        content = this.renderContents();
      }

      return wrapper({
        style: style,
        className: this.getClassName(),
        dangerouslySetInnerHTML: html
      }, content);
    }
  }]);

  return InlineSVG;
}(_react2.default.PureComponent);

InlineSVG.propTypes = {
  baseURL: _propTypes2.default.string,
  cacheGetRequests: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  className: _propTypes2.default.string,
  onError: _propTypes2.default.func,
  onLoad: _propTypes2.default.func,
  preloader: _propTypes2.default.node,
  processSVG: _propTypes2.default.func,
  src: _propTypes2.default.string.isRequired,
  style: _propTypes2.default.object,
  supportTest: _propTypes2.default.func,
  uniqueHash: _propTypes2.default.string,
  uniquifyIDs: _propTypes2.default.bool,
  wrapper: _propTypes2.default.func
};
InlineSVG.defaultProps = {
  baseURL: '',
  cacheGetRequests: false,
  onLoad: function onLoad() {},
  supportTest: _utils.isSupportedEnvironment,
  uniquifyIDs: true,
  wrapper: _react2.default.createFactory('span')
};
exports.default = InlineSVG;

/***/ }),

/***/ "C5vU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"HeaderAutoMessage":"HeaderAutoMessage__3_ATo","HeaderNoAutoMessage":"HeaderNoAutoMessage__3zf2_"};

/***/ }),

/***/ "CvAI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("3MPn");

var _style2 = _interopRequireDefault(_style);

var _Input = __webpack_require__("p/6D");

var _Input2 = _interopRequireDefault(_Input);

var _SelectInput = __webpack_require__("BZkz");

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _Textarea = __webpack_require__("V7//");

var _Textarea2 = _interopRequireDefault(_Textarea);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("lmuV");

var _model6 = __webpack_require__("RmM5");

var _model7 = _interopRequireDefault(_model6);

var _History = __webpack_require__("QQKR");

var _History2 = _interopRequireDefault(_History);

var _Validation = __webpack_require__("SiXk");

var _Validation2 = _interopRequireDefault(_Validation);

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var StartChattingButton = function (_Component) {
  _inherits(StartChattingButton, _Component);

  function StartChattingButton(props) {
    _classCallCheck(this, StartChattingButton);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    var offlineFormsConfig = props.offlineSettings.config;
    _this.state = {
      send: false,
      select: [],
      selectValidate: true,
      forms: {
        email: {
          value: props.user.email,
          require: offlineFormsConfig.email.require,
          visible: offlineFormsConfig.email.visible,
          alias: offlineFormsConfig.email.alias,
          missing: false,
          isValidate: true,
          validate: _Validation2.default.validateEmail
        },
        name: {
          value: props.user.name,
          require: offlineFormsConfig.name.require,
          visible: offlineFormsConfig.name.visible,
          alias: offlineFormsConfig.name.alias,
          missing: false,
          isValidate: true,
          validate: _Validation2.default.validateDummy
        },
        phone: {
          value: props.user.phone,
          require: offlineFormsConfig.phone.require,
          visible: offlineFormsConfig.phone.visible,
          alias: offlineFormsConfig.phone.alias,
          missing: false,
          isValidate: true,
          validate: _Validation2.default.validateDummy
        },
        customerRef: {
          value: props.user.customer_ref,
          require: offlineFormsConfig.customer_ref.require,
          visible: offlineFormsConfig.customer_ref.visible,
          alias: offlineFormsConfig.customer_ref.alias,
          missing: false,
          isValidate: true,
          validate: _Validation2.default.validateDummy
        },
        message: {
          require: true,
          visible: true,
          value: "",
          missing: false,
          isValidate: true,
          validate: _Validation2.default.validateDummy
        }
      },
      historyIconHover: false
    };
    _this.handleNewConversationClick = _this.handleNewConversationClick.bind(_this);
    _this.renderForm = _this.renderForm.bind(_this);
    return _this;
  }

  StartChattingButton.prototype.handleNewConversationClick = function handleNewConversationClick() {
    var missing = false;
    var newState = _extends({}, this.state);
    var _props = this.props,
        exchangeAvailable = _props.exchangeAvailable,
        exchangePayload = _props.exchangePayload,
        offlineSettings = _props.offlineSettings;
    var _state = this.state,
        forms = _state.forms,
        select = _state.select;


    var isValidate = true;
    var formsConfig = offlineSettings.config;
    for (var form in forms) {
      var value = forms[form].value;
      if (!value && forms[form].require && forms[form].visible) {
        newState.forms[form].missing = true;
        missing = true;
      } else {
        newState.forms[form].missing = false;
      }
      if (value && !newState.forms[form].validate(value)) {
        newState.forms[form].isValidate = false;
        isValidate = false;
      }
    }
    if (exchangeAvailable && exchangePayload.exchange_on) {
      if (select.length == 0) {
        newState.selectValidate = false;
      }
    }

    if (!isValidate || missing) {
      this.setState(newState);
      return;
    }

    var payload = {
      email: forms.email.value,
      name: forms.name.value,
      phone: forms.phone.value,
      customer_ref: forms.customerRef.value
    };
    var last = void 0;
    if (select.length > 0) {
      var options = exchangePayload.options;
      last = _.last(select);
    }
    this.props.dispatch(_model5.TicketModel.requestNewOfflineTicket(forms.message.value, payload, last));
    this.setState({ send: true });
  };

  StartChattingButton.prototype.renderForm = function renderForm(form, label) {
    var _this2 = this;

    var obj = this.state.forms[form];
    var require = obj.require;
    var visible = obj.visible;
    if (visible) {
      var value = obj.value;
      var missing = obj.missing;
      var isValidate = obj.isValidate;
      return (0, _preact.h)(
        "div",
        {
          style: { position: "relative", width: "70%", margin: "12px auto" }
        },
        (0, _preact.h)(_Input2.default, {
          label: label,
          value: value,
          onChange: function onChange(newValue) {
            var newState = _extends({}, _this2.state);
            newState.forms[form].value = newValue;
            _this2.setState(newState);
          },
          require: require,
          missing: missing,
          isValidate: isValidate
        })
      );
    }
    return null;
  };

  StartChattingButton.prototype.renderExchange = function renderExchange() {
    var _this3 = this;

    if (!this.props.exchangeAvailable) return null;
    if (!this.props.exchangePayload.exchange_on) return null;
    var language = this.props.language;

    var options = _.filter(this.props.exchangePayload.options, ["visible", true]);

    var values = { "-1": language.get("Others") };
    for (var index in options) {
      values[options[index].id] = options[index].label;
    }
    var option = _.find(options, function (o) {
      return o.id === _this3.state.select[0];
    });

    var ChildInput = null;
    var hasChildren = option ? _.size(option.children) > 0 : false;
    if (hasChildren) {
      var _childrenValues;

      var childrenValues = (_childrenValues = {}, _childrenValues[option.id] = language.get("Others"), _childrenValues);
      for (var index in option.children) {
        childrenValues[option.children[index].id] = option.children[index].label;
      }
      ChildInput = (0, _preact.h)(_SelectInput2.default, {
        values: childrenValues,
        onChange: function onChange(e) {
          var list = [].concat(_this3.state.select);
          list[1] = e.target.value;
          _this3.setState({ select: list });
        },
        select: this.state.select[1],
        label: language.get("SelectTopic"),
        isValidate: this.state.selectValidate
      });
    }

    //<div style={{fontSize: '14px', color: '#404040', margin: '5px 0px'}}>
    //    Vad gäller ditt ärende
    //</div>
    return (0, _preact.h)(
      "div",
      { style: { position: "relative", width: "70%", margin: "15px auto" } },
      (0, _preact.h)(
        "div",
        { style: { fontSize: "14px", color: "#404040", margin: "5px 0px" } },
        language.get("SelectTopicHeader")
      ),
      (0, _preact.h)(_SelectInput2.default, {
        values: values,
        onChange: function onChange(e) {
          _this3.setState({ select: [e.target.value] });
        },
        select: this.state.select[0],
        label: language.get("SelectTopic"),
        isValidate: this.state.selectValidate
      }),
      hasChildren && ChildInput
    );
  };

  StartChattingButton.prototype.renderOfflineForms = function renderOfflineForms() {
    var _this4 = this;

    //Minus (Powered by Jibber) height
    var bodyHeight = this.props.height - 35;
    var language = this.props.language;

    var formsCount = 0;
    for (var form in this.props.offlineSettings.config) {
      if (this.props.offlineSettings.config[form].visible) {
        formsCount += 1;
      }
    }
    var paddingTop = "50" - formsCount * 10 + "px";

    var PreviousConversationsButtonProps = {
      title: language.get("ViewPreviousConversation"),
      onClick: function onClick() {
        return _this4.props.dispatch(_model2.default.setRoute("Conversations"));
      },
      onMouseOver: function onMouseOver() {
        return _this4.setState({ historyIconHover: true });
      },
      onMouseLeave: function onMouseLeave() {
        return _this4.setState({ historyIconHover: false });
      },
      style: {
        minHeight: "1px",
        float: "left",
        display: "inline-block",
        width: "48px",
        cursor: "pointer"
      }
    };
    var TextareaProps = {
      label: language.get("Message"),
      value: this.state.forms.message.value,
      onChange: function onChange(newValue) {
        var newState = _extends({}, _this4.state);
        newState.forms.message.value = newValue;
        _this4.setState(newState);
      },
      missing: this.state.forms.message.missing,
      require: true
    };

    var customerRef = this.state.forms.customerRef;
    var customerRefLabel;
    switch (customerRef.alias) {
      case "ord":
        customerRefLabel = language.get("OrderNo.");
        break;
      case "cust":
        customerRefLabel = language.get("CustomerNo.");
        break;
      case "ref":
      default:
        customerRefLabel = language.get("ReferenceNo.");
        break;
    }

    return (0, _preact.h)(
      "div",
      {
        className: _style2.default.StartChattingButtonWrapper,
        style: { paddingTop: paddingTop, minHeight: bodyHeight + "px" }
      },
      (0, _preact.h)(
        "form",
        null,
        this.renderForm("email", language.get("Email"), _Validation2.default.validateEmail),
        this.renderForm("name", language.get("Name")),
        this.renderForm("phone", language.get("Phone")),
        this.renderForm("customerRef", customerRefLabel),
        (0, _preact.h)(
          "div",
          {
            style: {
              position: "relative",
              width: "70%",
              margin: "auto",
              marginBottom: "10px"
            }
          },
          (0, _preact.h)(_Textarea2.default, TextareaProps)
        )
      ),
      this.renderExchange(),
      (0, _preact.h)(
        "div",
        { style: { width: "100%", marginLeft: "20%" } },
        (0, _preact.h)(
          "div",
          {
            className: _style2.default.StartChattingButton,
            onClick: this.handleNewConversationClick
          },
          (0, _preact.h)(
            "div",
            PreviousConversationsButtonProps,
            this.props.conversations.size !== 0 && // above is for placeholder, if no img found
            (0, _preact.h)(_History2.default, {
              color: this.state.historyIconHover ? this.props.color : "#898989"
            })
          ),
          (0, _preact.h)(
            "div",
            {
              style: {
                backgroundColor: this.props.color,
                color: "white",
                height: "55px",
                lineHeight: "55px",
                borderRadius: "60px",
                float: "left",
                paddingLeft: "4px",
                paddingRight: "4px"
              }
            },
            (0, _preact.h)(
              "span",
              { className: _style2.default.StartChattingText },
              " ",
              language.get("LeaveMessage"),
              " "
            )
          )
        )
      )
    );
  };

  StartChattingButton.prototype.renderSend = function renderSend() {
    var _this5 = this;

    var bodyHeight = this.props.height;
    var language = this.props.language;

    var marginTop = bodyHeight / 2 - 50;
    var marginBottom = bodyHeight / 2 - 120;

    return (0, _preact.h)(
      "div",
      {
        style: {
          marginTop: marginTop,
          marginBottom: marginBottom
        },
        className: _style2.default.StartChattingButtonWrapper
      },
      (0, _preact.h)(
        "div",
        {
          style: {
            padding: "0 20px 20px 20px",
            fontSize: "20px",
            marginLeft: "auto",
            marginRight: "auto",
            whiteSpace: "pre-wrap"
          }
        },
        language.get("OfflineThanksMessage")
      ),
      (0, _preact.h)(
        "div",
        { style: { marginLeft: "20%", width: "100%", height: "65px" } },
        this.props.conversations.size !== 0 ? (0, _preact.h)("img", {
          title: language.get("ViewPreviousConversation"),
          style: {
            height: "40px",
            float: "left",
            marginRight: "5px",
            cursor: "pointer",
            marginTop: "5px"
          },
          onClick: function onClick() {
            _this5.props.dispatch(_model2.default.setRoute("Conversations"));
          },
          src: "common/assets/images/Menu_History.png"
        }) : (0, _preact.h)("div", { style: { width: "20px", height: "1px", float: "left" } }),
        (0, _preact.h)(
          "div",
          {
            className: _style2.default.StartChattingButton + " hvr-grow",
            onClick: function onClick(event) {
              _this5.setState({ send: false });
            },
            style: {
              backgroundColor: this.props.color,
              color: "white",
              width: "50%",
              borderRadius: "60px",
              float: "left",
              height: "55px",
              lineHeight: "55px"
            }
          },
          (0, _preact.h)(
            "span",
            { className: _style2.default.StartChattingText },
            " ",
            language.get("LeaveMessage"),
            " "
          )
        )
      )
    );
  };

  StartChattingButton.prototype.render = function render() {
    if (this.state.send) {
      return this.renderSend();
    }
    return this.renderOfflineForms();
  };

  return StartChattingButton;
}(_preact.Component);

function mapStateToProps(state) {
  return {
    height: _model2.default.getBodyHeight(state),
    width: _model2.default.getShellWidth(state),
    language: _model4.default.getLanguage(state),
    color: _model4.default.getColor(state),
    conversations: _model5.TicketModel.getAll(state),
    offlineSettings: _model4.default.getOfflineFormsSettings(state).toJS(),
    user: _model7.default.get(state).toJS(),
    exchangeAvailable: _model5.FeaturesModel.getFeatureAvailable(state, "exchange"),
    exchangePayload: _model5.FeaturesModel.getFeaturePayload(state, "exchange")
  };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(StartChattingButton);

/***/ }),

/***/ "D9vB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavRight = function (_Component) {
    _inherits(NavRight, _Component);

    function NavRight() {
        _classCallCheck(this, NavRight);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    NavRight.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 42" },
            (0, _preact.h)("path", { fill: this.props.color, d: "M2.53,38a1.49,1.49,0,0,1-1.22-2.36L11.63,21.49,1.31,7.39A1.5,1.5,0,1,1,3.75,5.66l10.94,15a1.5,1.5,0,0,1,0,1.74l-10.94,15A1.49,1.49,0,0,1,2.53,38Z" })
        );
    };

    return NavRight;
}(_preact.Component);

exports.default = NavRight;

/***/ }),

/***/ "DSuZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _FaqItem = __webpack_require__("LM1n");

var _FaqItem2 = _interopRequireDefault(_FaqItem);

var _style = __webpack_require__("5MAO");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("9VrP");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("2YDt");

var _model6 = _interopRequireDefault(_model5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    'div',
    null,
    'Inga fr\xE5gor hittades f\xF6r s\xF6kning'
);

var Faq = function (_Component) {
    _inherits(Faq, _Component);

    function Faq() {
        _classCallCheck(this, Faq);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            selectedItemId: '',
            searchInputValue: ''
        };

        _this.renderFaqList = _this.renderFaqList.bind(_this);
        _this.handleItemClick = _this.handleItemClick.bind(_this);
        _this.handleSearch = _this.handleSearch.bind(_this);
        _this.searchItem = _this.searchItem.bind(_this);
        return _this;
    }

    Faq.prototype.render = function render() {
        var _this2 = this;

        // NOTE: the input take up 50 px of height, always
        var height = this.props.height - 50 + 'px';
        return (0, _preact.h)(
            'div',
            null,
            (0, _preact.h)(
                'div',
                {
                    className: _style2.default.InputWrapper,
                    style: { backgroundColor: this.props.color } },
                (0, _preact.h)('input', {
                    type: 'text',
                    placeholder: this.props.language.get("SearchQuestion"),
                    className: _style2.default.InputSearch,
                    style: { border: '1px solid ' + this.props.color },
                    onInput: this.handleSearch,
                    onClick: this.handleSearch,
                    ref: function ref(inputDOM) {
                        _this2.inputDOM = inputDOM;
                    } }),
                (0, _preact.h)('img', {
                    src: '/common/assets/images/ClientChat_Icon_Search.png',
                    style: { backgroundColor: this.props.color },
                    className: _style2.default.SearchIcon
                })
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.FAQList, style: { height: height } },
                this.renderFaqList(this.props.color)
            )
        );
    };

    Faq.prototype.renderFaqList = function renderFaqList(color) {
        var _this3 = this;

        var faqs = this.props.faqs;
        var selectedItemId = this.state.selectedItemId;
        var searchInputValue = this.state.searchInputValue;

        if (searchInputValue) {
            faqs = this.searchItem(faqs, searchInputValue);
        }

        if (faqs.length > 0) {
            return faqs.map(function (faq, index) {
                return (0, _preact.h)(_FaqItem2.default, {
                    faq: faq,
                    color: color,
                    handleItemClick: _this3.handleItemClick,
                    selectedItemId: selectedItemId
                });
            });
        } else {
            return (0, _preact.h)(
                'div',
                { className: _style2.default.FAQNotFound },
                _ref,
                (0, _preact.h)(
                    'div',
                    null,
                    ' ',
                    (0, _preact.h)(
                        'b',
                        null,
                        searchInputValue
                    )
                )
            );
        }
    };

    Faq.prototype.handleItemClick = function handleItemClick(id) {
        var selectedItemId = this.state.selectedItemId;

        if (selectedItemId === id) {
            this.setState({
                selectedItemId: ''
            });
        } else {
            this.setState({
                selectedItemId: id
            });
        }
    };

    Faq.prototype.handleSearch = function handleSearch(e) {
        var faqs = this.props.faqs;
        var value = e.target.value;

        this.setState({
            searchInputValue: value
        });
    };

    Faq.prototype.searchItem = function searchItem(faqs, searchInputValue) {
        var results = [];
        var idCheck = []; //Id flag for checking doubles
        var match = false;

        faqs.map(function (faq, index) {
            var question = faq.question.toUpperCase();
            var answer = faq.answer.toUpperCase();
            var keywords = searchInputValue.split(' ');

            for (var i = 0; i < keywords.length; i++) {
                if (question.includes(keywords[i].toUpperCase()) || answer.includes(keywords[i].toUpperCase())) {
                    match = true;
                } else {
                    match = false;
                    break;
                }
            }

            if (match && !idCheck.includes(faq.id)) {
                results.push(faq);
                idCheck.push(faq.id);
            }
        });
        return results;
    };

    return Faq;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model6.default.getColor(state);
    var language = _model6.default.getLanguage(state);
    var faqs = _model4.default.getFeaturePayload(state, 'faq')['faq'];
    return {
        color: color,
        language: language,
        height: _model2.default.getBodyHeight(state),
        faqs: faqs
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Faq);

/***/ }),

/***/ "DlyD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"StartChattingButtonWrapper":"StartChattingButtonWrapper__Ad0yg","StartChattingButton":"StartChattingButton__2wibJ","StartChattingText":"StartChattingText__30r2w","Header":"Header___ApPf"};

/***/ }),

/***/ "Dti/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cancel = function (_Component) {
    _inherits(Cancel, _Component);

    function Cancel() {
        _classCallCheck(this, Cancel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Cancel.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            size = _props.size;

        return (0, _preact.h)(
            "svg",
            { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 16 16" },
            (0, _preact.h)("path", { fill: color, d: "M14 11v2h-12v-2h-2v4h16v-4zM12 6h-3v-5h-2v5h-3l4 6z" })
        );
    };

    return Cancel;
}(_preact.Component);

exports.default = Cancel;

/***/ }),

/***/ "Du07":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _FooterButton = __webpack_require__("un2Q");

var _FooterButton2 = _interopRequireDefault(_FooterButton);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("et9O");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("9VrP");

var _model6 = _interopRequireDefault(_model5);

var _style = __webpack_require__("cuVP");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Footer = function (_Component) {
    _inherits(Footer, _Component);

    function Footer() {
        _classCallCheck(this, Footer);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Footer.prototype.render = function render() {
        var _this2 = this;

        return (0, _preact.h)(
            'div',
            { className: _style2.default.FooterContainer,
                style: { height: this.props.height + 'px', width: this.props.width + 'px' } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.FooterButton },
                (0, _preact.h)(_FooterButton2.default, {
                    orientation: 'left',
                    text: this.props.label,
                    active: this.props.activeTab === 0,
                    color: this.props.color,
                    onClick: function onClick() {
                        return _this2.props.dispatch(_model4.default.setActiveTab(0));
                    },
                    imgSrc: '/common/assets/images/help_desk_sm.svg'
                })
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.FooterButton },
                (0, _preact.h)(_FooterButton2.default, {
                    orientation: 'right',
                    text: this.props.language.get('Chat'),
                    index: 1,
                    active: this.props.activeTab === 1,
                    color: this.props.color,
                    onClick: function onClick() {
                        return _this2.props.dispatch(_model4.default.setActiveTab(1));
                    },
                    imgSrc: '/common/assets/images/chatt_sm.svg'
                })
            )
        );
    };

    return Footer;
}(_preact.Component);

function mapStateToProps(state) {
    var features = _model6.default.getActiveFeatures(state);
    var language = _model2.default.getLanguage(state);

    var label = '';
    var faqType = features['faq_type'];
    switch (faqType) {
        case 'helpdesk':
            label = 'Helpdesk';
            break;
        case 'faq':
        default:
            label = language.get("QuestionsAndAnswers");
    }

    return {
        activeTab: _model4.default.getActiveTab(state),
        color: _model2.default.getColor(state),
        width: _model4.default.getShellWidth(state),
        label: label,
        language: language
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Footer);

/***/ }),

/***/ "EMlc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Scroller":"Scroller__2HbhD","LineWrapper":"LineWrapper__3eEva","Line":"Line__ay_6m"};

/***/ }),

/***/ "EOpn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NewConversationButton":"NewConversationButton__1ZOxi","NewConversationWrapper":"NewConversationWrapper__K33Si","NewConversationText":"NewConversationText__hIZpd"};

/***/ }),

/***/ "EbsL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QuestionsContainer":"QuestionsContainer__2km4z","CustomScroll":"CustomScroll__1fp9x"};

/***/ }),

/***/ "FW1l":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _ellipsis = __webpack_require__("xvMY");

var _ellipsis2 = _interopRequireDefault(_ellipsis);

var _redux = __webpack_require__("2KeS");

var _DateTime = __webpack_require__("VN4q");

var _DateTime2 = _interopRequireDefault(_DateTime);

var _reactEmojiRender = __webpack_require__("Stiw");

var _style = __webpack_require__("or3P");

var _style2 = _interopRequireDefault(_style);

var _immutable = __webpack_require__("BYKG");

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("tdsa");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("lmuV");

var _DefaultProfileImage = __webpack_require__("d+Cn");

var _DefaultProfileImage2 = _interopRequireDefault(_DefaultProfileImage);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import {emojify} from 'react-emojione';


var Conversation = function (_Component) {
    _inherits(Conversation, _Component);

    function Conversation() {
        _classCallCheck(this, Conversation);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleConversationClick = _this.handleConversationClick.bind(_this);
        return _this;
    }

    Conversation.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Conversation, onClick: this.handleConversationClick },
            this.renderUnreadEntriesCount(),
            this.renderSupportProfileImage(),
            this.renderConversationInformation()
        );
    };

    Conversation.prototype.renderConversationInformation = function renderConversationInformation() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.ConversationInformation },
            this.renderName(),
            this.renderLastEntry(),
            this.renderLastEntryTime()
        );
    };

    Conversation.prototype.renderName = function renderName() {
        var name = void 0;
        var unread = this.props.unread;
        if (this.props.assignedEmployee) {
            name = this.__getSupportName();
        } else {
            name = this.__getCompanyName();
        }
        return (0, _preact.h)(
            'div',
            {
                style: unread && { fontWeight: 'bold' },
                className: _style2.default.ConversationItemName },
            '  ',
            name,
            ' '
        );
    };

    Conversation.prototype.__getCompanyName = function __getCompanyName() {
        return (0, _ellipsis2.default)(this.props.name, 33);
    };

    Conversation.prototype.__getSupportName = function __getSupportName() {
        var assignedEmployee = this.props.assignedEmployee;
        var name = (0, _ellipsis2.default)(assignedEmployee.get('display_name'), 33);
        if (!name) {
            name = (0, _ellipsis2.default)(assignedEmployee.get('name'), 33);
        }
        return name;
    };

    Conversation.prototype.renderLastEntry = function renderLastEntry() {
        var unread = this.props.unread;
        var lastEntry = this.props.lastEntry;
        var lastEntryBody = lastEntry.get('entry_body') || '';
        var lastEntryCreator = this.getLastEntryCreatorId();
        var visitorId = this.props.visitor.get('id');
        var you = '';

        if (!lastEntry.get('meta')) {
            if (lastEntryCreator == visitorId && !lastEntry.meta) {
                you = this.props.language.get('You') + ': ';
            }
        }
        return (0, _preact.h)(
            'div',
            { className: _style2.default.ConversationLastEntry,
                style: unread && { fontWeight: 'bold' }
            },
            (0, _preact.h)(_TextDisplay2.default, { text: lastEntryBody })
        );
    };

    Conversation.prototype.renderLastEntryTime = function renderLastEntryTime() {
        var lastEntry = this.props.lastEntry;
        var dateString = lastEntry.get('date_created');
        if (!dateString) return null;

        var time = _DateTime2.default.getDetailedNiceDate(dateString);
        return (0, _preact.h)(
            'span',
            { className: _style2.default.ConversationLastEntryTime },
            time
        );
    };

    Conversation.prototype.renderSupportProfileImage = function renderSupportProfileImage() {
        if (this.props.assignedEmployee) {
            var assignedEmployeeProfileImageUrl = this.props.assignedEmployee.get('image_url');

            if (assignedEmployeeProfileImageUrl) {
                return (0, _preact.h)('img', { 'class': _style2.default.ProfileImage, src: assignedEmployeeProfileImageUrl });
            } else {
                return this.renderBranding();
            }
        }
        return this.renderBranding();
    };

    Conversation.prototype.renderBranding = function renderBranding() {
        var companyName = this.props.name;
        var firstLetter = companyName[0].toUpperCase();

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: '#EAEAEA' }, className: _style2.default.ProfileImage },
            (0, _preact.h)(_DefaultProfileImage2.default, { color: this.props.color })
        );
    };

    Conversation.prototype.renderUnreadEntriesCount = function renderUnreadEntriesCount() {
        return null;
        if (this.props.unread !== 0) return (0, _preact.h)('span', { className: _style2.default.ConversationUnreadEntriesCount });
    };

    Conversation.prototype.getLastEntryCreatorId = function getLastEntryCreatorId() {
        return this.props.lastEntry.get('creator_id', '');
    };

    Conversation.prototype.handleConversationClick = function handleConversationClick() {
        this.props.dispatch(_model4.default.setCurrentRoom(this.props.room));
        this.props.dispatch(_model5.SystemModel.setRoute('Chat'));
    };

    return Conversation;
}(_preact.Component);

function mapStateToProps(state, ownProps) {
    var room = ownProps.conversation.get('room');
    var name = _model2.default.getCompanyDisplayName(state);
    var assignedEmployeeId = _model4.default.getAssignedEmployeeId(room, state);

    return {
        room: room,
        language: _model2.default.getLanguage(state),
        color: _model2.default.getColor(state),
        unread: _model4.default.getUnread(room, state),
        visitor: state.get('user'),
        config: state.get('config'),
        company: state.get('company'),
        unreadEntriesCount: state.get('unreadEntriesCount'),
        assignedEmployee: _model5.CompanyModel.getEmployee(assignedEmployeeId, state),
        lastEntry: _model4.default.getLastEntry(room, state),
        name: name
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Conversation);

/***/ }),

/***/ "Fkom":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  angry: [">:(", ">:-("],
  blush: [':")', ':-")'],
  broken_heart: ["</3", "<\\3"],
  confused: [":/", ":-/"],
  cry: [":'(", ":'-(", ":,(", ":,-("],
  frowning: [":(", ":-("],
  heart: ["<3"],
  imp: ["]:(", "]:-("],
  innocent: ["o:)", "O:)", "o:-)", "O:-)", "0:)", "0:-)"],
  joy: [":')", ":'-)", ":,)", ":,-)", ":'D", ":'-D", ":,D", ":,-D"],
  kissing: [":*", ":-*"],
  laughing: ["x-)", "X-)"],
  neutral_face: [":|", ":-|"],
  open_mouth: [":o", ":-o", ":O", ":-O"],
  rage: [":@", ":-@"],
  smile: [":D", ":-D"],
  smiley: [":)", ":-)"],
  smiling_imp: ["]:)", "]:-)"],
  sob: [":,'(", ":,'-(", ";(", ";-("],
  stuck_out_tongue: [":P", ":-P", ":p", ":-p"],
  sunglasses: ["8-)", "B-)"],
  sweat: [",:(", ",:-("],
  sweat_smile: [",:)", ",:-)"],
  unamused: [":s", ":-S", ":z", ":-Z", ":$", ":-$"],
  wink: [";)", ";-)"]
};

/***/ }),

/***/ "Ft9W":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Header":"Header__3fxbJ"};

/***/ }),

/***/ "G0LE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Returns a wrapper function that returns a wrapped callback
// The wrapper function should do some stuff, and return a
// presumably different callback function.
// This makes sure that own properties are retained, so that
// decorations and such are not lost along the way.
module.exports = wrappy;
function wrappy(fn, cb) {
  if (fn && cb) return wrappy(fn)(cb);

  if (typeof fn !== 'function') throw new TypeError('need wrapper function');

  Object.keys(fn).forEach(function (k) {
    wrapper[k] = fn[k];
  });

  return wrapper;

  function wrapper() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    var ret = fn.apply(this, args);
    var cb = args[args.length - 1];
    if (typeof ret === 'function' && ret !== cb) {
      Object.keys(cb).forEach(function (k) {
        ret[k] = cb[k];
      });
    }
    return ret;
  }
}

/***/ }),

/***/ "G7eB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function Request(optsOrUrl) {
  var opts = typeof optsOrUrl === 'string' ? { url: optsOrUrl } : optsOrUrl || {};
  this.method = opts.method ? opts.method.toUpperCase() : 'GET';
  this.url = opts.url;
  this.headers = opts.headers || {};
  this.body = opts.body;
  this.timeout = opts.timeout || 0;
  this.errorOn404 = opts.errorOn404 != null ? opts.errorOn404 : true;
  this.onload = opts.onload;
  this.onerror = opts.onerror;
}

Request.prototype.abort = function () {
  if (this.aborted) return;
  this.aborted = true;
  this.xhr.abort();
  return this;
};

Request.prototype.header = function (name, value) {
  var k;
  for (k in this.headers) {
    if (this.headers.hasOwnProperty(k)) {
      if (name.toLowerCase() === k.toLowerCase()) {
        if (arguments.length === 1) {
          return this.headers[k];
        }

        delete this.headers[k];
        break;
      }
    }
  }
  if (value != null) {
    this.headers[name] = value;
    return value;
  }
};

module.exports = Request;

/***/ }),

/***/ "G8/f":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _style = __webpack_require__("+RxT");

var _style2 = _interopRequireDefault(_style);

var _actionSetEmojiContainerIsDisplayed = __webpack_require__("pjGl");

var _actionSetEmojiContainerIsDisplayed2 = _interopRequireDefault(_actionSetEmojiContainerIsDisplayed);

var _ChatEmojiIcon = __webpack_require__("bL8x");

var _ChatEmojiIcon2 = _interopRequireDefault(_ChatEmojiIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// Redux actions


var ChatFooterEmojiButton = function (_Component) {
    _inherits(ChatFooterEmojiButton, _Component);

    function ChatFooterEmojiButton(props) {
        _classCallCheck(this, ChatFooterEmojiButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            hover: false,
            isActive: props.emoji.get('isEmojiContainerDisplayed')
        };
        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    ChatFooterEmojiButton.prototype.onHover = function onHover(e) {
        this.setState({ hover: true });
    };

    ChatFooterEmojiButton.prototype.onHoverLeave = function onHoverLeave(e) {
        if (!this.state.isActive) {
            this.setState({ hover: false });
        }
    };

    ChatFooterEmojiButton.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.setState({
            isActive: nextProps.emoji.get('isEmojiContainerDisplayed')
        });
    };

    ChatFooterEmojiButton.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { onClick: this.handleClick,
                onMouseEnter: this.onHover.bind(this),
                onMouseLeave: this.onHoverLeave.bind(this),
                className: _style2.default.ChatFooterEmojiButton },
            (0, _preact.h)(_ChatEmojiIcon2.default, { active: this.state.hover, color: this.props.color })
        );
    };

    ChatFooterEmojiButton.prototype.handleClick = function handleClick() {
        this.toggleEmojiContainerDisplay();
    };

    ChatFooterEmojiButton.prototype.toggleEmojiContainerDisplay = function toggleEmojiContainerDisplay() {
        this.props.actionSetEmojiContainerIsDisplayed(!this.state.isActive);
    };

    return ChatFooterEmojiButton;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        emoji: state.get('emoji')
    };
}

function matchDispatchToProps(dispatch) {
    return (0, _redux.bindActionCreators)({
        actionSetEmojiContainerIsDisplayed: _actionSetEmojiContainerIsDisplayed2.default

    }, dispatch);
}

exports.default = (0, _preactRedux.connect)(mapStateToProps, matchDispatchToProps)(ChatFooterEmojiButton);

/***/ }),

/***/ "GSpp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _DateTime = __webpack_require__("uRCp");

var _DateTime2 = _interopRequireDefault(_DateTime);

var _lang = __webpack_require__("r3oa");

var _lang2 = _interopRequireDefault(_lang);

var _style = __webpack_require__("2wQW");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("lmuV");

var _model2 = __webpack_require__("2YDt");

var _model3 = _interopRequireDefault(_model2);

var _preactRedux = __webpack_require__("1AcT");

var _Autoresponse = __webpack_require__("8Yot");

var _Autoresponse2 = _interopRequireDefault(_Autoresponse);

var _OfflineMessage = __webpack_require__("zHk1");

var _OfflineMessage2 = _interopRequireDefault(_OfflineMessage);

var _OnlineFormular = __webpack_require__("3Yhk");

var _OnlineFormular2 = _interopRequireDefault(_OnlineFormular);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MetaMessage = function (_Component) {
    _inherits(MetaMessage, _Component);

    function MetaMessage() {
        _classCallCheck(this, MetaMessage);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    MetaMessage.prototype.renderFileMessage = function renderFileMessage(entry) {
        var meta = entry.meta;
        var isImage = /\.(gif|jpg|jpeg|tiff|png)$/i.test(meta.details.file_name);
        return (0, _preact.h)(
            'div',
            null,
            (0, _preact.h)(
                'div',
                { style: { color: 'black', marginBottom: '10px' } },
                entry.entry_body
            ),
            (0, _preact.h)(
                'div',
                null,
                isImage && (0, _preact.h)('img', { style: { width: '60%', height: 'auto' }, src: meta.details.url })
            ),
            (0, _preact.h)(
                'a',
                { download: meta.details.file_name, target: '_blank', href: meta.details.url },
                meta.details.file_name
            )
        );
    };

    MetaMessage.prototype.render = function render() {
        var entry = this.props.entry.toJS();
        var user = this.props.user.toJS();
        var message;
        if (!entry.meta) return;
        var meta = entry.meta;
        var type = meta.type;
        switch (meta.type) {
            case 'file':
                message = this.renderFileMessage(entry);
                break;
            case 'autoresponse':
                return (0, _preact.h)(_Autoresponse2.default, { user: user, entry: entry });
            case 'autoresponse_customer':
                switch (meta.details.type) {
                    case 'reply_by_email':
                        message = this.props.language.get("AutoresponseCustomerReplyByEmail");
                        break;
                    default:
                        message = '';
                        break;
                }
                break;
            case 'offline_message':
                return (0, _preact.h)(_OfflineMessage2.default, { entry: entry });
            case 'online_formular':
                return (0, _preact.h)(_OnlineFormular2.default, { entry: entry });
            default:
                message = entry.entry_body;
        }
        return (0, _preact.h)(
            'div',
            { 'class': 'meta-message' },
            message
        );
    };

    return MetaMessage;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        language: _model3.default.getLanguage(state)
    };
})(MetaMessage);

/***/ }),

/***/ "GgF8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' || !isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag;
}

module.exports = isString;

/***/ }),

/***/ "GmLO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = isString;
function isString(maybe) {
  return typeof maybe === 'string';
}

/***/ }),

/***/ "GxWo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("DlyD");

var _style2 = _interopRequireDefault(_style);

var _Input = __webpack_require__("p/6D");

var _Input2 = _interopRequireDefault(_Input);

var _model = __webpack_require__("lmuV");

var _lib = __webpack_require__("vdh7");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var StartChattingButton = function (_Component) {
    _inherits(StartChattingButton, _Component);

    function StartChattingButton(props) {
        _classCallCheck(this, StartChattingButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleNewConversationClick = _this.handleNewConversationClick.bind(_this);
        return _this;
    }

    StartChattingButton.prototype.handleNewConversationClick = function handleNewConversationClick() {
        if (this.props.conversations.isEmpty()) {
            this.props.dispatch(_model.SystemModel.setRoute('Chat'));
        } else {
            this.props.dispatch(_model.SystemModel.setRoute('Conversations'));
        }
    };

    StartChattingButton.prototype.render = function render() {
        //20px for Powered by Jibber label
        var bodyHeight = this.props.height - 35;
        var bodyHeightPx = bodyHeight + 'px';
        var bodyWidth = this.props.width;
        var language = this.props.language;

        var text = language.get("ContinueChatting");
        if (this.props.conversations.isEmpty()) text = language.get("StartChatting");

        var size = bodyHeight > bodyWidth ? bodyWidth / 2 : bodyHeight / 2;
        size += 30;
        var height = size;
        var width = size;
        var borderRadius = size;
        var heightPx = height + 'px';
        var widthPx = width + 'px';
        var marginTop = bodyHeight / 2 - size / 2 - 10 + 'px';
        var marginBottom = '10px';
        var fontSize = '20px';
        var hoverStyle = " hvr-grow";
        if (bodyHeight < 260) {
            heightPx = '55px';
            widthPx = '50%';
            borderRadius = '60px';
            marginTop = height / 2 + 'px';
            hoverStyle = " ";
        }
        return (0, _preact.h)(
            'div',
            {
                className: _style2.default.StartChattingButtonWrapper,
                style: { height: bodyHeightPx }
            },
            (0, _preact.h)(
                'div',
                {
                    className: _style2.default.StartChattingButton + hoverStyle,
                    onClick: this.handleNewConversationClick,
                    style: {
                        marginTop: marginTop,
                        backgroundColor: this.props.color,
                        width: widthPx,
                        height: heightPx,
                        lineHeight: heightPx,
                        borderRadius: borderRadius,
                        fontSize: fontSize
                    } },
                (0, _preact.h)(
                    'span',
                    { className: _style2.default.StartChattingText },
                    ' ',
                    text,
                    ' '
                )
            )
        );
    };

    return StartChattingButton;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model.CustomizationModel.getColor(state);
    var language = _model.CustomizationModel.getLanguage(state);
    var conversations = _model.TicketModel.getAll(state);
    return {
        height: _model.SystemModel.getBodyHeight(state),
        width: _model.SystemModel.getShellWidth(state),
        user: _model.UserModel.get(state).toJS(),
        conversations: conversations, color: color, language: language
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(StartChattingButton);

/***/ }),

/***/ "H7oh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NormalFaq":"NormalFaq__vrIIQ","MobileFaq":"MobileFaq__27iad"};

/***/ }),

/***/ "HJJ4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*https://icons8.com/cssload/en/horizontal-bars*/
var User = function (_Component) {
    _inherits(User, _Component);

    function User() {
        _classCallCheck(this, User);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    User.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            size = _props.size;

        return (0, _preact.h)(
            "svg",
            { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 16 16" },
            (0, _preact.h)("path", { fill: color, d: "M4 5c0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.209-1.791 4-4 4s-4-1.791-4-4zM12 10h-8c-2.209 0-4 1.791-4 4v1h16v-1c0-2.209-1.791-4-4-4z" })
        );
    };

    return User;
}(_preact.Component);

exports.default = User;

/***/ }),

/***/ "HNHs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* The following list is defined in React's core */
var IS_UNITLESS = {
  animationIterationCount: true,
  boxFlex: true,
  boxFlexGroup: true,
  boxOrdinalGroup: true,
  columnCount: true,
  flex: true,
  flexGrow: true,
  flexPositive: true,
  flexShrink: true,
  flexNegative: true,
  flexOrder: true,
  gridRow: true,
  gridColumn: true,
  fontWeight: true,
  lineClamp: true,
  lineHeight: true,
  opacity: true,
  order: true,
  orphans: true,
  tabSize: true,
  widows: true,
  zIndex: true,
  zoom: true,

  // SVG-related properties
  fillOpacity: true,
  stopOpacity: true,
  strokeDashoffset: true,
  strokeOpacity: true,
  strokeWidth: true
};

module.exports = function (name, value) {
  if (typeof value === 'number' && !IS_UNITLESS[name]) {
    return value + 'px';
  } else {
    return value;
  }
};

/***/ }),

/***/ "HW6M":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;

/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = (function () {
			return classNames;
		}).apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
})();

/***/ }),

/***/ "Hjtp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("2g6U");

var _style2 = _interopRequireDefault(_style);

var _NavLeft = __webpack_require__("w84i");

var _NavLeft2 = _interopRequireDefault(_NavLeft);

var _NavRight = __webpack_require__("D9vB");

var _NavRight2 = _interopRequireDefault(_NavRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavButton = function (_Component) {
    _inherits(NavButton, _Component);

    function NavButton(props) {
        _classCallCheck(this, NavButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            isHovered: false
        };
        return _this;
    }

    NavButton.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            display = _props.display,
            onClick = _props.onClick,
            direction = _props.direction,
            color = _props.color;

        var directionStyle = direction === 'left' ? _style2.default.LeftNav : _style2.default.RightNav;
        var arrowColor = this.state.isHovered ? this.props.color : '#e5e5e5';
        var arrow = direction === 'left' ? (0, _preact.h)(_NavLeft2.default, { color: arrowColor }) : (0, _preact.h)(_NavRight2.default, { color: arrowColor });
        if (display) {
            return (0, _preact.h)(
                'div',
                {
                    onMouseEnter: function onMouseEnter() {
                        return _this2.setState({ isHovered: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2.setState({ isHovered: false });
                    },
                    className: '' + _style2.default.NavWrapper },
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.NavBtn + ' ' + directionStyle, onClick: onClick },
                    arrow
                )
            );
        } else {
            return null;
        }
    };

    return NavButton;
}(_preact.Component);

exports.default = NavButton;

/***/ }),

/***/ "I52i":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"fountainG":"fountainG__1x6W_","bounce_fountainG":"bounce_fountainG__3ikd-","fountainG_1":"fountainG_1__3B5Ud","fountainG_2":"fountainG_2__W_XJT","fountainG_3":"fountainG_3__2GLS3","fountainG_4":"fountainG_4__31FCc","fountainG_5":"fountainG_5__2yxsO","fountainG_6":"fountainG_6__2MWqN","fountainG_7":"fountainG_7__aO-9L","fountainG_8":"fountainG_8__3WwD5"};

/***/ }),

/***/ "ICtB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ConversationBody":"ConversationBody__2ddlk"};

/***/ }),

/***/ "II9e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function (global, factory) {
   true ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.draftjsToHtml = factory();
})(undefined, function () {
  'use strict';

  /**
  * Utility function to execute callback for eack key->value pair.
  */

  function forEach(obj, callback) {
    if (obj) {
      for (var key in obj) {
        // eslint-disable-line no-restricted-syntax
        if ({}.hasOwnProperty.call(obj, key)) {
          callback(key, obj[key]);
        }
      }
    }
  }

  /**
  * The function returns true if the string passed to it has no content.
  */
  function isEmptyString(str) {
    if (str === undefined || str === null || str.length === 0 || str.trim().length === 0) {
      return true;
    }
    return false;
  }

  /**
  * Mapping block-type to corresponding html tag.
  */
  var blockTypesMapping = {
    unstyled: 'p',
    'header-one': 'h1',
    'header-two': 'h2',
    'header-three': 'h3',
    'header-four': 'h4',
    'header-five': 'h5',
    'header-six': 'h6',
    'unordered-list-item': 'ul',
    'ordered-list-item': 'ol',
    blockquote: 'blockquote',
    code: 'pre'
  };

  /**
  * Function will return HTML tag for a block.
  */
  function getBlockTag(type) {
    return type && blockTypesMapping[type];
  }

  /**
  * Function will return style string for a block.
  */
  function getBlockStyle(data) {
    var styles = '';
    forEach(data, function (key, value) {
      if (value) {
        styles += key + ':' + value + ';';
      }
    });
    return styles;
  }

  /**
  * The function returns an array of hashtag-sections in blocks.
  * These will be areas in block which have hashtags applicable to them.
  */
  function getHashtagRanges(blockText, hashtagConfig) {
    var sections = [];
    if (hashtagConfig) {
      var counter = 0;
      var startIndex = 0;
      var text = blockText;
      var trigger = hashtagConfig.trigger || '#';
      var separator = hashtagConfig.separator || ' ';
      for (; text.length > 0 && startIndex >= 0;) {
        if (text[0] === trigger) {
          startIndex = 0;
          counter = 0;
          text = text.substr(trigger.length);
        } else {
          startIndex = text.indexOf(separator + trigger);
          if (startIndex >= 0) {
            text = text.substr(startIndex + (separator + trigger).length);
            counter += startIndex + separator.length;
          }
        }
        if (startIndex >= 0) {
          var endIndex = text.indexOf(separator) >= 0 ? text.indexOf(separator) : text.length;
          var hashtag = text.substr(0, endIndex);
          if (hashtag && hashtag.length > 0) {
            sections.push({
              offset: counter,
              length: hashtag.length + trigger.length,
              type: 'HASHTAG'
            });
          }
          counter += trigger.length;
        }
      }
    }
    return sections;
  }

  /**
  * The function returns an array of entity-sections in blocks.
  * These will be areas in block which have same entity or no entity applicable to them.
  */
  function getSections(block, hashtagConfig) {
    var sections = [];
    var lastOffset = 0;
    var sectionRanges = block.entityRanges.map(function (range) {
      var offset = range.offset,
          length = range.length,
          key = range.key;

      return {
        offset: offset,
        length: length,
        key: key,
        type: 'ENTITY'
      };
    });
    sectionRanges = sectionRanges.concat(getHashtagRanges(block.text, hashtagConfig));
    sectionRanges = sectionRanges.sort(function (s1, s2) {
      return s1.offset - s2.offset;
    });
    sectionRanges.forEach(function (r) {
      if (r.offset > lastOffset) {
        sections.push({
          start: lastOffset,
          end: r.offset
        });
      }
      sections.push({
        start: r.offset,
        end: r.offset + r.length,
        entityKey: r.key,
        type: r.type
      });
      lastOffset = r.offset + r.length;
    });
    if (lastOffset < block.text.length) {
      sections.push({
        start: lastOffset,
        end: block.text.length
      });
    }
    return sections;
  }

  /**
  * Function to check if the block is an atomic entity block.
  */
  function isAtomicEntityBlock(block) {
    if (block.entityRanges.length > 0 && (isEmptyString(block.text) || block.type === 'atomic')) {
      return true;
    }
    return false;
  }

  /**
  * The function will return array of inline styles applicable to the block.
  */
  function getStyleArrayForBlock(block) {
    var text = block.text,
        inlineStyleRanges = block.inlineStyleRanges;

    var inlineStyles = {
      BOLD: new Array(text.length),
      ITALIC: new Array(text.length),
      UNDERLINE: new Array(text.length),
      STRIKETHROUGH: new Array(text.length),
      CODE: new Array(text.length),
      SUPERSCRIPT: new Array(text.length),
      SUBSCRIPT: new Array(text.length),
      COLOR: new Array(text.length),
      BGCOLOR: new Array(text.length),
      FONTSIZE: new Array(text.length),
      FONTFAMILY: new Array(text.length),
      length: text.length
    };
    if (inlineStyleRanges && inlineStyleRanges.length > 0) {
      inlineStyleRanges.forEach(function (range) {
        var offset = range.offset;

        var length = offset + range.length;
        for (var i = offset; i < length; i += 1) {
          if (range.style.indexOf('color-') === 0) {
            inlineStyles.COLOR[i] = range.style.substring(6);
          } else if (range.style.indexOf('bgcolor-') === 0) {
            inlineStyles.BGCOLOR[i] = range.style.substring(8);
          } else if (range.style.indexOf('fontsize-') === 0) {
            inlineStyles.FONTSIZE[i] = range.style.substring(9);
          } else if (range.style.indexOf('fontfamily-') === 0) {
            inlineStyles.FONTFAMILY[i] = range.style.substring(11);
          } else if (inlineStyles[range.style]) {
            inlineStyles[range.style][i] = true;
          }
        }
      });
    }
    return inlineStyles;
  }

  /**
  * The function will return inline style applicable at some offset within a block.
  */
  function getStylesAtOffset(inlineStyles, offset) {
    var styles = {};
    if (inlineStyles.COLOR[offset]) {
      styles.COLOR = inlineStyles.COLOR[offset];
    }
    if (inlineStyles.BGCOLOR[offset]) {
      styles.BGCOLOR = inlineStyles.BGCOLOR[offset];
    }
    if (inlineStyles.FONTSIZE[offset]) {
      styles.FONTSIZE = inlineStyles.FONTSIZE[offset];
    }
    if (inlineStyles.FONTFAMILY[offset]) {
      styles.FONTFAMILY = inlineStyles.FONTFAMILY[offset];
    }
    if (inlineStyles.UNDERLINE[offset]) {
      styles.UNDERLINE = true;
    }
    if (inlineStyles.ITALIC[offset]) {
      styles.ITALIC = true;
    }
    if (inlineStyles.BOLD[offset]) {
      styles.BOLD = true;
    }
    if (inlineStyles.STRIKETHROUGH[offset]) {
      styles.STRIKETHROUGH = true;
    }
    if (inlineStyles.CODE[offset]) {
      styles.CODE = true;
    }
    if (inlineStyles.SUBSCRIPT[offset]) {
      styles.SUBSCRIPT = true;
    }
    if (inlineStyles.SUPERSCRIPT[offset]) {
      styles.SUPERSCRIPT = true;
    }
    return styles;
  }

  /**
  * Function returns true for a set of styles if the value of these styles at an offset
  * are same as that on the previous offset.
  */
  function sameStyleAsPrevious(inlineStyles, styles, index) {
    var sameStyled = true;
    if (index > 0 && index < inlineStyles.length) {
      styles.forEach(function (style) {
        sameStyled = sameStyled && inlineStyles[style][index] === inlineStyles[style][index - 1];
      });
    } else {
      sameStyled = false;
    }
    return sameStyled;
  }

  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */
  function addInlineStyleMarkup(style, content) {
    if (style === 'BOLD') {
      return '<strong>' + content + '</strong>';
    } else if (style === 'ITALIC') {
      return '<em>' + content + '</em>';
    } else if (style === 'UNDERLINE') {
      return '<ins>' + content + '</ins>';
    } else if (style === 'STRIKETHROUGH') {
      return '<del>' + content + '</del>';
    } else if (style === 'CODE') {
      return '<code>' + content + '</code>';
    } else if (style === 'SUPERSCRIPT') {
      return '<sup>' + content + '</sup>';
    } else if (style === 'SUBSCRIPT') {
      return '<sub>' + content + '</sub>';
    }
    return content;
  }

  /**
  * The function returns text for given section of block after doing required character replacements.
  */
  function getSectionText(text) {
    if (text && text.length > 0) {
      var chars = text.map(function (ch) {
        switch (ch) {
          case '\n':
            return '<br>';
          case '&':
            return '&amp;';
          case '<':
            return '&lt;';
          case '>':
            return '&gt;';
          default:
            return ch;
        }
      });
      return chars.join('');
    }
    return '';
  }

  /**
  * Function returns html for text depending on inline style tags applicable to it.
  */
  function addStylePropertyMarkup(styles, text) {
    if (styles && (styles.COLOR || styles.BGCOLOR || styles.FONTSIZE || styles.FONTFAMILY)) {
      var styleString = 'style="';
      if (styles.COLOR) {
        styleString += 'color: ' + styles.COLOR + ';';
      }
      if (styles.BGCOLOR) {
        styleString += 'background-color: ' + styles.BGCOLOR + ';';
      }
      if (styles.FONTSIZE) {
        styleString += 'font-size: ' + styles.FONTSIZE + (/^\d+$/.test(styles.FONTSIZE) ? 'px' : '') + ';';
      }
      if (styles.FONTFAMILY) {
        styleString += 'font-family: ' + styles.FONTFAMILY + ';';
      }
      styleString += '"';
      return '<span ' + styleString + '>' + text + '</span>';
    }
    return text;
  }

  /**
  * Function will return markup for Entity.
  */
  function getEntityMarkup(entityMap, entityKey, text, customEntityTransform) {
    var entity = entityMap[entityKey];
    if (typeof customEntityTransform === 'function') {
      var html = customEntityTransform(entity, text);
      if (html) {
        return html;
      }
    }
    if (entity.type === 'MENTION') {
      return '<a href="' + entity.data.url + '" class="wysiwyg-mention" data-mention data-value="' + entity.data.value + '">' + text + '</a>';
    }
    if (entity.type === 'LINK') {
      var targetOption = entity.data.targetOption || '_self';
      return '<a href="' + entity.data.url + '" target="' + targetOption + '">' + text + '</a>';
    }
    if (entity.type === 'IMAGE') {
      return '<img src="' + entity.data.src + '" alt="' + entity.data.alt + '" style="float:' + (entity.data.alignment || 'none') + ';height: ' + entity.data.height + ';width: ' + entity.data.width + '"/>';
    }
    if (entity.type === 'EMBEDDED_LINK') {
      return '<iframe width="' + entity.data.width + '" height="' + entity.data.height + '" src="' + entity.data.src + '" frameBorder="0"></iframe>';
    }
    return text;
  }

  /**
  * For a given section in a block the function will return a further list of sections,
  * with similar inline styles applicable to them.
  */
  function getInlineStyleSections(block, styles, start, end) {
    var styleSections = [];
    var text = block.text;

    if (text.length > 0) {
      var inlineStyles = getStyleArrayForBlock(block);
      var section = void 0;
      for (var i = start; i < end; i += 1) {
        if (i !== start && sameStyleAsPrevious(inlineStyles, styles, i)) {
          section.text.push(text[i]);
          section.end = i + 1;
        } else {
          section = {
            styles: getStylesAtOffset(inlineStyles, i),
            text: [text[i]],
            start: i,
            end: i + 1
          };
          styleSections.push(section);
        }
      }
    }
    return styleSections;
  }

  /**
  * Replace leading blank spaces by &nbsp;
  */
  function trimLeadingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;
      for (var i = 0; i < replacedText.length; i += 1) {
        if (sectionText[i] === ' ') {
          replacedText = replacedText.replace(' ', '&nbsp;');
        } else {
          break;
        }
      }
      return replacedText;
    }
    return sectionText;
  }

  /**
  * Replace trailing blank spaces by &nbsp;
  */
  function trimTrailingZeros(sectionText) {
    if (sectionText) {
      var replacedText = sectionText;
      for (var i = replacedText.length - 1; i >= 0; i -= 1) {
        if (replacedText[i] === ' ') {
          replacedText = replacedText.substring(0, i) + '&nbsp;' + replacedText.substring(i + 1);
        } else {
          break;
        }
      }
      return replacedText;
    }
    return sectionText;
  }

  /**
  * The method returns markup for section to which inline styles
  * like BOLD, ITALIC, UNDERLINE, STRIKETHROUGH, CODE, SUPERSCRIPT, SUBSCRIPT are applicable.
  */
  function getStyleTagSectionMarkup(styleSection) {
    var styles = styleSection.styles,
        text = styleSection.text;

    var content = getSectionText(text);
    forEach(styles, function (style, value) {
      content = addInlineStyleMarkup(style, content, value);
    });
    return content;
  }

  /**
  * The method returns markup for section to which inline styles
  like color, background-color, font-size are applicable.
  */
  function getInlineStyleSectionMarkup(block, styleSection) {
    var styleTagSections = getInlineStyleSections(block, ['BOLD', 'ITALIC', 'UNDERLINE', 'STRIKETHROUGH', 'CODE', 'SUPERSCRIPT', 'SUBSCRIPT'], styleSection.start, styleSection.end);
    var styleSectionText = '';
    styleTagSections.forEach(function (stylePropertySection) {
      styleSectionText += getStyleTagSectionMarkup(stylePropertySection);
    });
    styleSectionText = addStylePropertyMarkup(styleSection.styles, styleSectionText);
    return styleSectionText;
  }

  /*
  * The method returns markup for an entity section.
  * An entity section is a continuous section in a block
  * to which same entity or no entity is applicable.
  */
  function getSectionMarkup(block, entityMap, section, customEntityTransform) {
    var entityInlineMarkup = [];
    var inlineStyleSections = getInlineStyleSections(block, ['COLOR', 'BGCOLOR', 'FONTSIZE', 'FONTFAMILY'], section.start, section.end);
    inlineStyleSections.forEach(function (styleSection) {
      entityInlineMarkup.push(getInlineStyleSectionMarkup(block, styleSection));
    });
    var sectionText = entityInlineMarkup.join('');
    if (section.type === 'ENTITY') {
      if (section.entityKey !== undefined && section.entityKey !== null) {
        sectionText = getEntityMarkup(entityMap, section.entityKey, sectionText, customEntityTransform); // eslint-disable-line max-len
      }
    } else if (section.type === 'HASHTAG') {
      sectionText = '<a href="' + sectionText + '" class="wysiwyg-hashtag">' + sectionText + '</a>';
    }
    return sectionText;
  }

  /**
  * Function will return the markup for block preserving the inline styles and
  * special characters like newlines or blank spaces.
  */
  function getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform) {
    var blockMarkup = [];
    var sections = getSections(block, hashtagConfig);
    sections.forEach(function (section, index) {
      var sectionText = getSectionMarkup(block, entityMap, section, customEntityTransform);
      if (index === 0) {
        sectionText = trimLeadingZeros(sectionText);
      }
      if (index === sections.length - 1) {
        sectionText = trimTrailingZeros(sectionText);
      }
      blockMarkup.push(sectionText);
    });
    return blockMarkup.join('');
  }

  /**
  * Function will return html for the block.
  */
  function getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform) {
    var blockHtml = [];
    if (isAtomicEntityBlock(block)) {
      blockHtml.push(getEntityMarkup(entityMap, block.entityRanges[0].key, undefined, customEntityTransform));
    } else {
      var blockTag = getBlockTag(block.type);
      if (blockTag) {
        blockHtml.push('<' + blockTag);
        var blockStyle = getBlockStyle(block.data);
        if (blockStyle) {
          blockHtml.push(' style="' + blockStyle + '"');
        }
        if (directional) {
          blockHtml.push(' dir = "auto"');
        }
        blockHtml.push('>');
        blockHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        blockHtml.push('</' + blockTag + '>');
      }
    }
    blockHtml.push('\n');
    return blockHtml.join('');
  }

  /**
  * Function to check if a block is of type list.
  */
  function isList(blockType) {
    return blockType === 'unordered-list-item' || blockType === 'ordered-list-item';
  }

  /**
  * Function will return html markup for a list block.
  */
  function getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform) {
    var listHtml = [];
    var nestedListBlock = [];
    var previousBlock = void 0;
    listBlocks.forEach(function (block) {
      var nestedBlock = false;
      if (!previousBlock) {
        listHtml.push('<' + getBlockTag(block.type) + '>\n');
      } else if (previousBlock.type !== block.type) {
        listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
        listHtml.push('<' + getBlockTag(block.type) + '>\n');
      } else if (previousBlock.depth === block.depth) {
        if (nestedListBlock && nestedListBlock.length > 0) {
          listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
          nestedListBlock = [];
        }
      } else {
        nestedBlock = true;
        nestedListBlock.push(block);
      }
      if (!nestedBlock) {
        listHtml.push('<li');
        var blockStyle = getBlockStyle(block.data);
        if (blockStyle) {
          listHtml.push(' style="' + blockStyle + '"');
        }
        if (directional) {
          listHtml.push(' dir = "auto"');
        }
        listHtml.push('>');
        listHtml.push(getBlockInnerMarkup(block, entityMap, hashtagConfig, customEntityTransform));
        listHtml.push('</li>\n');
        previousBlock = block;
      }
    });
    if (nestedListBlock && nestedListBlock.length > 0) {
      listHtml.push(getListMarkup(nestedListBlock, entityMap, hashtagConfig, directional, customEntityTransform));
    }
    listHtml.push('</' + getBlockTag(previousBlock.type) + '>\n');
    return listHtml.join('');
  }

  /**
  * The function will generate html markup for given draftjs editorContent.
  */
  function draftToHtml(editorContent, hashtagConfig, directional, customEntityTransform) {
    var html = [];
    if (editorContent) {
      var blocks = editorContent.blocks,
          entityMap = editorContent.entityMap;

      if (blocks && blocks.length > 0) {
        var listBlocks = [];
        blocks.forEach(function (block) {
          if (isList(block.type)) {
            listBlocks.push(block);
          } else {
            if (listBlocks.length > 0) {
              var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, customEntityTransform); // eslint-disable-line max-len
              html.push(listHtml);
              listBlocks = [];
            }
            var blockHtml = getBlockMarkup(block, entityMap, hashtagConfig, directional, customEntityTransform);
            html.push(blockHtml);
          }
        });
        if (listBlocks.length > 0) {
          var listHtml = getListMarkup(listBlocks, entityMap, hashtagConfig, directional, customEntityTransform); // eslint-disable-line max-len
          html.push(listHtml);
          listBlocks = [];
        }
      }
    }
    return html.join('');
  }

  return draftToHtml;
});

/***/ }),

/***/ "Jw2m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Button = exports.BackButton = exports.SettingsButton = exports.FaqButton = exports.CloseButton = undefined;

var _CloseButton = __webpack_require__("p9Bm");

var _CloseButton2 = _interopRequireDefault(_CloseButton);

var _FaqButton = __webpack_require__("R+0I");

var _FaqButton2 = _interopRequireDefault(_FaqButton);

var _SettingsButton = __webpack_require__("kThW");

var _SettingsButton2 = _interopRequireDefault(_SettingsButton);

var _BackButton = __webpack_require__("cgTv");

var _BackButton2 = _interopRequireDefault(_BackButton);

var _Button = __webpack_require__("pZVW");

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CloseButton = _CloseButton2.default;
exports.FaqButton = _FaqButton2.default;
exports.SettingsButton = _SettingsButton2.default;
exports.BackButton = _BackButton2.default;
exports.Button = _Button2.default;

/***/ }),

/***/ "K3CK":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Container":"Container__1hoWw","CategoriesWrapper":"CategoriesWrapper__3Hwdw","RowFocused":"RowFocused__3Ts8Y","Row":"Row__OmAJI","QuestionsContainer":"QuestionsContainer__sXK8r"};

/***/ }),

/***/ "KSGD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element') || 0xeac7;

  var isValidElement = function isValidElement(object) {
    return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__("Q4WQ")();
}

/***/ }),

/***/ "Kylw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("Zj7u");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button(props) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.mouseEnter = _this.mouseEnter.bind(_this);
        _this.mouseLeave = _this.mouseLeave.bind(_this);

        _this.state = {
            hover: false
        };
        return _this;
    }

    Button.prototype.mouseEnter = function mouseEnter() {
        this.setState({ hover: true });
        this.props.mouseEnter();
    };

    Button.prototype.mouseLeave = function mouseLeave() {
        this.setState({ hover: false });
        this.props.mouseLeave();
    };

    Button.prototype.render = function render() {
        var _props = this.props,
            text = _props.text,
            color = _props.color,
            onClick = _props.onClick,
            active = _props.active;
        var hover = this.state.hover;

        var bgColor = hover || active ? color : 'white';
        var textColor = hover || active ? 'white' : '#6c6c6c';
        var border = hover || active ? 'solid 2px ' + color : 'solid 2px #bababa';

        return (0, _preact.h)(
            'div',
            { className: _style2.default.ButtonContainer,
                style: {
                    backgroundColor: bgColor,
                    border: border,
                    color: textColor
                },
                onClick: onClick,
                onMouseEnter: this.mouseEnter,
                onMouseLeave: this.mouseLeave },
            text
        );
    };

    return Button;
}(_preact.Component);

exports.default = Button;

/***/ }),

/***/ "LIe4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Left":"Left__1XV9W","Right":"Right__IQ1ZQ","FooterButton":"FooterButton__2mmsj","FooterButtonImg":"FooterButtonImg__hiaKL","FooterButtonText":"FooterButtonText__2aPVw","UnreadDotContainer":"UnreadDotContainer__b_1EX","UnreadDot":"UnreadDot__2A8a8"};

/***/ }),

/***/ "LM1n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _ellipsis = __webpack_require__("xvMY");

var _ellipsis2 = _interopRequireDefault(_ellipsis);

var _style = __webpack_require__("5MAO");

var _style2 = _interopRequireDefault(_style);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FaqItem = function (_Component) {
    _inherits(FaqItem, _Component);

    function FaqItem() {
        _classCallCheck(this, FaqItem);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    FaqItem.prototype.render = function render() {
        var faq = this.props.faq;
        var question = faq.question;
        var answer = faq.answer;
        var answerLength = faq.answer.length;
        var itemId = faq.id;
        var color = this.props.color;
        var handleItemClick = this.props.handleItemClick;
        var selectedItemId = this.props.selectedItemId;

        var itemColor = '';
        var arrowClassName = _style2.default.ArrowDown;

        var ellipsisStyle = _style2.default.ellipsis;

        if (answerLength < 180) {
            ellipsisStyle = ' ';
        }
        if (selectedItemId === itemId && answerLength > 180) {
            itemColor = '#FBFBFB';
            arrowClassName = _style2.default.ArrowUp;
            ellipsisStyle = ' ';
        }

        var className = _style2.default.ItemWrapper;
        return (0, _preact.h)(
            'div',
            { 'class': _style2.default.ItemWrapper, style: { background: itemColor }, onClick: function onClick() {
                    handleItemClick(itemId);
                } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.ItemQuestion },
                (0, _preact.h)(_TextDisplay2.default, { text: question })
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.ItemAnswer + ' ' + ellipsisStyle },
                (0, _preact.h)(_TextDisplay2.default, { text: answer }),
                this.renderIcon(color, arrowClassName, answerLength)
            )
        );
    };

    FaqItem.prototype.renderIcon = function renderIcon(color, arrowClassName, answerLength) {
        if (answerLength > 180) {
            return (0, _preact.h)('span', { className: arrowClassName, style: { color: color } });
        }
    };

    return FaqItem;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        faqs: state.get('faqs')
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(FaqItem);

/***/ }),

/***/ "LqNj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cancel = function (_Component) {
    _inherits(Cancel, _Component);

    function Cancel() {
        _classCallCheck(this, Cancel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Cancel.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            size = _props.size;

        return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M4.58,39a1.51,1.51,0,0,1-1.37-2.15l2.8-6a18.07,18.07,0,1,1,6,5.66L5.07,38.9A1.47,1.47,0,0,1,4.58,39Zm-.35-2.34h0Zm8.13-3a1.23,1.23,0,0,1,.65.19,15.13,15.13,0,1,0-4.29-4,1.23,1.23,0,0,1,.11,1.24L6.76,35.49,12,33.73A1.23,1.23,0,0,1,12.36,33.66Z" }),
            (0, _preact.h)("path", { fill: color, d: "M15.94,12.9a8.18,8.18,0,0,1,5-1.81c3.37,0,6.08,2.25,6.08,5.54,0,2.62-2.2,4-3.91,4.93-.9.52-1.77.75-1.77,1.41s.56,1,.43,1.51-.5.82-1.4.82a2,2,0,0,1-2-2.19c0-1.53,1.1-2.48,2.49-3.29S24,18.15,24,16.65a2.73,2.73,0,0,0-3-2.71A6,6,0,0,0,18,15.06a2.56,2.56,0,0,1-1.48.66,1.6,1.6,0,0,1-1.39-1.47A1.67,1.67,0,0,1,15.94,12.9Z" }),
            (0, _preact.h)("circle", { fill: color, cx: "20.02", cy: "30", r: "1.97" })
        );
    };

    return Cancel;
}(_preact.Component);

exports.default = Cancel;

/***/ }),

/***/ "MDPO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInnerHeight;
function getInnerHeight(el) {
  var clientHeight = el.clientHeight;

  var _window$getComputedSt = window.getComputedStyle(el),
      paddingTop = _window$getComputedSt.paddingTop,
      paddingBottom = _window$getComputedSt.paddingBottom;

  return clientHeight - parseFloat(paddingTop) - parseFloat(paddingBottom);
}

/***/ }),

/***/ "Ma+D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var cleanURL = __webpack_require__("Qc0D"),
    XHR = __webpack_require__("BbdM"),
    delay = __webpack_require__("6UoE"),
    RequestError = __webpack_require__("cC0N"),
    Response = __webpack_require__("63ec"),
    Request = __webpack_require__("G7eB"),
    extend = __webpack_require__("TRnG"),
    once = __webpack_require__("YXF7");

var i,
    createError = RequestError.create;

function factory(defaults, plugins) {
  defaults = defaults || {};
  plugins = plugins || [];

  function http(req, cb) {
    var xhr, plugin, done, k, timeoutId, supportsLoadAndErrorEvents;

    req = new Request(extend(defaults, req));

    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.processRequest) {
        plugin.processRequest(req);
      }
    }

    // Give the plugins a chance to create the XHR object
    for (i = 0; i < plugins.length; i++) {
      plugin = plugins[i];
      if (plugin.createXHR) {
        xhr = plugin.createXHR(req);
        break; // First come, first serve
      }
    }
    xhr = xhr || new XHR();

    req.xhr = xhr;

    // Use a single completion callback. This can be called with or without
    // an error. If no error is passed, the request will be examined to see
    // if it was successful.
    done = once(delay(function (rawError) {
      clearTimeout(timeoutId);
      xhr.onload = xhr.onerror = xhr.onabort = xhr.onreadystatechange = xhr.ontimeout = xhr.onprogress = null;

      var err = getError(req, rawError);

      var res = err || Response.fromRequest(req);
      for (i = 0; i < plugins.length; i++) {
        plugin = plugins[i];
        if (plugin.processResponse) {
          plugin.processResponse(res);
        }
      }

      // Invoke callbacks
      if (err && req.onerror) req.onerror(err);
      if (!err && req.onload) req.onload(res);
      if (cb) cb(err, err ? undefined : res);
    }));

    supportsLoadAndErrorEvents = 'onload' in xhr && 'onerror' in xhr;
    xhr.onload = function () {
      done();
    };
    xhr.onerror = done;
    xhr.onabort = function () {
      done();
    };

    // We'd rather use `onload`, `onerror`, and `onabort` since they're the
    // only way to reliably detect successes and failures but, if they
    // aren't available, we fall back to using `onreadystatechange`.
    xhr.onreadystatechange = function () {
      if (xhr.readyState !== 4) return;

      if (req.aborted) return done();

      if (!supportsLoadAndErrorEvents) {
        // Assume a status of 0 is an error. This could be a false
        // positive, but there's no way to tell when using
        // `onreadystatechange` ):
        // See matthewwithanm/react-inlinesvg#10.

        // Some browsers don't like you reading XHR properties when the
        // XHR has been aborted. In case we've gotten here as a result
        // of that (either our calling `about()` in the timeout handler
        // or the user calling it directly even though they shouldn't),
        // be careful about accessing it.
        var status;
        try {
          status = xhr.status;
        } catch (err) {}
        var err = status === 0 ? new Error('Internal XHR Error') : null;
        return done(err);
      }
    };

    // IE sometimes fails if you don't specify every handler.
    // See http://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
    xhr.ontimeout = function () {/* noop */};
    xhr.onprogress = function () {/* noop */};

    xhr.open(req.method, req.url);

    if (req.timeout) {
      // If we use the normal XHR timeout mechanism (`xhr.timeout` and
      // `xhr.ontimeout`), `onreadystatechange` will be triggered before
      // `ontimeout`. There's no way to recognize that it was triggered by
      // a timeout, and we'd be unable to dispatch the right error.
      timeoutId = setTimeout(function () {
        req.timedOut = true;
        done();
        try {
          xhr.abort();
        } catch (err) {}
      }, req.timeout);
    }

    for (k in req.headers) {
      if (req.headers.hasOwnProperty(k)) {
        xhr.setRequestHeader(k, req.headers[k]);
      }
    }

    xhr.send(req.body);

    return req;
  }

  var method,
      methods = ['get', 'post', 'put', 'head', 'patch', 'delete'],
      verb = function verb(method) {
    return function (req, cb) {
      req = new Request(req);
      req.method = method;
      return http(req, cb);
    };
  };
  for (i = 0; i < methods.length; i++) {
    method = methods[i];
    http[method] = verb(method);
  }

  http.plugins = function () {
    return plugins;
  };

  http.defaults = function (newValues) {
    if (newValues) {
      return factory(extend(defaults, newValues), plugins);
    }
    return defaults;
  };

  http.use = function () {
    var newPlugins = Array.prototype.slice.call(arguments, 0);
    return factory(defaults, plugins.concat(newPlugins));
  };

  http.bare = function () {
    return factory();
  };

  http.Request = Request;
  http.Response = Response;
  http.RequestError = RequestError;

  return http;
}

module.exports = factory({}, [cleanURL]);

/**
 * Analyze the request to see if it represents an error. If so, return it! An
 * original error object can be passed as a hint.
 */
function getError(req, err) {
  if (req.aborted) return createError('Request aborted', req, { name: 'Abort' });

  if (req.timedOut) return createError('Request timeout', req, { name: 'Timeout' });

  var xhr = req.xhr;
  var type = Math.floor(xhr.status / 100);

  var kind;
  switch (type) {
    case 0:
    case 2:
      // These don't represent errors unless the function was passed an
      // error object explicitly.
      if (!err) return;
      return createError(err.message, req);
    case 4:
      // Sometimes 4XX statuses aren't errors.
      if (xhr.status === 404 && !req.errorOn404) return;
      kind = 'Client';
      break;
    case 5:
      kind = 'Server';
      break;
    default:
      kind = 'HTTP';
  }
  var msg = kind + ' Error: ' + 'The server returned a status of ' + xhr.status + ' for the request "' + req.method.toUpperCase() + ' ' + req.url + '"';
  return createError(msg, req);
}

/***/ }),

/***/ "Mx5r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


https: //github.com/tommoor/react-emoji-render/blob/master/data/aliases.js
module.exports = {
  "skin-tone-2": "🏻",
  "skin-tone-3": "🏿",
  "skin-tone-4": "🏽",
  "skin-tone-5": "🏾",
  "skin-tone-6": "🏿",
  "100": "💯",
  "1234": "🔢",
  money_mouth_face: "🤑",
  skull_and_crossbones: "☠️",
  smile: "😄",
  smiley: "😃",
  grinning: "😀",
  ':)': "🙂",
  slightly_smiling_face: "🙂",
  blush: "😊",
  relaxed: "☺️",
  wink: "😉",
  heart_eyes: "😍",
  kissing_heart: "😘",
  kissing_closed_eyes: "😚",
  kissing: "😗",
  kissing_smiling_eyes: "😙",
  stuck_out_tongue_winking_eye: "😜",
  stuck_out_tongue_closed_eyes: "😝",
  stuck_out_tongue: "😛",
  flushed: "😳",
  grin: "😁",
  pensive: "😔",
  relieved: "😌",
  unamused: "😒",
  disappointed: "😞",
  persevere: "😣",
  cry: "😢",
  joy: "😂",
  sob: "😭",
  sleepy: "😪",
  disappointed_relieved: "😥",
  cold_sweat: "😰",
  sweat_smile: "😅",
  sweat: "😓",
  weary: "😩",
  tired_face: "😫",
  fearful: "😨",
  scream: "😱",
  angry: "😠",
  rage: "😡",
  pout: "😡",
  triumph: "😤",
  confounded: "😖",
  laughing: "😆",
  satisfied: "😆",
  yum: "😋",
  mask: "😷",
  sunglasses: "😎",
  sleeping: "😴",
  dizzy_face: "😵",
  astonished: "😲",
  worried: "😟",
  frowning: "😦",
  anguished: "😧",
  smiling_imp: "😈",
  imp: "👿",
  open_mouth: "😮",
  grimacing: "😬",
  neutral_face: "😐",
  confused: "😕",
  hushed: "😯",
  no_mouth: "😶",
  innocent: "😇",
  smirk: "😏",
  expressionless: "😑",
  man_with_gua_pi_mao: "👲",
  man_with_turban: "👳",
  cop: "👮",
  construction_worker: "👷",
  guardsman: "💂",
  baby: "👶",
  boy: "👦",
  girl: "👧",
  man: "👨",
  woman: "👩",
  older_man: "👴",
  older_woman: "👵",
  person_with_blond_hair: "👱",
  angel: "👼",
  princess: "👸",
  smiley_cat: "😺",
  smile_cat: "😸",
  heart_eyes_cat: "😻",
  kissing_cat: "😽",
  smirk_cat: "😼",
  scream_cat: "🙀",
  crying_cat_face: "😿",
  joy_cat: "😹",
  pouting_cat: "😾",
  japanese_ogre: "👹",
  japanese_goblin: "👺",
  see_no_evil: "🙈",
  hear_no_evil: "🙉",
  speak_no_evil: "🙊",
  skull: "💀",
  alien: "👽",
  hankey: "💩",
  poop: "💩",
  shit: "💩",
  fire: "🔥",
  sparkles: "✨",
  star2: "🌟",
  dizzy: "💫",
  boom: "💥",
  collision: "💥",
  anger: "💢",
  sweat_drops: "💦",
  droplet: "💧",
  zzz: "💤",
  dash: "💨",
  ear: "👂",
  eyes: "👀",
  nose: "👃",
  tongue: "👅",
  lips: "👄",
  "+1": "👍",
  thumbsup: "👍",
  "-1": "👎",
  thumbsdown: "👎",
  ok_hand: "👌",
  facepunch: "👊",
  punch: "👊",
  fist: "✊",
  v: "✌️",
  wave: "👋",
  hand: "✋",
  raised_hand: "✋",
  open_hands: "👐",
  point_up_2: "👆",
  point_down: "👇",
  point_right: "👉",
  point_left: "👈",
  raised_hands: "🙌",
  pray: "🙏",
  point_up: "☝️",
  clap: "👏",
  muscle: "💪",
  walking: "🚶",
  runner: "🏃",
  running: "🏃",
  dancer: "💃",
  couple: "👫",
  family: "👪",
  two_men_holding_hands: "👬",
  two_women_holding_hands: "👭",
  couplekiss: "💏",
  couple_with_heart: "💑",
  dancers: "👯",
  ok_woman: "🙆",
  no_good: "🙅",
  ng_woman: "🙅",
  information_desk_person: "💁",
  raising_hand: "🙋",
  massage: "💆",
  haircut: "💇",
  nail_care: "💅",
  bride_with_veil: "👰",
  person_with_pouting_face: "🙎",
  person_frowning: "🙍",
  bow: "🙇",
  tophat: "🎩",
  crown: "👑",
  womans_hat: "👒",
  athletic_shoe: "👟",
  mans_shoe: "👞",
  shoe: "👞",
  sandal: "👡",
  high_heel: "👠",
  boot: "👢",
  shirt: "👕",
  tshirt: "👕",
  necktie: "👔",
  womans_clothes: "👚",
  dress: "👗",
  running_shirt_with_sash: "🎽",
  jeans: "👖",
  kimono: "👘",
  bikini: "👙",
  briefcase: "💼",
  handbag: "👜",
  pouch: "👝",
  purse: "👛",
  eyeglasses: "👓",
  ribbon: "🎀",
  closed_umbrella: "🌂",
  lipstick: "💄",
  yellow_heart: "💛",
  blue_heart: "💙",
  purple_heart: "💜",
  green_heart: "💚",
  heart: "❤️",
  broken_heart: "💔",
  heartpulse: "💗",
  heartbeat: "💓",
  two_hearts: "💕",
  sparkling_heart: "💖",
  revolving_hearts: "💞",
  cupid: "💘",
  love_letter: "💌",
  kiss: "💋",
  ring: "💍",
  gem: "💎",
  bust_in_silhouette: "👤",
  busts_in_silhouette: "👥",
  speech_balloon: "💬",
  footprints: "👣",
  thought_balloon: "💭",
  dog: "🐶",
  wolf: "🐺",
  cat: "🐱",
  mouse: "🐭",
  hamster: "🐹",
  rabbit: "🐰",
  frog: "🐸",
  tiger: "🐯",
  koala: "🐨",
  bear: "🐻",
  pig: "🐷",
  pig_nose: "🐽",
  cow: "🐮",
  boar: "🐗",
  monkey_face: "🐵",
  monkey: "🐒",
  horse: "🐴",
  sheep: "🐑",
  elephant: "🐘",
  panda_face: "🐼",
  penguin: "🐧",
  bird: "🐦",
  baby_chick: "🐤",
  hatched_chick: "🐥",
  hatching_chick: "🐣",
  chicken: "🐔",
  snake: "🐍",
  turtle: "🐢",
  bug: "🐛",
  bee: "🐝",
  honeybee: "🐝",
  ant: "🐜",
  beetle: "🐞",
  snail: "🐌",
  octopus: "🐙",
  shell: "🐚",
  tropical_fish: "🐠",
  fish: "🐟",
  dolphin: "🐬",
  flipper: "🐬",
  whale: "🐳",
  whale2: "🐋",
  cow2: "🐄",
  ram: "🐏",
  rat: "🐀",
  water_buffalo: "🐃",
  tiger2: "🐅",
  rabbit2: "🐇",
  dragon: "🐉",
  racehorse: "🐎",
  goat: "🐐",
  rooster: "🐓",
  dog2: "🐕",
  pig2: "🐖",
  mouse2: "🐁",
  ox: "🐂",
  dragon_face: "🐲",
  blowfish: "🐡",
  crocodile: "🐊",
  camel: "🐫",
  dromedary_camel: "🐪",
  leopard: "🐆",
  cat2: "🐈",
  poodle: "🐩",
  feet: "🐾",
  paw_prints: "🐾",
  bouquet: "💐",
  cherry_blossom: "🌸",
  tulip: "🌷",
  four_leaf_clover: "🍀",
  rose: "🌹",
  sunflower: "🌻",
  hibiscus: "🌺",
  maple_leaf: "🍁",
  leaves: "🍃",
  fallen_leaf: "🍂",
  herb: "🌿",
  ear_of_rice: "🌾",
  mushroom: "🍄",
  cactus: "🌵",
  palm_tree: "🌴",
  evergreen_tree: "🌲",
  deciduous_tree: "🌳",
  chestnut: "🌰",
  seedling: "🌱",
  blossom: "🌼",
  globe_with_meridians: "🌐",
  sun_with_face: "🌞",
  full_moon_with_face: "🌝",
  new_moon_with_face: "🌚",
  new_moon: "🌑",
  waxing_crescent_moon: "🌒",
  first_quarter_moon: "🌓",
  moon: "🌔",
  waxing_gibbous_moon: "🌔",
  full_moon: "🌕",
  waning_gibbous_moon: "🌖",
  last_quarter_moon: "🌗",
  waning_crescent_moon: "🌘",
  last_quarter_moon_with_face: "🌜",
  first_quarter_moon_with_face: "🌛",
  crescent_moon: "🌙",
  earth_africa: "🌍",
  earth_americas: "🌎",
  earth_asia: "🌏",
  volcano: "🌋",
  milky_way: "🌌",
  stars: "🌠",
  star: "⭐",
  sunny: "☀️",
  partly_sunny: "⛅",
  cloud: "☁️",
  zap: "⚡",
  umbrella: "☔",
  snowflake: "❄️",
  snowman: "⛄",
  cyclone: "🌀",
  foggy: "🌁",
  rainbow: "🌈",
  ocean: "🌊",
  bamboo: "🎍",
  gift_heart: "💝",
  dolls: "🎎",
  school_satchel: "🎒",
  mortar_board: "🎓",
  flags: "🎏",
  fireworks: "🎆",
  sparkler: "🎇",
  wind_chime: "🎐",
  rice_scene: "🎑",
  jack_o_lantern: "🎃",
  ghost: "👻",
  santa: "🎅",
  christmas_tree: "🎄",
  gift: "🎁",
  tanabata_tree: "🎋",
  tada: "🎉",
  confetti_ball: "🎊",
  balloon: "🎈",
  crossed_flags: "🎌",
  crystal_ball: "🔮",
  movie_camera: "🎥",
  camera: "📷",
  video_camera: "📹",
  vhs: "📼",
  cd: "💿",
  dvd: "📀",
  minidisc: "💽",
  floppy_disk: "💾",
  desktop_computer: "🖥️",
  computer: "💻",
  iphone: "📱",
  phone: "☎️",
  telephone: "☎️",
  telephone_receiver: "📞",
  pager: "📟",
  fax: "📠",
  satellite: "📡",
  tv: "📺",
  radio: "📻",
  loud_sound: "🔊",
  sound: "🔉",
  speaker: "🔈",
  mute: "🔇",
  bell: "🔔",
  no_bell: "🔕",
  loudspeaker: "📢",
  mega: "📣",
  hourglass_flowing_sand: "⏳",
  hourglass: "⌛",
  alarm_clock: "⏰",
  watch: "⌚",
  unlock: "🔓",
  lock: "🔒",
  lock_with_ink_pen: "🔏",
  closed_lock_with_key: "🔐",
  key: "🔑",
  mag_right: "🔎",
  bulb: "💡",
  flashlight: "🔦",
  high_brightness: "🔆",
  low_brightness: "🔅",
  electric_plug: "🔌",
  battery: "🔋",
  mag: "🔍",
  bathtub: "🛁",
  bath: "🛀",
  shower: "🚿",
  toilet: "🚽",
  wrench: "🔧",
  nut_and_bolt: "🔩",
  hammer: "🔨",
  hammer_and_pick: "⚒",
  hammer_and_wrench: "⚒",
  door: "🚪",
  smoking: "🚬",
  bomb: "💣",
  gun: "🔫",
  hocho: "🔪",
  knife: "🔪",
  pill: "💊",
  syringe: "💉",
  moneybag: "💰",
  yen: "💴",
  dollar: "💵",
  pound: "💷",
  euro: "💶",
  credit_card: "💳",
  money_with_wings: "💸",
  calling: "📲",
  "e-mail": "📧",
  inbox_tray: "📥",
  outbox_tray: "📤",
  email: "✉️",
  envelope: "✉️",
  envelope_with_arrow: "📩",
  incoming_envelope: "📨",
  postal_horn: "📯",
  mailbox: "📫",
  mailbox_closed: "📪",
  mailbox_with_mail: "📬",
  mailbox_with_no_mail: "📭",
  postbox: "📮",
  package: "📦",
  memo: "📝",
  pencil: "📝",
  page_facing_up: "📄",
  page_with_curl: "📃",
  bookmark_tabs: "📑",
  bar_chart: "📊",
  chart_with_upwards_trend: "📈",
  chart_with_downwards_trend: "📉",
  scroll: "📜",
  clipboard: "📋",
  date: "📅",
  calendar: "📆",
  card_index: "📇",
  file_folder: "📁",
  open_file_folder: "📂",
  scissors: "✂️",
  pushpin: "📌",
  paperclip: "📎",
  black_nib: "✒️",
  pencil2: "✏️",
  straight_ruler: "📏",
  triangular_ruler: "📐",
  closed_book: "📕",
  green_book: "📗",
  blue_book: "📘",
  orange_book: "📙",
  notebook: "📓",
  notebook_with_decorative_cover: "📔",
  ledger: "📒",
  books: "📚",
  book: "📖",
  open_book: "📖",
  bookmark: "🔖",
  name_badge: "📛",
  microscope: "🔬",
  telescope: "🔭",
  newspaper: "📰",
  art: "🎨",
  clapper: "🎬",
  microphone: "🎤",
  headphones: "🎧",
  musical_score: "🎼",
  musical_note: "🎵",
  notes: "🎶",
  musical_keyboard: "🎹",
  violin: "🎻",
  trumpet: "🎺",
  saxophone: "🎷",
  guitar: "🎸",
  space_invader: "👾",
  video_game: "🎮",
  black_joker: "🃏",
  flower_playing_cards: "🎴",
  mahjong: "🀄",
  game_die: "🎲",
  dart: "🎯",
  football: "🏈",
  basketball: "🏀",
  soccer: "⚽",
  baseball: "⚾️",
  tennis: "🎾",
  "8ball": "🎱",
  rugby_football: "🏉",
  bowling: "🎳",
  golf: "⛳",
  mountain_bicyclist: "🚵",
  bicyclist: "🚴",
  checkered_flag: "🏁",
  horse_racing: "🏇",
  trophy: "🏆",
  ski: "🎿",
  snowboarder: "🏂",
  swimmer: "🏊",
  surfer: "🏄",
  fishing_pole_and_fish: "🎣",
  coffee: "☕",
  tea: "🍵",
  sake: "🍶",
  baby_bottle: "🍼",
  beer: "🍺",
  beers: "🍻",
  cocktail: "🍸",
  tropical_drink: "🍹",
  wine_glass: "🍷",
  fork_and_knife: "🍴",
  pizza: "🍕",
  hamburger: "🍔",
  fries: "🍟",
  poultry_leg: "🍗",
  meat_on_bone: "🍖",
  spaghetti: "🍝",
  curry: "🍛",
  fried_shrimp: "🍤",
  bento: "🍱",
  sushi: "🍣",
  fish_cake: "🍥",
  rice_ball: "🍙",
  rice_cracker: "🍘",
  rice: "🍚",
  ramen: "🍜",
  stew: "🍲",
  oden: "🍢",
  dango: "🍡",
  egg: "🍳",
  bread: "🍞",
  doughnut: "🍩",
  custard: "🍮",
  icecream: "🍦",
  ice_cream: "🍨",
  shaved_ice: "🍧",
  birthday: "🎂",
  cake: "🍰",
  cookie: "🍪",
  chocolate_bar: "🍫",
  candy: "🍬",
  lollipop: "🍭",
  honey_pot: "🍯",
  apple: "🍎",
  green_apple: "🍏",
  tangerine: "🍊",
  orange: "🍊",
  mandarin: "🍊",
  lemon: "🍋",
  cherries: "🍒",
  grapes: "🍇",
  watermelon: "🍉",
  strawberry: "🍓",
  peach: "🍑",
  melon: "🍈",
  banana: "🍌",
  pear: "🍐",
  pineapple: "🍍",
  sweet_potato: "🍠",
  eggplant: "🍆",
  tomato: "🍅",
  corn: "🌽",
  house: "🏠",
  house_with_garden: "🏡",
  school: "🏫",
  office: "🏢",
  post_office: "🏣",
  hospital: "🏥",
  bank: "🏦",
  convenience_store: "🏪",
  love_hotel: "🏩",
  hotel: "🏨",
  wedding: "💒",
  church: "⛪",
  department_store: "🏬",
  european_post_office: "🏤",
  city_sunrise: "🌇",
  city_sunset: "🌆",
  japanese_castle: "🏯",
  european_castle: "🏰",
  tent: "⛺",
  factory: "🏭",
  tokyo_tower: "🗼",
  japan: "🗾",
  mount_fuji: "🗻",
  sunrise_over_mountains: "🌄",
  sunrise: "🌅",
  night_with_stars: "🌃",
  statue_of_liberty: "🗽",
  bridge_at_night: "🌉",
  carousel_horse: "🎠",
  ferris_wheel: "🎡",
  fountain: "⛲",
  roller_coaster: "🎢",
  ship: "🚢",
  boat: "⛵",
  sailboat: "⛵",
  speedboat: "🚤",
  rowboat: "🚣",
  anchor: "⚓",
  rocket: "🚀",
  airplane: "✈️",
  seat: "💺",
  helicopter: "🚁",
  steam_locomotive: "🚂",
  tram: "🚊",
  station: "🚉",
  mountain_railway: "🚞",
  train2: "🚆",
  bullettrain_side: "🚄",
  bullettrain_front: "🚅",
  light_rail: "🚈",
  metro: "🚇",
  monorail: "🚝",
  train: "🚋",
  railway_car: "🚃",
  trolleybus: "🚎",
  bus: "🚌",
  oncoming_bus: "🚍",
  blue_car: "🚙",
  oncoming_automobile: "🚘",
  car: "🚗",
  red_car: "🚗",
  taxi: "🚕",
  oncoming_taxi: "🚖",
  articulated_lorry: "🚛",
  truck: "🚚",
  rotating_light: "🚨",
  police_car: "🚓",
  oncoming_police_car: "🚔",
  fire_engine: "🚒",
  ambulance: "🚑",
  minibus: "🚐",
  bike: "🚲",
  aerial_tramway: "🚡",
  suspension_railway: "🚟",
  mountain_cableway: "🚠",
  tractor: "🚜",
  barber: "💈",
  busstop: "🚏",
  ticket: "🎫",
  vertical_traffic_light: "🚦",
  traffic_light: "🚥",
  warning: "⚠️",
  construction: "🚧",
  beginner: "🔰",
  fuelpump: "⛽",
  izakaya_lantern: "🏮",
  lantern: "🏮",
  slot_machine: "🎰",
  hotsprings: "♨️",
  moyai: "🗿",
  circus_tent: "🎪",
  performing_arts: "🎭",
  round_pushpin: "📍",
  triangular_flag_on_post: "🚩",
  jp: "🇯🇵",
  kr: "🇰🇷",
  de: "🇩🇪",
  cn: "🇨🇳",
  us: "🇺🇸",
  fr: "🇫🇷",
  es: "🇪🇸",
  it: "🇮🇹",
  ru: "🇷🇺",
  gb: "🇬🇧",
  uk: "🇬🇧",
  one: "1️⃣",
  two: "2️⃣",
  three: "3️⃣",
  four: "4️⃣",
  five: "5️⃣",
  six: "6️⃣",
  seven: "7️⃣",
  eight: "8️⃣",
  nine: "9️⃣",
  zero: "0️⃣",
  keycap_ten: "🔟",
  hash: "#️⃣",
  symbols: "🔣",
  arrow_up: "⬆️",
  arrow_down: "⬇️",
  arrow_left: "⬅️",
  arrow_right: "➡️",
  capital_abcd: "🔠",
  abcd: "🔡",
  abc: "🔤",
  arrow_upper_right: "↗️",
  arrow_upper_left: "↖️",
  arrow_lower_right: "↘️",
  arrow_lower_left: "↙️",
  left_right_arrow: "↔️",
  arrow_up_down: "↕️",
  arrows_counterclockwise: "🔄",
  arrow_backward: "◀️",
  arrow_forward: "▶️",
  arrow_up_small: "🔼",
  arrow_down_small: "🔽",
  leftwards_arrow_with_hook: "↩️",
  arrow_right_hook: "↪️",
  information_source: "ℹ️",
  rewind: "⏪",
  fast_forward: "⏩",
  arrow_double_up: "⏫",
  arrow_double_down: "⏬",
  arrow_heading_down: "⤵️",
  arrow_heading_up: "⤴️",
  ok: "🆗",
  twisted_rightwards_arrows: "🔀",
  repeat: "🔁",
  repeat_one: "🔂",
  new: "🆕",
  up: "🆙",
  cool: "🆒",
  free: "🆓",
  ng: "🆖",
  signal_strength: "📶",
  cinema: "🎦",
  koko: "🈁",
  u6307: "🈯",
  u7a7a: "🈳",
  u6e80: "🈵",
  u5408: "🈴",
  u7981: "🈲",
  ideograph_advantage: "🉐",
  u5272: "🈹",
  u55b6: "🈺",
  u6709: "🈶",
  u7121: "🈚",
  restroom: "🚻",
  mens: "🚹",
  womens: "🚺",
  baby_symbol: "🚼",
  wc: "🚾",
  potable_water: "🚰",
  put_litter_in_its_place: "🚮",
  parking: "🅿️",
  wheelchair: "♿",
  no_smoking: "🚭",
  u6708: "🈷️",
  u7533: "🈸",
  sa: "🈂️",
  m: "Ⓜ️",
  passport_control: "🛂",
  baggage_claim: "🛄",
  left_luggage: "🛅",
  customs: "🛃",
  accept: "🉑",
  secret: "㊙️",
  congratulations: "㊗️",
  cl: "🆑",
  sos: "🆘",
  id: "🆔",
  no_entry_sign: "🚫",
  underage: "🔞",
  no_mobile_phones: "📵",
  do_not_litter: "🚯",
  "non-potable_water": "🚱",
  no_bicycles: "🚳",
  no_pedestrians: "🚷",
  children_crossing: "🚸",
  no_entry: "⛔",
  eight_spoked_asterisk: "✳️",
  sparkle: "❇️",
  negative_squared_cross_mark: "❎",
  white_check_mark: "✅",
  eight_pointed_black_star: "✴️",
  heart_decoration: "💟",
  vs: "🆚",
  vibration_mode: "📳",
  mobile_phone_off: "📴",
  a: "🅰️",
  b: "🅱️",
  ab: "🆎",
  o2: "🅾️",
  diamond_shape_with_a_dot_inside: "💠",
  loop: "➿",
  recycle: "♻️",
  aries: "♈",
  taurus: "♉",
  gemini: "♊",
  cancer: "♋",
  leo: "♌",
  virgo: "♍",
  libra: "♎",
  scorpius: "♏",
  sagittarius: "♐",
  capricorn: "♑",
  aquarius: "♒",
  pisces: "♓",
  ophiuchus: "⛎",
  six_pointed_star: "🔯",
  atm: "🏧",
  chart: "💹",
  heavy_dollar_sign: "💲",
  currency_exchange: "💱",
  copyright: "©️",
  registered: "®️",
  tm: "™️",
  x: "❌",
  bangbang: "‼️",
  interrobang: "⁉️",
  exclamation: "❗",
  heavy_exclamation_mark: "❗",
  question: "❓",
  grey_exclamation: "❕",
  grey_question: "❔",
  o: "⭕",
  top: "🔝",
  end: "🔚",
  back: "🔙",
  on: "🔛",
  soon: "🔜",
  arrows_clockwise: "🔃",
  clock12: "🕛",
  clock1230: "🕧",
  clock1: "🕐",
  clock130: "🕜",
  clock2: "🕑",
  clock230: "🕝",
  clock3: "🕒",
  clock330: "🕞",
  clock4: "🕓",
  clock430: "🕟",
  clock5: "🕔",
  clock530: "🕠",
  clock6: "🕕",
  clock7: "🕖",
  clock8: "🕗",
  clock9: "🕘",
  clock10: "🕙",
  clock11: "🕚",
  clock630: "🕡",
  clock730: "🕢",
  clock830: "🕣",
  clock930: "🕤",
  clock1030: "🕥",
  clock1130: "🕦",
  heavy_multiplication_x: "✖️",
  heavy_plus_sign: "➕",
  heavy_minus_sign: "➖",
  heavy_division_sign: "➗",
  spades: "♠️",
  hearts: "♥️",
  clubs: "♣️",
  diamonds: "♦️",
  white_flower: "💮",
  heavy_check_mark: "✔️",
  ballot_box_with_check: "☑️",
  radio_button: "🔘",
  link: "🔗",
  curly_loop: "➰",
  wavy_dash: "〰️",
  part_alternation_mark: "〽️",
  trident: "🔱",
  black_medium_square: "◼️",
  white_medium_square: "◻️",
  black_medium_small_square: "◾",
  white_medium_small_square: "◽",
  black_small_square: "▪️",
  white_small_square: "▫️",
  small_red_triangle: "🔺",
  black_square_button: "🔲",
  white_square_button: "🔳",
  black_circle: "⚫",
  white_circle: "⚪",
  red_circle: "🔴",
  large_blue_circle: "🔵",
  small_red_triangle_down: "🔻",
  white_large_square: "⬜",
  black_large_square: "⬛",
  large_orange_diamond: "🔶",
  large_blue_diamond: "🔷",
  small_orange_diamond: "🔸",
  small_blue_diamond: "🔹",
  flag_ac: "🇦🇨",
  flag_ad: "🇦🇩",
  flag_ae: "🇦🇪",
  flag_af: "🇦🇫",
  flag_ag: "🇦🇬",
  flag_ai: "🇦🇮",
  flag_al: "🇦🇱",
  flag_am: "🇦🇲",
  flag_ao: "🇦🇴",
  flag_aq: "🇦🇶",
  flag_ar: "🇦🇷",
  flag_as: "🇦🇸",
  flag_at: "🇦🇹",
  flag_au: "🇦🇺",
  flag_aw: "🇦🇼",
  flag_ax: "🇦🇽",
  flag_az: "🇦🇿",
  flag_ba: "🇧🇦",
  flag_bb: "🇧🇧",
  flag_bd: "🇧🇩",
  flag_be: "🇧🇪",
  flag_bf: "🇧🇫",
  flag_bg: "🇧🇬",
  flag_bh: "🇧🇭",
  flag_bi: "🇧🇮",
  flag_bj: "🇧🇯",
  flag_bl: "🇧🇱",
  flag_bm: "🇧🇲",
  flag_bn: "🇧🇳",
  flag_bo: "🇧🇴",
  flag_bq: "🇧🇶",
  flag_br: "🇧🇷",
  flag_bs: "🇧🇸",
  flag_bt: "🇧🇹",
  flag_bv: "🇧🇻",
  flag_bw: "🇧🇼",
  flag_by: "🇧🇾",
  flag_bz: "🇧🇿",
  flag_ca: "🇨🇦",
  flag_cc: "🇨🇨",
  flag_cd: "🇨🇩",
  flag_cf: "🇨🇫",
  flag_cg: "🇨🇬",
  flag_ch: "🇨🇭",
  flag_ci: "🇨🇮",
  flag_ck: "🇨🇰",
  flag_cl: "🇨🇱",
  flag_cm: "🇨🇲",
  flag_cn: "🇨🇳",
  flag_co: "🇨🇴",
  flag_cp: "🇨🇵",
  flag_cr: "🇨🇷",
  flag_cu: "🇨🇺",
  flag_cv: "🇨🇻",
  flag_cw: "🇨🇼",
  flag_cx: "🇨🇽",
  flag_cy: "🇨🇾",
  flag_cz: "🇨🇿",
  flag_de: "🇩🇪",
  flag_dg: "🇩🇬",
  flag_dj: "🇩🇯",
  flag_dk: "🇩🇰",
  flag_dm: "🇩🇲",
  flag_do: "🇩🇴",
  flag_dz: "🇩🇿",
  flag_ea: "🇪🇦",
  flag_ec: "🇪🇨",
  flag_ee: "🇪🇪",
  flag_eg: "🇪🇬",
  flag_eh: "🇪🇭",
  flag_er: "🇪🇷",
  flag_es: "🇪🇸",
  flag_et: "🇪🇹",
  flag_eu: "🇪🇺",
  flag_fi: "🇫🇮",
  flag_fj: "🇫🇯",
  flag_fk: "🇫🇰",
  flag_fm: "🇫🇲",
  flag_fo: "🇫🇴",
  flag_fr: "🇫🇷",
  flag_ga: "🇬🇦",
  flag_gb: "🇬🇧",
  flag_gd: "🇬🇩",
  flag_ge: "🇬🇪",
  flag_gf: "🇬🇫",
  flag_gg: "🇬🇬",
  flag_gh: "🇬🇭",
  flag_gi: "🇬🇮",
  flag_gl: "🇬🇱",
  flag_gm: "🇬🇲",
  flag_gn: "🇬🇳",
  flag_gp: "🇬🇵",
  flag_gq: "🇬🇶",
  flag_gr: "🇬🇷",
  flag_gs: "🇬🇸",
  flag_gt: "🇬🇹",
  flag_gu: "🇬🇺",
  flag_gw: "🇬🇼",
  flag_gy: "🇬🇾",
  flag_hk: "🇭🇰",
  flag_hm: "🇭🇲",
  flag_hn: "🇭🇳",
  flag_hr: "🇭🇷",
  flag_ht: "🇭🇹",
  flag_hu: "🇭🇺",
  flag_ic: "🇮🇨",
  flag_id: "🇮🇩",
  flag_ie: "🇮🇪",
  flag_il: "🇮🇱",
  flag_im: "🇮🇲",
  flag_in: "🇮🇳",
  flag_io: "🇮🇴",
  flag_iq: "🇮🇶",
  flag_ir: "🇮🇷",
  flag_is: "🇮🇸",
  flag_it: "🇮🇹",
  flag_je: "🇯🇪",
  flag_jm: "🇯🇲",
  flag_jo: "🇯🇴",
  flag_jp: "🇯🇵",
  flag_ke: "🇰🇪",
  flag_kg: "🇰🇬",
  flag_kh: "🇰🇭",
  flag_ki: "🇰🇮",
  flag_km: "🇰🇲",
  flag_kn: "🇰🇳",
  flag_kp: "🇰🇵",
  flag_kr: "🇰🇷",
  flag_kw: "🇰🇼",
  flag_ky: "🇰🇾",
  flag_kz: "🇰🇿",
  flag_la: "🇱🇦",
  flag_lb: "🇱🇧",
  flag_lc: "🇱🇨",
  flag_li: "🇱🇮",
  flag_lk: "🇱🇰",
  flag_lr: "🇱🇷",
  flag_ls: "🇱🇸",
  flag_lt: "🇱🇹",
  flag_lu: "🇱🇺",
  flag_lv: "🇱🇻",
  flag_ly: "🇱🇾",
  flag_ma: "🇲🇦",
  flag_mc: "🇲🇨",
  flag_md: "🇲🇩",
  flag_me: "🇲🇪",
  flag_mf: "🇲🇫",
  flag_mg: "🇲🇬",
  flag_mh: "🇲🇭",
  flag_mk: "🇲🇰",
  flag_ml: "🇲🇱",
  flag_mm: "🇲🇲",
  flag_mn: "🇲🇳",
  flag_mo: "🇲🇴",
  flag_mp: "🇲🇵",
  flag_mq: "🇲🇶",
  flag_mr: "🇲🇷",
  flag_ms: "🇲🇸",
  flag_mt: "🇲🇹",
  flag_mu: "🇲🇺",
  flag_mv: "🇲🇻",
  flag_mw: "🇲🇼",
  flag_mx: "🇲🇽",
  flag_my: "🇲🇾",
  flag_mz: "🇲🇿",
  flag_na: "🇳🇦",
  flag_nc: "🇳🇨",
  flag_ne: "🇳🇪",
  flag_nf: "🇳🇫",
  flag_ng: "🇳🇬",
  flag_ni: "🇳🇮",
  flag_nl: "🇳🇱",
  flag_no: "🇳🇴",
  flag_np: "🇳🇵",
  flag_nr: "🇳🇷",
  flag_nu: "🇳🇺",
  flag_nz: "🇳🇿",
  flag_om: "🇴🇲",
  flag_pa: "🇵🇦",
  flag_pe: "🇵🇪",
  flag_pf: "🇵🇫",
  flag_pg: "🇵🇬",
  flag_ph: "🇵🇭",
  flag_pk: "🇵🇰",
  flag_pl: "🇵🇱",
  flag_pm: "🇵🇲",
  flag_pn: "🇵🇳",
  flag_pr: "🇵🇷",
  flag_ps: "🇵🇸",
  flag_pt: "🇵🇹",
  flag_pw: "🇵🇼",
  flag_py: "🇵🇾",
  flag_qa: "🇶🇦",
  flag_re: "🇷🇪",
  flag_ro: "🇷🇴",
  flag_rs: "🇷🇸",
  flag_ru: "🇷🇺",
  flag_rw: "🇷🇼",
  flag_sa: "🇸🇦",
  flag_sb: "🇸🇧",
  flag_sc: "🇸🇨",
  flag_sd: "🇸🇩",
  flag_se: "🇸🇪",
  flag_sg: "🇸🇬",
  flag_sh: "🇸🇭",
  flag_si: "🇸🇮",
  flag_sj: "🇸🇯",
  flag_sk: "🇸🇰",
  flag_sl: "🇸🇱",
  flag_sm: "🇸🇲",
  flag_sn: "🇸🇳",
  flag_so: "🇸🇴",
  flag_sr: "🇸🇷",
  flag_ss: "🇸🇸",
  flag_st: "🇸🇹",
  flag_sv: "🇸🇻",
  flag_sx: "🇸🇽",
  flag_sy: "🇸🇾",
  flag_sz: "🇸🇿",
  flag_ta: "🇹🇦",
  flag_tc: "🇹🇨",
  flag_td: "🇹🇩",
  flag_tf: "🇹🇫",
  flag_tg: "🇹🇬",
  flag_th: "🇹🇭",
  flag_tj: "🇹🇯",
  flag_tk: "🇹🇰",
  flag_tl: "🇹🇱",
  flag_tm: "🇹🇲",
  flag_tn: "🇹🇳",
  flag_to: "🇹🇴",
  flag_tr: "🇹🇷",
  flag_tt: "🇹🇹",
  flag_tv: "🇹🇻",
  flag_tw: "🇹🇼",
  flag_tz: "🇹🇿",
  flag_ua: "🇺🇦",
  flag_ug: "🇺🇬",
  flag_um: "🇺🇲",
  flag_un: "🇺🇳",
  flag_us: "🇺🇸",
  flag_uy: "🇺🇾",
  flag_uz: "🇺🇿",
  flag_va: "🇻🇦",
  flag_vc: "🇻🇨",
  flag_ve: "🇻🇪",
  flag_vg: "🇻🇬",
  flag_vi: "🇻🇮",
  flag_vn: "🇻🇳",
  flag_vu: "🇻🇺",
  flag_wf: "🇼🇫",
  flag_ws: "🇼🇸",
  flag_xk: "🇽🇰",
  flag_ye: "🇾🇪",
  flag_yt: "🇾🇹",
  flag_za: "🇿🇦",
  flag_zm: "🇿🇲",
  flag_zw: "🇿🇼"
};

/***/ }),

/***/ "O6gZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("C5vU");

var _style2 = _interopRequireDefault(_style);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

var _reactEmojiRender = __webpack_require__("Stiw");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AutoMessage = function (_Component) {
    _inherits(AutoMessage, _Component);

    function AutoMessage() {
        _classCallCheck(this, AutoMessage);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    AutoMessage.prototype.render = function render() {
        if (!this.props.automessage) {
            return (0, _preact.h)('div', { className: _style2.default.HeaderNoAutoMessage });
        }
        var message = this.props.automessage.getIn(['message', 'message'], '');

        return (0, _preact.h)(
            'div',
            { className: _style2.default.HeaderAutoMessage },
            (0, _preact.h)(_TextDisplay2.default, { text: message })
        );
    };

    return AutoMessage;
}(_preact.Component);

exports.default = AutoMessage;

/***/ }),

/***/ "ObqT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("kfHX");

var _style2 = _interopRequireDefault(_style);

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _SearchIcon = __webpack_require__("BOLS");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("ksTV");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("et9O");

var _model6 = _interopRequireDefault(_model5);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var HelpDeskHeader = function (_Component) {
    _inherits(HelpDeskHeader, _Component);

    function HelpDeskHeader(props) {
        _classCallCheck(this, HelpDeskHeader);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this._goBack = _this._goBack.bind(_this);
        return _this;
    }

    HelpDeskHeader.prototype.componentDidMount = function componentDidMount() {
        //User hits refresh while searching.
        if (this.props.route === 'HelpDeskSearch' && this.props.searchInput === '') {
            this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDesk'));
        }
    };

    HelpDeskHeader.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
        if (prevProps.searchInput === '' && this.props.searchInput !== '') {
            this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDeskSearch'));
        } else if (prevProps.searchInput !== '' && this.props.searchInput === '') {
            this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDesk'));
        }
    };

    HelpDeskHeader.prototype._goBack = function _goBack() {
        var route = this.props.route;
        var activeCategory = this.props.activeCategory;
        switch (route) {
            case 'HelpDeskArticle':
                //activeCategory === -1 implies no category set, it entered
                //article through search results.
                if (activeCategory === '-1') {
                    this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDeskSearch'));
                } else {
                    this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDeskFocused', activeCategory));
                }
                break;
            case 'HelpDeskSearch':
                this.props.dispatch(_model6.default.helpDeskSearch(''));
                break;
            case 'HelpDeskFocused':
            default:
                this.props.dispatch(_model6.default.setHelpDeskRoute('HelpDesk'));
                break;
        }
    };

    HelpDeskHeader.prototype._renderSearchInput = function _renderSearchInput() {
        var _this2 = this;

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color }, className: _style2.default.InputWrapper },
            (0, _preact.h)('input', {
                type: 'text',
                placeholder: this.props.language.get("SearchQuestion"),
                'class': _style2.default.InputSearch,
                style: { border: '1px solid ' + this.props.color },
                value: this.props.searchInput,
                onInput: function onInput(e) {
                    return _this2.props.dispatch(_model6.default.helpDeskSearch(e.target.value));
                } }),
            (0, _preact.h)(
                'div',
                null,
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.SearchIcon },
                    (0, _preact.h)(_SearchIcon2.default, { color: this.props.color })
                )
            )
        );
    };

    HelpDeskHeader.prototype.render = function render() {
        var route = this.props.route;
        var showBackBtn = route === 'HelpDeskFocused' || route === 'HelpDeskArticle' || route === 'HelpDeskSearch';
        var showSearchInput = route === 'HelpDeskFocused' || route === 'HelpDesk' || route === 'HelpDeskSearch';
        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.BackButtonWrapper },
                showBackBtn && (0, _preact.h)(_Buttons.BackButton, { callback: this._goBack })
            ),
            _ref,
            (0, _preact.h)(
                'div',
                { className: _style2.default.HeaderContainer },
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.CompanyName },
                    ' ',
                    this.props.companyName,
                    ' '
                ),
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.HelpDesk },
                    ' Helpdesk '
                ),
                showSearchInput && this._renderSearchInput()
            )
        );
    };

    return HelpDeskHeader;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model2.default.getColor(state);
    var companyName = _model2.default.getCompanyDisplayName(state);
    var fullRoute = _model6.default.getHelpDeskRoute(state).split(';');
    var route = fullRoute[0];
    var activeCategory = fullRoute[1];
    var language = _model2.default.getLanguage(state);
    var searchInput = _model6.default.getSearchInput(state);
    return {
        color: color,
        language: language,
        companyName: companyName,
        route: route,
        activeCategory: activeCategory,
        searchInput: searchInput
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(HelpDeskHeader);

/***/ }),

/***/ "Oqyg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var extend = __webpack_require__("TRnG");

module.exports = function (req) {
  var xhr = req.xhr;
  var props = { request: req, xhr: xhr };

  // Try to create the response from the request. If the request was aborted,
  // accesssing properties of the XHR may throw an error, so we wrap in a
  // try/catch.
  try {
    var lines,
        i,
        m,
        headers = {};
    if (xhr.getAllResponseHeaders) {
      lines = xhr.getAllResponseHeaders().split('\n');
      for (i = 0; i < lines.length; i++) {
        if (m = lines[i].match(/\s*([^\s]+):\s+([^\s]+)/)) {
          headers[m[1]] = m[2];
        }
      }
    }

    props = extend(props, {
      status: xhr.status,
      contentType: xhr.contentType || xhr.getResponseHeader && xhr.getResponseHeader('Content-Type'),
      headers: headers,
      text: xhr.responseText,
      body: xhr.response || xhr.responseText
    });
  } catch (err) {}

  return props;
};

/***/ }),

/***/ "PqSB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var prefix = __webpack_require__("nPmw");
var toCamelCase = __webpack_require__("UTRz");
var cache = { 'float': 'cssFloat' };
var addPxToStyle = __webpack_require__("HNHs");

function style(element, property, value) {
  var camel = cache[property];
  if (typeof camel === 'undefined') {
    camel = detect(property);
  }

  // may be false if CSS prop is unsupported
  if (camel) {
    if (value === undefined) {
      return element.style[camel];
    }

    element.style[camel] = addPxToStyle(camel, value);
  }
}

function each(element, properties) {
  for (var k in properties) {
    if (properties.hasOwnProperty(k)) {
      style(element, k, properties[k]);
    }
  }
}

function detect(cssProp) {
  var camel = toCamelCase(cssProp);
  var result = prefix(camel);
  cache[camel] = cache[cssProp] = cache[result] = result;
  return result;
}

function set() {
  if (arguments.length === 2) {
    if (typeof arguments[1] === 'string') {
      arguments[0].style.cssText = arguments[1];
    } else {
      each(arguments[0], arguments[1]);
    }
  } else {
    style(arguments[0], arguments[1], arguments[2]);
  }
}

module.exports = set;
module.exports.set = set;

module.exports.get = function (element, properties) {
  if (Array.isArray(properties)) {
    return properties.reduce(function (obj, prop) {
      obj[prop] = style(element, prop || '');
      return obj;
    }, {});
  } else {
    return style(element, properties || '');
  }
};

/***/ }),

/***/ "Q4WQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__("e6+Q");
var invariant = __webpack_require__("cxPT");
var ReactPropTypesSecret = __webpack_require__("gt/O");

module.exports = function () {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(false, 'Calling PropTypes validators directly is not supported by the `prop-types` package. ' + 'Use PropTypes.checkPropTypes() to call them. ' + 'Read more at http://fb.me/use-check-prop-types');
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/***/ }),

/***/ "QQKR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)("path", { d: "M48,18.25a28,28,0,0,0-37.63-1.79l.94-4.79a1.42,1.42,0,1,0-2.78-.54L6.69,20.26A1.42,1.42,0,0,0,8.08,22h0l9.32,0a1.42,1.42,0,0,0,0-2.84h0l-5.81,0A25.17,25.17,0,0,1,46,55.85a1.42,1.42,0,1,0,2,2,28,28,0,0,0,0-39.6Z" });

var _ref2 = (0, _preact.h)("path", { d: "M29,22.06a16,16,0,1,0,16,16A16,16,0,0,0,29,22.06ZM29,51a13,13,0,1,1,13-13A13,13,0,0,1,29,51Z" });

var _ref3 = (0, _preact.h)("path", { d: "M34.61,37H30V29.41a1.48,1.48,0,0,0-3,0v9.07A1.48,1.48,0,0,0,28.49,40h6.12a1.47,1.47,0,1,0,0-2.95Z" });

var History = function (_Component) {
    _inherits(History, _Component);

    function History() {
        _classCallCheck(this, History);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    History.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            { viewBox: "0 0 64 64", fill: this.props.color },
            _ref,
            _ref2,
            _ref3
        );
    };

    return History;
}(_preact.Component);

exports.default = History;

/***/ }),

/***/ "Qc0D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
  processRequest: function processRequest(req) {
    req.url = req.url.replace(/[^%]+/g, function (s) {
      return encodeURI(s);
    });
  }
};

/***/ }),

/***/ "Qgwq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NormalSettings":"NormalSettings__1e2KN","MobileSettings":"MobileSettings__1x6tH"};

/***/ }),

/***/ "R+0I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("H7oh");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _Faq = __webpack_require__("4LjX");

var _Faq2 = _interopRequireDefault(_Faq);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Faq2.default, { color: 'white', width: '40', height: '30' });

var FaqButton = function (_Component) {
    _inherits(FaqButton, _Component);

    function FaqButton() {
        _classCallCheck(this, FaqButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    FaqButton.prototype.render = function render() {
        var _this2 = this;

        var defaultStyle = _style2.default.NormalFaq;
        if (this.props.isMobile) defaultStyle = _style2.default.MobileFaq;
        return (0, _preact.h)(
            'div',
            {
                onClick: function onClick() {
                    _this2.props.dispatch(_model2.default.setRoute('Faq'));
                },
                className: defaultStyle },
            _ref
        );
    };

    return FaqButton;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        isMobile: _model2.default.isMobile(state)
    };
})(FaqButton);

/***/ }),

/***/ "RE7E":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _Buttons = __webpack_require__("Jw2m");

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("9fbE");

var _style2 = _interopRequireDefault(_style);

var _lang = __webpack_require__("r3oa");

var _lang2 = _interopRequireDefault(_lang);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Header.prototype.render = function render() {
        var company = this.props.company;
        var isEmpty = this.props.conversations.isEmpty();
        var route = isEmpty ? 'StartChatting' : 'Conversations';
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Header, style: { backgroundColor: this.props.color } },
            (0, _preact.h)(_Title2.default, { title: this.props.language.get("QuestionsAndAnswersWith"), body: this.props.name }),
            _ref
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    var name = _model4.default.getCompanyDisplayName(state);
    return {
        company: state.get('company'),
        conversations: state.get('conversations'),
        color: color,
        language: language,
        name: name
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "RFY+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preact2 = _interopRequireDefault(_preact);

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("K3CK");

var _style2 = _interopRequireDefault(_style);

var _CategoryButton = __webpack_require__("jRWN");

var _CategoryButton2 = _interopRequireDefault(_CategoryButton);

var _CategoryQuestions = __webpack_require__("frwL");

var _CategoryQuestions2 = _interopRequireDefault(_CategoryQuestions);

var _CategoryScroll = __webpack_require__("uG4N");

var _CategoryScroll2 = _interopRequireDefault(_CategoryScroll);

var _NavButton = __webpack_require__("Hjtp");

var _NavButton2 = _interopRequireDefault(_NavButton);

var _SearchResults = __webpack_require__("tXeI");

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("et9O");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("9VrP");

var _model6 = _interopRequireDefault(_model5);

var _PersistentRouting = __webpack_require__("5R3C");

var _PersistentRouting2 = _interopRequireDefault(_PersistentRouting);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
    NOTE Category are referenced with two indices:
        1. Layout index: CategoryButtons are referenced with indices w/ values 0-8 (activeCategory).
        Therefore, the component seldom works directly with the category ID. This index is important to calculate which row
        and column each item is located in.

        2. ID: When requesting data for an item (category ID or question ID), it uses the the cateogory ID.

    NOTE There are always 9 CategoryButtons. This makes it easier to manage layout and keeping sanity.
*/
var _ref = (0, _preact.h)(_CategoryButton2.default, null);

var HelpDeskBody = function (_preact$Component) {
    _inherits(HelpDeskBody, _preact$Component);

    function HelpDeskBody(props) {
        _classCallCheck(this, HelpDeskBody);

        var _this = _possibleConstructorReturn(this, _preact$Component.call(this, props));

        _this.row = 0;
        _this.container = null;
        _this.state = {
            animating: false
        };
        return _this;
    }

    HelpDeskBody.prototype.onClickCategory = function onClickCategory(id) {
        var _this2 = this;

        return function () {
            if (_this2.state.animating) return;

            var currentRoute = _this2.props.route;
            var focused = currentRoute === 'HelpDeskFocused';
            if (id === _this2.props.activeCategory) {
                if (!_this2.state.animating) setTimeout(function () {
                    _this2.setState({ animating: false });
                    _this2.props.dispatch(_model4.default.setHelpDeskRoute('HelpDesk'));
                }, 400);
                _this2.setState({ animating: true });
            } else if (focused && id !== _this2.props.activeCategory) {
                _this2.props.dispatch(_model4.default.setHelpDeskRoute(currentRoute, id));
            } else {
                if (!_this2.state.animating) setTimeout(function () {
                    _this2.setState({ animating: false });
                    _this2.props.dispatch(_model4.default.setHelpDeskRoute('HelpDeskFocused', id));
                }, 400);
                _this2.props.dispatch(_model4.default.setHelpDeskRoute('HelpDesk', id));
                _this2.setState({ animating: true });
            }
        };
    };

    HelpDeskBody.prototype.navigateCategories = function navigateCategories(nav) {
        var _props = this.props,
            activeCategory = _props.activeCategory,
            categories = _props.categories;

        var lenCategories = categories.length;
        var maximumRow = Math.floor((categories.length - 1) / 3);
        var currentRow = Math.floor(activeCategory / 3);

        var newRow = void 0;
        switch (nav) {
            case 'back':
                newRow = currentRow - 1 < 0 ? maximumRow : currentRow - 1;
                break;
            case 'next':
            default:
                newRow = currentRow + 1 > maximumRow ? 0 : currentRow + 1;
                break;
        }
        //First column in the newRow.
        var nextIdx = newRow * 3;
        this.props.dispatch(_model4.default.setHelpDeskRoute('HelpDeskFocused', nextIdx));
    };

    HelpDeskBody.prototype._renderRow = function _renderRow(row) {
        var _this3 = this;

        var focused = this.props.route === 'HelpDeskFocused';
        var heightNav = this.row ? { height: this.row.clientHeight / 2 + 'px' } : { height: '100px' };
        var rowClass = focused ? _style2.default.RowFocused : _style2.default.Row;
        var categoriesOccupySingleRow = this.props.categories.length <= 3;

        var categories = this.props.categories;
        var btns = [];
        var startIdx = row * 3;
        for (var i = startIdx; i < startIdx + 3; i++) {
            if (i < this.props.categories.length) {
                btns.push((0, _preact.h)(_CategoryButton2.default, {
                    onClick: this.onClickCategory(i),
                    catName: categories[i]['category'],
                    color: this.props.color,
                    imgSrc: 'https://storage.googleapis.com/jibber-image/images/' + categories[i]['imgSrc'] }));
            } else {
                btns.push(_ref);
            }
        }

        return (0, _preact.h)(
            'div',
            { style: this.__animationStyle(row), className: rowClass, ref: function ref(node) {
                    return _this3.row = node ? node : _this3.row;
                } },
            (0, _preact.h)(_NavButton2.default, {
                onClick: function onClick() {
                    return _this3.navigateCategories('back');
                },
                display: focused && !this.state.animating && !categoriesOccupySingleRow,
                direction: 'left', color: this.props.color }),
            btns,
            (0, _preact.h)(_NavButton2.default, {
                onClick: function onClick() {
                    return _this3.navigateCategories('next');
                },
                display: focused && !this.state.animating && !categoriesOccupySingleRow,
                direction: 'right', color: this.props.color }),
            (0, _preact.h)(_CategoryScroll2.default, {
                activeCategory: this.props.activeCategory,
                color: this.props.color,
                display: focused && !this.state.animating })
        );
    };

    HelpDeskBody.prototype._renderCategories = function _renderCategories() {
        var focused = this.props.route === 'HelpDeskFocused';
        //4px for extra spacing
        var categoriesHeight = this.row ? { height: this.row.clientHeight + 10 + 'px' } : { height: '100px' };
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Container, style: categoriesHeight },
            (0, _preact.h)(
                'div',
                { className: _style2.default.CategoriesWrapper, style: categoriesHeight },
                this._renderRow(0),
                this._renderRow(1),
                this._renderRow(2)
            )
        );
    };

    HelpDeskBody.prototype._renderQuestions = function _renderQuestions() {
        var focused = this.props.route === 'HelpDeskFocused';
        var questionsHeight = this.row ? this.props.height - this.row.clientHeight - 20 : 120;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.QuestionsContainer, style: { height: questionsHeight + 'px' } },
            focused && !this.state.animating && (0, _preact.h)(_CategoryQuestions2.default, {
                questions: this.props.questions,
                activeCategory: this.props.activeCategory })
        );
    };

    HelpDeskBody.prototype.render = function render() {
        var focused = this.props.route === 'HelpDeskFocused';
        var overflowY = focused ? 'hidden' : 'auto';
        return (0, _preact.h)(
            'div',
            { className: _style2.default.HelpDeskBodyContainer, style: { overflowY: overflowY, height: this.props.height + 'px' } },
            this._renderCategories(),
            this._renderQuestions()
        );
    };

    HelpDeskBody.prototype.__animationStyle = function __animationStyle(rowIdx) {
        var translation = void 0,
            opacity = void 0,
            visibility = void 0;
        var animating = this.state.animating;
        var focusedMode = this.props.route === 'HelpDeskFocused';
        var activeRow = Math.floor(this.props.activeCategory / 3);
        if (animating) {
            //Animating towards focusedMode == false, else towards focused == true
            if (focusedMode) {
                translation = 0;
                opacity = 1;
                visibility = 'visible';
            } else {
                translation = rowIdx * -100;
                opacity = rowIdx === activeRow ? 1 : 0;
                visibility = 'visible';
            }
        } else {
            if (focusedMode) {
                translation = rowIdx * -100;
                opacity = rowIdx === activeRow ? 1 : 0;
                visibility = rowIdx === activeRow ? 'visible' : 'hidden';
            } else {
                translation = 0;
                opacity = 1;
                visibility = 'visible';
            }
        }
        return {
            transform: 'translateY(' + translation + '%)',
            opacity: opacity,
            visibility: visibility
        };
    };

    return HelpDeskBody;
}(_preact2.default.Component);

function mapStateToProps(state) {
    var fullRoute = _model4.default.getHelpDeskRoute(state).split(';');
    var route = fullRoute[0];
    var activeCategory = parseInt(fullRoute[1]);
    var color = _model2.default.getColor(state);
    var categories = _model6.default.getActiveCategories(state);
    var questions = _model6.default.getActiveQuestions(state);
    return {
        height: _model4.default.getBodyHeight(state),
        color: color,
        activeCategory: activeCategory,
        route: route,
        categories: categories.toJS(),
        questions: questions
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(HelpDeskBody);

/***/ }),

/***/ "RIoB":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ButtonContainer":"ButtonContainer__hRTa3","Text":"Text__1YX6g","Image":"Image__TEJD4"};

/***/ }),

/***/ "RLDv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getInnerWidth;
function getInnerWidth(el) {
  var clientWidth = el.clientWidth;

  var _window$getComputedSt = window.getComputedStyle(el),
      paddingLeft = _window$getComputedSt.paddingLeft,
      paddingRight = _window$getComputedSt.paddingRight;

  return clientWidth - parseFloat(paddingLeft) - parseFloat(paddingRight);
}

/***/ }),

/***/ "RdLw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function () {
	// https://mathiasbynens.be/notes/es-unicode-property-escapes#emoji
	return (/\uD83C\uDFF4\uDB40\uDC67\uDB40\uDC62(?:\uDB40\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDB40\uDC77\uDB40\uDC6C\uDB40\uDC73|\uDB40\uDC73\uDB40\uDC63\uDB40\uDC74)\uDB40\uDC7F|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC68(?:\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D)?\uD83D\uDC68|(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67]))|\uD83D\uDC66\u200D\uD83D\uDC66|\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|[\u2695\u2696\u2708]\uFE0F|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]\uFE0F|(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]))|\uD83D\uDC69\u200D(?:\u2764\uFE0F\u200D(?:\uD83D\uDC8B\u200D(?:\uD83D[\uDC68\uDC69])|\uD83D[\uDC68\uDC69])|\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66\u200D\uD83D\uDC66|(?:\uD83D\uDC41\uFE0F\u200D\uD83D\uDDE8|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2695\u2696\u2708]|(?:(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)\uFE0F|\uD83D\uDC6F|\uD83E[\uDD3C\uDDDE\uDDDF])\u200D[\u2640\u2642]|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:(?:\uD83C[\uDFFB-\uDFFF])\u200D[\u2640\u2642]|\u200D[\u2640\u2642])|\uD83D\uDC69\u200D[\u2695\u2696\u2708])\uFE0F|\uD83D\uDC69\u200D\uD83D\uDC67\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC69\u200D\uD83D\uDC69\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D\uDC68(?:\u200D(?:(?:\uD83D[\uDC68\uDC69])\u200D(?:\uD83D[\uDC66\uDC67])|\uD83D[\uDC66\uDC67])|\uD83C[\uDFFB-\uDFFF])|\uD83C\uDFF3\uFE0F\u200D\uD83C\uDF08|\uD83D\uDC69\u200D\uD83D\uDC67|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])\u200D(?:\uD83C[\uDF3E\uDF73\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92])|\uD83D\uDC69\u200D\uD83D\uDC66|\uD83C\uDDF4\uD83C\uDDF2|\uD83C\uDDFD\uD83C\uDDF0|\uD83C\uDDF6\uD83C\uDDE6|\uD83D\uDC69(?:\uD83C[\uDFFB-\uDFFF])|\uD83C\uDDFC(?:\uD83C[\uDDEB\uDDF8])|\uD83C\uDDEB(?:\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7])|\uD83C\uDDE9(?:\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF])|\uD83C\uDDE7(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF1(?:\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE])|\uD83C\uDDFE(?:\uD83C[\uDDEA\uDDF9])|\uD83C\uDDF9(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF])|\uD83C\uDDF5(?:\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE])|\uD83C\uDDEF(?:\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5])|\uD83C\uDDED(?:\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA])|\uD83C\uDDEE(?:\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9])|\uD83C\uDDFB(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA])|\uD83C\uDDEC(?:\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE])|\uD83C\uDDF7(?:\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC])|\uD83C\uDDEA(?:\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA])|\uD83C\uDDFA(?:\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF])|\uD83C\uDDE8(?:\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF5\uDDF7\uDDFA-\uDDFF])|\uD83C\uDDE6(?:\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF])|[#\*0-9]\uFE0F\u20E3|\uD83C\uDDF8(?:\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF])|\uD83C\uDDFF(?:\uD83C[\uDDE6\uDDF2\uDDFC])|\uD83C\uDDF0(?:\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF])|\uD83C\uDDF3(?:\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF])|\uD83C\uDDF2(?:\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF])|(?:\uD83C[\uDFC3\uDFC4\uDFCA]|\uD83D[\uDC6E\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4-\uDEB6]|\uD83E[\uDD26\uDD37-\uDD39\uDD3D\uDD3E\uDDD6-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])|(?:\u26F9|\uD83C[\uDFCB\uDFCC]|\uD83D\uDD75)(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u270A-\u270D]|\uD83C[\uDF85\uDFC2\uDFC7]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC70\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDCAA\uDD74\uDD7A\uDD90\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD30-\uDD36\uDDD1-\uDDD5])(?:\uD83C[\uDFFB-\uDFFF])|(?:[\u261D\u26F9\u270A-\u270D]|\uD83C[\uDF85\uDFC2-\uDFC4\uDFC7\uDFCA-\uDFCC]|\uD83D[\uDC42\uDC43\uDC46-\uDC50\uDC66-\uDC69\uDC6E\uDC70-\uDC78\uDC7C\uDC81-\uDC83\uDC85-\uDC87\uDCAA\uDD74\uDD75\uDD7A\uDD90\uDD95\uDD96\uDE45-\uDE47\uDE4B-\uDE4F\uDEA3\uDEB4-\uDEB6\uDEC0\uDECC]|\uD83E[\uDD18-\uDD1C\uDD1E\uDD1F\uDD26\uDD30-\uDD39\uDD3D\uDD3E\uDDD1-\uDDDD])(?:\uD83C[\uDFFB-\uDFFF])?|(?:[\u231A\u231B\u23E9-\u23EC\u23F0\u23F3\u25FD\u25FE\u2614\u2615\u2648-\u2653\u267F\u2693\u26A1\u26AA\u26AB\u26BD\u26BE\u26C4\u26C5\u26CE\u26D4\u26EA\u26F2\u26F3\u26F5\u26FA\u26FD\u2705\u270A\u270B\u2728\u274C\u274E\u2753-\u2755\u2757\u2795-\u2797\u27B0\u27BF\u2B1B\u2B1C\u2B50\u2B55]|\uD83C[\uDC04\uDCCF\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF7C\uDF7E-\uDF93\uDFA0-\uDFCA\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF4\uDFF8-\uDFFF]|\uD83D[\uDC00-\uDC3E\uDC40\uDC42-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDD7A\uDD95\uDD96\uDDA4\uDDFB-\uDE4F\uDE80-\uDEC5\uDECC\uDED0-\uDED2\uDEEB\uDEEC\uDEF4-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])|(?:[#\*0-9\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23E9-\u23F3\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB-\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u261D\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u2660\u2663\u2665\u2666\u2668\u267B\u267F\u2692-\u2697\u2699\u269B\u269C\u26A0\u26A1\u26AA\u26AB\u26B0\u26B1\u26BD\u26BE\u26C4\u26C5\u26C8\u26CE\u26CF\u26D1\u26D3\u26D4\u26E9\u26EA\u26F0-\u26F5\u26F7-\u26FA\u26FD\u2702\u2705\u2708-\u270D\u270F\u2712\u2714\u2716\u271D\u2721\u2728\u2733\u2734\u2744\u2747\u274C\u274E\u2753-\u2755\u2757\u2763\u2764\u2795-\u2797\u27A1\u27B0\u27BF\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B50\u2B55\u3030\u303D\u3297\u3299]|\uD83C[\uDC04\uDCCF\uDD70\uDD71\uDD7E\uDD7F\uDD8E\uDD91-\uDD9A\uDDE6-\uDDFF\uDE01\uDE02\uDE1A\uDE2F\uDE32-\uDE3A\uDE50\uDE51\uDF00-\uDF21\uDF24-\uDF93\uDF96\uDF97\uDF99-\uDF9B\uDF9E-\uDFF0\uDFF3-\uDFF5\uDFF7-\uDFFF]|\uD83D[\uDC00-\uDCFD\uDCFF-\uDD3D\uDD49-\uDD4E\uDD50-\uDD67\uDD6F\uDD70\uDD73-\uDD7A\uDD87\uDD8A-\uDD8D\uDD90\uDD95\uDD96\uDDA4\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA-\uDE4F\uDE80-\uDEC5\uDECB-\uDED2\uDEE0-\uDEE5\uDEE9\uDEEB\uDEEC\uDEF0\uDEF3-\uDEF8]|\uD83E[\uDD10-\uDD3A\uDD3C-\uDD3E\uDD40-\uDD45\uDD47-\uDD4C\uDD50-\uDD6B\uDD80-\uDD97\uDDC0\uDDD0-\uDDE6])\uFE0F/g
	);
};

/***/ }),

/***/ "S09b":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preact2 = _interopRequireDefault(_preact);

var _preactRedux = __webpack_require__("1AcT");

var _store = __webpack_require__("RHIr");

var _store2 = _interopRequireDefault(_store);

var _Audio = __webpack_require__("t9XJ");

var _Audio2 = _interopRequireDefault(_Audio);

var _UserAgentConstants = __webpack_require__("mi58");

var _UserAgentConstants2 = _interopRequireDefault(_UserAgentConstants);

var _Header = __webpack_require__("X0Jh");

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__("8d6x");

var _Body2 = _interopRequireDefault(_Body);

var _Header3 = __webpack_require__("W0rJ");

var _Header4 = _interopRequireDefault(_Header3);

var _Body3 = __webpack_require__("zvqD");

var _Body4 = _interopRequireDefault(_Body3);

var _Header5 = __webpack_require__("2i1w");

var _Header6 = _interopRequireDefault(_Header5);

var _Body5 = __webpack_require__("n7b9");

var _Body6 = _interopRequireDefault(_Body5);

var _Header7 = __webpack_require__("x584");

var _Header8 = _interopRequireDefault(_Header7);

var _Body7 = __webpack_require__("ej/C");

var _Body8 = _interopRequireDefault(_Body7);

var _Header9 = __webpack_require__("U6Pu");

var _Header10 = _interopRequireDefault(_Header9);

var _Body9 = __webpack_require__("fnIt");

var _Body10 = _interopRequireDefault(_Body9);

var _Header11 = __webpack_require__("nGPF");

var _Header12 = _interopRequireDefault(_Header11);

var _Body11 = __webpack_require__("c2sW");

var _Body12 = _interopRequireDefault(_Body11);

var _GDPROverlay = __webpack_require__("9rLE");

var _GDPROverlay2 = _interopRequireDefault(_GDPROverlay);

var _Body13 = __webpack_require__("RFY+");

var _Body14 = _interopRequireDefault(_Body13);

var _Header13 = __webpack_require__("ObqT");

var _Header14 = _interopRequireDefault(_Header13);

var _HelpDeskArticle = __webpack_require__("5T05");

var _HelpDeskArticle2 = _interopRequireDefault(_HelpDeskArticle);

var _SearchResults = __webpack_require__("tXeI");

var _SearchResults2 = _interopRequireDefault(_SearchResults);

var _Header15 = __webpack_require__("RE7E");

var _Header16 = _interopRequireDefault(_Header15);

var _Body15 = __webpack_require__("DSuZ");

var _Body16 = _interopRequireDefault(_Body15);

var _Footer = __webpack_require__("Du07");

var _Footer2 = _interopRequireDefault(_Footer);

var _model = __webpack_require__("lmuV");

var _style = __webpack_require__("r7nU");

var _style2 = _interopRequireDefault(_style);

var _preactCustomScrollbars = __webpack_require__("kKTp");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Header14.default, null);

var _ref2 = (0, _preact.h)(_HelpDeskArticle2.default, null);

var _ref3 = (0, _preact.h)(_Header14.default, null);

var _ref4 = (0, _preact.h)(_SearchResults2.default, null);

var _ref5 = (0, _preact.h)(_Header16.default, null);

var _ref6 = (0, _preact.h)(_Body16.default, null);

var _ref7 = (0, _preact.h)(_Header14.default, null);

var _ref8 = (0, _preact.h)(_Body14.default, null);

var _ref9 = (0, _preact.h)(_Header2.default, null);

var _ref10 = (0, _preact.h)(_Body2.default, null);

var _ref11 = (0, _preact.h)(_Header4.default, null);

var _ref12 = (0, _preact.h)(_Body4.default, null);

var _ref13 = (0, _preact.h)(_Header12.default, null);

var _ref14 = (0, _preact.h)(_Body12.default, null);

var _ref15 = (0, _preact.h)(_Header8.default, null);

var _ref16 = (0, _preact.h)(
  _GDPROverlay2.default,
  null,
  (0, _preact.h)(_Body8.default, null)
);

var _ref17 = (0, _preact.h)(_Header10.default, null);

var _ref18 = (0, _preact.h)(
  _GDPROverlay2.default,
  null,
  (0, _preact.h)(_Body10.default, null)
);

var _ref19 = (0, _preact.h)(_Header6.default, null);

var _ref20 = (0, _preact.h)(
  _GDPROverlay2.default,
  null,
  (0, _preact.h)(_Body6.default, null)
);

var _ref21 = (0, _preact.h)("div", null);

var _ref22 = (0, _preact.h)("div", null);

var _ref23 = (0, _preact.h)(_Audio2.default, null);

var Router = function (_Component) {
  _inherits(Router, _Component);

  function Router(props) {
    _classCallCheck(this, Router);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._updateHeight = _this._updateHeight.bind(_this);
    return _this;
  }

  Router.prototype._renderRoute = function _renderRoute() {
    var _this2 = this;

    var header = void 0,
        body = void 0;

    if (this.props.activeTab === 0) {
      var helpDeskFullRoute = this.props.helpDeskRoute.split(";");
      var helpDeskRoute = helpDeskFullRoute[0];
      switch (helpDeskRoute) {
        case "HelpDeskArticle":
          header = _ref;
          body = _ref2;
          break;
        case "HelpDeskSearch":
          header = _ref3;
          body = _ref4;
          break;
        case "FAQ":
          header = _ref5;
          body = _ref6;
          break;
        case "HelpDesk":
        case "HelpDeskFocused":
        default:
          header = _ref7;
          body = _ref8;
          break;
      }
    } else {
      switch (this.props.chatRoute) {
        case "Chat":
          header = _ref9;
          body = _ref10;
          break;
        case "Conversations":
          header = _ref11;
          body = _ref12;
          break;
        case "Settings":
          header = _ref13;
          body = _ref14;
          break;
        case "StartChatting":
        default:
          if (this.props.isOffline) {
            header = _ref15;
            body = _ref16;
          } else if (this.props.formsRequire) {
            header = _ref17;
            body = _ref18;
          } else {
            header = _ref19;
            body = _ref20;
          }
      }
    }

    var FOOTER_HEIGHT = 40;
    return (0, _preact.h)(
      "div",
      { className: _style2.default.BodyWrapper },
      (0, _preact.h)(
        _preactCustomScrollbars.Scrollbars,
        {
          className: _style2.default.BodyScrollbar,
          universal: true,
          renderTrackHorizontal: function renderTrackHorizontal(props) {
            return _ref21;
          },
          renderThumbHorizontal: function renderThumbHorizontal(props) {
            return _ref22;
          }
        },
        (0, _preact.h)(
          "div",
          { id: "HeaderWrapper", ref: function ref(div) {
              return _this2.header = div;
            } },
          header
        ),
        (0, _preact.h)(
          "div",
          { id: "BodyWrapper", style: { minHeight: "50px" } },
          body
        )
      ),
      this.props.hasFeatureFooter && (0, _preact.h)(_Footer2.default, { height: FOOTER_HEIGHT })
    );
  };

  Router.prototype._updateHeight = function _updateHeight(shellHeight, shellWidth, headerHeight) {
    if (this.props.shellHeight !== shellHeight) this.props.dispatch(_model.SystemModel.setShellHeight(shellHeight));
    if (this.props.shellWidth !== shellWidth) this.props.dispatch(_model.SystemModel.setShellWidth(shellWidth));
    if (this.props.headerHeight !== headerHeight) this.props.dispatch(_model.SystemModel.setHeaderHeight(headerHeight));
  };

  Router.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    this._updateHeight(this.shell.clientHeight, this.shell.clientWidth, this.header.clientHeight);
  };

  Router.prototype.componentDidMount = function componentDidMount() {
    var _this3 = this;

    if (this.shell) {
      this._updateHeight(this.shell.clientHeight, this.shell.clientWidth, this.header.clientHeight);
    }
    window.addEventListener("resize", function () {
      if (_this3.shell) {
        _this3._updateHeight(_this3.shell.clientHeight, _this3.shell.clientWidth, _this3.header.clientHeight);
      }
    });
  };

  Router.prototype.render = function render() {
    var _this4 = this;

    var shellClassName = _style2.default.Shell;

    var isInstagram = navigator.userAgent.match(_UserAgentConstants2.default.instagram);
    if (isInstagram) shellClassName += " " + _style2.default.ShellInstagram; // Instagram has some weird padding top-issues.
    return (0, _preact.h)(
      "div",
      { className: shellClassName },
      (0, _preact.h)(
        "div",
        { className: _style2.default.ShellBody, ref: function ref(div) {
            return _this4.shell = div;
          } },
        this._renderRoute()
      ),
      _ref23
    );
  };

  return Router;
}(_preact.Component);

function mapStateToProps(state) {
  var features = state.getIn(["features", "features"]);
  var hasFeatureFooter = features.has("faq_type");
  var isOffline = _model.CompanyModel.isOffline(state);

  return {
    chatRoute: _model.SystemModel.getRoute(state),
    activeTab: _model.SystemModel.getActiveTab(state),
    helpDeskRoute: _model.SystemModel.getHelpDeskRoute(state),
    shellHeight: _model.SystemModel.getShellHeight(state),
    shellWidth: _model.SystemModel.getShellWidth(state),
    headerHeight: _model.SystemModel.getHeaderHeight(state),
    formsRequire: _model.CustomizationModel.getFormsRequire(state),
    isOffline: isOffline,

    isShort: _model.SystemModel.isShort(state),
    hasFeatureFooter: hasFeatureFooter,

    exchangeAvailableAndOnline: _model.FeaturesModel.getExchangeAvailableAndOnline(state)
  };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Router);

/***/ }),

/***/ "SNSg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = normalizeProtocol;
// ensure protocol has trailing : if missing
function normalizeProtocol(protocol) {
  if (protocol && !protocol.endsWith(":")) return protocol + ":";
  return protocol;
}

/***/ }),

/***/ "SX1U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cog = function (_Component) {
    _inherits(Cog, _Component);

    function Cog() {
        _classCallCheck(this, Cog);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Cog.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            { version: "1.1", xmlns: "http://www.w3.org/2000/svg", width: "16", height: "16", viewBox: "0 0 16 16" },
            (0, _preact.h)("path", { fill: this.props.color, d: "M16 7l-3.767-0.753 2.131-3.196-1.414-1.414-3.196 2.131-0.753-3.767h-2l-0.753 3.767-3.196-2.131-1.414 1.414 2.131 3.196-3.767 0.753v2l3.767 0.753-2.131 3.196 1.414 1.414 3.196-2.131 0.753 3.767h2l0.753-3.767 3.196 2.131 1.414-1.414-2.131-3.196 3.767-0.753v-2zM8 11c-1.657 0-3-1.343-3-3s1.343-3 3-3 3 1.343 3 3-1.343 3-3 3z" }),
            (0, _preact.h)("path", { fill: this.props.color, d: "M9 8c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z" })
        );
    };

    return Cog;
}(_preact.Component);

exports.default = Cog;

/***/ }),

/***/ "SgI6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _MetaMessage = __webpack_require__("GSpp");

var _MetaMessage2 = _interopRequireDefault(_MetaMessage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MetaMessage2.default;

/***/ }),

/***/ "SiXk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var emailRegex = /(.+)@(.+)\.(.+)/;

var validateEmail = function validateEmail(email) {
    return emailRegex.test(email);
};
var validateDummy = function validateDummy(value) {
    return true;
};

exports.default = {
    validateEmail: validateEmail, validateDummy: validateDummy
};

/***/ }),

/***/ "Stiw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toArray = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _renderer = __webpack_require__("f10v");

Object.defineProperty(exports, "toArray", {
  enumerable: true,
  get: function get() {
    return _renderer.toArray;
  }
});
exports.Twemoji = Twemoji;
exports.Emojione = Emojione;

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _renderer2 = _interopRequireDefault(_renderer);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var protocol = "https";

if (typeof location !== "undefined" && location.protocol === "http:") {
  protocol = "http";
}

exports.default = _renderer2.default;
function Twemoji(_ref) {
  var svg = _ref.svg,
      options = _ref.options,
      rest = _objectWithoutProperties(_ref, ["svg", "options"]);

  var size = svg ? "" : "72x72";
  var ext = svg ? "svg" : "png";

  options = _extends({
    protocol: protocol,
    baseUrl: "//twemoji.maxcdn.com/2/" + (svg ? "svg/" : ""),
    size: size,
    ext: ext
  }, options);

  return _react2.default.createElement(_renderer2.default, _extends({ options: options }, rest));
}

Twemoji.propTypes = {
  text: _propTypes2.default.string,
  options: _propTypes2.default.object,
  svg: _propTypes2.default.bool
};

function Emojione(_ref2) {
  var svg = _ref2.svg,
      options = _ref2.options,
      rest = _objectWithoutProperties(_ref2, ["svg", "options"]);

  var ext = svg ? "svg" : "png";

  options = _extends({
    protocol: protocol,
    baseUrl: "//cdnjs.cloudflare.com/ajax/libs/emojione/2.2.7/assets/" + ext + "/",
    size: "",
    ext: ext
  }, options);

  return _react2.default.createElement(_renderer2.default, _extends({ options: options }, rest));
}

Emojione.propTypes = {
  text: _propTypes2.default.string,
  options: _propTypes2.default.object,
  svg: _propTypes2.default.bool
};

/***/ }),

/***/ "TAZ7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.configurationError = exports.unsupportedBrowserError = exports.uniquifySVGIDs = exports.randomString = exports.isSupportedEnvironment = exports.supportsInlineSVG = undefined;

var _once = __webpack_require__("7suT");

var _once2 = _interopRequireDefault(_once);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var supportsInlineSVG = exports.supportsInlineSVG = (0, _once2.default)(function () {
  /* istanbul ignore next */
  if (!document) {
    return false;
  }

  var div = document.createElement('div');
  div.innerHTML = '<svg />';
  return div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
});

var isSupportedEnvironment = exports.isSupportedEnvironment = (0, _once2.default)(function () {
  return supportsInlineSVG() && typeof window !== 'undefined' && window !== null ? window.XMLHttpRequest || window.XDomainRequest : false;
});

var randomString = exports.randomString = function randomString() {
  var length = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;

  var letters = 'abcdefghijklmnopqrstuvwxyz';
  var numbers = '1234567890';
  var charset = letters + letters.toUpperCase() + numbers;

  var randomCharacter = function randomCharacter(array) {
    return array[Math.floor(Math.random() * array.length)];
  };

  var R = '';
  for (var i = 0; i < length; i++) {
    R += randomCharacter(charset);
  }
  return R;
};

var uniquifySVGIDs = exports.uniquifySVGIDs = function () {
  var mkAttributePattern = function mkAttributePattern(attr) {
    return '(?:(?:\\s|\\:)' + attr + ')';
  };

  var idPattern = new RegExp('(?:(' + mkAttributePattern('id') + ')="([^"]+)")|(?:(' + mkAttributePattern('href') + '|' + mkAttributePattern('role') + '|' + mkAttributePattern('arcrole') + ')="\\#([^"]+)")|(?:="url\\(\\#([^\\)]+)\\)")|(?:url\\(\\#([^\\)]+)\\))', 'g');

  return function (svgText, svgID, baseURL) {
    var uniquifyID = function uniquifyID(id) {
      return id + '___' + svgID;
    };

    return svgText.replace(idPattern, function (m, p1, p2, p3, p4, p5, p6) {
      //eslint-disable-line consistent-return
      /* istanbul ignore else */
      if (p2) {
        return p1 + '="' + uniquifyID(p2) + '"';
      }

      if (p4) {
        return p3 + '="' + baseURL + '#' + uniquifyID(p4) + '"';
      }

      if (p5) {
        return '="url(' + baseURL + '#' + uniquifyID(p5) + ')"';
      }

      if (p6) {
        return 'url(' + baseURL + '#' + uniquifyID(p6) + ')';
      }
    });
  };
}();

var InlineSVGError = function (_Error) {
  _inherits(InlineSVGError, _Error);

  function InlineSVGError(message) {
    var _ret;

    _classCallCheck(this, InlineSVGError);

    var _this = _possibleConstructorReturn(this, (InlineSVGError.__proto__ || Object.getPrototypeOf(InlineSVGError)).call(this));

    _this.name = 'InlineSVGError';
    _this.isSupportedBrowser = true;
    _this.isConfigurationError = false;
    _this.isUnsupportedBrowserError = false;
    _this.message = message;

    return _ret = _this, _possibleConstructorReturn(_this, _ret);
  }

  return InlineSVGError;
}(Error);

var createError = function createError(message, attrs) {
  var err = new InlineSVGError(message);

  return _extends({}, err, attrs);
};

var unsupportedBrowserError = exports.unsupportedBrowserError = function unsupportedBrowserError(message) {
  var newMessage = message;

  /* istanbul ignore else */
  if (!newMessage) {
    newMessage = 'Unsupported Browser';
  }

  return createError(newMessage, {
    isSupportedBrowser: false,
    isUnsupportedBrowserError: true
  });
};

var configurationError = exports.configurationError = function configurationError(message) {
  return createError(message, {
    isConfigurationError: true
  });
};

/***/ }),

/***/ "TRnG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = extend;

function extend() {
    var target = {};

    for (var i = 0; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
            if (source.hasOwnProperty(key)) {
                target[key] = source[key];
            }
        }
    }

    return target;
}

/***/ }),

/***/ "TnEH":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"CloseButton":"CloseButton__1df5Q"};

/***/ }),

/***/ "U6Pu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("qIew");

var _style2 = _interopRequireDefault(_style);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _AutoMessage = __webpack_require__("O6gZ");

var _AutoMessage2 = _interopRequireDefault(_AutoMessage);

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            HeaderHeight: 0
        };
        return _this;
    }

    Header.prototype.render = function render() {
        var _props = this.props,
            company = _props.company,
            automessage = _props.automessage,
            features = _props.features,
            language = _props.language,
            name = _props.name;

        var hasFaq = features.get('hasFaq');
        var welcomeTo = language.get("WelcomeTo");

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Header },
                (0, _preact.h)(_Title2.default, { title: welcomeTo, body: name }),
                (0, _preact.h)(_AutoMessage2.default, { automessage: automessage }),
                _ref
            )
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    var name = _model4.default.getCompanyDisplayName(state);
    return {
        color: color,
        language: language,
        company: state.get('company'),
        automessage: state.getIn(['autoMessages', 'currentAutoMessage']),
        features: state.get('features'),
        system: state.get('system'),
        name: name
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "UGHC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Generated by CoffeeScript 1.12.2
(function () {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if (typeof performance !== "undefined" && performance !== null && performance.now) {
    module.exports = function () {
      return performance.now();
    };
  } else if (typeof process !== "undefined" && process !== null && process.hrtime) {
    module.exports = function () {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function getNanoSeconds() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function () {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function () {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }
}).call(undefined);

//# sourceMappingURL=performance-now.js.map

/***/ }),

/***/ "UTRz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var space = __webpack_require__("0K3L");

/**
 * Export.
 */

module.exports = toCamelCase;

/**
 * Convert a `string` to camel case.
 *
 * @param {String} string
 * @return {String}
 */

function toCamelCase(string) {
  return space(string).replace(/\s(\w)/g, function (matches, letter) {
    return letter.toUpperCase();
  });
}

/***/ }),

/***/ "Ue4h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendButton = function (_Component) {
    _inherits(SendButton, _Component);

    function SendButton() {
        _classCallCheck(this, SendButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SendButton.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            active = _props.active;

        if (active) return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M41,20.49a3.26,3.26,0,0,0-2.27-2.88L6.2,3.42c-2.08-.9-3.14-.15-3.6.37s-1,1.7.14,3.6l4,11.21L8.95,20.5,6.72,22.41l-4,11.21c-1.18,1.92-.59,3.08-.14,3.61A2.34,2.34,0,0,0,4.43,38a4.43,4.43,0,0,0,1.8-.42l32.49-14.2C40.74,22.49,41,21.09,41,20.49Z" })
        );else return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M41,20.49a3.26,3.26,0,0,0-2.27-2.88L6.2,3.42c-2.08-.9-3.14-.15-3.6.37s-1,1.7.14,3.6l4,11.21L8.95,20.5,6.72,22.41l-4,11.21c-1.18,1.92-.59,3.08-.14,3.61A2.34,2.34,0,0,0,4.43,38a4.43,4.43,0,0,0,1.8-.42l32.49-14.2C40.74,22.49,41,21.09,41,20.49ZM7.31,33.11,10,24.18c.07-.13.13-.26.19-.4a8.83,8.83,0,0,1,.74-.52l1.83-.37.3-.07h.11L24.7,20.51,13.16,18.23h-.08l-.33-.08-1.82-.36a13.72,13.72,0,0,0-1.07-1.11L7.31,7.87,36.2,20.49Z" })
        );
    };

    return SendButton;
}(_preact.Component);

exports.default = SendButton;

/***/ }),

/***/ "UfLy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("qZCq");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderTitle = function (_Component) {
    _inherits(HeaderTitle, _Component);

    function HeaderTitle() {
        _classCallCheck(this, HeaderTitle);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    HeaderTitle.prototype.render = function render() {
        var title = this.props.title;
        var body = this.props.body;

        var defaultStyle = _style2.default.NormalHeader;
        if (this.props.isMobile) defaultStyle = _style2.default.MobileHeader;

        return (0, _preact.h)(
            'div',
            { className: defaultStyle },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Title },
                title,
                ' '
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.Body },
                body
            )
        );
    };

    return HeaderTitle;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        isMobile: _model2.default.isMobile(state)
    };
})(HeaderTitle);

/***/ }),

/***/ "V7//":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("3rs2");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Textarea = function (_Component) {
    _inherits(Textarea, _Component);

    function Textarea(props) {
        _classCallCheck(this, Textarea);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            value: props.value || '',
            focus: false,
            onLabelHover: false
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.inputRef = null;
        _this.setFocus = _this.setFocus.bind(_this);
        return _this;
    }

    Textarea.prototype.onChange = function onChange(event) {
        this.setState({ value: event.target.value });
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    };

    Textarea.prototype.setFocus = function setFocus() {
        this.setState({ focus: true });
        if (this.inputRef) {
            this.inputRef.focus();
        }
    };

    Textarea.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            width = _props.width,
            label = _props.label,
            autocomplete = _props.autocomplete,
            require = _props.require,
            missing = _props.missing;

        return (0, _preact.h)(
            'span',
            { className: _style2.default.InputWrapper,
                onClick: this.setFocus
            },
            (0, _preact.h)(
                'span',
                { className: this.state.value || this.state.focus || this.state.hover ? _style2.default.TextareaLabelHover : _style2.default.TextareaLabel },
                label,
                ' ',
                require && missing && this.props.language.get('Require')
            ),
            (0, _preact.h)('textarea', { className: _style2.default.Textarea,
                ref: function ref(inputRef) {
                    return _this2.inputRef = inputRef;
                },
                onfocus: function onfocus() {
                    _this2.setState({ focus: true });
                },
                onBlur: function onBlur() {
                    return _this2.setState({ focus: false });
                },
                onInput: this.onChange,
                value: this.state.value,
                id: label,
                style: require && missing && {
                    border: '2px solid #ff6d67'
                }
            }),
            (0, _preact.h)(
                'span',
                { className: _style2.default.TextareaRequired,
                    onMouseEnter: function onMouseEnter() {
                        return _this2.setState({ onLabelHover: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2.setState({ onLabelHover: false });
                    }
                },
                ' * '
            ),
            this.state.onLabelHover && (0, _preact.h)(
                'span',
                { className: _style2.default.LabelRequiredMissing
                },
                ' ',
                label,
                ' '
            ),
            require && missing && (0, _preact.h)(
                'span',
                { className: _style2.default.InputRequiredMissing },
                ' * '
            )
        );
    };

    return Textarea;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        language: _model2.default.getLanguage(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Textarea);

/***/ }),

/***/ "VN4q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _store = __webpack_require__("RHIr");

var _store2 = _interopRequireDefault(_store);

var _lang = __webpack_require__("r3oa");

var _lang2 = _interopRequireDefault(_lang);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var MONTH_NAMES = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
var WEEK_DAY = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

var DateTime = function () {
    function DateTime() {
        _classCallCheck(this, DateTime);

        var selected = _store2.default.getState().getIn(['customization', 'default_language'], 'se');
        this.language = _lang2.default[selected];
    }

    DateTime.prototype.formatDate = function formatDate(dateString, format) {
        var date = this.getUTCDate(dateString);

        switch (format) {
            case 'hh:mm':
                return this.getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return this.getDate(date) + ' ' + this.getTime(date);
            default:
                return this.getDate(date) + ' ' + this.getTime(date);
        }
    };

    DateTime.prototype.getUTCDate = function getUTCDate(dateString) {
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];

        /*
        * The date we get from the server is UTC time.
        * We need to add UTC to the end of date_created
        * so that the Date function will convert it to
        * the UTC time that the browser is using.
        */
        var dateStringUTC = dateString;

        return new Date(dateStringUTC);
    };

    DateTime.prototype.getTimestamp = function getTimestamp(dateString) {
        return this.getUTCDate(dateString).getTime();
    };

    DateTime.prototype.getTime = function getTime(date) {
        var hours = this.padDate(date.getHours());
        var minutes = this.padDate(date.getMinutes());
        return hours + ':' + minutes;
    };

    DateTime.prototype.getDate = function getDate(date) {
        var year = date.getFullYear();
        var month = this.padDate(date.getMonth() + 1);
        var day = this.padDate(date.getDate());
        return year + '-' + month + '-' + day;
    };

    DateTime.prototype.padDate = function padDate(number) {
        number = String(number);
        if (number.length === 1) {
            number = '0' + number;
        }
        return number;
    };

    DateTime.prototype.isToday = function isToday(dateString) {
        var date = this.getUTCDate(dateString);
        var today = new Date();
        return today.toDateString() === date.toDateString();
    };

    DateTime.prototype.getDiffTime = function getDiffTime(here, there) {
        var hereDate = this.getUTCDate(here);
        var thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    };

    DateTime.prototype.getDiffMinutes = function getDiffMinutes(here, there) {
        return Math.ceil(this.getDiffTime(here, there) / (1000 * 60));
    };

    DateTime.prototype.getDetailedNiceDate = function getDetailedNiceDate(dateString) {

        var date = this.getUTCDate(dateString);
        var today = new Date();

        if (this.isToday(dateString)) return this.language["Today"] + ' ' + this.getTime(date);

        var weekDate = date.getDay();
        var monthDate = date.getMonth();
        var weekKey = WEEK_DAY[weekDate];
        var week = this.language[weekKey].substring(0, 3);
        var monthKey = MONTH_NAMES[monthDate];
        var month = this.language[monthKey].substring(0, 3);

        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays === 1) return this.language["Yesterday"] + ' ' + this.getTime(date);
        if (diffDays < 7) return week + ' ' + this.getTime(date);
        return date.getDate() + ' ' + month + ' ' + this.getTime(date);
    };

    return DateTime;
}();

exports.default = new DateTime();

/***/ }),

/***/ "W0rJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Arrow = __webpack_require__("fCv+");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _Buttons = __webpack_require__("Jw2m");

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _style = __webpack_require__("Ft9W");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Buttons.BackButton, null);

var _ref2 = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header() {
        _classCallCheck(this, Header);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Header.prototype.render = function render() {
        var company = this.props.company;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Header, style: { backgroundColor: this.props.color } },
            _ref,
            (0, _preact.h)(_Title2.default, { body: this.props.language.get("ConversationsWith") }),
            _ref2
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    return {
        company: state.get('company'),
        features: state.get('features'),
        color: color,
        language: language
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "Wioz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _LocalStorage = __webpack_require__("LgRH");

var _LocalStorage2 = _interopRequireDefault(_LocalStorage);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/*
    For Feedback system. It internally uses localStorage.
*/

var Feedback = function () {
    function Feedback() {
        _classCallCheck(this, Feedback);
    }

    Feedback.addToVoted = function addToVoted(articleId, dateModified) {
        var feedbackList = _LocalStorage2.default.get('feedback', 'feedbackList');
        var tempList = JSON.parse(feedbackList);
        if (feedbackList === null) {
            var _JSON$stringify;

            _LocalStorage2.default.set('feedback', 'feedbackList', JSON.stringify((_JSON$stringify = {}, _JSON$stringify[articleId] = { dateModified: dateModified }, _JSON$stringify)));
        } else {
            var _extends2;

            var newList = _extends({}, tempList, (_extends2 = {}, _extends2[articleId] = { dateModified: dateModified }, _extends2));
            _LocalStorage2.default.set('feedback', 'feedbackList', JSON.stringify(newList));
        }
    };

    Feedback.isVoteable = function isVoteable(articleId, dateModified) {
        var feedbackList = JSON.parse(_LocalStorage2.default.get('feedback', 'feedbackList'));

        if (feedbackList === null) return true;
        if (!(articleId in feedbackList)) return true;
        if (feedbackList[articleId].dateModified !== dateModified) return true;

        return false;
    };

    return Feedback;
}();

exports.default = Feedback;

/***/ }),

/***/ "WjAf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _redux = __webpack_require__("2KeS");

var _style = __webpack_require__("+RxT");

var _style2 = _interopRequireDefault(_style);

var _SendButton = __webpack_require__("Ue4h");

var _SendButton2 = _interopRequireDefault(_SendButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatFooterSendButton = function (_Component) {
    _inherits(ChatFooterSendButton, _Component);

    function ChatFooterSendButton() {
        _classCallCheck(this, ChatFooterSendButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.state = {
            hover: false
        };
        _this.handleSendClick = _this.handleSendClick.bind(_this);
        return _this;
    }

    ChatFooterSendButton.prototype.onHover = function onHover(e) {
        this.setState({ hover: true });
    };

    ChatFooterSendButton.prototype.onHoverLeave = function onHoverLeave(e) {
        this.setState({ hover: false });
    };

    ChatFooterSendButton.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            {
                onMouseEnter: this.onHover.bind(this),
                onMouseLeave: this.onHoverLeave.bind(this),
                onClick: this.handleSendClick,
                className: _style2.default.ChatFooterSendButton },
            (0, _preact.h)(_SendButton2.default, { active: this.state.hover, color: this.props.color })
        );
    };

    ChatFooterSendButton.prototype.handleSendClick = function handleSendClick() {
        this.props.onClick();
    };

    return ChatFooterSendButton;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(null, null, null, { withRef: true })(ChatFooterSendButton);

/***/ }),

/***/ "X0Jh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Arrow = __webpack_require__("fCv+");

var _Arrow2 = _interopRequireDefault(_Arrow);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("lmuV");

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _style = __webpack_require__("mBif");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    _RightSide2.default,
    null,
    (0, _preact.h)(_Buttons.CloseButton, null)
);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header() {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this._goBack = _this._goBack.bind(_this);
        return _this;
    }

    Header.prototype.render = function render() {
        var _props = this.props,
            company = _props.company,
            conversations = _props.conversations,
            features = _props.features,
            name = _props.name,
            color = _props.color,
            totalUnread = _props.totalUnread;

        var route = conversations.isEmpty() ? 'StartChatting' : 'Conversations';
        var hasFaq = features.get('hasFaq');
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Header, style: { backgroundColor: color } },
            (0, _preact.h)(_Buttons.BackButton, { callback: this._goBack }),
            totalUnread !== 0 && (0, _preact.h)('span', { className: _style2.default.UnreadNotis }),
            (0, _preact.h)(_Title2.default, { body: name }),
            _ref
        );
    };

    Header.prototype._goBack = function _goBack() {
        this.props.dispatch(_model2.default.goBack());
        this.props.dispatch(_model5.TicketModel.setCurrentRoom(''));
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var name = _model4.default.getCompanyDisplayName(state);
    return {
        totalUnread: _model5.TicketModel.getTotalUnread(state),
        company: state.get('company'),
        conversations: state.get('conversations'),
        features: state.get('features'),
        color: color,
        name: name
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "XX8A":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SendButton = function (_Component) {
    _inherits(SendButton, _Component);

    function SendButton() {
        _classCallCheck(this, SendButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SendButton.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            active = _props.active;

        if (active) return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M36,15a4.86,4.86,0,0,0-1.48-3L29,6.52A5,5,0,0,0,26,5H8.39A1.34,1.34,0,0,0,7,6.37V36.61A1.34,1.34,0,0,0,8.39,38H18V35H10V8H24v7.86c0,.74.4,1.1,1.14,1.1H33V35h-8V38h9.59A1.34,1.34,0,0,0,36,36.61Zm-3-.94H26.93V8Z" }),
            (0, _preact.h)("path", { fill: color, d: "M25.6,26.35,22.93,23v13.4a1.42,1.42,0,1,1-2.83,0V22.89l-2.76,3.47a1.42,1.42,0,0,1-1.88.16,1.15,1.15,0,0,1-.17-1.71l5.16-6.35a1.59,1.59,0,0,1,1-.44,1.64,1.64,0,0,1,1,.44l5.15,6.35a1.15,1.15,0,0,1-.17,1.71A1.42,1.42,0,0,1,25.6,26.35Z" })
        );else return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M36,15a4.86,4.86,0,0,0-1.48-3L29,6.52a5,5,0,0,0-3-1.5H8.39A1.34,1.34,0,0,0,7,6.37V36.61A1.34,1.34,0,0,0,8.39,38H18V35H10V8H24v7.86c0,.74.4,1.1,1.14,1.1H33V35h-8V38h9.59A1.34,1.34,0,0,0,36,36.61Zm-3-.94H26.93V8Z" }),
            (0, _preact.h)("path", { fill: color, d: "M25.59,29.35,22.92,26v13.4a1.42,1.42,0,1,1-2.83,0V25.89l-2.76,3.47a1.42,1.42,0,0,1-1.88.16,1.15,1.15,0,0,1-.17-1.71l5.16-6.35a1.59,1.59,0,0,1,1-.44,1.64,1.64,0,0,1,1,.44l5.15,6.35a1.15,1.15,0,0,1-.17,1.71A1.42,1.42,0,0,1,25.59,29.35Z" })
        );
    };

    return SendButton;
}(_preact.Component);

exports.default = SendButton;

/***/ }),

/***/ "XbHO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = {
    "<3": "heart",
    ":o)": "monkey_face",
    ":*": "kiss",
    ":-*": "kiss",
    "<\/3": "broken_heart",
    "=)": "smiley",
    "=-)": "smiley",
    "C:": "smile",
    "c:": "smile",
    ":D": "smile",
    ":-D": "smile",
    ":>": "laughing",
    ":->": "laughing",
    ";)": "wink",
    ";-)": "wink",
    "8)": "sunglasses",
    ":|": "neutral_face",
    ":-|": "neutral_face",
    ":\\": "confused",
    ":-\\": "confused",
    ":\/": "confused",
    ":-\/": "confused",
    ":p": "stuck_out_tongue",
    ":-p": "stuck_out_tongue",
    ":P": "stuck_out_tongue",
    ":-P": "stuck_out_tongue",
    ":b": "stuck_out_tongue",
    ":-b": "stuck_out_tongue",
    ";p": "stuck_out_tongue_winking_eye",
    ";-p": "stuck_out_tongue_winking_eye",
    ";b": "stuck_out_tongue_winking_eye",
    ";-b": "stuck_out_tongue_winking_eye",
    ";P": "stuck_out_tongue_winking_eye",
    ";-P": "stuck_out_tongue_winking_eye",
    "):": "disappointed",
    ":(": "disappointed",
    ":-(": "disappointed",
    ">:(": "angry",
    ">:-(": "angry",
    ":'(": "cry",
    "D:": "anguished",
    ":o": "open_mouth",
    ":-o": "open_mouth",
    ":O": "open_mouth",
    ":-O": "open_mouth",
    ":)": "slightly_smiling_face",
    "(:": "slightly_smiling_face",
    ":-)": "slightly_smiling_face"
};

/***/ }),

/***/ "YXF7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// A "once" utility.

module.exports = function (fn) {
  var result,
      called = false;
  return function () {
    if (!called) {
      called = true;
      result = fn.apply(this, arguments);
    }
    return result;
  };
};

/***/ }),

/***/ "ZV3n":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var urllite = __webpack_require__("gR2x"),
    once = __webpack_require__("YXF7");

var warningShown = false;

var supportsXHR = once(function () {
  return typeof window !== 'undefined' && window !== null && window.XMLHttpRequest && 'withCredentials' in new window.XMLHttpRequest();
});

// This plugin creates a Microsoft `XDomainRequest` in supporting browsers when
// the URL being requested is on a different domain. This is necessary to
// support IE9, which only supports CORS via its proprietary `XDomainRequest`
// object. We need to check the URL because `XDomainRequest` *doesn't* work for
// same domain requests (unless your server sends CORS headers).
// `XDomainRequest` also has other limitations (no custom headers), so we try to
// catch those and error.
module.exports = {
  createXHR: function createXHR(req) {
    var a, b, k;

    if (typeof window === 'undefined' || window === null) {
      return;
    }

    a = urllite(req.url);
    b = urllite(window.location.href);

    // Don't do anything for same-domain requests.
    if (!a.host) {
      return;
    }
    if (a.protocol === b.protocol && a.host === b.host && a.port === b.port) {
      return;
    }

    // Show a warning if there are custom headers. We do this even in
    // browsers that won't use XDomainRequest so that users know there's an
    // issue right away, instead of if/when they test in IE9.
    if (!warningShown && req.headers) {
      for (k in req.headers) {
        if (req.headers.hasOwnProperty(k)) {
          warningShown = true;
          if (window && window.console && window.console.warn) {
            window.console.warn('Request headers are ignored in old IE when using the oldiexdomain plugin.');
          }
          break;
        }
      }
    }

    // Don't do anything if we can't do anything (:
    // Don't do anything if the browser supports proper XHR.
    if (window.XDomainRequest && !supportsXHR()) {
      // We've come this far. Might as well make an XDomainRequest.
      var xdr = new window.XDomainRequest();
      xdr.setRequestHeader = function () {}; // Ignore request headers.
      return xdr;
    }
  }
};

/***/ }),

/***/ "Zj7u":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"ButtonContainer":"ButtonContainer__dTVh6"};

/***/ }),

/***/ "bL8x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ChatEmojiIcon = function (_Component) {
    _inherits(ChatEmojiIcon, _Component);

    function ChatEmojiIcon() {
        _classCallCheck(this, ChatEmojiIcon);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ChatEmojiIcon.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            active = _props.active;

        if (active) return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M20.53,30.82a10,10,0,0,1-2.68-.36,10.61,10.61,0,0,1-3.43-1.79,11.74,11.74,0,0,1-2.53-2.91c-.66-1.07-.47-2.69-.11-3s1.7-.73,8.75-.73,8.35.51,8.73.73.54,1.83-.14,2.93a13.6,13.6,0,0,1-2.54,2.94,9.86,9.86,0,0,1-3.37,1.79A10,10,0,0,1,20.53,30.82Z" }),
            (0, _preact.h)("path", { fill: color, d: "M36.59,13.7A17.38,17.38,0,0,0,27.3,4.4,17.11,17.11,0,0,0,20.5,3,17.11,17.11,0,0,0,13.7,4.4,17.38,17.38,0,0,0,4.4,13.7,17.11,17.11,0,0,0,3,20.5,17.11,17.11,0,0,0,4.4,27.3,17.38,17.38,0,0,0,13.7,36.6,17.11,17.11,0,0,0,20.5,38a17.11,17.11,0,0,0,6.8-1.36,17.38,17.38,0,0,0,9.29-9.29A17.11,17.11,0,0,0,38,20.5,17.11,17.11,0,0,0,36.59,13.7ZM33.94,26.14a14.52,14.52,0,0,1-7.76,7.76,14.72,14.72,0,0,1-11.36,0,14.52,14.52,0,0,1-7.76-7.76,14.72,14.72,0,0,1,0-11.36A14.52,14.52,0,0,1,14.82,7,14.72,14.72,0,0,1,26.18,7a14.52,14.52,0,0,1,7.76,7.76,14.72,14.72,0,0,1,0,11.36Z" }),
            (0, _preact.h)("path", { fill: color, d: "M14.2,16a5.42,5.42,0,0,0,.67,2.79A1.94,1.94,0,0,0,16.52,20a1.94,1.94,0,0,0,1.65-1.15A5.42,5.42,0,0,0,18.85,16a5.42,5.42,0,0,0-.67-2.79,1.94,1.94,0,0,0-1.65-1.15,1.94,1.94,0,0,0-1.65,1.15A5.42,5.42,0,0,0,14.2,16Z" }),
            (0, _preact.h)("path", { fill: color, d: "M23.2,16a5.42,5.42,0,0,0,.67,2.79,1.77,1.77,0,0,0,3.31,0A5.42,5.42,0,0,0,27.85,16a5.42,5.42,0,0,0-.67-2.79,1.77,1.77,0,0,0-3.31,0A5.42,5.42,0,0,0,23.2,16Z" })
        );else return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M36.59,13.7A17.38,17.38,0,0,0,27.3,4.4,17.11,17.11,0,0,0,20.5,3,17.11,17.11,0,0,0,13.7,4.4,17.38,17.38,0,0,0,4.4,13.7,17.11,17.11,0,0,0,3,20.5,17.11,17.11,0,0,0,4.4,27.3,17.38,17.38,0,0,0,13.7,36.6,17.11,17.11,0,0,0,20.5,38a17.11,17.11,0,0,0,6.8-1.36,17.38,17.38,0,0,0,9.29-9.29A17.11,17.11,0,0,0,38,20.5,17.11,17.11,0,0,0,36.59,13.7ZM33.94,26.14a14.52,14.52,0,0,1-7.76,7.76,14.72,14.72,0,0,1-11.36,0,14.52,14.52,0,0,1-7.76-7.76,14.72,14.72,0,0,1,0-11.36A14.52,14.52,0,0,1,14.82,7,14.72,14.72,0,0,1,26.18,7a14.52,14.52,0,0,1,7.76,7.76,14.72,14.72,0,0,1,0,11.36Z" }),
            (0, _preact.h)("path", { fill: color, d: "M20.5,30c-4.48,0-8.78-3.74-9.25-4.54a1.61,1.61,0,0,1,.53-2.17,1.72,1.72,0,0,1,2.13.55c.54.59,3.38,3.27,6.59,3.27s6.05-2.73,6.59-3.27a1.78,1.78,0,0,1,2.13-.55,1.61,1.61,0,0,1,.53,2.17C29.28,26.22,25,30,20.5,30Z" }),
            (0, _preact.h)("path", { fill: color, d: "M14.2,16a5.42,5.42,0,0,0,.67,2.79A1.94,1.94,0,0,0,16.52,20a1.94,1.94,0,0,0,1.65-1.15A5.42,5.42,0,0,0,18.85,16a5.42,5.42,0,0,0-.67-2.79,1.94,1.94,0,0,0-1.65-1.15,1.94,1.94,0,0,0-1.65,1.15A5.42,5.42,0,0,0,14.2,16Z" }),
            (0, _preact.h)("path", { fill: color, d: "M23.2,16a5.42,5.42,0,0,0,.67,2.79,1.77,1.77,0,0,0,3.31,0A5.42,5.42,0,0,0,27.85,16a5.42,5.42,0,0,0-.67-2.79,1.77,1.77,0,0,0-3.31,0A5.42,5.42,0,0,0,23.2,16Z" })
        );
    };

    return ChatEmojiIcon;
}(_preact.Component);

exports.default = ChatEmojiIcon;

/***/ }),

/***/ "c2sW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("A+Mm");

var _style2 = _interopRequireDefault(_style);

var _Input = __webpack_require__("p/6D");

var _Input2 = _interopRequireDefault(_Input);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("lmuV");

var _model6 = __webpack_require__("RmM5");

var _model7 = _interopRequireDefault(_model6);

var _User = __webpack_require__("HJJ4");

var _User2 = _interopRequireDefault(_User);

var _Save = __webpack_require__("Dti/");

var _Save2 = _interopRequireDefault(_Save);

var _Cancel = __webpack_require__("cWLq");

var _Cancel2 = _interopRequireDefault(_Cancel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var _ref = (0, _preact.h)(_User2.default, { color: 'black', size: '20' });

var _ref2 = (0, _preact.h)(_Save2.default, { color: 'black', size: '16' });

var SettingsBody = function (_Component) {
    _inherits(SettingsBody, _Component);

    function SettingsBody(props) {
        _classCallCheck(this, SettingsBody);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            email: props.user.email,
            name: props.user.name,
            phone: props.user.phone
        };
        _this.renderForm = _this.renderForm.bind(_this);
        _this.handleSave = _this.handleSave.bind(_this);
        return _this;
    }

    SettingsBody.prototype.handleSave = function handleSave() {
        this.props.dispatch(_model7.default.update({
            'email': this.state.email,
            'name': this.state.name,
            'phone': this.state.phone
        }));
    };

    SettingsBody.prototype.renderForm = function renderForm(form) {
        var _this2 = this;

        var obj = this.state[form];
        return (0, _preact.h)(
            'div',
            { style: { position: 'relative', width: '70%', margin: 'auto', marginBottom: '10px' } },
            (0, _preact.h)(_Input2.default, { label: form, value: obj,
                onChange: function onChange(newValue) {
                    var _this2$setState;

                    _this2.setState((_this2$setState = {}, _this2$setState[form] = newValue, _this2$setState));
                }
            })
        );
    };

    SettingsBody.prototype.render = function render() {
        var language = this.props.language;
        /*
        <div className={style.Button} onClick={()=>{
        this.setState({'email': '', 'name': '', 'phone': ''})
        }}>
        <CancelImage color='black' size='16'/>
        <span style={{marginLeft: '10px'}}>
        Rensa alla fält
        </span>
        </div>
        */
        return (0, _preact.h)(
            'div',
            {
                className: _style2.default.Body
            },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Component,
                    style: {
                        fontSize: '20px',
                        fontWeight: '300'
                    }

                },
                _ref,
                (0, _preact.h)(
                    'span',
                    { style: { marginLeft: '10px' } },
                    language.get('UserInfo')
                )
            ),
            (0, _preact.h)(
                'form',
                null,
                this.renderForm('email', language.get('Email')),
                this.renderForm('name', language.get('Name')),
                this.renderForm('phone', language.get('Phone'))
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.Button + ' ' + _style2.default.Rounded, onClick: this.handleSave },
                _ref2,
                (0, _preact.h)(
                    'span',
                    { style: { marginLeft: '10px' } },
                    language.get('Save')
                )
            )
        );
    };

    return SettingsBody;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    var conversations = _model5.TicketModel.getAll(state);
    return {
        language: language,
        user: _model7.default.get(state).toJS()
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(SettingsBody);

/***/ }),

/***/ "c3iG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FeedbackSmiley":"FeedbackSmiley__2ztR9","FeedbackContainer":"FeedbackContainer__3KFFv","FeedbackPromptText":"FeedbackPromptText__1BYn7","FeedbackButtons":"FeedbackButtons__e-FuS","FeedbackTextInputContainer":"FeedbackTextInputContainer__1wmrg","FeedbackTextInputHelp":"FeedbackTextInputHelp__EKsTg","TextArea":"TextArea__I9J3H","SendButtonWrapper":"SendButtonWrapper__fZQ_w","FeedbackThanks":"FeedbackThanks__3LJL9","FeedbackThanksStart":"FeedbackThanksStart__2gqQH","FeedbackThanksEnd":"FeedbackThanksEnd__1SVqP","FeedbackIcon":"FeedbackIcon__182cb","IconWrapper":"IconWrapper__3r4kX","ThanksIconWrapper":"ThanksIconWrapper__1oLyc"};

/***/ }),

/***/ "c6ek":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return new RegExp("(" + edgeCases + ")?(" + names + ")((?!(" + edgeCases + "))[a-z0-9_\\-\\+]+:)?", "g");
};

var _asciiAliases = __webpack_require__("Fkom");

var _asciiAliases2 = _interopRequireDefault(_asciiAliases);

var _lodash = __webpack_require__("vqYw");

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function quoteRE(str) {
  return str.replace(/[.?*+^$[\]\\(){}|-]/g, "\\$&");
}

var names = (0, _lodash2.default)(Object.keys(_asciiAliases2.default).map(function (name) {
  return _asciiAliases2.default[name].map(function (alias) {
    return quoteRE(alias);
  });
})).join("|");

var edgeCases = ["http", "https"].join("|");

// Regex reads as following:
//
// Match ascii aliases with optional edge cases before it (to know if parsing is needed)
// Additionally, after the ascii alias:
//    - Forbid edge cases
//    - Allow characters included in normal aliases (to check later cases like :s and :smile:)

/***/ }),

/***/ "cC0N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Response = __webpack_require__("63ec");
var extractResponseProps = __webpack_require__("Oqyg");
var extend = __webpack_require__("TRnG");

function RequestError(message, props) {
  var err = new Error(message);
  err.name = 'RequestError';
  this.name = err.name;
  this.message = err.message;
  if (err.stack) {
    this.stack = err.stack;
  }

  this.toString = function () {
    return this.message;
  };

  for (var k in props) {
    if (props.hasOwnProperty(k)) {
      this[k] = props[k];
    }
  }
}

RequestError.prototype = extend(Error.prototype);
RequestError.prototype.constructor = RequestError;

RequestError.create = function (message, req, props) {
  var err = new RequestError(message, props);
  Response.call(err, extractResponseProps(req));
  return err;
};

module.exports = RequestError;

/***/ }),

/***/ "cWLq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cancel = function (_Component) {
    _inherits(Cancel, _Component);

    function Cancel() {
        _classCallCheck(this, Cancel);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Cancel.prototype.render = function render() {
        var color = this.props.color;

        return (0, _preact.h)(
            "svg",
            { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42", height: "20px" },
            (0, _preact.h)("path", { fill: color, d: "M23.83,21,37.16,7.69a2,2,0,0,0-2.84-2.84L21,18.19,7.66,4.85A2,2,0,1,0,4.82,7.69L18.15,21,4.82,34.36a2,2,0,0,0,2.84,2.84L21,23.86,34.32,37.19a2,2,0,0,0,2.84-2.84Z" })
        );
    };

    return Cancel;
}(_preact.Component);

exports.default = Cancel;

/***/ }),

/***/ "cbmj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("6Xo/");

var _style2 = _interopRequireDefault(_style);

var _preactRedux = __webpack_require__("1AcT");

var _model = __webpack_require__("lmuV");

var _model2 = __webpack_require__("2YDt");

var _model3 = _interopRequireDefault(_model2);

var _reactInlinesvg = __webpack_require__("Bl3B");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var StarRating = function (_Component) {
    _inherits(StarRating, _Component);

    function StarRating(props) {
        _classCallCheck(this, StarRating);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.handleMouseOver = function (value) {
            _this.setState({ hoveredValue: value });
        };

        _this.handleClick = function (value) {
            // Set the rating using the backend api
            _this.props.updateRatingHandle(value);
            // TODO: Fix so that the rating is only set if the backend api returns a success
            // .then(success => {
            //   console.log("Is it ok", success.ok);
            //   if (success.ok) {
            //     this.setState({ selectedValue: value });
            //   }
            // })
            // .catch(error => {
            //   console.error("Error in updating rating", error);
            // });
            _this.setState({ selectedValue: value });
        };

        _this.handleMouseLeave = function () {
            _this.setState({ hoveredValue: -1 });
        };

        _this.constructStars = function () {
            var _this$state = _this.state,
                selectedValue = _this$state.selectedValue,
                hoveredValue = _this$state.hoveredValue;

            var stars = [];

            var _loop = function _loop(i) {
                var isFilled = hoveredValue <= selectedValue ? i <= selectedValue : i <= hoveredValue;
                stars.push((0, _preact.h)(
                    'svg',
                    {
                        id: 'a',
                        xmlns: 'http://www.w3.org/2000/svg',
                        viewBox: '-10 -10 60 60',
                        width: '40', height: '40',
                        'data-value': i,
                        alt: 'star',
                        onMouseOver: function onMouseOver() {
                            return _this.handleMouseOver(i);
                        },
                        onClick: function onClick() {
                            return _this.handleClick(i);
                        },
                        onMouseLeave: function onMouseLeave() {
                            return _this.handleMouseLeave();
                        } },
                    (0, _preact.h)('path', { 'class': _style2.default.star, 'stroke-linecap': 'round', stroke: _this.props.color, fill: isFilled ? _this.props.color : "none", 'stroke-linejoin': 'round', 'stroke-width': '3px', d: 'M37.94,17.79c.39-.34,.29-.67-.23-.72l-10.71-1.02c-.52-.05-1.11-.48-1.32-.96l-4.28-9.87c-.21-.48-.55-.48-.75,0l-4.28,9.87c-.21,.48-.8,.91-1.32,.96l-10.71,1.02c-.52,.05-.62,.37-.23,.72l8.07,7.12c.39,.34,.62,1.04,.5,1.55l-2.34,10.5c-.11,.51,.16,.71,.61,.44l9.27-5.47c.45-.26,1.18-.26,1.63,0l9.27,5.47c.45,.26,.72,.07,.61-.44l-2.34-10.5c-.11-.51,.11-1.21,.5-1.55l8.07-7.12Z' }),
                    'data-value=',
                    i
                ));
            };

            for (var i = 1; i <= 5; i++) {
                _loop(i);
            }
            return stars;
        };

        _this.state = {
            selectedValue: -1, //Default to -1 until the backend api returns the rating
            hoveredValue: -1,
            rating: -1
        };
        return _this;
    }

    StarRating.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        this.props.updateRatingHandle = _model.TicketModel.updateRating(this.props.room);
        this.props.getRatingHandle = function () {
            return _model.TicketModel.getRating(_this2.props.room);
        };
        this.props.getRatingHandle().then(function (rating) {
            _this2.setState({ selectedValue: rating });
        }).catch(function (error) {
            console.error("Error in fetching rating", error); // This will log any error that occurred during the fetch
        });
    };

    StarRating.prototype.render = function render() {
        var _state = this.state,
            selectedValue = _state.selectedValue,
            hoveredValue = _state.hoveredValue;

        this.stars = this.constructStars();

        return (0, _preact.h)(
            'div',
            { className: _style2.default.ratingContainer },
            (0, _preact.h)(
                'div',
                null,
                (0, _preact.h)(
                    'p',
                    { className: _style2.default.ratingTitle },
                    selectedValue > 0 ? this.props.language.get("ThankForFeedback") : this.props.language.get("RatingPrompt")
                )
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.rating },
                this.stars
            )
        );
    };

    return StarRating;
}(_preact.Component);

function mapStateToProps(state) {
    var language = _model3.default.getLanguage(state);
    var color = _model3.default.getColor(state);
    var room = _model.TicketModel.getCurrentRoom(state);
    return {
        room: room, language: language, color: color
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(StarRating);

/***/ }),

/***/ "cgTv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("ApQG");

var _style2 = _interopRequireDefault(_style);

var _ArrowLeft = __webpack_require__("0DRr");

var _ArrowLeft2 = _interopRequireDefault(_ArrowLeft);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_ArrowLeft2.default, { color: 'white' });

var BackButton = function (_Component) {
    _inherits(BackButton, _Component);

    function BackButton() {
        _classCallCheck(this, BackButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    BackButton.prototype.render = function render() {
        var _this2 = this;

        var callback = this.props.callback;

        var defaultStyle = _style2.default.NormalBackButton;
        if (this.props.isMobile) defaultStyle = _style2.default.MobileBackButton;

        return (0, _preact.h)(
            'div',
            { className: defaultStyle, onClick: function onClick() {
                    if (_this2.props.callback) {
                        _this2.props.callback();
                    } else {
                        _this2.props.dispatch(_model2.default.goBack());
                    }
                } },
            _ref
        );
    };

    return BackButton;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        isMobile: _model2.default.isMobile(state)
    };
})(BackButton);

/***/ }),

/***/ "crWv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function invariant(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;

/***/ }),

/***/ "cuVP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"FooterButton":"FooterButton__1YgXr","FooterContainer":"FooterContainer__3XMjb"};

/***/ }),

/***/ "cxPT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),

/***/ "d+Cn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*https://icons8.com/cssload/en/horizontal-bars*/
var _ref = (0, _preact.h)(
    "title",
    null,
    "ClientChat_ProfilePic_DynamicColour"
);

var DefaultProfileImage = function (_Component) {
    _inherits(DefaultProfileImage, _Component);

    function DefaultProfileImage() {
        _classCallCheck(this, DefaultProfileImage);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    DefaultProfileImage.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            {
                id: "Layer_1", "data-name": "Layer 1",
                xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 64 64" },
            _ref,
            (0, _preact.h)("path", {
                style: { fill: this.props.color },

                d: "M17.49,20.58l-1.59.14a1.69,1.69,0,0,0-1.53,1.83l.76,8.65A1.69,1.69,0,0,0,17,32.73l2.17-.19a1.68,1.68,0,0,0,1.42-1.1,12.22,12.22,0,0,0,2.7,4A11.94,11.94,0,0,0,32,39l-6.82,6.15,4.7,18.72c.71,0,1.43.08,2.15.08s1.44,0,2.16-.08l4.71-18.72L32.05,39a11.94,11.94,0,0,0,8.74-3.61,12.21,12.21,0,0,0,2.68-3.94,1.69,1.69,0,0,0,1.45,1.15H45c-.38,1.63-1.88,3.81-2.95,5.43a1.33,1.33,0,0,0-1,.49l-1.65,1.86a1.49,1.49,0,0,0,0,2.2c.66.43,1.54.87,2.1.21L43.13,41a1.93,1.93,0,0,0,.35-1.67c1.36-2,3-4.58,3.43-6.52l.19,0a1.69,1.69,0,0,0,1.83-1.53l.76-8.65a1.69,1.69,0,0,0-1.53-1.83l-1.61-.14C44.76,9,35,8,31.74,8,27.78,8,19.11,9.37,17.49,20.58ZM44,23.45a12.36,12.36,0,0,0-12-9.18,12.36,12.36,0,0,0-12,9.2c.38-11,7.44-12.66,11.7-12.66C36.2,10.81,43.56,12.51,44,23.45Z" }),
            (0, _preact.h)("path", {
                style: { fill: this.props.color },
                d: "M7.53,52A31,31,0,0,0,28.88,63.83L17.77,41a10.61,10.61,0,0,0-3.26,1.4A13.32,13.32,0,0,0,10.46,46a17.85,17.85,0,0,0-2.74,5.32C7.64,51.54,7.59,51.77,7.53,52Z" }),
            (0, _preact.h)("path", {
                style: { fill: this.props.color },
                d: "M56.72,51.32A17.86,17.86,0,0,0,54,46a13.33,13.33,0,0,0-4.06-3.59A10.33,11.33,0,0,0,46.3,41L35.15,63.83A31,31,0,0,0,56.8,51.6C56.77,51.51,56.75,51.42,56.72,51.32Z" })
        );
    };

    return DefaultProfileImage;
}(_preact.Component);

exports.default = DefaultProfileImage;

/***/ }),

/***/ "d04+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("c3iG");

var _style2 = _interopRequireDefault(_style);

var _Button = __webpack_require__("Kylw");

var _Button2 = _interopRequireDefault(_Button);

var _Buttons = __webpack_require__("Jw2m");

var _SendButton = __webpack_require__("Ue4h");

var _SendButton2 = _interopRequireDefault(_SendButton);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("BXPw");

var _model4 = _interopRequireDefault(_model3);

var _Feedback = __webpack_require__("Wioz");

var _Feedback2 = _interopRequireDefault(_Feedback);

var _reactInlinesvg = __webpack_require__("Bl3B");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_SendButton2.default, { color: "white" });

var Feedback = function (_Component) {
  _inherits(Feedback, _Component);

  function Feedback(props) {
    _classCallCheck(this, Feedback);

    //hover: None == 0, Yes == 1, No == -1.
    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _this._setRef = _this._setRef.bind(_this);
    _this.onClickSend = _this.onClickSend.bind(_this);
    _this._handleRequest = _this._handleRequest.bind(_this);
    _this._onChange = _this._onChange.bind(_this);
    _this.state = {
      hover: 0,
      selected: 0,
      conisent: false,
      input: "",
      isVotable: ""
    };
    return _this;
  }

  Feedback.prototype._renderSmiley = function _renderSmiley() {
    var _state = this.state,
        hover = _state.hover,
        selected = _state.selected;

    if (selected === 1) return (0, _preact.h)(_reactInlinesvg2.default, {
      className: _style2.default.FeedbackIcon,
      src: "/common/assets/images/FeedbackHappy.svg",
      style: { fill: "#86d677" }
    });
    if (hover === -1 || selected === -1) return (0, _preact.h)(_reactInlinesvg2.default, {
      className: _style2.default.FeedbackIcon,
      src: "/common/assets/images/FeedbackNegative.svg",
      style: { fill: "#ff6d67" }
    });
    if (hover === 1) return (0, _preact.h)(_reactInlinesvg2.default, {
      className: _style2.default.FeedbackIcon,
      src: "/common/assets/images/FeedbackPositive.svg",
      style: { fill: "#86d677" }
    });

    if (hover === 0 || selected === 0) return (0, _preact.h)(_reactInlinesvg2.default, {
      className: _style2.default.FeedbackIcon,
      src: "/common/assets/images/FeedbackNeutral.svg",
      style: { fill: "#bababa" }
    });
  };

  Feedback.prototype._handleRequest = function _handleRequest(payload) {};

  Feedback.prototype._setRef = function _setRef(node) {
    this.feedbackInput = node;
  };

  Feedback.prototype.componentDidMount = function componentDidMount() {
    this.setState({
      isVotable: _Feedback2.default.isVoteable(this.props.articleId, this.props.dateModified)
    });
  };

  Feedback.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var selected = this.state.selected;

    if (prevState.selected !== -1 && selected === -1) {
      this.feedbackInput.scrollIntoView();
    }

    if (this.props !== prevProps) {
      this.setState({
        isVotable: _Feedback2.default.isVoteable(this.props.articleId, this.props.dateModified)
      });
    }
  };

  Feedback.prototype._renderInput = function _renderInput() {
    var _state2 = this.state,
        selected = _state2.selected,
        input = _state2.input;

    if (selected === -1) {
      var imgCmp = _ref;
      return (0, _preact.h)(
        "div",
        null,
        (0, _preact.h)(
          "div",
          { className: _style2.default.FeedbackTextInputContainer, ref: this._setRef },
          (0, _preact.h)(
            "div",
            { className: _style2.default.FeedbackTextInputHelp },
            "Hj\xE4lp oss att bli b\xE4ttre med din feedback."
          ),
          (0, _preact.h)(
            "textarea",
            {
              rows: "9",
              value: input,
              onChange: this._onChange,
              className: _style2.default.TextArea
            },
            " "
          )
        ),
        (0, _preact.h)(
          "div",
          { className: _style2.default.SendButtonWrapper },
          (0, _preact.h)(_Buttons.Button, { onClick: this.onClickSend, text: "Skicka", imgCmp: imgCmp })
        )
      );
    }
    return null;
  };

  Feedback.prototype._onChange = function _onChange(e) {
    this.setState({ input: e.target.value });
  };

  Feedback.prototype.onClickYesNo = function onClickYesNo(selected) {
    var _props = this.props,
        articleId = _props.articleId,
        dateModified = _props.dateModified;


    this.setState({ selected: selected });

    if (selected === 1) {
      _Feedback2.default.addToVoted(articleId, dateModified, selected);
      _model4.default.sendFeedback("helpdesk", articleId, this.state.input, this.state.selected, this._handleRequest);
    }

    if (selected === 1) {
      this.setState({ isVotable: false });
    }
  };

  Feedback.prototype.onClickSend = function onClickSend() {
    var _props2 = this.props,
        articleId = _props2.articleId,
        dateModified = _props2.dateModified;
    var _state3 = this.state,
        input = _state3.input,
        selected = _state3.selected;


    _model4.default.sendFeedback("helpdesk", articleId, input, selected, this._handleRequest);
    _Feedback2.default.addToVoted(articleId, dateModified, selected);

    this.setState({ isVotable: false });
  };

  Feedback.prototype.render = function render() {
    var _this2 = this;

    var _state4 = this.state,
        selected = _state4.selected,
        isVotable = _state4.isVotable;


    if (isVotable) {
      return (0, _preact.h)(
        "div",
        { className: _style2.default.FeedbackContainer },
        (0, _preact.h)(
          "div",
          { className: _style2.default.FeedbackSmiley },
          (0, _preact.h)(
            "div",
            { className: _style2.default.FeedbackPromptText },
            this.props.language.get("WasThisArticleHelpful")
          ),
          (0, _preact.h)(
            "div",
            { className: _style2.default.FeedbackButtons },
            (0, _preact.h)(_Button2.default, {
              text: this.props.language.get("Yes"),
              color: "#86d677",
              active: selected === 1,
              mouseEnter: function mouseEnter() {
                return _this2.setState({ hover: 1 });
              },
              mouseLeave: function mouseLeave() {
                return _this2.setState({ hover: 0 });
              },
              onClick: function onClick() {
                return _this2.onClickYesNo(1);
              }
            }),
            (0, _preact.h)(
              "div",
              { className: _style2.default.IconWrapper },
              this._renderSmiley()
            ),
            (0, _preact.h)(_Button2.default, {
              text: this.props.language.get("No"),
              color: "#ff6d67",
              active: selected === -1,
              mouseEnter: function mouseEnter() {
                return _this2.setState({ hover: -1 });
              },
              mouseLeave: function mouseLeave() {
                return _this2.setState({ hover: 0 });
              },
              onClick: function onClick() {
                return _this2.onClickYesNo(-1);
              }
            })
          )
        ),
        this._renderInput()
      );
    } else {
      return (0, _preact.h)(
        "div",
        { className: _style2.default.FeedbackThanks },
        this.props.language.get("ThankForFeedback"),
        (0, _preact.h)(
          "div",
          { className: _style2.default.ThanksIconWrapper },
          (0, _preact.h)(_reactInlinesvg2.default, {
            className: _style2.default.FeedbackIcon,
            src: "/common/assets/images/FeedbackPositive.svg",
            style: { fill: "#86d677" }
          })
        )
      );
    }
  };

  return Feedback;
}(_preact.Component);

function mapStateToProps(state) {
  return {
    language: _model2.default.getLanguage(state)
  };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Feedback);

/***/ }),

/***/ "dgY3":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"PoweredByJibber":"PoweredByJibber__2q6iI"};

/***/ }),

/***/ "e6+Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),

/***/ "eTtw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preact2 = _interopRequireDefault(_preact);

var _preactRedux = __webpack_require__("1AcT");

var _DateTime = __webpack_require__("uRCp");

var _DateTime2 = _interopRequireDefault(_DateTime);

var _DefaultProfileImage = __webpack_require__("d+Cn");

var _DefaultProfileImage2 = _interopRequireDefault(_DefaultProfileImage);

var _style = __webpack_require__("gknL");

var _style2 = _interopRequireDefault(_style);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Message = function (_Component) {
    _inherits(Message, _Component);

    function Message() {
        _classCallCheck(this, Message);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Message.prototype.render = function render() {
        var index = this.props.entryIndex;
        if (this.shouldDisplaySupportInfo()) return this.renderMessageWithSupportInfo();
        return this.renderMessage();
    };

    Message.prototype.hasPreviousMessage = function hasPreviousMessage() {
        var current = this.props.entry;
        var previous = this.props.previousEntry;

        if (this.props.index == 0) return false;
        if (!previous) return false;
        if (!previous.size) return false;
        if (previous.get('meta')) return false;
        if (this.shouldRenderTime(previous)) return false;
        if (current.get('creator_id') !== previous.get('creator_id')) return false;

        return true;
    };

    Message.prototype.hasNextMessage = function hasNextMessage() {
        var current = this.props.entry;
        var next = this.props.nextEntry;
        if (!next) return false;
        if (!next.size) return false;
        if (next.get('meta')) return false;
        if (this.shouldRenderTime(next)) return false;
        if (current.get('creator_id') !== next.get('creator_id')) return false;

        return true;
    };

    Message.prototype.shouldDisplaySupportInfo = function shouldDisplaySupportInfo() {
        var index = this.props.entryIndex;
        if (this.isSupportEntryCreator()) {
            if (!this.hasPreviousMessage(index)) {
                return true;
            }
        }
        return false;
    };

    Message.prototype.renderMessage = function renderMessage() {
        var entry = this.props.entry;
        var entryBody = entry.get('entry_body') || '';

        var direction = this.getMessageDirection();
        var customStyle = {};

        if (direction === 'customer') customStyle.backgroundColor = this.props.color;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.MessageWrapper },
            this.renderTime(),
            (0, _preact.h)(
                'div',
                {
                    'class': 'message message--' + direction + ' message--single'
                },
                (0, _preact.h)(
                    'div',
                    { 'class': 'message__body', style: customStyle },
                    (0, _preact.h)(_TextDisplay2.default, { text: entryBody })
                )
            )
        );
    };

    Message.prototype.renderMessageWithSupportInfo = function renderMessageWithSupportInfo() {
        return (0, _preact.h)(
            'div',
            null,
            this.renderSupportInfo(),
            this.renderMessage()
        );
    };

    Message.prototype.renderSupportInfo = function renderSupportInfo() {
        var entry = this.props.entry;

        if (this.doesConversationExist()) {
            var supportParticipant = this.getSupportParticipant(entry.get('creator_id'));
            if (supportParticipant) {
                var name = supportParticipant.get('display_name');
                if (!name) name = supportParticipant.get('name');
                var profileImageUrl = supportParticipant.get('image_url');
                var imageElement = null;

                if (profileImageUrl) {
                    imageElement = (0, _preact.h)('img', { src: profileImageUrl, 'class': 'message-support-info__profile-image' });
                } else {
                    imageElement = (0, _preact.h)(
                        'div',
                        { className: 'message-support-info__profile-image' },
                        (0, _preact.h)(_DefaultProfileImage2.default, { color: this.props.color })
                    );
                }
                return (0, _preact.h)(
                    'div',
                    { 'class': 'message-support-info' },
                    imageElement,
                    (0, _preact.h)(
                        'span',
                        { 'class': 'message-support-info__name' },
                        name
                    )
                );
            } else {
                return null;
            }
        } else {
            return null;
        }
    };

    Message.prototype.getSupportParticipant = function getSupportParticipant(id) {
        return this.props.employees.get(id.toString());
    };

    Message.prototype.renderTime = function renderTime() {
        var index = this.props.entryIndex;
        if (index !== 0) return null;
        var dateString = this.props.conversationEntries.getIn([this.props.entryIndex, 'date_created']);
        if (!dateString) return null;
        var dateTime = _DateTime2.default.getDetailedNiceDate(dateString);
        return (0, _preact.h)(
            'div',
            { 'class': _style2.default.TimeMessage },
            (0, _preact.h)(
                'div',
                { 'class': _style2.default.TimeBody },
                ' ',
                dateTime,
                ' '
            )
        );
    };

    Message.prototype.shouldRenderTime = function shouldRenderTime(diffEntry) {
        var currentDate = this.props.entry.get('date_created');
        var diffDate = diffEntry.get('date_created');
        if (_DateTime2.default.getDiffMinutes(currentDate, diffDate) > 30) return true;
        return false;
    };

    Message.prototype.getMessageDirection = function getMessageDirection() {
        if (this.isVisitorEntryCreator()) return 'customer';
        return 'support';
    };

    Message.prototype.doesConversationExist = function doesConversationExist() {
        return this.props.conversation !== null;
    };

    Message.prototype.isSupportEntryCreator = function isSupportEntryCreator() {
        return !this.isVisitorEntryCreator();
    };

    Message.prototype.isVisitorEntryCreator = function isVisitorEntryCreator() {
        var visitorId = this.props.visitor.get('id');
        var entry = this.props.entry;
        return visitorId === entry.get('creator_id');
    };

    Message.prototype.isFirstMessage = function isFirstMessage() {
        var entryIndex = this.props.entryIndex;
        return entryIndex === 0;
    };

    Message.prototype.getLastMessageIndex = function getLastMessageIndex() {
        var conversationEntries = this.props.conversationEntries;
        return conversationEntries.size - 1;
    };

    return Message;
}(_preact.Component);

exports.default = Message;

/***/ }),

/***/ "ej/C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Button = __webpack_require__("CvAI");

var _Button2 = _interopRequireDefault(_Button);

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _style = __webpack_require__("3MPn");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Button2.default, null);

var _ref2 = (0, _preact.h)(_PoweredByJibber2.default, null);

var StartChattingBody = function (_Component) {
    _inherits(StartChattingBody, _Component);

    function StartChattingBody() {
        _classCallCheck(this, StartChattingBody);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    StartChattingBody.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Body },
            _ref,
            _ref2
        );
    };

    return StartChattingBody;
}(_preact.Component);

exports.default = StartChattingBody;

/***/ }),

/***/ "f10v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.toArray = toArray;
exports.default = Emoji;

var _react = __webpack_require__("AX2D");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__("HW6M");

var _classnames3 = _interopRequireDefault(_classnames2);

var _stringReplaceToArray = __webpack_require__("goy3");

var _stringReplaceToArray2 = _interopRequireDefault(_stringReplaceToArray);

var _emojiRegex = __webpack_require__("RdLw");

var _emojiRegex2 = _interopRequireDefault(_emojiRegex);

var _asciiRegex = __webpack_require__("c6ek");

var _asciiRegex2 = _interopRequireDefault(_asciiRegex);

var _normalizeProtocol = __webpack_require__("SNSg");

var _normalizeProtocol2 = _interopRequireDefault(_normalizeProtocol);

var _unicodeToCodepoint = __webpack_require__("rnVk");

var _unicodeToCodepoint2 = _interopRequireDefault(_unicodeToCodepoint);

var _aliases = __webpack_require__("037A");

var _aliases2 = _interopRequireDefault(_aliases);

var _asciiAliases = __webpack_require__("Fkom");

var _asciiAliases2 = _interopRequireDefault(_asciiAliases);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }return obj;
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

var asciiAliasesRegex = (0, _asciiRegex2.default)();
var unicodeEmojiRegex = (0, _emojiRegex2.default)();
var aliasesRegex = /:([\w\-\_\+]+):/g;

// using em's we can ensure size matches surrounding font
var style = {
  width: "1em",
  height: "1em",
  margin: "0 .05em 0 .1em",
  verticalAlign: "-0.1em"
};

function toArray(text) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var protocol = (0, _normalizeProtocol2.default)(options.protocol);

  function replaceUnicodeEmoji(match, i) {
    if (!options.baseUrl) {
      return _react2.default.createElement("span", { key: i, style: style, className: options.className }, match);
    }

    var separator = options.size ? "/" : "";
    var codepoint = (0, _unicodeToCodepoint2.default)(match);
    var src = "" + protocol + options.baseUrl + options.size + separator + codepoint + "." + options.ext;

    return _react2.default.createElement("img", _extends({
      key: i,
      alt: match,
      src: src,
      style: style,
      className: options.className
    }, options.props));
  }

  function replaceAsciiAliases() {
    var asciiAliasKeys = Object.keys(_asciiAliases2.default);

    for (var _len = arguments.length, match = Array(_len), _key = 0; _key < _len; _key++) {
      match[_key] = arguments[_key];
    }

    for (var i in asciiAliasKeys) {
      var alias = asciiAliasKeys[i];
      var data = _asciiAliases2.default[alias];
      var aliasFound = match[2];

      if (data.includes(aliasFound)) {
        var isEdgeCase = match[1];
        var fullMatchContent = match[0].slice(1, -1); // remove ":" at the beginning and end
        var validAsciiAlias = !_aliases2.default[fullMatchContent]; // ":" + fullMatchContent + ":" alias doesn't exist

        if (!isEdgeCase && validAsciiAlias) {
          return ":" + alias + ":";
        }

        // return the original word to replace its value in aliasesRegex
        return match[0];
      }
    }
  }

  function replaceAliases() {
    for (var _len2 = arguments.length, match = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      match[_key2] = arguments[_key2];
    }

    return _aliases2.default[match[1]] || match[0];
  }

  return (0, _stringReplaceToArray2.default)(text.replace(asciiAliasesRegex, replaceAsciiAliases).replace(aliasesRegex, replaceAliases), unicodeEmojiRegex, replaceUnicodeEmoji);
}

function Emoji(_ref) {
  var text = _ref.text,
      onlyEmojiClassName = _ref.onlyEmojiClassName,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options,
      className = _ref.className,
      rest = _objectWithoutProperties(_ref, ["text", "onlyEmojiClassName", "options", "className"]);

  function isOnlyEmoji(output) {
    if (output.length > 3) return false;

    for (var i = 0; i < output.length; i++) {
      if (typeof output[i] === "string") return false;
    }

    return true;
  }

  var output = toArray(text, options);
  var classes = (0, _classnames3.default)(className, _defineProperty({}, onlyEmojiClassName, isOnlyEmoji(output)));

  return _react2.default.createElement("span", _extends({}, rest, { className: classes }), output);
}

Emoji.propTypes = {
  text: _propTypes2.default.string,
  props: _propTypes2.default.object,
  onlyEmojiClassName: _propTypes2.default.string,
  options: _propTypes2.default.shape({
    baseUrl: _propTypes2.default.string,
    size: _propTypes2.default.string,
    ext: _propTypes2.default.string,
    className: _propTypes2.default.string
  })
};

/***/ }),

/***/ "fCv+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("BjJe");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HeaderArrow = function (_Component) {
    _inherits(HeaderArrow, _Component);

    function HeaderArrow() {
        _classCallCheck(this, HeaderArrow);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    HeaderArrow.prototype.render = function render() {
        var direction = this.props.direction;
        var callback = this.props.callback;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Arrow, onClick: callback },
            (0, _preact.h)('i', { className: _style2.default[direction] })
        );
    };

    return HeaderArrow;
}(_preact.Component);

exports.default = HeaderArrow;

/***/ }),

/***/ "fnIt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _style = __webpack_require__("qIew");

var _style2 = _interopRequireDefault(_style);

var _Input = __webpack_require__("p/6D");

var _Input2 = _interopRequireDefault(_Input);

var _SelectInput = __webpack_require__("BZkz");

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _History = __webpack_require__("QQKR");

var _History2 = _interopRequireDefault(_History);

var _Textarea = __webpack_require__("V7//");

var _Textarea2 = _interopRequireDefault(_Textarea);

var _model = __webpack_require__("lmuV");

var _lib = __webpack_require__("vdh7");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _Body = __webpack_require__("n7b9");

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Body2.default, null);

var _ref2 = (0, _preact.h)(_PoweredByJibber2.default, null);

var OnlineFormular = function (_Component) {
    _inherits(OnlineFormular, _Component);

    OnlineFormular.prototype.constructStateFromProps = function constructStateFromProps(props) {
        return {
            select: [],
            selectValidate: true,
            forms: {
                email: {
                    value: props.user.email,
                    require: props.formsConfig.email.require,
                    visible: props.formsConfig.email.visible,
                    alias: props.formsConfig.email.alias,
                    missing: false,
                    isValidate: true,
                    validate: _lib.Validation.validateEmail
                },
                name: {
                    value: props.user.name,
                    require: props.formsConfig.name.require,
                    visible: props.formsConfig.name.visible,
                    alias: props.formsConfig.name.alias,
                    missing: false,
                    isValidate: true,
                    validate: _lib.Validation.validateDummy
                },
                phone: {
                    value: props.user.phone,
                    require: props.formsConfig.phone.require,
                    visible: props.formsConfig.phone.visible,
                    alias: props.formsConfig.phone.alias,
                    missing: false,
                    isValidate: true,
                    validate: _lib.Validation.validateDummy
                },
                customerRef: {
                    value: props.user.customer_ref,
                    require: props.formsConfig.customer_ref.require,
                    visible: props.formsConfig.customer_ref.visible,
                    alias: props.formsConfig.customer_ref.alias,
                    missing: false,
                    isValidate: true,
                    validate: _lib.Validation.validateDummy
                },
                message: {
                    require: true,
                    visible: false,
                    value: '',
                    missing: false,
                    isValidate: true,
                    validate: _lib.Validation.validateDummy
                }
            }
        };
    };

    function OnlineFormular(props) {
        _classCallCheck(this, OnlineFormular);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = _this.constructStateFromProps(props);
        _this.handleNewConversationClick = _this.handleNewConversationClick.bind(_this);
        _this.renderForm = _this.renderForm.bind(_this);
        _this.renderExchange = _this.renderExchange.bind(_this);
        return _this;
    }

    OnlineFormular.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextState) {
        this.setState(this.constructStateFromProps(nextProps));
    };

    OnlineFormular.prototype.handleNewConversationClick = function handleNewConversationClick() {
        var missing = false;
        var isValidate = true;
        var newState = _extends({}, this.state);
        var _state = this.state,
            forms = _state.forms,
            select = _state.select;
        var _props = this.props,
            formsConfig = _props.formsConfig,
            exchangeAvailable = _props.exchangeAvailable,
            exchangePayload = _props.exchangePayload;

        for (var form in forms) {
            var _forms$form = forms[form],
                value = _forms$form.value,
                require = _forms$form.require,
                visible = _forms$form.visible;

            var validate = true;
            if (!visible) continue;

            if (!value && require) {
                newState.forms[form].missing = true;
                missing = true;
            } else {
                newState.forms[form].missing = false;
            }
            if (value && !newState.forms[form].validate(value)) {
                newState.forms[form].isValidate = false;
                isValidate = false;
            }
        }
        if (exchangeAvailable && exchangePayload.exchange_on) {
            if (select.length == 0) {
                newState.selectValidate = false;
            }
        }

        if (!isValidate || missing) {
            this.setState(newState);
            return;
        }
        var payload = {
            'email': forms.email.value,
            'name': forms.name.value,
            'phone': forms.phone.value,
            'customer_ref': forms.customerRef.value
        };
        this.props.dispatch(_model.UserModel.updateUserOnState(payload));
        this.props.dispatch(_model.TicketModel.setCurrentRoom(null));
        this.props.dispatch(_model.TicketModel.setOnlineFormData(payload));
        if (exchangeAvailable && exchangePayload.exchange_on) {
            if (select.length > 0) {
                var options = exchangePayload.options;
                var last = _lodash2.default.last(select);
                this.props.dispatch(_model.TicketModel.setExchangeData({ 'id': last }));
            }
        }
        this.props.dispatch(_model.SystemModel.setRoute('Chat'));
    };

    OnlineFormular.prototype.renderForm = function renderForm(form, label) {
        var _this2 = this;

        var obj = this.state.forms[form];
        var require = obj.require;
        var visible = obj.visible;
        if (visible) {
            var value = obj.value;
            var missing = obj.missing;
            var isValidate = obj.isValidate;
            return (0, _preact.h)(
                'div',
                { style: { position: 'relative', width: '70%', margin: '15px auto' } },
                (0, _preact.h)(_Input2.default, { label: label, value: value,
                    onChange: function onChange(newValue) {
                        var newState = _extends({}, _this2.state);
                        newState.forms[form].value = newValue;
                        _this2.setState(newState);
                    },
                    require: require,
                    missing: missing,
                    isValidate: isValidate
                })
            );
        }
        return null;
    };

    OnlineFormular.prototype.renderExchange = function renderExchange() {
        var _this3 = this;

        if (!this.props.exchangeAvailable) return null;
        if (!this.props.exchangePayload.exchange_on) return null;
        var language = this.props.language;

        var options = _lodash2.default.filter(this.props.exchangePayload.options, ['visible', true]);

        var values = { '-1': language.get('Others') };
        for (var index in options) {
            values[options[index].id] = options[index].label;
        }
        var option = _lodash2.default.find(options, function (o) {
            return o.id === _this3.state.select[0];
        });

        var ChildInput = null;
        var hasChildren = option ? _lodash2.default.size(option.children) > 0 : false;
        if (hasChildren) {
            var _childrenValues;

            var childrenValues = (_childrenValues = {}, _childrenValues[option.id] = language.get('Others'), _childrenValues);
            for (var index in option.children) {
                childrenValues[option.children[index].id] = option.children[index].label;
            }
            ChildInput = (0, _preact.h)(_SelectInput2.default, { values: childrenValues, onChange: function onChange(e) {
                    var list = [].concat(_this3.state.select);
                    list[1] = e.target.value;
                    _this3.setState({ select: list });
                }, select: this.state.select[1],
                label: language.get('SelectTopic'),
                isValidate: this.state.selectValidate
            });
        }
        return (0, _preact.h)(
            'div',
            { style: { position: 'relative', width: '70%', margin: '15px auto' } },
            (0, _preact.h)(
                'div',
                { style: { fontSize: '14px', color: '#404040', margin: '5px 0px' } },
                'Vad g\xE4ller ditt \xE4rende'
            ),
            (0, _preact.h)(_SelectInput2.default, {
                values: values,
                onChange: function onChange(e) {
                    _this3.setState({ select: [e.target.value] });
                },
                select: this.state.select[0],
                label: language.get('SelectTopic'),
                isValidate: this.state.selectValidate
            }),
            hasChildren && ChildInput
        );
    };

    OnlineFormular.prototype.getRefLabel = function getRefLabel(alias, language) {
        switch (alias) {
            case 'ord':
                return language.get('OrderNo.');
            case 'cust':
                return language.get('CustomerNo.');
            case 'ref':
            default:
                return language.get('ReferenceNo.');break;
        }
    };

    OnlineFormular.prototype.render = function render() {
        var _this4 = this;

        var formsCount = 0;
        var _props2 = this.props,
            formsConfig = _props2.formsConfig,
            language = _props2.language,
            height = _props2.height;

        for (var forms in formsConfig) {
            if (formsConfig[forms].visible) {
                formsCount += 1;
            }
        }
        if (formsCount == 0) {
            //return this._renderStartChattingButton()
            return _ref;
        }

        var paddingTop = '50' - formsCount * 10 + 'px';

        var PreviousConversationsButtonProps = {
            title: language.get('ViewPreviousConversation'),
            onClick: function onClick() {
                return _this4.props.dispatch(_model.SystemModel.setRoute('Conversations'));
            },
            onMouseOver: function onMouseOver() {
                return _this4.setState({ historyIconHover: true });
            },
            onMouseLeave: function onMouseLeave() {
                return _this4.setState({ historyIconHover: false });
            },
            style: {
                minHeight: '1px',
                float: 'left',
                display: 'inline-block',
                width: '40px',
                cursor: 'pointer',
                paddingTop: '3px',
                paddingRight: '3px'
            }
        };
        var text = language.get("NewConversation");
        var customerRef = this.state.forms.customerRef;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Body },
            (0, _preact.h)(
                'div',
                { className: _style2.default.OnlineFormularBody },
                this.props.formsRequire && (0, _preact.h)(
                    'form',
                    { style: { paddingTop: paddingTop } },
                    this.renderForm('email', language.get('Email')),
                    this.renderForm('name', language.get('Name')),
                    this.renderForm('phone', language.get('Phone')),
                    this.renderForm('customerRef', this.getRefLabel(customerRef.alias, language))
                ),
                this.renderExchange(),
                (0, _preact.h)(
                    'div',
                    { style: { width: '100%', marginLeft: '20%', marginBottom: '10px' } },
                    (0, _preact.h)(
                        'div',
                        null,
                        (0, _preact.h)(
                            'div',
                            PreviousConversationsButtonProps,
                            this.props.conversations.size !== 0 && // above is for placeholder, if no img found
                            (0, _preact.h)(_History2.default, { color: this.state.historyIconHover ? this.props.color : '#898989' })
                        ),
                        (0, _preact.h)(
                            'div',
                            { className: _style2.default.StartChattingButton, style: { backgroundColor: this.props.color }, onClick: this.handleNewConversationClick },
                            (0, _preact.h)(
                                'span',
                                { className: _style2.default.StartChattingText },
                                ' ',
                                language.get('NewConversation'),
                                ' '
                            )
                        )
                    )
                )
            ),
            _ref2
        );
    };

    return OnlineFormular;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model.CustomizationModel.getColor(state);
    var language = _model.CustomizationModel.getLanguage(state);
    var conversations = _model.TicketModel.getAll(state);
    var height = _model.SystemModel.getBodyHeight(state);
    var width = _model.SystemModel.getShellWidth(state);
    var formsConfig = _model.CustomizationModel.getFormsConfig(state).toJS();
    var user = _model.UserModel.get(state).toJS();

    var formsRequire = _model.CustomizationModel.getFormsRequire(state);

    var exchangeAvailable = _model.FeaturesModel.getFeatureAvailable(state, 'exchange');
    var exchangePayload = _model.FeaturesModel.getFeaturePayload(state, 'exchange');
    return {
        height: height, width: width, formsConfig: formsConfig, user: user,
        conversations: conversations, color: color, language: language,

        formsRequire: formsRequire,

        exchangeAvailable: exchangeAvailable, exchangePayload: exchangePayload
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(OnlineFormular);

/***/ }),

/***/ "frwL":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _Question = __webpack_require__("0A5o");

var _Question2 = _interopRequireDefault(_Question);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("9VrP");

var _model4 = _interopRequireDefault(_model3);

var _PersistentRouting = __webpack_require__("5R3C");

var _PersistentRouting2 = _interopRequireDefault(_PersistentRouting);

var _style = __webpack_require__("EbsL");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryQuestions = function (_Component) {
    _inherits(CategoryQuestions, _Component);

    function CategoryQuestions(props) {
        _classCallCheck(this, CategoryQuestions);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this._onQuestionClick = _this._onQuestionClick.bind(_this);

        _this.state = {
            yTranslation: 5,
            opacity: 0
        };
        return _this;
    }

    CategoryQuestions.prototype.componentDidMount = function componentDidMount() {
        var _this2 = this;

        setTimeout(function () {
            return _this2.setState({ yTranslation: 0, opacity: 1 });
        }, 15);
    };

    CategoryQuestions.prototype._onQuestionClick = function _onQuestionClick(id) {
        this.props.dispatch(_model2.default.setHelpDeskRoute('HelpDeskArticle', this.props.activeCategory, id));
    };

    CategoryQuestions.prototype.render = function render() {
        var _this3 = this;

        var _state = this.state,
            yTranslation = _state.yTranslation,
            opacity = _state.opacity;
        var questions = this.props.questions;

        return (0, _preact.h)(
            'div',
            { style: { transform: 'translateY(' + yTranslation + 'px)', opacity: opacity },
                className: _style2.default.QuestionsContainer + ' ' + _style2.default.CustomScroll },
            questions.toJS().map(function (q, i) {
                return (0, _preact.h)(_Question2.default, { onClick: function onClick() {
                        return _this3._onQuestionClick(q['id']);
                    },
                    key: i,
                    questionTitle: q['question'] });
            })
        );
    };

    return CategoryQuestions;
}(_preact.Component);

function mapStateToProps(state, ownProps) {
    var activeCategoryId = _model4.default.getCategoryId(state, ownProps.activeCategory);
    var questions = _model4.default.getActiveQuestions(state);
    questions = questions.filter(function (question) {
        return question.get('category_id') === activeCategoryId;
    });
    return { questions: questions };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(CategoryQuestions);

/***/ }),

/***/ "gR2x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


(function () {
  var URL,
      URL_PATTERN,
      defaults,
      _urllite,
      __hasProp = {}.hasOwnProperty;

  URL_PATTERN = /^(?:(?:([^:\/?\#]+:)\/+|(\/\/))(?:([a-z0-9-\._~%]+)(?::([a-z0-9-\._~%]+))?@)?(([a-z0-9-\._~%!$&'()*+,;=]+)(?::([0-9]+))?)?)?([^?\#]*?)(\?[^\#]*)?(\#.*)?$/;

  _urllite = function urllite(raw, opts) {
    return _urllite.URL.parse(raw, opts);
  };

  _urllite.URL = URL = function () {
    function URL(props) {
      var k, v, _ref;
      for (k in defaults) {
        if (!__hasProp.call(defaults, k)) continue;
        v = defaults[k];
        this[k] = (_ref = props[k]) != null ? _ref : v;
      }
      this.host || (this.host = this.hostname && this.port ? "" + this.hostname + ":" + this.port : this.hostname ? this.hostname : '');
      this.origin || (this.origin = this.protocol ? "" + this.protocol + "//" + this.host : '');
      this.isAbsolutePathRelative = !this.host && this.pathname.charAt(0) === '/';
      this.isPathRelative = !this.host && this.pathname.charAt(0) !== '/';
      this.isRelative = this.isSchemeRelative || this.isAbsolutePathRelative || this.isPathRelative;
      this.isAbsolute = !this.isRelative;
    }

    URL.parse = function (raw) {
      var m, pathname, protocol;
      m = raw.toString().match(URL_PATTERN);
      pathname = m[8] || '';
      protocol = m[1];
      return new _urllite.URL({
        protocol: protocol,
        username: m[3],
        password: m[4],
        hostname: m[6],
        port: m[7],
        pathname: protocol && pathname.charAt(0) !== '/' ? "/" + pathname : pathname,
        search: m[9],
        hash: m[10],
        isSchemeRelative: m[2] != null
      });
    };

    return URL;
  }();

  defaults = {
    protocol: '',
    username: '',
    password: '',
    host: '',
    hostname: '',
    port: '',
    pathname: '',
    search: '',
    hash: '',
    origin: '',
    isSchemeRelative: false
  };

  module.exports = _urllite;
}).call(undefined);

/***/ }),

/***/ "gknL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"MessageWrapper":"MessageWrapper__Gh8ge","TimeLine":"TimeLine__2N4K6","TimeBody":"TimeBody__2TT8D","TimeMessage":"TimeMessage__8EVnx"};

/***/ }),

/***/ "goy3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Inspiration: https://github.com/facebook/react/issues/3386

var invariant = __webpack_require__("crWv"),
    isString = __webpack_require__("GgF8"),
    flatten = __webpack_require__("vqYw");

function replace(string, regexpOrSubstr, newValueOrFn) {
	invariant(typeof string === 'string', 'First param must be a string');
	invariant(typeof regexpOrSubstr === 'string' || regexpOrSubstr instanceof RegExp, 'Second param must be a string pattern or a regular expression');

	var fn = typeof regexpOrSubstr === 'string' ? replaceUsingString : replaceUsingRegexp;

	return fn(string, regexpOrSubstr, newValueOrFn);
}

function replaceUsingString(string, patternString, newValueOrFn) {
	var index = string.indexOf(patternString);

	if (index >= 0) {
		var arr = [];
		var endIndex = index + patternString.length;

		if (index > 0) {
			arr.push(string.substring(0, index));
		}

		arr.push(typeof newValueOrFn === 'function' ? newValueOrFn(string.substring(index, endIndex), index, string) : newValueOrFn);

		if (endIndex < string.length) {
			arr.push(string.substring(endIndex));
		}

		return arr;
	} else {
		return [string];
	}
}

function replaceUsingRegexp(string, regexp, newValueOrFn) {
	var output = [];

	var replacerIsFn = typeof newValueOrFn === 'function';

	var storedLastIndex = regexp.lastIndex;
	regexp.lastIndex = 0;

	var result;
	var lastIndex = 0;
	while (result = regexp.exec(string)) {
		var index = result.index;

		if (result[0] === '') {
			// When the regexp is an empty string
			// we still want to advance our cursor to the next item.
			// This is the behavior of String.replace.
			regexp.lastIndex++;
		}

		if (index !== lastIndex) {
			output.push(string.substring(lastIndex, index));
		}

		var match = result[0];
		lastIndex = index + match.length;

		var out = replacerIsFn ? newValueOrFn.apply(this, result.concat(index, result.input)) : newValueOrFn;
		output.push(out);

		if (!regexp.global) {
			break;
		}
	}

	if (lastIndex < string.length) {
		output.push(string.substring(lastIndex));
	}

	regexp.lastIndex = storedLastIndex;
	return output;
}

module.exports = function stringReplaceToArray(string, regexpOrSubstr, newSubStrOrFn) {
	if (isString(string)) {
		return replace(string, regexpOrSubstr, newSubStrOrFn);
	} else if (!Array.isArray(string) || !string[0]) {
		throw new TypeError('First argument must be an array or non-empty string');
	} else {
		return flatten(string.map(function (string) {
			if (!isString(string)) return string;
			return replace(string, regexpOrSubstr, newSubStrOrFn);
		}));
	}
};

/***/ }),

/***/ "gt/O":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;

/***/ }),

/***/ "iw93":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SearchResultsContainer":"SearchResultsContainer__2E4Zz","NoResults":"NoResults__cFzoS","NoResultsSearchTerm":"NoResultsSearchTerm__ym8WH"};

/***/ }),

/***/ "iwwO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Chat = function (_Component) {
    _inherits(Chat, _Component);

    function Chat() {
        _classCallCheck(this, Chat);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Chat.prototype.render = function render() {
        var _props = this.props,
            color = _props.color,
            size = _props.size;

        return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 42 42" },
            (0, _preact.h)("path", { fill: color, d: "M6.05,39a2,2,0,0,1-1.79-2.83l2.5-5.31A17.54,17.54,0,1,1,13,36.75L6.69,38.89A1.94,1.94,0,0,1,6.05,39Zm-.47-3.41h0Zm7.19-1.94a1.81,1.81,0,0,1,1,.28,14.64,14.64,0,1,0-4.13-3.88,1.84,1.84,0,0,1,.17,1.85L8.3,35.08l3.89-1.33A1.81,1.81,0,0,1,12.77,33.65Z" }),
            (0, _preact.h)("path", { fill: color, d: "M29.45,17H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z" }),
            (0, _preact.h)("path", { fill: color, d: "M29.45,23H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z" }),
            (0, _preact.h)("path", { fill: color, d: "M29.45,29H14.55a1.46,1.46,0,1,1,0-2.91H29.45a1.46,1.46,0,1,1,0,2.91Z" })
        );
    };

    return Chat;
}(_preact.Component);

exports.default = Chat;

/***/ }),

/***/ "jRWN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _reactInlinesvg = __webpack_require__("Bl3B");

var _reactInlinesvg2 = _interopRequireDefault(_reactInlinesvg);

var _style = __webpack_require__("7WtF");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryButton = function (_Component) {
    _inherits(CategoryButton, _Component);

    function CategoryButton(props) {
        _classCallCheck(this, CategoryButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            opacity: 0
        };
        return _this;
    }

    CategoryButton.prototype.componentDidMount = function componentDidMount() {
        this.setState({ opacity: 1 });
    };

    CategoryButton.prototype.render = function render() {
        var opacity = this.state.opacity;
        //Must be null, otherwise the button will be clickable.

        var visibility = this.props.imgSrc ? null : 'hidden';
        return (0, _preact.h)(
            'div',
            { className: _style2.default.CategoryContainer, style: { visibility: visibility, opacity: opacity } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.ClickSurface, onClick: this.props.onClick },
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.ImageWrapper },
                    (0, _preact.h)(_reactInlinesvg2.default, { className: _style2.default.CategoryIcon, src: this.props.imgSrc || '', style: { fill: this.props.color } })
                ),
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.CategoryText },
                    this.props.catName
                )
            )
        );
    };

    return CategoryButton;
}(_preact.Component);

exports.default = CategoryButton;

/***/ }),

/***/ "jVb+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("dgY3");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(
    'a',
    { href: 'https://jibber.se', className: '', target: '_blank' },
    'Powered By ',
    (0, _preact.h)(
        'span',
        null,
        'Jibber'
    )
);

var PoweredByJibber = function (_Component) {
    _inherits(PoweredByJibber, _Component);

    function PoweredByJibber() {
        _classCallCheck(this, PoweredByJibber);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    PoweredByJibber.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.PoweredByJibber, style: this.props.hasFeatureFooter && { marginBottom: '40px' } },
            _ref
        );
    };

    return PoweredByJibber;
}(_preact.Component);

function mapStateToProps(state) {
    var features = state.getIn(['features', 'features']);
    return {
        hasFeatureFooter: features.has('faq_type')
    };
}
exports.default = (0, _preactRedux.connect)(mapStateToProps)(PoweredByJibber);

/***/ }),

/***/ "jtSj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("EOpn");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("et9O");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("lmuV");

var _model6 = __webpack_require__("ksTV");

var _model7 = _interopRequireDefault(_model6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
//import ConversationClass from '/chat/src/lib/Conversation';


var NewConversationButton = function (_Component) {
    _inherits(NewConversationButton, _Component);

    function NewConversationButton() {
        _classCallCheck(this, NewConversationButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    NewConversationButton.prototype.render = function render() {
        var text = this.props.language.get('NewConversation');
        return (0, _preact.h)(
            'div',
            { className: _style2.default.NewConversationWrapper },
            (0, _preact.h)(
                'div',
                {
                    className: _style2.default.NewConversationButton,
                    style: { backgroundColor: this.props.color },
                    onClick: this.handleClick },
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.NewConversationText },
                    text
                )
            )
        );
    };

    NewConversationButton.prototype.handleClick = function handleClick() {
        this.props.dispatch(_model5.TicketModel.setCurrentRoom(''));
        if (this.props.isOffline || this.props.formsRequire) {
            this.props.dispatch(_model4.default.setRoute('StartChatting'));
        } else {
            this.props.dispatch(_model4.default.setRoute('Chat'));
        }
    };

    return NewConversationButton;
}(_preact.Component);

function mapStateToProps(state) {
    var language = _model2.default.getLanguage(state);
    var color = _model2.default.getColor(state);
    var isOffline = _model7.default.isOffline(state);
    return { language: language, color: color, isOffline: isOffline,
        formsRequire: _model2.default.getFormsRequire(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(NewConversationButton);

/***/ }),

/***/ "kKTp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Scrollbars = undefined;

var _Scrollbars = __webpack_require__("p5XT");

var _Scrollbars2 = _interopRequireDefault(_Scrollbars);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

exports["default"] = _Scrollbars2["default"];
exports.Scrollbars = _Scrollbars2["default"];

/***/ }),

/***/ "kThW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("Qgwq");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _Cog = __webpack_require__("SX1U");

var _Cog2 = _interopRequireDefault(_Cog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Cog2.default, { color: 'white' });

var SettingsButton = function (_Component) {
    _inherits(SettingsButton, _Component);

    function SettingsButton() {
        _classCallCheck(this, SettingsButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SettingsButton.prototype.render = function render() {
        var _this2 = this;

        var defaultStyle = _style2.default.NormalSettings;
        if (!this.props.isNormalView) defaultStyle = _style2.default.MobileSettings;
        return (0, _preact.h)(
            'div',
            {
                onClick: function onClick() {
                    _this2.props.dispatch(_model2.default.setRoute('Settings'));
                },
                className: defaultStyle },
            _ref
        );
    };

    return SettingsButton;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        isNormalView: _model2.default.isNormalView(state)
    };
})(SettingsButton);

/***/ }),

/***/ "kfHX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BackButtonWrapper":"BackButtonWrapper__rhK0J","HeaderContainer":"HeaderContainer__9U8ZH","CompanyName":"CompanyName__3y6ae","HelpDesk":"HelpDesk__17X91","InputSearch":"InputSearch__2pcBb","InputWrapper":"InputWrapper__3f31f","SearchIcon":"SearchIcon__2sj3O"};

/***/ }),

/***/ "lKnS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)('span', { 'class': 'unread-message-indicator-chat-body__arrow icon icon-arrow-down3' });

var UnreadMessageIndicatorChatBody = function (_Component) {
    _inherits(UnreadMessageIndicatorChatBody, _Component);

    function UnreadMessageIndicatorChatBody() {
        _classCallCheck(this, UnreadMessageIndicatorChatBody);

        var _this = _possibleConstructorReturn(this, _Component.call(this));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    UnreadMessageIndicatorChatBody.prototype.render = function render() {
        var unreadCount = this.props.unreadCount;
        return (0, _preact.h)(
            'div',
            { 'class': 'unread-message-indicator-chat-body-wrapper' },
            (0, _preact.h)(
                'span',
                { 'class': 'unread-message-indicator-chat-body pointer', onClick: this.handleClick },
                _ref,
                (0, _preact.h)(
                    'span',
                    { 'class': 'unread-message-indicator-chat-body__count' },
                    unreadCount
                )
            )
        );
    };

    UnreadMessageIndicatorChatBody.prototype.handleClick = function handleClick() {
        this.props.scrollToBottomOfChatBody();
    };

    return UnreadMessageIndicatorChatBody;
}(_preact.Component);

exports.default = UnreadMessageIndicatorChatBody;

/***/ }),

/***/ "lhLY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = returnFalse;
function returnFalse() {
  return false;
}

/***/ }),

/***/ "lwNl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

var _draftjsToHtml = __webpack_require__("II9e");

var _draftjsToHtml2 = _interopRequireDefault(_draftjsToHtml);

var _style = __webpack_require__("wDYE");

var _style2 = _interopRequireDefault(_style);

var _aliases = __webpack_require__("Mx5r");

var _aliases2 = _interopRequireDefault(_aliases);

var _textToAliases = __webpack_require__("XbHO");

var _textToAliases2 = _interopRequireDefault(_textToAliases);

var _emojiRegex = __webpack_require__("RdLw");

var _emojiRegex2 = _interopRequireDefault(_emojiRegex);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var unicodeEmojiRegex = (0, _emojiRegex2.default)();
//eslint-disable-next-line
var aliasesRegex = /:([\w\-\_\+]+):/g;
//eslint-disable-next-line
var textEmojiRegex = /(\:\w+\:|\<[\/\\]?3|[\(\)\\\D|\*\$][\-\^]?[\:\;\=]|[\:\;\=B8][\-\^]?[3DOPp\@\$\*\\\)\(\/\|])(?=\s|[\!\.\?]|$)/g;
var urlRegex = /^((?!href|src).)*(?:(?:https?|ftp|file):\/\/|www\.|ftp\.)(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.;]*\)|[-A-Z0-9+&@#\/%=~_|$?!:,.;])*(?:\([-A-Z0-9+&@#\/%=~_|$?!:,.;]*\)|[A-Z0-9+&@#\/%=~_;|$])/gim;

var shortCodeRegex = /:[0-9a-z-+_]+:/gi;

// avoid runtime RegExp creation for not so smart,
// not JIT based, and old browsers / engines
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L232
var UFE0Fg = /\uFE0F/g;

// \u200D is a zero-width joiner character
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L235
var U200D = String.fromCharCode(0x200d);

// convert utf16 into code points
function toCodePoint(input) {
    var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";

    var codePoints = [];
    for (var _iterator = input, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
        } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
        }

        var codePoint = _ref;

        codePoints.push(codePoint.codePointAt(0).toString(16));
    }
    return codePoints.join(separator);
}

function unicodeToCodepoint(input) {
    if (!input) return input;
    return toCodePoint(input.indexOf(U200D) < 0 ? input.replace(UFE0Fg, "") : input);
}

var TextDisplay = function (_Component) {
    _inherits(TextDisplay, _Component);

    function TextDisplay() {
        _classCallCheck(this, TextDisplay);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    /**
    * Replaces unicode emojis by twemojis as <img> tags
    * @param {*} text
    * @returns text with twemojis
    */
    TextDisplay.prototype.toSmileyImage = function toSmileyImage(text) {
        // Set the source for the emojis. Now using locally hosted twemojis
        var options = {
            baseUrl: '/common/assets/twemoji/',
            size: '72x72',
            ext: 'png'
        };
        var separator = options.size ? "/" : "";
        var codepoint = void 0,
            src = void 0;
        if (!text) return '';
        text = text.replace(shortCodeRegex, function (match) {
            // match :smile:
            var fullMatchContent = match.slice(1, -1); // remove ":" at the beginning and en
            codepoint = unicodeToCodepoint(_aliases2.default[fullMatchContent]); // Find code matching the emoji
            if (!codepoint) return ':' + match + ':';
            src = '' + options.baseUrl + options.size + separator + codepoint + '.' + options.ext; // Find the matching emoji from ...assets/twemoji
            return '<img src="' + src + '" style="width: 1em; height: 1em"/>'; // Create image element with asset to replace the :emoji: with
        }).replace(unicodeEmojiRegex, function (match) {
            // match 😁
            var codepoint = unicodeToCodepoint(match); // Find code matching the emoji
            if (!codepoint) return match;
            src = '' + options.baseUrl + options.size + separator + codepoint + '.' + options.ext; // Find the matching emoji from ...assets/twemoji
            return '<img src="' + src + '" style="width: 1em; height: 1em"/>'; // Create image element with asset to replace the :emoji: with
        });
        return text;
    };

    /**
    * Identifies links with urlRegex and replaces them by clickable anchor-tags
    * @param {*} text
    * @returns text with clickable links
    */


    TextDisplay.prototype.toLink = function toLink(text) {
        return text.replace(urlRegex, function (url) {
            var text = url;
            if (url.search(/(http(s)?:\/\/)/g) === -1) {
                url = '//' + url;
            }
            url = url.replace("<p>", "");
            return '<a href=\'' + url + '\' target=\'_blank\'>' + text + '</a>';
        });
    };

    /**
    * Processes text before sending it to toSmileyImage and toLink so that it is unformatted
    * @param {*} text to process
    * @returns processed text
    */


    TextDisplay.prototype.processText2 = function processText2(text) {
        try {
            // Try to parse it as if it were JSON-formatted.
            // If it isn't JSON-formatted the following line will throw an error.
            var parsed = JSON.parse(text.replace('_self', '_blank')); // replace target to new tab instead of change in iframe
            /*
                draftohtml add extra /&nbsp; to avoid trimming, but we need the space for the smiley, so i had to replace it back // tuan
            */
            // Make sure it is an object before converting it to HTML, otherwise it will not have the intended effect
            if (typeof parsed === 'object') {
                parsed = (0, _draftjsToHtml2.default)(parsed).replace(/&nbsp;/g, ' ');
            }
            //withLink = this.toLink(htmlText)
            return this.toLink(this.toSmileyImage(parsed));
        } catch (error) {
            // If the text isn't JSON-formatted the error gets caught here.
            return this.toLink(this.toSmileyImage(text));
        }
    };

    TextDisplay.prototype.render = function render() {
        var _props = this.props,
            text = _props.text,
            ellipsis = _props.ellipsis;

        if (!text) return '';
        var message = this.processText2(this.props.text);
        var ellips = ellipsis ? ' ellipsis' : '';
        return (0, _preact.h)('div', { className: _style2.default.Wrapper + ellips, dangerouslySetInnerHTML: { __html: message } });
    };

    return TextDisplay;
}(_preact.Component);

exports.default = TextDisplay;

/***/ }),

/***/ "mBif":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"no-select":"no-select__3mdsn","pointer":"pointer__3ae-z","Header":"Header__MG3bN","UnreadNotis":"UnreadNotis__3p5DZ"};

/***/ }),

/***/ "mb5j":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"QuestionWrapper":"QuestionWrapper__3eFTo","Question":"Question__33x7Q"};

/***/ }),

/***/ "mi58":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = {
    instagram: /instagram/i
};

/***/ }),

/***/ "n7b9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _Button = __webpack_require__("GxWo");

var _Button2 = _interopRequireDefault(_Button);

var _style = __webpack_require__("DlyD");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Button2.default, null);

var _ref2 = (0, _preact.h)(_PoweredByJibber2.default, null);

var StartChattingBody = function (_Component) {
    _inherits(StartChattingBody, _Component);

    function StartChattingBody() {
        _classCallCheck(this, StartChattingBody);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    StartChattingBody.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { className: _style2.default.Body },
            _ref,
            _ref2
        );
    };

    return StartChattingBody;
}(_preact.Component);

exports.default = StartChattingBody;

/***/ }),

/***/ "nGPF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("A+Mm");

var _style2 = _interopRequireDefault(_style);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _AutoMessage = __webpack_require__("O6gZ");

var _AutoMessage2 = _interopRequireDefault(_AutoMessage);

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Buttons.BackButton, null);

var _ref2 = (0, _preact.h)(_Buttons.FaqButton, null);

var _ref3 = (0, _preact.h)(_Buttons.CloseButton, null);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            HeaderHeight: 0
        };
        return _this;
    }

    Header.prototype.render = function render() {
        var company = this.props.company;
        var automessage = this.props.automessage;
        var hasFaq = this.props.features.get('hasFaq');

        var welcomeTo = this.props.language.get("WelcomeTo");

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Header },
                _ref,
                (0, _preact.h)(_Title2.default, { body: this.props.language.get('Settings') }),
                (0, _preact.h)(
                    _RightSide2.default,
                    null,
                    hasFaq && _ref2,
                    _ref3
                )
            )
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    return {
        color: color,
        language: language,
        company: state.get('company'),
        automessage: state.getIn(['autoMessages', 'currentAutoMessage']),
        features: state.get('features'),
        system: state.get('system')
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "nMX2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Export.
 */

module.exports = toNoCase;

/**
 * Test whether a string is camel-case.
 */

var hasSpace = /\s/;
var hasSeparator = /(_|-|\.|:)/;
var hasCamel = /([a-z][A-Z]|[A-Z][a-z])/;

/**
 * Remove any starting case from a `string`, like camel or snake, but keep
 * spaces and punctuation that may be important otherwise.
 *
 * @param {String} string
 * @return {String}
 */

function toNoCase(string) {
  if (hasSpace.test(string)) return string.toLowerCase();
  if (hasSeparator.test(string)) return (unseparate(string) || string).toLowerCase();
  if (hasCamel.test(string)) return uncamelize(string).toLowerCase();
  return string.toLowerCase();
}

/**
 * Separator splitter.
 */

var separatorSplitter = /[\W_]+(.|$)/g;

/**
 * Un-separate a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function unseparate(string) {
  return string.replace(separatorSplitter, function (m, next) {
    return next ? ' ' + next : '';
  });
}

/**
 * Camelcase splitter.
 */

var camelSplitter = /(.)([A-Z]+)/g;

/**
 * Un-camelcase a `string`.
 *
 * @param {String} string
 * @return {String}
 */

function uncamelize(string) {
  return string.replace(camelSplitter, function (m, previous, uppers) {
    return previous + ' ' + uppers.toLowerCase().split('').join(' ');
  });
}

/***/ }),

/***/ "nPmw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var div = null;
var prefixes = ['Webkit', 'Moz', 'O', 'ms'];

module.exports = function prefixStyle(prop) {
  // re-use a dummy div
  if (!div) {
    div = document.createElement('div');
  }

  var style = div.style;

  // prop exists without prefix
  if (prop in style) {
    return prop;
  }

  // borderRadius -> BorderRadius
  var titleCase = prop.charAt(0).toUpperCase() + prop.slice(1);

  // find the vendor-prefixed prop
  for (var i = prefixes.length; i >= 0; i--) {
    var name = prefixes[i] + titleCase;
    // e.g. WebkitBorderRadius or webkitBorderRadius
    if (name in style) {
      return name;
    }
  }

  return false;
};

/***/ }),

/***/ "ngBf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"BodyText":"BodyText__1neZE","ErrorText":"ErrorText__JzWbr","BackLink":"BackLink__2FPU7","Title":"Title__1WP20","ArticlePage":"ArticlePage__3YfX_","ArticleContainer":"ArticleContainer__TouL5","ProfilePicture":"ProfilePicture__2FX64","ProfileMetaText":"ProfileMetaText__3a3Ly","ArticleTextContainer":"ArticleTextContainer__x6-KX"};

/***/ }),

/***/ "ommR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

var now = __webpack_require__("UGHC"),
    root = typeof window === 'undefined' ? global : window,
    vendors = ['moz', 'webkit'],
    suffix = 'AnimationFrame',
    raf = root['request' + suffix],
    caf = root['cancel' + suffix] || root['cancelRequest' + suffix];

for (var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix];
  caf = root[vendors[i] + 'Cancel' + suffix] || root[vendors[i] + 'CancelRequest' + suffix];
}

// Some versions of FF have rAF but not cAF
if (!raf || !caf) {
  var last = 0,
      id = 0,
      queue = [],
      frameDuration = 1000 / 60;

  raf = function raf(callback) {
    if (queue.length === 0) {
      var _now = now(),
          next = Math.max(0, frameDuration - (_now - last));
      last = next + _now;
      setTimeout(function () {
        var cp = queue.slice(0);
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0;
        for (var i = 0; i < cp.length; i++) {
          if (!cp[i].cancelled) {
            try {
              cp[i].callback(last);
            } catch (e) {
              setTimeout(function () {
                throw e;
              }, 0);
            }
          }
        }
      }, Math.round(next));
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    });
    return id;
  };

  caf = function caf(handle) {
    for (var i = 0; i < queue.length; i++) {
      if (queue[i].handle === handle) {
        queue[i].cancelled = true;
      }
    }
  };
}

module.exports = function (fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn);
};
module.exports.cancel = function () {
  caf.apply(root, arguments);
};
module.exports.polyfill = function (object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf;
  object.cancelAnimationFrame = caf;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "or3P":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Conversation":"Conversation__1CM1i","ProfileImage":"ProfileImage__1B29f","ConversationItemName":"ConversationItemName__4wVLC","ConversationLastEntry":"ConversationLastEntry__3jfHI","ConversationLastEntryText":"ConversationLastEntryText__3GTB8","ConversationLastEntryTime":"ConversationLastEntryTime__3lYJk","BrandingName":"BrandingName__1ykxY","ConversationUnreadEntriesCount":"ConversationUnreadEntriesCount__5x2gD"};

/***/ }),

/***/ "p/6D":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _model = __webpack_require__("2YDt");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("3rs2");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_Component) {
    _inherits(Input, _Component);

    function Input(props) {
        _classCallCheck(this, Input);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            value: props.value || '',
            focus: false,
            onLabelHover: false
        };
        _this.onChange = _this.onChange.bind(_this);
        _this.inputRef = null;
        _this.setFocus = _this.setFocus.bind(_this);
        return _this;
    }

    Input.prototype.onChange = function onChange(event) {
        this.setState({ value: event.target.value });
        if (this.props.onChange) {
            this.props.onChange(event.target.value);
        }
    };

    Input.prototype.setFocus = function setFocus() {
        this.setState({ focus: true });
        if (this.inputRef) {
            this.inputRef.focus();
        }
    };

    Input.prototype.render = function render() {
        var _this2 = this;

        var _props = this.props,
            width = _props.width,
            label = _props.label,
            autocomplete = _props.autocomplete,
            require = _props.require,
            missing = _props.missing,
            isValidate = _props.isValidate;


        var requireAndMissing = require && missing;

        var error = false;
        if (requireAndMissing) {
            label = label + ' ' + this.props.language.get('Require');
            error = true;
        } else if (!isValidate) {
            label = label + ' ' + this.props.language.get('Invalid');
            error = true;
        }
        return (0, _preact.h)(
            'span',
            { className: _style2.default.InputWrapper, onClick: this.setFocus },
            (0, _preact.h)(
                'span',
                { className: this.state.value || this.state.focus ? _style2.default.InputLabelHover : _style2.default.InputLabel
                },
                ' ',
                label
            ),
            (0, _preact.h)('input', { className: _style2.default.Input,
                ref: function ref(inputRef) {
                    return _this2.inputRef = inputRef;
                },
                onfocus: function onfocus() {
                    _this2.setState({ focus: true });
                },
                onBlur: function onBlur() {
                    return _this2.setState({ focus: false });
                },
                onInput: this.onChange,
                value: this.state.value,
                id: label,
                autocomplete: 'off',
                style: error && {
                    border: '2px solid #ff6d67'
                }
            }),
            require && !missing && (0, _preact.h)(
                'span',
                { className: _style2.default.InputRequired,
                    onMouseEnter: function onMouseEnter() {
                        return _this2.setState({ onLabelHover: true });
                    },
                    onMouseLeave: function onMouseLeave() {
                        return _this2.setState({ onLabelHover: false });
                    }
                },
                ' * '
            ),
            this.state.onLabelHover && (0, _preact.h)(
                'span',
                { className: _style2.default.LabelRequiredMissing
                },
                ' ',
                label,
                ' '
            ),
            error && (0, _preact.h)(
                'span',
                { className: _style2.default.InputRequiredMissing },
                ' * '
            )
        );
    };

    return Input;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        language: _model2.default.getLanguage(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Input);

/***/ }),

/***/ "p5XT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;Object.defineProperty(target, descriptor.key, descriptor);
    }
  }return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
  };
}();

var _raf = __webpack_require__("ommR");

var _raf2 = _interopRequireDefault(_raf);

var _domCss = __webpack_require__("PqSB");

var _domCss2 = _interopRequireDefault(_domCss);

var _preact = __webpack_require__("EBst");

var _isString = __webpack_require__("GmLO");

var _isString2 = _interopRequireDefault(_isString);

var _getScrollbarWidth = __webpack_require__("1RYr");

var _getScrollbarWidth2 = _interopRequireDefault(_getScrollbarWidth);

var _returnFalse = __webpack_require__("lhLY");

var _returnFalse2 = _interopRequireDefault(_returnFalse);

var _getInnerWidth = __webpack_require__("RLDv");

var _getInnerWidth2 = _interopRequireDefault(_getInnerWidth);

var _getInnerHeight = __webpack_require__("MDPO");

var _getInnerHeight2 = _interopRequireDefault(_getInnerHeight);

var _styles = __webpack_require__("5ASY");

var _defaultRenderElements = __webpack_require__("wGi3");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { "default": obj };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Scrollbars = function (_Component) {
  _inherits(Scrollbars, _Component);

  function Scrollbars() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Scrollbars);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Scrollbars.__proto__ || Object.getPrototypeOf(Scrollbars)).call.apply(_ref, [this].concat(args))), _this), _this.refs = {}, _this.state = {
      didMountUniversal: false
    }, _this.componentDidMount = function () {
      _this.addListeners();
      _this.update();
      _this.componentDidMountUniversal();
    }, _this.componentDidUpdate = function () {
      _this.update();
    }, _this.componentWillUnmount = function () {
      _this.unsetDomStyles();
      _this.removeListeners();
      (0, _raf.cancel)(_this.requestFrame);
      clearTimeout(_this.hideTracksTimeout);
      clearInterval(_this.detectScrollingInterval);
    }, _this.getScrollLeft = function () {
      var view = _this.refs.view;

      return view.scrollLeft;
    }, _this.getScrollTop = function () {
      var view = _this.refs.view;

      return view.scrollTop;
    }, _this.getScrollWidth = function () {
      var view = _this.refs.view;

      return view.scrollWidth;
    }, _this.getScrollHeight = function () {
      var view = _this.refs.view;

      return view.scrollHeight;
    }, _this.getClientWidth = function () {
      var view = _this.refs.view;

      return view.clientWidth;
    }, _this.getClientHeight = function () {
      var view = _this.refs.view;

      return view.clientHeight;
    }, _this.getValues = function () {
      var view = _this.refs.view;
      var scrollLeft = view.scrollLeft,
          scrollTop = view.scrollTop,
          scrollWidth = view.scrollWidth,
          scrollHeight = view.scrollHeight,
          clientWidth = view.clientWidth,
          clientHeight = view.clientHeight;

      return {
        left: scrollLeft / (scrollWidth - clientWidth) || 0,
        top: scrollTop / (scrollHeight - clientHeight) || 0,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth,
        scrollHeight: scrollHeight,
        clientWidth: clientWidth,
        clientHeight: clientHeight
      };
    }, _this.getThumbHorizontalWidth = function () {
      var _this$props = _this.props,
          thumbSize = _this$props.thumbSize,
          thumbMinSize = _this$props.thumbMinSize;
      var _this$refs = _this.refs,
          view = _this$refs.view,
          trackHorizontal = _this$refs.trackHorizontal;
      var scrollWidth = view.scrollWidth,
          clientWidth = view.clientWidth;

      var trackWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
      var width = Math.ceil(clientWidth / scrollWidth * trackWidth);
      if (trackWidth === width) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(width, thumbMinSize);
    }, _this.getThumbVerticalHeight = function () {
      var _this$props2 = _this.props,
          thumbSize = _this$props2.thumbSize,
          thumbMinSize = _this$props2.thumbMinSize;
      var _this$refs2 = _this.refs,
          view = _this$refs2.view,
          trackVertical = _this$refs2.trackVertical;
      var scrollHeight = view.scrollHeight,
          clientHeight = view.clientHeight;

      var trackHeight = (0, _getInnerHeight2["default"])(trackVertical);
      var height = Math.ceil(clientHeight / scrollHeight * trackHeight);
      if (trackHeight === height) return 0;
      if (thumbSize) return thumbSize;
      return Math.max(height, thumbMinSize);
    }, _this.getScrollLeftForOffset = function (offset) {
      var _this$refs3 = _this.refs,
          view = _this$refs3.view,
          trackHorizontal = _this$refs3.trackHorizontal;
      var scrollWidth = view.scrollWidth,
          clientWidth = view.clientWidth;

      var trackWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
      var thumbWidth = _this.getThumbHorizontalWidth();
      return offset / (trackWidth - thumbWidth) * (scrollWidth - clientWidth);
    }, _this.getScrollTopForOffset = function (offset) {
      var _this$refs4 = _this.refs,
          view = _this$refs4.view,
          trackVertical = _this$refs4.trackVertical;
      var scrollHeight = view.scrollHeight,
          clientHeight = view.clientHeight;

      var trackHeight = (0, _getInnerHeight2["default"])(trackVertical);
      var thumbHeight = _this.getThumbVerticalHeight();
      return offset / (trackHeight - thumbHeight) * (scrollHeight - clientHeight);
    }, _this.scrollLeft = function () {
      var left = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var view = _this.refs.view;

      view.scrollLeft = left;
    }, _this.scrollTop = function () {
      var top = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var view = _this.refs.view;

      view.scrollTop = top;
    }, _this.scrollToLeft = function () {
      var view = _this.refs.view;

      view.scrollLeft = 0;
    }, _this.scrollToTop = function () {
      var view = _this.refs.view;

      view.scrollTop = 0;
    }, _this.scrollToRight = function () {
      var view = _this.refs.view;

      view.scrollLeft = view.scrollWidth;
    }, _this.scrollToBottom = function () {
      var view = _this.refs.view;

      view.scrollTop = view.scrollHeight;
    }, _this.addListeners = function () {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return;
      var _this$refs5 = _this.refs,
          view = _this$refs5.view,
          trackHorizontal = _this$refs5.trackHorizontal,
          trackVertical = _this$refs5.trackVertical,
          thumbHorizontal = _this$refs5.thumbHorizontal,
          thumbVertical = _this$refs5.thumbVertical;

      view.addEventListener('scroll', _this.handleScroll);
      if (!(0, _getScrollbarWidth2["default"])()) return;
      trackHorizontal.addEventListener('mouseenter', _this.handleTrackMouseEnter);
      trackHorizontal.addEventListener('mouseleave', _this.handleTrackMouseLeave);
      trackHorizontal.addEventListener('mousedown', _this.handleHorizontalTrackMouseDown);
      trackVertical.addEventListener('mouseenter', _this.handleTrackMouseEnter);
      trackVertical.addEventListener('mouseleave', _this.handleTrackMouseLeave);
      trackVertical.addEventListener('mousedown', _this.handleVerticalTrackMouseDown);
      thumbHorizontal.addEventListener('mousedown', _this.handleHorizontalThumbMouseDown);
      thumbVertical.addEventListener('mousedown', _this.handleVerticalThumbMouseDown);
      window.addEventListener('resize', _this.handleWindowResize);
    }, _this.removeListeners = function () {
      /* istanbul ignore if */
      if (typeof document === 'undefined') return;
      var _this$refs6 = _this.refs,
          view = _this$refs6.view,
          trackHorizontal = _this$refs6.trackHorizontal,
          trackVertical = _this$refs6.trackVertical,
          thumbHorizontal = _this$refs6.thumbHorizontal,
          thumbVertical = _this$refs6.thumbVertical;

      view.removeEventListener('scroll', _this.handleScroll);
      if (!(0, _getScrollbarWidth2["default"])()) return;
      trackHorizontal.removeEventListener('mouseenter', _this.handleTrackMouseEnter);
      trackHorizontal.removeEventListener('mouseleave', _this.handleTrackMouseLeave);
      trackHorizontal.removeEventListener('mousedown', _this.handleHorizontalTrackMouseDown);
      trackVertical.removeEventListener('mouseenter', _this.handleTrackMouseEnter);
      trackVertical.removeEventListener('mouseleave', _this.handleTrackMouseLeave);
      trackVertical.removeEventListener('mousedown', _this.handleVerticalTrackMouseDown);
      thumbHorizontal.removeEventListener('mousedown', _this.handleHorizontalThumbMouseDown);
      thumbVertical.removeEventListener('mousedown', _this.handleVerticalThumbMouseDown);
      window.removeEventListener('resize', _this.handleWindowResize);
      // Possibly setup by `handleDragStart`
      _this.teardownDragging();
    }, _this.handleScroll = function (event) {
      var _this$props3 = _this.props,
          onScroll = _this$props3.onScroll,
          onScrollFrame = _this$props3.onScrollFrame;

      if (onScroll) onScroll(event);
      _this.update(function (values) {
        var scrollLeft = values.scrollLeft,
            scrollTop = values.scrollTop;

        _this.viewScrollLeft = scrollLeft;
        _this.viewScrollTop = scrollTop;
        if (onScrollFrame) onScrollFrame(values);
      });
      _this.detectScrolling();
    }, _this.handleScrollStart = function () {
      var onScrollStart = _this.props.onScrollStart;

      if (onScrollStart) onScrollStart();
      _this.handleScrollStartAutoHide();
    }, _this.handleScrollStartAutoHide = function () {
      var autoHide = _this.props.autoHide;

      if (!autoHide) return;
      _this.showTracks();
    }, _this.handleScrollStop = function () {
      var onScrollStop = _this.props.onScrollStop;

      if (onScrollStop) onScrollStop();
      _this.handleScrollStopAutoHide();
    }, _this.handleScrollStopAutoHide = function () {
      var autoHide = _this.props.autoHide;

      if (!autoHide) return;
      _this.hideTracks();
    }, _this.handleWindowResize = function () {
      _this.update();
    }, _this.handleHorizontalTrackMouseDown = function (event) {
      event.preventDefault();
      var view = _this.refs.view;
      var target = event.target,
          clientX = event.clientX;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          targetLeft = _target$getBoundingCl.left;

      var thumbWidth = _this.getThumbHorizontalWidth();
      var offset = Math.abs(targetLeft - clientX) - thumbWidth / 2;
      view.scrollLeft = _this.getScrollLeftForOffset(offset);
    }, _this.handleVerticalTrackMouseDown = function (event) {
      event.preventDefault();
      var view = _this.refs.view;
      var target = event.target,
          clientY = event.clientY;

      var _target$getBoundingCl2 = target.getBoundingClientRect(),
          targetTop = _target$getBoundingCl2.top;

      var thumbHeight = _this.getThumbVerticalHeight();
      var offset = Math.abs(targetTop - clientY) - thumbHeight / 2;
      view.scrollTop = _this.getScrollTopForOffset(offset);
    }, _this.handleHorizontalThumbMouseDown = function (event) {
      event.preventDefault();
      _this.handleDragStart(event);
      var target = event.target,
          clientX = event.clientX;
      var offsetWidth = target.offsetWidth;

      var _target$getBoundingCl3 = target.getBoundingClientRect(),
          left = _target$getBoundingCl3.left;

      _this.prevPageX = offsetWidth - (clientX - left);
    }, _this.handleVerticalThumbMouseDown = function (event) {
      event.preventDefault();
      _this.handleDragStart(event);
      var target = event.target,
          clientY = event.clientY;
      var offsetHeight = target.offsetHeight;

      var _target$getBoundingCl4 = target.getBoundingClientRect(),
          top = _target$getBoundingCl4.top;

      _this.prevPageY = offsetHeight - (clientY - top);
    }, _this.setupDragging = function () {
      (0, _domCss2["default"])(document.body, _styles.disableSelectStyle);
      document.addEventListener('mousemove', _this.handleDrag);
      document.addEventListener('mouseup', _this.handleDragEnd);
      document.onselectstart = _returnFalse2["default"];
    }, _this.teardownDragging = function () {
      (0, _domCss2["default"])(document.body, _styles.disableSelectStyleReset);
      document.removeEventListener('mousemove', _this.handleDrag);
      document.removeEventListener('mouseup', _this.handleDragEnd);
      document.onselectstart = undefined;
    }, _this.handleDragStart = function (event) {
      _this.dragging = true;
      event.stopImmediatePropagation();
      _this.setupDragging();
    }, _this.handleDrag = function (event) {
      if (_this.prevPageX) {
        var clientX = event.clientX;
        var _this$refs7 = _this.refs,
            view = _this$refs7.view,
            trackHorizontal = _this$refs7.trackHorizontal;

        var _trackHorizontal$getB = trackHorizontal.getBoundingClientRect(),
            trackLeft = _trackHorizontal$getB.left;

        var thumbWidth = _this.getThumbHorizontalWidth();
        var clickPosition = thumbWidth - _this.prevPageX;
        var offset = -trackLeft + clientX - clickPosition;
        view.scrollLeft = _this.getScrollLeftForOffset(offset);
      }
      if (_this.prevPageY) {
        var clientY = event.clientY;
        var _this$refs8 = _this.refs,
            _view = _this$refs8.view,
            trackVertical = _this$refs8.trackVertical;

        var _trackVertical$getBou = trackVertical.getBoundingClientRect(),
            trackTop = _trackVertical$getBou.top;

        var thumbHeight = _this.getThumbVerticalHeight();
        var _clickPosition = thumbHeight - _this.prevPageY;
        var _offset = -trackTop + clientY - _clickPosition;
        _view.scrollTop = _this.getScrollTopForOffset(_offset);
      }
      return false;
    }, _this.handleDragEnd = function () {
      _this.dragging = false;
      _this.prevPageX = _this.prevPageY = 0;
      _this.teardownDragging();
      _this.handleDragEndAutoHide();
    }, _this.handleDragEndAutoHide = function () {
      var autoHide = _this.props.autoHide;

      if (!autoHide) return;
      _this.hideTracks();
    }, _this.handleTrackMouseEnter = function () {
      _this.trackMouseOver = true;
      _this.handleTrackMouseEnterAutoHide();
    }, _this.handleTrackMouseEnterAutoHide = function () {
      var autoHide = _this.props.autoHide;

      if (!autoHide) return;
      _this.showTracks();
    }, _this.handleTrackMouseLeave = function () {
      _this.trackMouseOver = false;
      _this.handleTrackMouseLeaveAutoHide();
    }, _this.handleTrackMouseLeaveAutoHide = function () {
      var autoHide = _this.props.autoHide;

      if (!autoHide) return;
      _this.hideTracks();
    }, _this.showTracks = function () {
      var _this$refs9 = _this.refs,
          trackHorizontal = _this$refs9.trackHorizontal,
          trackVertical = _this$refs9.trackVertical;

      clearTimeout(_this.hideTracksTimeout);
      (0, _domCss2["default"])(trackHorizontal, { opacity: 1 });
      (0, _domCss2["default"])(trackVertical, { opacity: 1 });
    }, _this.hideTracks = function () {
      if (_this.dragging) return;
      if (_this.scrolling) return;
      if (_this.trackMouseOver) return;
      var autoHideTimeout = _this.props.autoHideTimeout;
      var _this$refs10 = _this.refs,
          trackHorizontal = _this$refs10.trackHorizontal,
          trackVertical = _this$refs10.trackVertical;

      clearTimeout(_this.hideTracksTimeout);
      _this.hideTracksTimeout = setTimeout(function () {
        (0, _domCss2["default"])(trackHorizontal, { opacity: 0 });
        (0, _domCss2["default"])(trackVertical, { opacity: 0 });
      }, autoHideTimeout);
    }, _this.detectScrolling = function () {
      if (_this.scrolling) return;
      _this.scrolling = true;
      _this.handleScrollStart();
      _this.detectScrollingInterval = setInterval(function () {
        if (_this.lastViewScrollLeft === _this.viewScrollLeft && _this.lastViewScrollTop === _this.viewScrollTop) {
          clearInterval(_this.detectScrollingInterval);
          _this.scrolling = false;
          _this.handleScrollStop();
        }
        _this.lastViewScrollLeft = _this.viewScrollLeft;
        _this.lastViewScrollTop = _this.viewScrollTop;
      }, 100);
    }, _this.raf = function (callback) {
      if (_this.requestFrame) _raf2["default"].cancel(_this.requestFrame);
      _this.requestFrame = (0, _raf2["default"])(function () {
        _this.requestFrame = undefined;
        callback();
      });
    }, _this.update = function (callback) {
      _this.raf(function () {
        return _this._update(callback);
      });
    }, _this._update = function (callback) {
      var _this$props4 = _this.props,
          onUpdate = _this$props4.onUpdate,
          hideTracksWhenNotNeeded = _this$props4.hideTracksWhenNotNeeded;

      var values = _this.getValues();
      if ((0, _getScrollbarWidth2["default"])()) {
        var _this$refs11 = _this.refs,
            thumbHorizontal = _this$refs11.thumbHorizontal,
            thumbVertical = _this$refs11.thumbVertical,
            trackHorizontal = _this$refs11.trackHorizontal,
            trackVertical = _this$refs11.trackVertical;
        var scrollLeft = values.scrollLeft,
            clientWidth = values.clientWidth,
            scrollWidth = values.scrollWidth;

        var trackHorizontalWidth = (0, _getInnerWidth2["default"])(trackHorizontal);
        var thumbHorizontalWidth = _this.getThumbHorizontalWidth();
        var thumbHorizontalX = scrollLeft / (scrollWidth - clientWidth) * (trackHorizontalWidth - thumbHorizontalWidth);
        var thumbHorizontalStyle = {
          width: thumbHorizontalWidth,
          transform: 'translateX(' + thumbHorizontalX + 'px)'
        };
        var scrollTop = values.scrollTop,
            clientHeight = values.clientHeight,
            scrollHeight = values.scrollHeight;

        var trackVerticalHeight = (0, _getInnerHeight2["default"])(trackVertical);
        var thumbVerticalHeight = _this.getThumbVerticalHeight();
        var thumbVerticalY = scrollTop / (scrollHeight - clientHeight) * (trackVerticalHeight - thumbVerticalHeight);
        var thumbVerticalStyle = {
          height: thumbVerticalHeight,
          transform: 'translateY(' + thumbVerticalY + 'px)'
        };
        if (hideTracksWhenNotNeeded) {
          var trackHorizontalStyle = {
            visibility: scrollWidth > clientWidth ? 'visible' : 'hidden'
          };
          var trackVerticalStyle = {
            visibility: scrollHeight > clientHeight ? 'visible' : 'hidden'
          };
          (0, _domCss2["default"])(trackHorizontal, trackHorizontalStyle);
          (0, _domCss2["default"])(trackVertical, trackVerticalStyle);
        }
        (0, _domCss2["default"])(thumbHorizontal, thumbHorizontalStyle);
        (0, _domCss2["default"])(thumbVertical, thumbVerticalStyle);
      }
      if (onUpdate) onUpdate(values);
      if (typeof callback !== 'function') return;
      callback(values);
    }, _this.render = function () {
      var scrollbarWidth = (0, _getScrollbarWidth2["default"])();
      /* eslint-disable no-unused-vars */

      var _this$props5 = _this.props,
          onScroll = _this$props5.onScroll,
          onScrollFrame = _this$props5.onScrollFrame,
          onScrollStart = _this$props5.onScrollStart,
          onScrollStop = _this$props5.onScrollStop,
          onUpdate = _this$props5.onUpdate,
          renderView = _this$props5.renderView,
          renderTrackHorizontal = _this$props5.renderTrackHorizontal,
          renderTrackVertical = _this$props5.renderTrackVertical,
          renderThumbHorizontal = _this$props5.renderThumbHorizontal,
          renderThumbVertical = _this$props5.renderThumbVertical,
          tagName = _this$props5.tagName,
          hideTracksWhenNotNeeded = _this$props5.hideTracksWhenNotNeeded,
          autoHide = _this$props5.autoHide,
          autoHideTimeout = _this$props5.autoHideTimeout,
          autoHideDuration = _this$props5.autoHideDuration,
          thumbSize = _this$props5.thumbSize,
          thumbMinSize = _this$props5.thumbMinSize,
          universal = _this$props5.universal,
          autoHeight = _this$props5.autoHeight,
          autoHeightMin = _this$props5.autoHeightMin,
          autoHeightMax = _this$props5.autoHeightMax,
          style = _this$props5.style,
          children = _this$props5.children,
          props = _objectWithoutProperties(_this$props5, ['onScroll', 'onScrollFrame', 'onScrollStart', 'onScrollStop', 'onUpdate', 'renderView', 'renderTrackHorizontal', 'renderTrackVertical', 'renderThumbHorizontal', 'renderThumbVertical', 'tagName', 'hideTracksWhenNotNeeded', 'autoHide', 'autoHideTimeout', 'autoHideDuration', 'thumbSize', 'thumbMinSize', 'universal', 'autoHeight', 'autoHeightMin', 'autoHeightMax', 'style', 'children']);
      /* eslint-enable no-unused-vars */

      var didMountUniversal = _this.state.didMountUniversal;

      var containerStyle = _extends({}, _styles.containerStyleDefault, autoHeight && _extends({}, _styles.containerStyleAutoHeight, {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }), style);

      var viewStyle = _extends({}, _styles.viewStyleDefault, {
        // Hide scrollbars by setting a negative margin
        marginRight: scrollbarWidth ? -scrollbarWidth : 0,
        marginBottom: scrollbarWidth ? -scrollbarWidth : 0
      }, autoHeight && _extends({}, _styles.viewStyleAutoHeight, {
        // Add scrollbarWidth to autoHeight in order to compensate negative margins
        minHeight: (0, _isString2["default"])(autoHeightMin) ? 'calc(' + autoHeightMin + ' + ' + scrollbarWidth + 'px)' : autoHeightMin + scrollbarWidth,
        maxHeight: (0, _isString2["default"])(autoHeightMax) ? 'calc(' + autoHeightMax + ' + ' + scrollbarWidth + 'px)' : autoHeightMax + scrollbarWidth
      }), autoHeight && universal && !didMountUniversal && {
        minHeight: autoHeightMin,
        maxHeight: autoHeightMax
      }, universal && !didMountUniversal && _styles.viewStyleUniversalInitial);

      var trackAutoHeightStyle = {
        transition: 'opacity ' + autoHideDuration + 'ms',
        opacity: 0
      };

      var trackHorizontalStyle = _extends({}, _styles.trackHorizontalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
        display: 'none'
      });

      var trackVerticalStyle = _extends({}, _styles.trackVerticalStyleDefault, autoHide && trackAutoHeightStyle, (!scrollbarWidth || universal && !didMountUniversal) && {
        display: 'none'
      });

      return (0, _preact.h)(tagName, _extends({}, props, { style: containerStyle, ref: function ref(r) {
          _this.refs.container = r;
        } }), [(0, _preact.cloneElement)(renderView({ style: viewStyle }), { key: 'view', ref: function ref(r) {
          _this.refs.view = r;
        } }, children), (0, _preact.cloneElement)(renderTrackHorizontal({ style: trackHorizontalStyle }), { key: 'trackHorizontal', ref: function ref(r) {
          _this.refs.trackHorizontal = r;
        } }, (0, _preact.cloneElement)(renderThumbHorizontal({ style: _styles.thumbHorizontalStyleDefault }), { ref: function ref(r) {
          _this.refs.thumbHorizontal = r;
        } })), (0, _preact.cloneElement)(renderTrackVertical({ style: trackVerticalStyle }), { key: 'trackVertical', ref: function ref(r) {
          _this.refs.trackVertical = r;
        } }, (0, _preact.cloneElement)(renderThumbVertical({ style: _styles.thumbVerticalStyleDefault }), { ref: function ref(r) {
          _this.refs.thumbVertical = r;
        } }))]);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Scrollbars, [{
    key: 'componentDidMountUniversal',
    value: function componentDidMountUniversal() {
      // eslint-disable-line react/sort-comp
      var universal = this.props.universal;

      if (!universal) return;
      this.setState({ didMountUniversal: true });
    }
  }, {
    key: 'unsetDomStyles',
    value: function unsetDomStyles() {
      var _refs = this.refs,
          thumbHorizontal = _refs.thumbHorizontal,
          thumbVertical = _refs.thumbVertical,
          trackHorizontal = _refs.trackHorizontal,
          trackVertical = _refs.trackVertical;

      var stylesReset = {
        width: '',
        height: '',
        transform: '',
        opacity: '',
        visibility: ''
      };
      (0, _domCss2["default"])(thumbVertical, stylesReset);
      (0, _domCss2["default"])(thumbHorizontal, stylesReset);
      (0, _domCss2["default"])(trackVertical, stylesReset);
      (0, _domCss2["default"])(trackHorizontal, stylesReset);
    }
  }]);

  return Scrollbars;
}(_preact.Component);

Scrollbars.defaultProps = {
  renderView: _defaultRenderElements.renderViewDefault,
  renderTrackHorizontal: _defaultRenderElements.renderTrackHorizontalDefault,
  renderTrackVertical: _defaultRenderElements.renderTrackVerticalDefault,
  renderThumbHorizontal: _defaultRenderElements.renderThumbHorizontalDefault,
  renderThumbVertical: _defaultRenderElements.renderThumbVerticalDefault,
  tagName: 'div',
  thumbMinSize: 30,
  hideTracksWhenNotNeeded: false,
  autoHide: false,
  autoHideTimeout: 1000,
  autoHideDuration: 200,
  autoHeight: false,
  autoHeightMin: 0,
  autoHeightMax: 200,
  universal: false
};
exports["default"] = Scrollbars;

/***/ }),

/***/ "p9Bm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("TnEH");

var _style2 = _interopRequireDefault(_style);

var _emitter = __webpack_require__("7UP4");

var _emitter2 = _interopRequireDefault(_emitter);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _Cancel = __webpack_require__("cWLq");

var _Cancel2 = _interopRequireDefault(_Cancel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Cancel2.default, { color: 'white' });

var CloseButton = function (_Component) {
    _inherits(CloseButton, _Component);

    function CloseButton(props) {
        _classCallCheck(this, CloseButton);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this._onClick = _this._onClick.bind(_this);

        return _this;
    }

    CloseButton.prototype._onClick = function _onClick() {
        _emitter2.default.send('*', 'openState', false);
    };

    CloseButton.prototype.render = function render() {
        if (this.props.isNormalView) return null;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.CloseButton, onClick: this._onClick },
            _ref
        );
    };

    return CloseButton;
}(_preact.Component);

exports.default = (0, _preactRedux.connect)(function (state) {
    return {
        isNormalView: _model2.default.isNormalView(state)
    };
})(CloseButton);

/***/ }),

/***/ "pZVW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _style = __webpack_require__("RIoB");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Button = function (_Component) {
    _inherits(Button, _Component);

    function Button(props) {
        _classCallCheck(this, Button);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.mouseEnter = _this.mouseEnter.bind(_this);
        _this.mouseLeave = _this.mouseLeave.bind(_this);

        _this.state = {
            hover: false
        };
        return _this;
    }

    Button.prototype.mouseEnter = function mouseEnter() {
        this.setState({ hover: true });
    };

    Button.prototype.mouseLeave = function mouseLeave() {
        this.setState({ hover: false });
    };

    Button.prototype.getContainerStyle = function getContainerStyle() {
        var _props = this.props,
            bgColor = _props.bgColor,
            textColor = _props.textColor;

        return {
            backgroundColor: bgColor || '#4dc5e2',
            color: textColor || 'white'
        };
    };

    Button.prototype._renderImage = function _renderImage() {
        var imgCmp = this.props.imgCmp;

        if (imgCmp) {
            return (0, _preact.h)(
                'div',
                { className: _style2.default.Image },
                ' ',
                imgCmp,
                ' '
            );
        }
        return null;
    };

    Button.prototype.render = function render() {
        var _props2 = this.props,
            text = _props2.text,
            onClick = _props2.onClick;

        var containerStyle = this.getContainerStyle();
        return (0, _preact.h)(
            'div',
            { className: _style2.default.ButtonContainer,
                style: containerStyle,
                onMouseEnter: this.mouseEnter,
                onMouseLeave: this.mouseLeave,
                onClick: onClick },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Text },
                text
            ),
            this._renderImage()
        );
    };

    return Button;
}(_preact.Component);

exports.default = Button;

/***/ }),

/***/ "pjGl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _types = __webpack_require__("LB+H");

function actionSetEmojiContainerIsDisplayed(isDisplayed) {
    return {
        type: _types.SET_EMOJI_CONTAINER_IS_DISPLAYED,
        payload: isDisplayed
    };
}

exports.default = actionSetEmojiContainerIsDisplayed;

/***/ }),

/***/ "qIew":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"OnlineFormularBody":"OnlineFormularBody__11x22","StartChattingButton":"StartChattingButton__fQ4N7","StartChattingText":"StartChattingText__3hHzz","Header":"Header__19ISK"};

/***/ }),

/***/ "qZCq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"NormalHeader":"NormalHeader__3BIqT","MobileHeader":"MobileHeader__2cdBp","Title":"Title__3GYsW","Body":"Body__phR7J"};

/***/ }),

/***/ "r7nU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Shell":"Shell__3TFLd","ShellInstagram":"ShellInstagram__1jwZX","ShellBody":"ShellBody__3aNRl","BodyWrapper":"BodyWrapper__2e6tU","BodyScrollbar":"BodyScrollbar__1JCiv"};

/***/ }),

/***/ "rALM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CheckboxInputForm = function (_Component) {
  _inherits(CheckboxInputForm, _Component);

  function CheckboxInputForm() {
    var _temp, _this, _ret;

    _classCallCheck(this, CheckboxInputForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.toggle = function (e) {
      var checked = !_this.state.checked;
      _this.setState({ checked: checked });
      _this.props.onChange(checked);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  CheckboxInputForm.prototype.render = function render(_, _ref) {
    var checked = _ref.checked;

    return (0, _preact.h)(
      "div",
      null,
      (0, _preact.h)("input", { type: "checkbox", checked: checked, onClick: this.toggle }),
      (0, _preact.h)("span", { dangerouslySetInnerHTML: { __html: this.props.label } })
    );
  };

  return CheckboxInputForm;
}(_preact.Component);

exports.default = CheckboxInputForm;

/***/ }),

/***/ "rnVk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = unicodeToCodepoint;
// avoid runtime RegExp creation for not so smart,
// not JIT based, and old browsers / engines
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L232
var UFE0Fg = /\uFE0F/g;

// \u200D is a zero-width joiner character
// https://github.com/twitter/twemoji/blob/gh-pages/2/twemoji.js#L235
var U200D = String.fromCharCode(0x200d);

// convert utf16 into code points
function toCodePoint(input) {
  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "-";

  var codePoints = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = input[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var codePoint = _step.value;

      codePoints.push(codePoint.codePointAt(0).toString(16));
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return codePoints.join(separator);
}

function unicodeToCodepoint(input) {
  return toCodePoint(input.indexOf(U200D) < 0 ? input.replace(UFE0Fg, "") : input);
}

/***/ }),

/***/ "t9XJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.playNewMessage = undefined;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var playNewMessage = exports.playNewMessage = void 0;

var Audio = function (_Component) {
    _inherits(Audio, _Component);

    function Audio(props) {
        _classCallCheck(this, Audio);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.play = _this.play.bind(_this);

        exports.playNewMessage = playNewMessage = _this.playNewMessage.bind(_this);

        _this.audioElement = null;
        return _this;
    }

    Audio.prototype.render = function render() {
        var _this2 = this;

        return (0, _preact.h)(
            'div',
            { 'class': 'audio-elements' },
            (0, _preact.h)(
                'audio',
                { ref: function ref(newMessageAudioElement) {
                        _this2.newMessageAudioElement = newMessageAudioElement;
                    } },
                (0, _preact.h)('source', { src: '/common/assets/audio/new-message.mp3', type: 'audio/mpeg' })
            )
        );
    };

    Audio.prototype.play = function play() {
        var playPromise = this.audioElement.play();

        if (playPromise !== undefined) {
            playPromise.then(function (_) {}).catch(function (error) {});
        }
    };

    Audio.prototype.stop = function stop() {
        if (this.audioElement !== null) {
            this.audioElement.pause();
            this.audioElement.currentTime = 0;
        }
    };

    Audio.prototype.playNewMessage = function playNewMessage() {
        this.stop();
        this.audioElement = this.newMessageAudioElement;
        this.play();
    };

    return Audio;
}(_preact.Component);

exports.default = Audio;

/***/ }),

/***/ "tXeI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _style = __webpack_require__("iw93");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _model3 = __webpack_require__("9VrP");

var _model4 = _interopRequireDefault(_model3);

var _model5 = __webpack_require__("2YDt");

var _model6 = _interopRequireDefault(_model5);

var _Question = __webpack_require__("0A5o");

var _Question2 = _interopRequireDefault(_Question);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResults = function (_Component) {
    _inherits(SearchResults, _Component);

    function SearchResults() {
        _classCallCheck(this, SearchResults);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    SearchResults.prototype.__filterResults = function __filterResults(question, searchWords) {
        for (var i = 0; i < searchWords.length; i++) {
            if (!question.includes(searchWords[i])) return false;
        }
        return true;
    };

    SearchResults.prototype._search = function _search() {
        var _this2 = this;

        var _props = this.props,
            questions = _props.questions,
            searchInput = _props.searchInput;

        var searchWords = searchInput.trim().toLowerCase().split(' ');
        var results = _lodash2.default.filter(questions, function (question) {
            return _this2.__filterResults(question['question'].toLowerCase(), searchWords);
        });
        return results;
    };

    SearchResults.prototype._onQuestionClick = function _onQuestionClick(id) {
        this.props.dispatch(_model2.default.setHelpDeskRoute('HelpDeskArticle', this.props.activeCategory, id));
    };

    SearchResults.prototype._renderResults = function _renderResults() {
        var _this3 = this;

        var results = this._search();
        if (results.length > 0) {
            return (0, _preact.h)(
                'div',
                null,
                results.map(function (question) {
                    return (0, _preact.h)(_Question2.default, { questionTitle: question['question'], onClick: function onClick() {
                            return _this3._onQuestionClick(question['id']);
                        } });
                })
            );
        } else {
            return (0, _preact.h)(
                'div',
                { className: _style2.default.NoResults },
                (0, _preact.h)(
                    'div',
                    null,
                    this.props.language.get('NoHelpDeskSearchResults')
                ),
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.NoResultsSearchTerm },
                    ' ',
                    this.props.searchInput,
                    ' '
                )
            );
        }
    };

    SearchResults.prototype.render = function render() {
        return (0, _preact.h)(
            'div',
            { style: { height: this.props.height + 'px' }, className: _style2.default.SearchResultsContainer },
            this._renderResults()
        );
    };

    return SearchResults;
}(_preact.Component);

function mapStatetoProps(state) {
    var searchInput = _model2.default.getSearchInput(state);
    var questions = _model4.default.getFeaturePayload(state, 'helpdesk')['questions'];
    var language = _model6.default.getLanguage(state);
    return {
        height: _model2.default.getBodyHeight(state),
        searchInput: searchInput,
        questions: questions,
        language: language
    };
}

exports.default = (0, _preactRedux.connect)(mapStatetoProps)(SearchResults);

/***/ }),

/***/ "uG4N":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("EMlc");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CategoryScroll = function (_Component) {
    _inherits(CategoryScroll, _Component);

    function CategoryScroll() {
        _classCallCheck(this, CategoryScroll);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    CategoryScroll.prototype.render = function render() {
        var _props = this.props,
            isAnimating = _props.isAnimating,
            isFocused = _props.isFocused,
            color = _props.color,
            activeCategory = _props.activeCategory;

        var xTranslate = activeCategory % 3 * 100;
        var display = this.props.display;
        if (display) {
            return (0, _preact.h)(
                'div',
                { className: _style2.default.Scroller },
                (0, _preact.h)(
                    'div',
                    { style: { transform: 'translateX(' + xTranslate + '%)' }, className: _style2.default.LineWrapper },
                    (0, _preact.h)('div', { className: _style2.default.Line, style: { backgroundColor: color } })
                )
            );
        } else {
            return null;
        }
    };

    return CategoryScroll;
}(_preact.Component);

exports.default = CategoryScroll;

/***/ }),

/***/ "uRCp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var weekDay = ["Mån", "Tis", "Ons", "Tor", "Fre", "Lör", "Sön"];

var DateTime = function () {
    function DateTime() {
        _classCallCheck(this, DateTime);
    }

    DateTime.formatDate = function formatDate(dateString, format) {
        var date = this.getUTCDate(dateString);

        switch (format) {
            case 'hh:mm':
                return this.getTime(date);
            case 'yyyy-mm-dd':
                return this.getDate(date);
            case 'yyyy-mm-dd hh:mm':
                return this.getDate(date) + " " + this.getTime(date);
            default:
                return this.getDate(date) + " " + this.getTime(date);
        }
    };

    DateTime.getUTCDate = function getUTCDate(dateString) {
        // replace - with / in dateString for browser compatibility.
        dateString = dateString.replace(/-/g, "/");

        // Entries that come via socket have a date then a dot followed by a 6 digit number that should not be in the date
        dateString = dateString.split('.')[0];

        /*
        * The date we get from the server is UTC time.
        * We need to add UTC to the end of date_created
        * so that the Date function will convert it to
        * the UTC time that the browser is using.
        */
        var dateStringUTC = dateString + ' UTC';

        return new Date(dateStringUTC);
    };

    DateTime.getTimestamp = function getTimestamp(dateString) {
        return this.getUTCDate(dateString).getTime();
    };

    DateTime.getTime = function getTime(date) {
        var hours = this.padDate(date.getHours());
        var minutes = this.padDate(date.getMinutes());
        return hours + ":" + minutes;
    };

    DateTime.getDate = function getDate(date) {
        var year = date.getFullYear();
        var month = this.padDate(date.getMonth() + 1);
        var day = this.padDate(date.getDate());
        return year + "-" + month + "-" + day;
    };

    DateTime.padDate = function padDate(number) {
        number = String(number);

        if (number.length === 1) {
            number = "0" + number;
        }

        return number;
    };

    DateTime.isToday = function isToday(dateString) {
        var date = this.getUTCDate(dateString);

        var today = new Date();

        return today.toDateString() === date.toDateString();
    };

    DateTime.getDiffTime = function getDiffTime(here, there) {
        var hereDate = this.getUTCDate(here);
        var thereDate = this.getUTCDate(there);
        return Math.abs(hereDate - thereDate);
    };

    DateTime.getDiffMinutes = function getDiffMinutes(here, there) {
        return Math.ceil(this.getDiffTime(here, there) / (1000 * 60));
    };

    DateTime.getDetailedNiceDate = function getDetailedNiceDate(dateString) {
        var date = this.getUTCDate(dateString);
        var today = new Date();
        if (this.isToday(dateString)) return this.getTime(date);

        var weekDate = date.getDay();
        var month = date.getMonth();

        var timeDiff = Math.abs(today.getTime() - date.getTime());
        var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
        if (diffDays === 1) return "Igår " + this.getTime(date);
        if (diffDays < 7) return weekDay[weekDate - 1] + " " + this.getTime(date);
        return date.getDate() + " " + monthNames[month] + " " + this.getTime(date);
    };

    return DateTime;
}();

exports.default = DateTime;

/***/ }),

/***/ "un2Q":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Chat = __webpack_require__("iwwO");

var _Chat2 = _interopRequireDefault(_Chat);

var _HelpDesk = __webpack_require__("LqNj");

var _HelpDesk2 = _interopRequireDefault(_HelpDesk);

var _style = __webpack_require__("LIe4");

var _style2 = _interopRequireDefault(_style);

var _model = __webpack_require__("tdsa");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FooterButton = function (_Component) {
    _inherits(FooterButton, _Component);

    function FooterButton() {
        _classCallCheck(this, FooterButton);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    FooterButton.prototype.render = function render() {
        var _props = this.props,
            orientation = _props.orientation,
            active = _props.active,
            color = _props.color,
            onClick = _props.onClick,
            text = _props.text,
            hasUnread = _props.hasUnread;

        var styleClass = orientation === 'left' ? _style2.default.Left : _style2.default.Right;
        color = active ? color : '#898989';
        var icon = orientation === 'left' ? (0, _preact.h)(_HelpDesk2.default, { color: color }) : (0, _preact.h)(_Chat2.default, { color: color });
        return (0, _preact.h)(
            'div',
            {
                onClick: onClick,
                style: { borderColor: color },
                className: styleClass + ' ' + _style2.default.FooterButton },
            (0, _preact.h)(
                'div',
                { className: _style2.default.FooterButtonImg },
                icon
            ),
            (0, _preact.h)(
                'div',
                { className: _style2.default.FooterButtonText, style: { color: color } },
                this.props.text
            ),
            orientation === 'right' && hasUnread && (0, _preact.h)(
                'div',
                { className: _style2.default.UnreadDotContainer },
                (0, _preact.h)(
                    'div',
                    { className: _style2.default.UnreadDot },
                    ' '
                )
            )
        );
    };

    return FooterButton;
}(_preact.Component);

function mapStateToProps(state) {
    return { hasUnread: _model2.default.getTotalUnread(state) !== 0 };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(FooterButton);

/***/ }),

/***/ "vdh7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Validation = undefined;

var _Validation = __webpack_require__("SiXk");

var _Validation2 = _interopRequireDefault(_Validation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Validation = _Validation2.default;

/***/ }),

/***/ "vqYw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]';

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var Symbol = root.Symbol,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
}

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array ? array.length : 0;
  return length ? baseFlatten(array, 1) : [];
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') && (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = flatten;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("DuR2")))

/***/ }),

/***/ "w84i":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavLeft = function (_Component) {
    _inherits(NavLeft, _Component);

    function NavLeft() {
        _classCallCheck(this, NavLeft);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    NavLeft.prototype.render = function render() {
        return (0, _preact.h)(
            "svg",
            { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 42" },
            (0, _preact.h)("path", { fill: this.props.color, d: "M13.47,38a1.49,1.49,0,0,0,1.22-2.36L4.37,21.49,14.69,7.39a1.5,1.5,0,1,0-2.44-1.73l-10.94,15a1.5,1.5,0,0,0,0,1.74l10.94,15A1.49,1.49,0,0,0,13.47,38Z" })
        );
    };

    return NavLeft;
}(_preact.Component);

exports.default = NavLeft;

/***/ }),

/***/ "wDYE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Wrapper":"Wrapper__2p7Nh"};

/***/ }),

/***/ "wGi3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }return target;
};

exports.renderViewDefault = renderViewDefault;
exports.renderTrackHorizontalDefault = renderTrackHorizontalDefault;
exports.renderTrackVerticalDefault = renderTrackVerticalDefault;
exports.renderThumbHorizontalDefault = renderThumbHorizontalDefault;
exports.renderThumbVerticalDefault = renderThumbVerticalDefault;

var _preact = __webpack_require__("EBst");

function _objectWithoutProperties(obj, keys) {
  var target = {};for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;target[i] = obj[i];
  }return target;
}

function renderViewDefault(props) {
  return (0, _preact.h)('div', props);
}

function renderTrackHorizontalDefault(_ref) {
  var style = _ref.style,
      props = _objectWithoutProperties(_ref, ['style']);

  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    left: 2,
    borderRadius: 3
  });
  return (0, _preact.h)('div', _extends({ style: finalStyle }, props));
}

function renderTrackVerticalDefault(_ref2) {
  var style = _ref2.style,
      props = _objectWithoutProperties(_ref2, ['style']);

  var finalStyle = _extends({}, style, {
    right: 2,
    bottom: 2,
    top: 2,
    borderRadius: 3
  });
  return (0, _preact.h)('div', _extends({ style: finalStyle }, props));
}

function renderThumbHorizontalDefault(_ref3) {
  var style = _ref3.style,
      props = _objectWithoutProperties(_ref3, ['style']);

  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });
  return (0, _preact.h)('div', _extends({ style: finalStyle }, props));
}

function renderThumbVerticalDefault(_ref4) {
  var style = _ref4.style,
      props = _objectWithoutProperties(_ref4, ['style']);

  var finalStyle = _extends({}, style, {
    cursor: 'pointer',
    borderRadius: 'inherit',
    backgroundColor: 'rgba(0,0,0,.2)'
  });
  return (0, _preact.h)('div', _extends({ style: finalStyle }, props));
}

/***/ }),

/***/ "x584":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _PoweredByJibber = __webpack_require__("jVb+");

var _PoweredByJibber2 = _interopRequireDefault(_PoweredByJibber);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

var _style = __webpack_require__("3MPn");

var _style2 = _interopRequireDefault(_style);

var _Title = __webpack_require__("UfLy");

var _Title2 = _interopRequireDefault(_Title);

var _AutoMessage = __webpack_require__("O6gZ");

var _AutoMessage2 = _interopRequireDefault(_AutoMessage);

var _Buttons = __webpack_require__("Jw2m");

var _RightSide = __webpack_require__("6AAI");

var _RightSide2 = _interopRequireDefault(_RightSide);

var _model3 = __webpack_require__("2YDt");

var _model4 = _interopRequireDefault(_model3);

var _TextDisplay = __webpack_require__("lwNl");

var _TextDisplay2 = _interopRequireDefault(_TextDisplay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_Buttons.FaqButton, { color: 'white' });

var _ref2 = (0, _preact.h)(_Buttons.CloseButton, null);

var Header = function (_Component) {
    _inherits(Header, _Component);

    function Header(props) {
        _classCallCheck(this, Header);

        var _this = _possibleConstructorReturn(this, _Component.call(this, props));

        _this.state = {
            HeaderHeight: 0
        };
        _this._faqOnClick = _this._faqOnClick.bind(_this);
        return _this;
    }

    Header.prototype._faqOnClick = function _faqOnClick() {
        this.props.dispatch(_model2.default.setRoute('Faq'));
    };

    Header.prototype.render = function render() {
        var _props = this.props,
            company = _props.company,
            features = _props.features,
            language = _props.language,
            name = _props.name,
            formsSetting = _props.formsSetting;

        var hasFaq = features.get('hasFaq');
        var welcomeTo = language.get("WelcomeTo");
        var text = this.props.language.get('OfflineMessage');

        if (formsSetting) {
            if (formsSetting['config']['is_overide_message'] && formsSetting['config']['message']) {
                text = formsSetting['config']['message'];
            } else if (formsSetting['message']) {
                text = formsSetting['message'];
            }
        }

        return (0, _preact.h)(
            'div',
            { style: { backgroundColor: this.props.color } },
            (0, _preact.h)(
                'div',
                { className: _style2.default.Header },
                (0, _preact.h)(_Title2.default, { title: welcomeTo, body: name }),
                (0, _preact.h)('div', { style: { height: '10px' } }),
                (0, _preact.h)(_TextDisplay2.default, { text: text }),
                (0, _preact.h)(
                    _RightSide2.default,
                    null,
                    hasFaq && _ref,
                    _ref2
                )
            )
        );
    };

    return Header;
}(_preact.Component);

function mapStateToProps(state) {
    var color = _model4.default.getColor(state);
    var language = _model4.default.getLanguage(state);
    var name = _model4.default.getCompanyDisplayName(state);
    var offline = state.getIn(['features', 'features_payload', 'offline'], null);
    return {
        color: color,
        language: language,
        company: state.get('company'),
        features: state.get('features'),
        system: state.get('system'),
        name: name,
        formsSetting: _model4.default.getOfflineFormsSettings(state).toJS()
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Header);

/***/ }),

/***/ "xfPb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"SelectWrapper":"SelectWrapper__3XgDU"};

/***/ }),

/***/ "xvMY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
function ellipsis(str, maxLength) {
    if (!str) return '';
    if (!str.length) return '';

    if (str.length > maxLength) {
        return str.substr(0, maxLength) + '...';
    }
    return str;
}

exports.default = ellipsis;

/***/ }),

/***/ "zHk1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = undefined;

var _preact = __webpack_require__("EBst");

var _style = __webpack_require__("2wQW");

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var OfflineMessage = function (_Component) {
    _inherits(OfflineMessage, _Component);

    function OfflineMessage() {
        _classCallCheck(this, OfflineMessage);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    OfflineMessage.prototype.render = function render() {
        var forms = this.props.entry.meta.details.forms;
        return (0, _preact.h)(
            'div',
            { className: _style2.default.MetaOffline },
            'Meddelande skickat via offline-formul\xE4r',
            Object.keys(forms).map(function (key, i) {
                if (forms[key]) {
                    return (0, _preact.h)('input', { key: i, value: forms[key], disabled: true });
                }
                return '';
            }),
            (0, _preact.h)('textarea', {
                className: _style2.default.MetaOfflineTextArea,
                disabled: true,
                resize: 'none',
                value: this.props.entry.entry_body
            })
        );
    };

    return OfflineMessage;
}(_preact.Component);

exports.default = OfflineMessage;

/***/ }),

/***/ "zjtR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"Emoji":"Emoji__mIMbO","Container":"Container__2YkxO"};

/***/ }),

/***/ "zvqD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _preact = __webpack_require__("EBst");

var _preactRedux = __webpack_require__("1AcT");

var _Header = __webpack_require__("W0rJ");

var _Header2 = _interopRequireDefault(_Header);

var _NewConversationButton = __webpack_require__("jtSj");

var _NewConversationButton2 = _interopRequireDefault(_NewConversationButton);

var _ConversationsList = __webpack_require__("/750");

var _ConversationsList2 = _interopRequireDefault(_ConversationsList);

var _style = __webpack_require__("ICtB");

var _style2 = _interopRequireDefault(_style);

var _SearchIcon = __webpack_require__("BOLS");

var _SearchIcon2 = _interopRequireDefault(_SearchIcon);

var _model = __webpack_require__("et9O");

var _model2 = _interopRequireDefault(_model);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = (0, _preact.h)(_NewConversationButton2.default, null);

var Conversations = function (_Component) {
    _inherits(Conversations, _Component);

    function Conversations() {
        _classCallCheck(this, Conversations);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Conversations.prototype.render = function render() {
        var conversations = this.props.conversations;

        // NewconversationButton take up 63px
        var height = this.props.height - 63 + 'px';
        if (conversations.size === 0) {
            this.props.dispatch(_model2.default.setRoute('StartChatting'));
        }
        return (0, _preact.h)(
            'div',
            null,
            (0, _preact.h)(
                'div',
                { className: _style2.default.ConversationBody, style: { height: height } },
                (0, _preact.h)(_ConversationsList2.default, { conversations: conversations })
            ),
            _ref
        );
    };

    return Conversations;
}(_preact.Component);

function mapStateToProps(state) {
    return {
        conversations: state.getIn(['ticket', 'list']),
        height: _model2.default.getBodyHeight(state)
    };
}

exports.default = (0, _preactRedux.connect)(mapStateToProps)(Conversations);

/***/ })

});


// WEBPACK FOOTER //
// route-index.chunk.fce3c.js